'use strict';

angular.module('dodomaApp', ['LocalStorageModule', 'tmh.dynamicLocale',
                             'ui.select', 'ngSanitize', // for autocompletes
                             'ui.bootstrap',
                             'mgcrea.ngStrap.select', // drop-down select
                             'mgcrea.ngStrap.datepicker', 'mgcrea.ngStrap.timepicker' , // for working datepicker
                             'mgcrea.ngStrap.tooltip', 'mgcrea.ngStrap.popover', 'ngAnimate', // for popovers
                             'monospaced.elastic', // textarea autosize
                             'angular-loading-bar', // for loading bar
                             'ngFileUpload', // for file upload
    'ngResource', 'ui.router', 'ngCookies', 'pascalprecht.translate', 'ngCacheBuster'])

    .run(function ($rootScope, $window, $state, $translate, $transitions, Auth, Principal, Language, ENV, VERSION, DodomaConfig, SystemConfiguration) {
        $rootScope.ENV = ENV;
        $rootScope.VERSION = VERSION;
        $rootScope.DodomaConfig = DodomaConfig;

        $transitions.onBefore({}, function(transition /*: Transition */) {
          // var stateService = transition.router.stateService;
          var toStateObject = transition.$to();
          // console.log("transition to ", toStateObject, " params=", toStateObject.params);
          $rootScope.toState = toStateObject;
          return Auth.authorizeUser(toStateObject);
        });
        $transitions.onStart({}, function(transition /*: Transition */) {
          // Update the language
          Language.getCurrent().then(function (language) {
              $translate.use(language);
          });
        });

        SystemConfiguration.get(function(sysConfig) {
            $rootScope.sysConfig = sysConfig;
            for (var key in sysConfig) {
              var valueType = typeof(sysConfig[key]);
              // copy all the non-null, non functions values to the Config object, if not started with $
              if (!key.startsWith('$') && valueType !== 'function' && valueType !== 'undefined') {
                console.log('key ',key,' value ', sysConfig[key])
                $rootScope.DodomaConfig[key] = sysConfig[key];
              }
            }
            var modules = $rootScope.DodomaConfig.modules;
            $rootScope.DodomaConfig.modules.homeScreen = function() {
                if (modules.multiModule) {
                    return 'home';
                }
                if (modules.stock) {
                    return 'stock';
                }
                if (modules.prod) {
                    return 'orderPlan';
                }
                if (modules.rehab) {
                    return 'rehab';
                }
            }
        });

        $transitions.onSuccess({}, function(trans/*: Transition */) {
            var from = trans.$from();
            $rootScope.previousStateName = from.name;
            $rootScope.previousStateParams = from.params;

            // Set the page title key to the one configured in state or use default one
            var to = trans.$to();
            var titleKey = to.data && to.data.pageTitle || 'global.title';

            $translate(titleKey).then(function (title) {
                // Change window title with translated one
                $window.document.title = title;
            });
        });

        $rootScope.$on('$titleChange', function(event, key, param) {
          $translate(key, param).then(function(title) {
            $window.document.title = title;
          })
        });

        $rootScope.back = function() {
            // If previous state is 'activate' or do not exist go to 'home'
            if ($rootScope.previousStateName === 'activate' || $rootScope.previousStateName === '' || $state.get($rootScope.previousStateName) === null) {
                $state.go('home');
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams);
            }
        };
    })
    .factory('authExpiredInterceptor', function ($rootScope, $q, $injector) {
        return {
            responseError: function(response) {
                // If we have an unauthorized request we redirect to the login page
                // Don't do this check on the account API to avoid infinite loop
                if (response.status === 401 && response.data.path !== undefined && response.data.path.indexOf("/api/account") === -1){
                    var Auth = $injector.get('Auth');
                    var $state = $injector.get('$state');
                    var to = $rootScope.toState;
                    var params = $rootScope.toStateParams;
                    Auth.logout();
                    $rootScope.returnToState = to;
                    $rootScope.returnToStateParams = params;
                    $state.go('login');
                }
                return $q.reject(response);
            }
        };
    })
    .config(function ($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $translateProvider, tmhDynamicLocaleProvider, httpRequestInterceptorCacheBusterProvider) {

        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'XSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');
        $stateProvider.state('site', {
            'abstract': true,
            views: {
                'navbar@': {
                    templateUrl: 'scripts/components/navbar/navbar.html',
                    controller: 'NavbarController'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modules/all');
                    return $translate.refresh();
                }]
            }
        });

        // http interceptors
        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');

        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: function(name, lang) {
                var safeLang = lang.replace(/\"/g,"");
                return 'i18n/{lang}.json'.replace(/\{lang\}/g, safeLang) + '?rnd='+Math.random();
            }
        });

        $translateProvider.preferredLanguage('hu');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('escaped');

        tmhDynamicLocaleProvider.localeLocationPattern('node_modules/angular-i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');

    });

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('dodomaApp')
        .constant('VERSION', "2.0.6")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ENV', "prod")
        .constant('BUILD_TIMESTAMP', 1778435679961)
;
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
  .constant('DodomaConfig', {
    modules : {
      multiModule : true,
      stock: true,
      prod : true,
      rehab : true,
      homeScreen : function() { return 'home'; } // this method is overwritten
    },
    showPartReservation: false,
    logo: '/assets/images/kezmu.jpg',
    backdatedMovements: true,
    separateOffers: false,
    showWorkStepMinimumRatio: false,
    magicalPageSize: 100,

    workerRecords: [],
    listedWorkerRecords : [ ],

    records: {},
    // map of "record type" -> Object{
    //  validityDate : false, 
    //  multipleWorker: false, 
    //  oneRecordPerWorker : true, 
    //  printable: true,
    //  showMinutes: true
    //  deadlines: List<String>
    // }

  })
  .config(function($datepickerProvider) {
    angular.extend($datepickerProvider.defaults, {
      dateFormat: 'yyyy-MM-dd',
      autoclose: true,
      useNative: true,
      startWeek: 1
    });
  }).config(function($timepickerProvider) {
    angular.extend($timepickerProvider.defaults, {
      timeFormat: 'HH:mm',
      useNative: true,
      length: 7
    });
  })
})();
'use strict';

angular.module('dodomaApp')
    .factory('SystemConfiguration', function($resource) {
        return $resource('api/system', {}, {
            'get': { method: 'GET' },
            'notifications' : {method: 'GET', url: 'api/notifications', isArray:true}
        });
    });

'use strict';

angular.module('dodomaApp')
    .factory('ErrorHandler', ['$state', '$q', function($state, $q) {
        return {
            /**
             * Create a rejection handler for 404 errors that redirects to the error page
             * @param {string} messageKey - Translation key for the error message (e.g., 'dodomaApp.orderPlan.notFound')
             * @returns {Function} A rejection handler function to use in .catch()
             */
            rejectWith: function(messageKey) {
                return function(response) {
                    if (response.status === 404) {
                        $state.go('error', {message: messageKey}, {location: false});
                    }
                };
            }
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Auth', function($rootScope, $state, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        return {
            login: function (credentials, callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.login(credentials).then(function (data) {
                    // retrieve the logged account information
                    Principal.identity(true).then(function(account) {

                        // After the login the language will be changed to
                        // the language selected by the user during his registration
                        var currentLang = $translate.use().replace(/\"/g,"");
                        if (currentLang != account.langKey) {
                            $translate.use(account.langKey);
                            //$translate.refresh();
                        }
                        deferred.resolve(data);
                    });
                    return cb();
                }).catch(function (err) {
                  // DO not call logout - this force session invalidation, which throws away the CSRF token on the server side.
                    //this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

                return deferred.promise;
            },

            logout: function () {
                AuthServerProvider.logout();
                Principal.authenticate(null);
            },

            authorizeUser: function(toStateObject) {
                return Principal.identity(false)
                    .then(function() {
                        var isAuthenticated = Principal.isAuthenticated();
                        var roles = toStateObject.data && toStateObject.data.roles;

                        if (roles && roles.length > 0 && !Principal.isInAnyRole(roles)) {
                            if (isAuthenticated) {
                                // user is signed in but not authorized for desired state
                                return $state.target('accessdenied');
                            }
                            else {
                                // user is not authenticated. stow the state they wanted before you
                                // send them to the signin state, so you can return them when you're done
                                $rootScope.returnToState = toStateObject.name;
                                $rootScope.returnToStateParams = toStateObject.params;

                                // now, send them to the signin state so they can log in
                                return $state.target('login');
                            }
                        }
                        if (isAuthenticated && toStateObject.name === 'login') {
                          var newState = $rootScope.returnToState;
                          if (angular.isString(newState)) {
                            console.log("returnToState defined ", newState, $rootScope.returnToStateParams);
                            delete $rootScope.returnToState;
                            return $state.target(newState, $rootScope.returnToStateParams);
                          } else {
                            console.log('redirect to home');
                            return $state.target('home');
                          }
                        }
                        // Allow to progress
                        return true;
                    });
            },
            createAccount: function (account, callback) {
                var cb = callback || angular.noop;

                return Register.save(account,
                    function () {
                        return cb(account);
                    },
                    function (err) {
                        this.logout();
                        return cb(err);
                    }.bind(this)).$promise;
            },

            updateAccount: function (account, callback) {
                var cb = callback || angular.noop;

                return Account.save(account,
                    function () {
                        return cb(account);
                    },
                    function (err) {
                        return cb(err);
                    }.bind(this)).$promise;
            },

            activateAccount: function (key, callback) {
                var cb = callback || angular.noop;

                return Activate.get(key,
                    function (response) {
                        return cb(response);
                    },
                    function (err) {
                        return cb(err);
                    }.bind(this)).$promise;
            },

            changePassword: function (newPassword, callback) {
                var cb = callback || angular.noop;

                return Password.save(newPassword, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            },

            resetPasswordInit: function (mail, callback) {
                var cb = callback || angular.noop;

                return PasswordResetInit.save(mail, function() {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            },

            resetPasswordFinish: function(keyAndPassword, callback) {
                var cb = callback || angular.noop;

                return PasswordResetFinish.save(keyAndPassword, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .factory('Principal', function($q, Account) {
        var _identity,
            _authenticated = false;

        return {
            isIdentityResolved: function () {
                return angular.isDefined(_identity);
            },
            isAuthenticated: function () {
                return _authenticated;
            },
            isInRole: function (role) {
                if (!_authenticated || !_identity || !_identity.authorities) {
                    return false;
                }

                return _identity.authorities.indexOf(role) !== -1;
            },
            isInAnyRole: function (roles) {
                if (!_authenticated || !_identity.authorities) {
                    return false;
                }

                for (var i = 0; i < roles.length; i++) {
                    if (this.isInRole(roles[i])) {
                        return true;
                    }
                }

                return false;
            },
            authenticate: function (identity) {
                _identity = identity;
                _authenticated = identity !== null;
            },
            identity: function (force) {
                var deferred = $q.defer();

                if (force === true) {
                    _identity = undefined;
                }

                // check and see if we have retrieved the identity data from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    deferred.resolve(_identity);

                    return deferred.promise;
                }

                // retrieve the identity data from the server, update the identity object, and then resolve.
                Account.get().$promise
                    .then(function (account) {
                        _identity = account.data;
                        _authenticated = true;
                        deferred.resolve(_identity);
                    })
                    .catch(function() {
                        _identity = null;
                        _authenticated = false;
                        deferred.resolve(_identity);
                    });
                return deferred.promise;
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .directive('hasAnyRole', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = Principal.isInAnyRole(roles);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    },
                    roles = attrs.hasAnyRole.replace(/\s+/g, '').split(',');

                if (roles.length > 0) {
                    defineVisibility(true);
                }
            }
        };
    }])
    .directive('hasRole', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {
                        var result, idx;
                        if (reset) {
                            setVisible();
                        }
                        for (idx in roles) {
                          if (Principal.isInRole(roles[idx])) {
                            setVisible();
                            return;
                          }
                        }
                        setHidden();
                    },
                    roles = attrs.hasRole.replace(/\s+/g, '').split(',');

                if (roles.length > 0) {
                    defineVisibility(true);
                }
            }
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Account', function($resource) {
        return $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    });

'use strict';

angular.module('dodomaApp')
    .factory('Activate', function ($resource) {
        return $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });
    });



'use strict';

angular.module('dodomaApp')
    .factory('Password', function ($resource) {
        return $resource('api/account/change-password', {}, {
            'save': {
                method: 'POST',
                headers: {'Content-Type': 'text/plain'},
                transformRequest: function(data) {
                    return data;
                }
            }
        })
    });

angular.module('dodomaApp')
    .factory('PasswordResetInit', function ($resource) {
        return $resource('api/account/reset-password/init', {}, {
            'save': {
                method: 'POST',
                headers: {'Content-Type': 'text/plain'},
                transformRequest: function(data) {
                    return data;
                }
            }
        })
    });

angular.module('dodomaApp')
    .factory('PasswordResetFinish', function ($resource) {
        return $resource('api/account/reset-password/finish', {}, {
        })
    });

'use strict';

angular.module('dodomaApp')
    .factory('Register', function ($resource) {
        return $resource('api/register', {}, {
        });
    });



/* globals $ */
'use strict';

angular.module('dodomaApp')
    .directive('showValidation', function() {
        return {
            restrict: 'A',
            require: 'form',
            link: function (scope, element) {
                element.find('.form-group').each(function() {
                    var $formGroup = $(this);
                    var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                    if ($inputs.length > 0) {
                        $inputs.each(function() {
                            var $input = $(this);
                            scope.$watch(function() {
                                return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                            }, function(isInvalid) {
                                $formGroup.toggleClass('has-error', isInvalid);
                            });
                        });
                    }
                });
            }
        };
    });

/* globals $ */
'use strict';

angular.module('dodomaApp')
    .directive('dodomaAppPager', function() {
        return {
            templateUrl: 'scripts/components/form/pager.html'
        };
    });

/* globals $ */
'use strict';

angular.module('dodomaApp')
    .directive('dodomaAppPagination', function() {
        return {
            templateUrl: 'scripts/components/form/pagination.html'
        };
    });

'use strict';
(function() { 
  angular.module('dodomaApp')
    .directive('dodomaNavigation', function() {
      return {
        restrict: 'E',
        scope: {
          pageInfo : '=',
          event: '@',
          callbackFn: '&'
        },
        templateUrl: 'scripts/components/form/navigation.directive.html',
        controller: function ($scope) {
          $scope.onLoadPage = function() {
            if ($scope.callbackFn) {
              $scope.callbackFn({ 'page': $scope.pageInfo.currentPageNumber });
              if ($scope.event) {
                console.log('callback-fn specified, the event wont be delivered:', $scope.event);
              }
            } else if ($scope.event) {
              $scope.$emit($scope.event, $scope.pageInfo.currentPageNumber);
            } else {
              console.log("Neither callbackFn nor event not defined!", $scope);
            }
          }
        }
      };
    }
  );
})();
'use strict';

angular.module('dodomaApp')
    .factory('Language', function ($q, $translate, LANGUAGES) {
        return {
            getCurrent: function () {
                var deferred = $q.defer();
                var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

                if (angular.isUndefined(language)) {
                    language = 'hu';
                }

                deferred.resolve(language);
                return deferred.promise;
            },
            getAll: function () {
                var deferred = $q.defer();
                deferred.resolve(LANGUAGES);
                return deferred.promise;
            }
        };
    })

/*
 Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 They are written in English to avoid character encoding issues (not a perfect solution)
 */
    .constant('LANGUAGES', [
        'en'
        ,'hu'
        //JHipster will add new languages here
    ]
);





'use strict';

angular.module('dodomaApp')
    .controller('LanguageController', function ($scope, $translate, Language, tmhDynamicLocale) {
        $scope.changeLanguage = function (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        };

        Language.getAll().then(function (languages) {
            $scope.languages = languages;
        });
    })
    .filter('findLanguageFromKey', function () {
        return function (lang) {
            return {
                "en": "English",
                "fr": "Français",
                "de": "Deutsch",
                "it": "Italiano",
                "ru": "Русский",
                "tr": "Türkçe",
                "ca": "Català",
                "da": "Dansk",
                "es": "Español",
                "hu": "Magyar",
                "ja": "日本語",
                "kr": "한국어",
                "pl": "Polski",
                "pt-br": "Português (Brasil)",
                "ro": "Română",
                "sv": "Svenska",
                "zh-cn": "中文（简体）",
                "zh-tw": "繁體中文",
            }[lang];
        }
    });

'use strict';

angular.module('dodomaApp')
  .factory('AuditsService', function($http, DateUtils) {
    return {
      findAll: function() {
        return $http.get('management/audits').then(function(response) {
          return response.data;
        });
      },
      findByDates: function(fromDate, toDate) {
        return $http.get('management/audits', { params: { 
          fromDate: DateUtils.convertLocaleDateToServer(fromDate), 
          toDate: DateUtils.convertLocaleDateToServer(toDate) } 
        }).then(function(response) {
          return response.data;
        });
      }
    };
  });

'use strict';

angular.module('dodomaApp')
    .factory('LogsService', function ($resource) {
        return $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });
    });

'use strict';

angular.module('dodomaApp')
    .factory('Authority', function ($resource) {
        return $resource('api/authorities/:name', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    });

'use strict';

angular.module('dodomaApp')
    .factory('UserManagement', function ($resource) {
        return $resource('api/userManagement/:id', {}, {
                'query': {method: 'GET', isArray: false},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                'update': { method:'PUT' }
            });
        });

'use strict';

angular.module('dodomaApp')
    .factory('ConfigurationService', function ($rootScope, $filter, $http) {
        return {
            get: function() {
                return $http.get('configprops').then(function (response) {
                    var properties = [];
                    angular.forEach(response.data, function (data) {
                        properties.push(data);
                    });
                    var orderBy = $filter('orderBy');
                    return orderBy(properties, 'prefix');
                });
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .factory('MonitoringService', function ($rootScope, $http) {
        return {
            getMetrics: function () {
                return $http.get('metrics/metrics').then(function (response) {
                    return response.data;
                });
            },

            checkHealth: function () {
                return $http.get('health').then(function (response) {
                    return response.data;
                });
            },

            threadDump: function () {
                return $http.get('dump').then(function (response) {
                    return response.data;
                });
            },

            clearCaches: function() {
              return $http.get('api/admin/clearCaches').then(function (response) {
                    return response.data;
              });
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .directive('activeMenu', function($translate, tmhDynamicLocale) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var language = attrs.activeMenu;

                scope.$watch(function() {
                    return $translate.use();
                }, function(selectedLanguage) {
                    if (language === selectedLanguage) {
                        tmhDynamicLocale.set(language);
                        element.addClass('active');
                    } else {
                        element.removeClass('active');
                    }
                });
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .controller('NavbarController', function ($scope, $state, Auth, Principal) {
        $scope.isAuthenticated = Principal.isAuthenticated;
        $scope.$state = $state;

        $scope.logout = function () {
            Auth.logout();
            $state.go('home');
        };
        $scope.adminRole = function() {
          return Principal.isInRole('ROLE_ADMIN');
        };
        
        $scope.sysAdminRole = function() {
          return Principal.isInRole('ROLE_SYSADMIN');
        };
        
        $scope.showAdminMenu = function() {
          return $scope.adminRole() && !$scope.sysAdminRole();
        };

    });

'use strict';

angular.module('dodomaApp')
    .factory('User', function ($resource) {
        return $resource('api/users/:login', {}, {
                'query': {method: 'GET', isArray: false},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                },
                'find' : { method: 'GET', url: 'api/users/find'}
            });
        });

'use strict';

angular.module('dodomaApp')
    .filter('characters', function () {
        return function (input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        };
    })
    .filter('words', function () {
        return function (input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        };
    });

/* global $ */
(function () {
  'use strict';

  angular
    .module('dodomaApp')
    .filter('dodTime', ['$filter', function($filter) {
      return function timeFormat(date) {
        return $filter('date')(date, 'yyyy-MM-dd HH:mm');
      };
    }])
    .filter('justIsoDate', function() {
      return function amDateFormatFunction(date) {
          // This can be a string, like: 2022-10-18T20:20:53.059Z
          if (typeof(date) == "string") {
            date = new Date(Date.parse(date));
          }
        // convert the date to 'yyyy-MM-dd' format
        return new Intl.DateTimeFormat('en-CA', {
          year: 'numeric', 
          month: '2-digit',
          day: '2-digit' 
        }).format(date);
      };
    })
    ;
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .service('DateUtils', function() {
      var currentLocale = 'hu';
      var timeFormat = new Intl.DateTimeFormat("fr-CA", {year: "numeric", month: "2-digit", day: "2-digit"});
      function convertLocaleDateToServer(date) {
        if (date) {
          // This can be a string, like: 2022-10-18T20:20:53.059Z
          if (typeof(date) == "string") {
            date = new Date(Date.parse(date));
          }
          // convert the date to 'yyyy-MM-dd' format
          return timeFormat.format(date);
        } else {
          return null;
        }
      };
      this.convertLocaleDateToServer = convertLocaleDateToServer;
      this.convertLocaleDateFromServer = function(date) {
        if (date) {
          // handle full date times, where the date is formatted as 2015-07-26T22:00:00.000Z
          var dateString = date.split('T')[0].split('-');
          return new Date(dateString[0], dateString[1] - 1, dateString[2]);
        }
        return null;
      };
      this.getMonthName = function(month) {
        var d = new Date(0);
        d.setUTCMonth(month - 1);
        return new Intl.DateTimeFormat(currentLocale, { month: 'long' }).format(d);
      }

      this.convertDateTimeFromServer = function(date) {
        if (date) {
          return new Date(date);
        } else {
          return null;
        }
      };
      function getRelativeDay(numberOfDays) {
        var d = new Date();
        d.setDate(d.getDate() + numberOfDays);
        return d;
      };
      this.getRelativeDay = getRelativeDay;
      this.todayAsString = function() {
        return convertLocaleDateToServer(new Date());
      };
      this.tomorrowAsString = function() {
        return convertLocaleDateToServer(getRelativeDay(1));
      };
      this.setCurrentLocale = function(newLocale) {
        currentLocale = newLocale;
      };
    });
})();

(function () {
    'use strict';
    angular
        .module('dodomaApp')
        .service('CollectionUtil', function () {
            return {

                find: function (list, predicate) {
                    if (!angular.isArray(list) || (angular.isArray(list) && list.length === 0)) {
                        return null;
                    }
                    var i = 0;

                    do {
                        if (predicate(list[i]) === true) {
                            return list[i];
                        }
                    } while (i++ < list.length - 1);
                    return null;
                },

                filter: function(list, predicate) {
                    if (!angular.isArray(list) || (angular.isArray(list) && list.length === 0)) {
                        return [];
                    }

                    var res = [],
                        i = 0;
                    do {
                        if (predicate(list[i]) === true) {
                            res.push(list[i]);
                        }
                    } while (++i < list.length);
                    return res;
                },

                findByField: function (list, field, value) {
                    return this.find(list, function (item) {
                        return item && item.hasOwnProperty(field) && item[field] === value;
                    });
                },
                
                findIndexByField: function (list, field, value) {
                  var item = this.findByField(list, field, value);
                  return item ? list.indexOf(item) : undefined;
                },
                
                remove: function(list, value) {
                  if (angular.isArray(list)) {
                    var idx = list.indexOf(value);
                    if (idx >= 0) {
                      list.splice(idx, 1);
                    }
                  }
                },

                removeByField: function(list, field, value) {
                  var idx = this.findIndexByField(list, field, value);
                  if (idx >= 0) {
                      list.splice(idx, 1);
                  }      
                },
                
                updateOrInsertByField: function(list, field, value, newObj) {
                  var item = this.findByField(list, field, value);
                  if (item === null) {
                    list.push(newObj);
                  } else {
                    list[list.indexOf(item)] = newObj;
                  }
                }
            };
        });
})();
/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .service('historyRecords', ['$state', '$window','$rootScope', function($state, $window,$rootScope ) {

      var skipHistory = false;
      var previousStates = [];

      $rootScope.$on("$stateChangeSuccess",  function(event, toState, toParams, fromState, fromParams) {
          // to be used for back button //won't work when page is reloaded.
        if (skipHistory) {
          skipHistory = false;
          return;
        }
        if (!angular.isDefined(fromState.onEnter)) {
          // heuristic, if onEnter is defined, it's a modal dialog ...'
          previousStates.push( {name :fromState.name,params : fromParams});
        } else {
          console.log('skip from history:', fromState);
        }
        
      });

      return {
        backStep : function() {
          if (previousStates.length > 0) {
            var destState = previousStates.pop();
            skipHistory = true;
            $state.go(destState.name, destState.params);
          } else {
            console.log('history is empty - go up :-/');
            $state.go('^');
            //$window.history.back();
          }
        },
        returnToPrevious : function() {
          if (previousStates.length > 0) {
            var destState = previousStates[previousStates.length - 1];
            skipHistory = true;
            $state.go(destState.name, destState.params);
          }
        }
      };

    }]);
})();

'use strict';

angular.module('dodomaApp')
    .service('ParseLinks', function () {
        this.parse = function (header) {
            if (header.length == 0) {
                throw new Error("input must not be of zero length");
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length != 2) {
                    throw new Error("section could not be split on ';'");
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString['page'];
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    });

(function() {
  'use strict';
  angular
    .module('dodomaApp')
    .service('RequestUtil', function() {
      return {
        createLink: function(basePath, keyValues, transformer) {
          var s = basePath;
          angular.forEach(keyValues, function(value, key) {
            if (value) {
              if (transformer) {
                value = transformer(key, value);
              }
              if (value) {
                s += key + '=' + encodeURIComponent(value) + '&';
              }
            }
          });
          return s;
        }
      }
    });
})();
/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .service('StorageUtil', ['localStorageService', function (localStorageService) {
        this.getFilterStatus = function(name) {
            var storedValue = localStorageService.get(name);
            if (storedValue) {
                return angular.extend({filter:{}, customFilter:{}}, angular.fromJson(storedValue));
            } else {
                var defaultValue = {filter:{}, customFilter:{}};
                localStorageService.set(name, angular.toJson(defaultValue));
                return defaultValue;
            }
        };
        this.setupFilters = function(name, scope, defFilter) {
            var p;
            var storedValue = localStorageService.get(name);
            if (storedValue) {
                p = angular.extend(defFilter || {filter:{}, customFilter:{}}, angular.fromJson(storedValue));
            } else {
                p = defFilter || {filter:{}, customFilter:{}};
                localStorageService.set(name, angular.toJson(p));
            }
            scope.filter = p.filter;
            scope.customFilter = p.customFilter;
        }
    }]);
})();

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('account', {
                abstract: true,
                parent: 'site'
            });
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('activate', {
                parent: 'account',
                url: '/activate?key',
                data: {
                    roles: [],
                    pageTitle: 'activate.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/activate/activate.html',
                        controller: 'ActivationController'
                    }
                }
            });
    });


'use strict';

angular.module('dodomaApp')
    .controller('ActivationController', function ($scope, $stateParams, Auth) {
        Auth.activateAccount({key: $stateParams.key}).then(function () {
            $scope.error = null;
            $scope.success = 'OK';
        }).catch(function () {
            $scope.success = null;
            $scope.error = 'ERROR';
        });
    });


'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('login', {
                parent: 'account',
                url: '/login',
                data: {
                    roles: [], 
                    pageTitle: 'login.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/login/login.html',
                        controller: 'LoginController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('LoginController', function ($rootScope, $scope, $state, $timeout, Auth) {
        $scope.user = {};
        $scope.errors = {};

        $scope.rememberMe = true;
        $timeout(function (){angular.element('[ng-model="username"]').triggerHandler( "focus" );});
        $scope.login = function (event) {
            event.preventDefault();
            Auth.login({
                username: $scope.username,
                password: $scope.password,
                rememberMe: $scope.rememberMe
            }).then(function () {
                $scope.authenticationError = false;
                if ($rootScope.previousStateName === 'register') {
                    $state.go('home');
                } else {
                    $rootScope.back();
                }
            }).catch(function () {
                $scope.authenticationError = true;
            });
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('logout', {
                parent: 'account',
                url: '/logout',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/main/main.html',
                        controller: 'LogoutController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('LogoutController', function (Auth) {
        Auth.logout();
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('password', {
                parent: 'account',
                url: '/password',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.password'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/password/password.html',
                        controller: 'PasswordController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('PasswordController', function ($scope, Auth, Principal) {
        Principal.identity().then(function(account) {
            $scope.account = account;
        });

        $scope.success = null;
        $scope.error = null;
        $scope.doNotMatch = null;
        $scope.changePassword = function () {
            if ($scope.password !== $scope.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                $scope.doNotMatch = null;
                Auth.changePassword($scope.password).then(function () {
                    $scope.error = null;
                    $scope.success = 'OK';
                }).catch(function () {
                    $scope.success = null;
                    $scope.error = 'ERROR';
                });
            }
        };
    });

/* globals $ */
'use strict';

angular.module('dodomaApp')
    .directive('passwordStrengthBar', function () {
        return {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            link: function (scope, iElement, attr) {
                var strength = {
                    colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                    mesureStrength: function (p) {

                        var _force = 0;
                        var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                        var _lowerLetters = /[a-z]+/.test(p);
                        var _upperLetters = /[A-Z]+/.test(p);
                        var _numbers = /[0-9]+/.test(p);
                        var _symbols = _regex.test(p);

                        var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                        var _passedMatches = $.grep(_flags, function (el) {
                            return el === true;
                        }).length;

                        _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                        _force += _passedMatches * 10;

                        // penality (short password)
                        _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                        // penality (poor variety of characters)
                        _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                        _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                        _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                        return _force;

                    },
                    getColor: function (s) {

                        var idx = 0;
                        if (s <= 10) {
                            idx = 0;
                        }
                        else if (s <= 20) {
                            idx = 1;
                        }
                        else if (s <= 30) {
                            idx = 2;
                        }
                        else if (s <= 40) {
                            idx = 3;
                        }
                        else {
                            idx = 4;
                        }

                        return { idx: idx + 1, col: this.colors[idx] };
                    }
                };
                scope.$watch(attr.passwordToCheck, function (password) {
                    if (password) {
                        var c = strength.getColor(strength.mesureStrength(password));
                        iElement.removeClass('ng-hide');
                        iElement.find('ul').children('li')
                            .css({ 'background': '#DDD' })
                            .slice(0, c.idx)
                            .css({ 'background': c.col });
                    }
                });
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('register', {
                parent: 'account',
                url: '/register',
                data: {
                    roles: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/register/register.html',
                        controller: 'RegisterController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('RegisterController', function ($scope, $translate, $timeout, Auth) {
        $scope.success = null;
        $scope.error = null;
        $scope.doNotMatch = null;
        $scope.errorUserExists = null;
        $scope.registerAccount = {};
        $timeout(function (){angular.element('[ng-model="registerAccount.login"]').triggerHandler("focus");});

        $scope.register = function () {
            if ($scope.registerAccount.password !== $scope.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                $scope.registerAccount.langKey = $translate.use();
                $scope.doNotMatch = null;
                $scope.error = null;
                $scope.errorUserExists = null;
                $scope.errorEmailExists = null;

                Auth.createAccount($scope.registerAccount).then(function () {
                    $scope.success = 'OK';
                }).catch(function (response) {
                    $scope.success = null;
                    if (response.status === 400 && response.data.message && response.data.message === 'login.already.in.use') {
                        $scope.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data.message && response.data.message === 'email.address.already.in.use') {
                        $scope.errorEmailExists = 'ERROR';
                    } else {
                        $scope.error = 'ERROR';
                    }
                });
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('settings', {
                parent: 'account',
                url: '/settings',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.settings'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/settings/settings.html',
                        controller: 'SettingsController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('SettingsController', function ($scope, Principal, Auth, Language, $translate) {
        $scope.success = null;
        $scope.error = null;
        Principal.identity(true).then(function(account) {
            $scope.settingsAccount = account;
        });

        $scope.save = function () {
            Auth.updateAccount($scope.settingsAccount).then(function() {
                $scope.error = null;
                $scope.success = 'OK';
                Principal.identity().then(function(account) {
                    $scope.settingsAccount = account;
                });
                Language.getCurrent().then(function(current) {
                    if ($scope.settingsAccount.langKey !== current) {
                        $translate.use($scope.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                $scope.success = null;
                $scope.error = 'ERROR';
            });
        };
    });

'use strict';

angular.module('dodomaApp')
    .controller('ResetFinishController', function ($scope, $stateParams, $timeout, Auth) {

        $scope.keyMissing = $stateParams.key === undefined;
        $scope.doNotMatch = null;

        $scope.resetAccount = {};
        $timeout(function (){angular.element('[ng-model="resetAccount.password"]').triggerHandler("focus");});

        $scope.finishReset = function() {
            if ($scope.resetAccount.password !== $scope.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: $scope.resetAccount.password}).then(function () {
                    $scope.success = 'OK';
                }).catch(function (response) {
                    $scope.success = null;
                    $scope.error = 'ERROR';

                });
            }

        };
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('finishReset', {
                parent: 'account',
                url: '/reset/finish?key',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/reset/finish/reset.finish.html',
                        controller: 'ResetFinishController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('RequestResetController', function ($rootScope, $scope, $state, $timeout, Auth) {

        $scope.success = null;
        $scope.error = null;
        $scope.errorEmailNotExists = null;
        $scope.resetAccount = {};
        $timeout(function (){angular.element('[ng-model="resetAccount.email"]').triggerHandler("focus");});

        $scope.requestReset = function () {

            $scope.error = null;
            $scope.errorEmailNotExists = null;

            Auth.resetPasswordInit($scope.resetAccount.email).then(function () {
                $scope.success = 'OK';
            }).catch(function (response) {
                $scope.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    $scope.errorEmailNotExists = 'ERROR';
                } else {
                    $scope.error = 'ERROR';
                }
            });
        }

    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('requestReset', {
                parent: 'account',
                url: '/reset/request',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/reset/request/reset.request.html',
                        controller: 'RequestResetController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                parent: 'site'
            });
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('audits', {
                parent: 'admin',
                url: '/audits',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'audits.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/audits/audits.html',
                        controller: 'AuditsController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('AuditsController', function ($scope, $filter, AuditsService) {
        $scope.onChangeDate = function () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')($scope.fromDate, dateFormat);
            var toDate = $filter('date')($scope.toDate, dateFormat);

            AuditsService.findByDates(fromDate, toDate).then(function (data) {
                $scope.audits = data;
            });
        };

        // Date picker configuration
        $scope.today = function () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            $scope.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        };

        $scope.previousMonth = function () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 0, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            $scope.fromDate = fromDate;
        };

        $scope.today();
        $scope.previousMonth();
        $scope.onChangeDate();
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('configuration', {
                parent: 'admin',
                url: '/configuration',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'configuration.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/configuration/configuration.html',
                        controller: 'ConfigurationController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('ConfigurationController', function ($scope, ConfigurationService) {
        ConfigurationService.get().then(function(configuration) {
            $scope.configuration = configuration;
        });
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('docs', {
                parent: 'admin',
                url: '/docs',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'global.menu.admin.apidocs'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/docs/docs.html'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('health', {
                parent: 'admin',
                url: '/health',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'health.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/health/health.html',
                        controller: 'HealthController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('HealthController', function ($scope, MonitoringService) {
        $scope.updatingHealth = true;
        $scope.separator = '.';

        $scope.refresh = function () {
            $scope.updatingHealth = true;
            MonitoringService.checkHealth().then(function (response) {
                $scope.healthData = $scope.transformHealthData(response);
                $scope.updatingHealth = false;
            }, function (response) {
                $scope.healthData =  $scope.transformHealthData(response.data);
                $scope.updatingHealth = false;
            });
        };

        $scope.refresh();

        $scope.getLabelClass = function (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        };

        $scope.transformHealthData = function (data) {
            var response = [];
            $scope.flattenHealthData(response, null, data);
            return response;
        };

        $scope.flattenHealthData = function (result, path, data) {
            angular.forEach(data, function (value, key) {
                if ($scope.isHealthObject(value)) {
                    if ($scope.hasSubSystem(value)) {
                        $scope.addHealthObject(result, false, value, $scope.getModuleName(path, key));
                        $scope.flattenHealthData(result, $scope.getModuleName(path, key), value);
                    } else {
                        $scope.addHealthObject(result, true, value, $scope.getModuleName(path, key));
                    }
                }
            });
            return result;
        };

        $scope.getModuleName = function (path, name) {
            var result;
            if (path && name) {
                result = path + $scope.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        };


        $scope.showHealth = function (health) {
            $scope.currentHealth = health;
            $('#showHealthModal').modal('show');
        };

        $scope.addHealthObject = function (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!$scope.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        };

        $scope.hasSubSystem = function (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        };

        $scope.isHealthObject = function (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        };

        $scope.baseName = function (name) {
            if (name) {
              var split = name.split('.');
              return split[0];
            }
        };

        $scope.subSystemName = function (name) {
            if (name) {
              var split = name.split('.');
              split.splice(0, 1);
              var remainder = split.join('.');
              return remainder ? ' - ' + remainder : '';
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('logs', {
                parent: 'admin',
                url: '/logs',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'logs.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/logs/logs.html',
                        controller: 'LogsController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('LogsController', function ($scope, LogsService) {
        $scope.loggers = LogsService.findAll();

        $scope.changeLevel = function (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                $scope.loggers = LogsService.findAll();
            });
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('metrics', {
                parent: 'admin',
                url: '/metrics',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'metrics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/metrics/metrics.html',
                        controller: 'MetricsController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('MetricsController', function ($scope, MonitoringService) {
        $scope.metrics = {};
        $scope.updatingMetrics = true;

        $scope.refresh = function () {
            $scope.updatingMetrics = true;
            MonitoringService.getMetrics().then(function (promise) {
                $scope.metrics = promise;
                $scope.updatingMetrics = false;
            }, function (promise) {
                $scope.metrics = promise.data;
                $scope.updatingMetrics = false;
            });
        };

        $scope.$watch('metrics', function (newValue) {
            $scope.servicesStats = {};
            $scope.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    $scope.servicesStats[key] = value;
                }

                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    $scope.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        $scope.clearCaches = function() {
          MonitoringService.clearCaches().then(function(result) {
            $scope.refresh();
          });
        };

        $scope.refresh();

        $scope.refreshThreadDumpData = function () {
            MonitoringService.threadDump().then(function (data) {
                $scope.threadDump = data;

                $scope.threadDumpRunnable = 0;
                $scope.threadDumpWaiting = 0;
                $scope.threadDumpTimedWaiting = 0;
                $scope.threadDumpBlocked = 0;

                angular.forEach(data, function (value) {
                    if (value.threadState === 'RUNNABLE') {
                        $scope.threadDumpRunnable += 1;
                    } else if (value.threadState === 'WAITING') {
                        $scope.threadDumpWaiting += 1;
                    } else if (value.threadState === 'TIMED_WAITING') {
                        $scope.threadDumpTimedWaiting += 1;
                    } else if (value.threadState === 'BLOCKED') {
                        $scope.threadDumpBlocked += 1;
                    }
                });

                $scope.threadDumpAll = $scope.threadDumpRunnable + $scope.threadDumpWaiting +
                    $scope.threadDumpTimedWaiting + $scope.threadDumpBlocked;

            });
        };

        $scope.getLabelClass = function (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .controller('UserManagementDetailController', function ($scope, $stateParams, UserManagement, Authority) {
        $scope.user = {};
        $scope.load = function (id) {
            UserManagement.get({id: id}, function(result) {
                $scope.user = result;
            });
        };
        $scope.load($stateParams.id);
    });

'use strict';

angular.module('dodomaApp')
    .controller('UserManagementController',
            ['$scope', 'UserManagement', 'Authority', '$translate', 'LANGUAGES', 'CollectionUtil',
            function ($scope, UserManagement, Authority, $translate, LANGUAGES, CollectionUtil) {
        $scope.users = [];
        $scope.authorities = Authority.query();

        $scope.languages = LANGUAGES;

        $scope.page = 1;
        $scope.loadAll = function() {
            UserManagement.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.users = result.entities;
                $scope.pageResult = result;
            });
        };
        
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.setActive = function (user, isActivated) {
            user.activated = isActivated;
            UserManagement.update(user, function () {
                $scope.loadAll();
                $scope.clear();
            });
        };
        
        $scope.authorityName = function(name) {
            return $translate.instant("userManagement.roles."+name);
        };
        $scope.toggleAuthority = function (name) {
            if ($scope.user.authorities) {
                var idx = CollectionUtil.findIndexByField($scope.user.authorities, 'name' ,name);
                if (idx>-1) {
                    $scope.user.authorities.splice(idx, 1);
                } else {
                    $scope.user.authorities.push({name: name});
                }
            }
        };
        $scope.hasAuthority = function(name) {
            return $scope.user && CollectionUtil.findByField($scope.user.authorities, 'name' ,name);
        };

        $scope.showUpdate = function (id) {
          if (angular.isNumber(id)) {
            UserManagement.get({id: id}, function(result) {
                $scope.user = result;
                $('#saveUserModal').modal('show');
            });
          } else {
            $scope.clear();
            $('#saveUserModal').modal('show');
          }
        };

        $scope.save = function () {
            UserManagement.update($scope.user,
                function () {
                    $scope.refresh();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $('#saveUserModal').modal('hide');
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.user = { id: null, login: null, firstName: null, lastName: null, email: null,
                            activated: null, langKey: null, createdBy: null, createdDate: null,
                            lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                            resetKey: null, authorities: null };
            $scope.editForm.$setPristine();
            $scope.editForm.$setUntouched();
        };

    }]);

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('userManagement', {
                parent: 'admin',
                url: '/user-management',
                data: {
                    roles: ['ROLE_SYSADMIN', 'ROLE_ADMIN'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/userManagement/usersManagement.html',
                        controller: 'UserManagementController'
                    }
                }
            })
            .state('userManagementDetail', {
                parent: 'admin',
                url: '/user-management/:id',
                data: {
                    roles: ['ROLE_SYSADMIN', 'ROLE_ADMIN'],
                    pageTitle: 'userManagement.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/userManagement/userManagement-detail.html',
                        controller: 'UserManagementDetailController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
      $stateProvider
      .state('entity', {
          abstract: true,
          parent: 'site'
      })
      .state('rehabManagement', {
          abstract: true,
          parent: 'site'
      })
      .state('stockManagement', {
          abstract: true,
          parent: 'site'
      })
      .state('productionManagement', {
          abstract: true,
          parent: 'site'
      });
    });

'use strict';

angular.module('dodomaApp')
    .controller('ErrorController', ['$scope', '$stateParams', '$translate', '$q', '$translatePartialLoader', function($scope, $stateParams, $translate, $q, $translatePartialLoader) {
        function loadAndTranslate(message) {
            var parts = message.split('.');
            var namespace = parts[0];
            
            var loadPromise = $q.when();
            if (namespace && namespace !== 'error') {
                // Load the translation partial for this namespace (e.g., 'orderPlan')
                $translatePartialLoader.addPart(namespace);
                loadPromise = $translate.refresh();
            }
            
            loadPromise.then(function() {
                return $translate(message);
            }).then(function(translated) {
                $scope.errorMessage = translated;
            }).catch(function() {
                // Fallback if translation key not found
                $scope.errorMessage = message;
            });
        }

        if ($stateParams.message) {
            loadAndTranslate($stateParams.message);
        } else {
            $translate('error.title').then(function(title) {
                $scope.errorMessage = title;
            });
        }
    }])
    .config(function ($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error?message',
                data: {
                    roles: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/error/error.html',
                        controller: 'ErrorController'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'site',
                url: '/accessdenied',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            });
    });
'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('home', {
                parent: 'site',
                url: '/',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/main/main.html',
                        controller: 'MainController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('MainController', function ($scope, Principal) {
        Principal.identity().then(function(account) {
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;
        });
    });

'use strict';

angular.module('dodomaApp')
    .factory('Sessions', function ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    });




'use strict';

angular.module('dodomaApp')
    .factory('AuthServerProvider', function loginService($http, localStorageService) {
        return {
            login: function(credentials) {
                var data = 'username=' + encodeURIComponent(credentials.username) +
                    '&password=' + encodeURIComponent(credentials.password) +
                    '&remember-me=' + credentials.rememberMe + '&submit=Login';
                return $http.post('api/authentication', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                });
            },
            logout: function() {
                // logout from the server
                $http.post('api/logout').then(function (response) {
                    localStorageService.clearAll();
                    // to get a new csrf token call the api
                    $http.get('api/account');
                    return response;
                });
            },
            getToken: function () {
                var token = localStorageService.get('token');
                return token;
            },
            hasValidToken: function () {
                var token = this.getToken();
                return !!token;
            }
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('rehab', {
                parent: 'rehabManagement',
                url: '/rehab',
                data: {
                    roles: ['ROLE_REHABMANAGER'],
                    pageTitle: 'dodomaApp.rehab.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/rehab/rehab.html',
                        controller: 'MainController'
                    }
                }
            })
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('errorHandlerInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {
        return {
            'responseError': function (response) {
                $rootScope.$emit('httpError', response);
                return $q.reject(response);
            }
        };
    }]);

(function () {
    'use strict';

    angular.module('dodomaApp').directive('errorDisplay', ['$rootScope', '$translate', function ($rootScope, $translate) {
        return {
            restrict: 'E',
            templateUrl: 'scripts/components/errorhandler/errorDisplay.html',
            controller: function ($scope) {
                $scope.alerts = $scope.alerts || [];
                $scope.collapsed = true;

                $scope.closeAlert = function (index) {
                    $scope.alerts.splice(index, 1);
                };

                function updateCollapsed() {
                  $scope.collapsed = $scope.collapsed = $scope.alerts.length === 0;
                };
                function clearAlerts() {
                  $scope.alerts.length = 0;
                  updateCollapsed();
                };
                
                var cleanupStateChangeListener = $rootScope.$on('$stateChangeSuccess', clearAlerts);

                var cleanHttpErrorListener = $rootScope.$on('httpError', function (event, httpResponse) {
                    var i;
                    clearAlerts();

                    switch (httpResponse.status) {
                        // connection refused, server not reachable
                        case 0:
                            $translate('error.serverNotReachable').then($scope.addAlert);
                            break;

                        case 400:
                            if (httpResponse.data && httpResponse.data.fieldErrors) {
                                for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                                    var fe = httpResponse.data.fieldErrors[i];
                                    // convert 'requirements[14].part[4].id' to 'requirements[].part[].id'
                                    var convertedField = fe.field.replace(/\[\d*\]/g,"[]");
                                    var fieldName = $translate.instant('error.fieldName.'+convertedField);
                                    $scope.addAlert($translate.instant('error.'+fe.message, {fieldName: fieldName}));
                                }
                            } else if (httpResponse.data && httpResponse.data.message) {
                                if (httpResponse.data.params) {
                                    $scope.addAlert($translate.instant(httpResponse.data.message, httpResponse.data.params));
                                } else {
                                    $scope.addAlert($translate.instant(httpResponse.data.message, httpResponse.data));
                                }
                            } else {
                              $scope.addAlert(httpResponse.data);
                            }
                            break;
                        case 500:
                            if (httpResponse.data) {
                                if (httpResponse.data.detail) {
                                    $scope.addAlert($translate.instant(httpResponse.data.detail, httpResponse.data));
                                } else if (httpResponse.data.message) {
                                    $scope.addAlert($translate.instant(httpResponse.data.message, httpResponse.data.params));
                                }
                            }
                            break;
                        default:
                            if (httpResponse.data && httpResponse.data.message) {
                                $scope.addAlert($translate.instant(httpResponse.data.message));
                            } else {
                                $scope.addAlert(JSON.stringify(httpResponse));
                            }
                    }
                });

                var cleanupCleanErrorsListener = $rootScope.$on('clearErrors', function () {
                    clearAlerts();
                });

                $scope.$on('$destroy', function () {
                    cleanupStateChangeListener();
                    cleanHttpErrorListener();
                    cleanupCleanErrorsListener();
                });

                $scope.addAlert = function (msg, important) {
                    $scope.alerts.push({'type': 'danger', 'msg': msg, 'important': important});
                    updateCollapsed();
                };
            }
        };
    }]);
})();

(function () {
    'use strict';

    angular.module('dodomaApp').directive('notificationDisplay',
        ['$rootScope', '$translate', 'SystemConfiguration', '$timeout', '$state', 'Principal' ,
         function ($rootScope, $translate, SystemConfiguration, $timeout, $state, Principal) {
      return {
        restrict: 'E',
        templateUrl: 'scripts/components/errorhandler/notificationDisplay.html',
        controller: function ($scope) {
          $scope.notifications = [];

          $scope.openNotification = function(notif) {
            var i = $scope.notifications.indexOf(notif);
            if(i != -1) {
              $scope.notifications.splice(i, 1);
            }
            $state.go(notif.linkType, notif.parameters);
          };

          $scope.closeAlert = function (index) {
            $scope.notifications.splice(index, 1);
          };

          var timer;

          function loadNotifications() {
            if (Principal.isAuthenticated()) {
              SystemConfiguration.notifications({}, function(result) {
                $scope.notifications = result;
                angular.forEach($scope.notifications, function(notif) {
                  angular.forEach(notif.parameters, function(value,key) {
                    if (angular.isString(value) && value.startsWith("$tr:")) {
                      value = $translate.instant(value.substring(4));
                      notif.parameters [key] = value;
                    }
                  });
                });

                timer = $timeout(loadNotifications, 600000);
              }, function(error) {
                console.log('error accessing the notifications: ', error);
                timer = $timeout(loadNotifications, 60000);
              });
            } else {
              $scope.notifications = [];
              timer = $timeout(loadNotifications, 60000);
            }
          };

          $scope.$on('$destroy', function() {
            if (timer) {
              $timeout.cancel(timer);
            }
          });

          timer = $timeout(loadNotifications, 5000);
        }
      };
    }]);
})();
'use strict';
/**
 * Configuration keys:
 * placeholderKey : String = the localization key for the placeholder text
 * formatObject : function(object):String = the function which formats the object for displaying
 * loader: function(String, callback(items), attributes) = the loader function which needs to get objects based on the first string parameter
 * objectList : a fixed list or a promise for a list, when the server shouldnt be asked everytime, because the values are never changing.
 */
angular
  .module('dodomaApp')
  .factory('directiveBuilder',
      ['$q', function($q) {
        return function($translate, $rootScope, config) {
          return {
            restrict : 'A', // Attribute
            require : [ 'uiSelect', 'ngModel' ],

            compile : function compile(tElement, tAttrs, transclude) {

              var allowClear = angular.isString (tAttrs.allowClear);

              var multiple = angular.isDefined( tAttrs.multiple );
              // Add the inner content to the element
              tElement
                  .append('<ui-select-match placeholder="{{placeholder}}"'+ (allowClear ? ' allow-clear' : '') + '>{{formatObject('+  (multiple ? '$item' : '$select.selected') +')}}</ui-select-match>\
              <ui-select-choices repeat="item in items" refresh="loadObjects($select.search)" refresh-delay="200">\
                <div ng-bind-html="formatObject(item) | highlight: $select.search"></div>\
              </ui-select-choices>');

              return {
                pre : function preLink(scope, iElement, iAttrs, controller) {},
                post : function postLink(scope, iElement, iAttrs, controller) {
                  scope.placeholder = "";

                  function translatePlaceholder() {
                    $translate(config.placeholderKey).then(function(result) {
                      scope.placeholder = result;
                    });
                  };

                  translatePlaceholder();
                  var unbind = $rootScope.$on('$translateChangeSuccess', translatePlaceholder);
                  scope.$on('$destroy', unbind);

                  scope.item = {};
                  scope.items = [];
                  scope.loadObjects = function(txt) {
                    if (angular.isString(txt) && txt.trim().length > 0) {
                      if (angular.isDefined(config.objectList)) {
                        $q.when(config.objectList).then(function(response) {
                          scope.items = response;
                        });
                      } else {
                        config.loader(txt, function(response) {
                          if (angular.isArray(response)) {
                            scope.items = response;
                          } else {
                            if (angular.isDefined(response.entities)) {
                              scope.items = response.entities;
                            } else {
                              throw new Error('Response is neither an array, nor an object with an "entities" attributes, unable to work!');
                            }
                          }
                        },iAttrs);
                      }
                    } else {
                      scope.items = [];
                    }
                  };
                  var defaultFormatObject = function(obj) {
                    if (obj && obj.name) {
                      return obj.name;
                    }
                    return '';
                  };
                  scope.formatObject = config.formatObject || defaultFormatObject;
                }
              }
            }
          }
        }
}]);

'use strict';

angular.module('dodomaApp').directive('dodomaPart',
    ['$rootScope', '$translate', 'Part',  'directiveBuilder',
    function($rootScope, $translate, Part, directiveBuilder) {

  var canBeBuiltLabel = $translate.instant("dodomaApp.part.canBeBuilt");
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.part',
    loader : function(txt, callback, attrs) {
      var criteria = {
        name: txt,
        includeVirtualPartnerId: null,
        excludeNotPartnerId: null,
        includeInactive: null,
      };

      if (angular.isDefined(attrs.includeVirtualPartnerId)) {
        if (attrs.includeVirtualPartnerId !== "") {
          criteria.includeVirtualPartnerId = attrs.includeVirtualPartnerId;
        }
      }
      if (angular.isDefined(attrs.excludeNotPartnerId)) {
        if (attrs.excludeNotPartnerId !== "") {
          criteria.excludeNotPartnerId = attrs.excludeNotPartnerId;
        }
      }
      if (angular.isDefined(attrs.includeInactive)) {
        if (attrs.includeInactive !== "") {
          criteria.includeInactive = attrs.includeInactive;
        }
      }
      Part.queryMinimal(criteria, callback);
    },
    formatObject : function(obj) {
      if (obj && obj.name) {
        var res = obj.name;
        if (obj.serialNumber) {
          res = res + ' (' + obj.serialNumber + ')';
        }
        if (obj.description) {
          res = res + ' (' + obj.description + ')';
        }
        if (obj.canBeBuilt) {
          res = res + ' ['+ canBeBuiltLabel + ']';
        }
        return res;
      } else {
        return '';
      }
    }
    });
 }
]);
'use strict';

angular.module('dodomaApp').directive('dodomaStock', [ '$rootScope', '$translate', 'Stock',  'directiveBuilder', function($rootScope, $translate, Stock, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.stock',
    loader : function(txt, callback) {
      Stock.query({name : txt}, callback);
    }
    });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaPartner', [ '$rootScope', '$translate', 'Partner',  'directiveBuilder', function($rootScope, $translate, Partner, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.partner',
    loader : function(txt, callback, attrs) {
      var criteria = {
        name: txt,
        customStock: null,
      };
      if (angular.isDefined(attrs.customStock)) {
        criteria.customStock = attrs.customStock; 
      }
      Partner.query(criteria, callback);
    },
    formatObject : function(obj) {
      if (obj && obj.name) {
        var res = obj.name;
        if (obj.email) {
          res = res + ' (' + obj.email + ')';
        }
        return res;
      } else {
        return '';
      }
    }
    });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaPartType', [ '$rootScope', '$translate', 'PartType',  'directiveBuilder', function($rootScope, $translate, PartType, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.partType',
    loader : function(txt, callback) {
      PartType.query({name : txt}, callback);
    }
    });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaProductionVariant',
    [ '$rootScope', '$translate', 'ProductionVariant',  'directiveBuilder',
      function($rootScope, $translate, ProductionVariant, directiveBuilder) {
        var productionVariantLabelDefault = $translate.instant('dodomaApp.productionVariant.default');
        var productionVariantLabelInactive = $translate.instant('dodomaApp.productionVariant.inactive');
        return directiveBuilder($translate, $rootScope, {
          placeholderKey : 'autocomplete.pick.productionVariant',
          loader : function(txt, callback, attrs) {
            var criteria = {
              name : txt,
              includeDefault: true,
              partId: null,
            };
            if (angular.isDefined(attrs.partId)) {
              criteria.partId = attrs.partId;
            }
            if (angular.isDefined(criteria.partId)) {
              ProductionVariant.query(criteria, callback);
            } else {
              console.warn('productionVariant directive: partId is required for loading production variants');
              callback([]);
            }
          },
          formatObject : function(obj) {
            if (obj) {
              var res = '';
              if (obj.name) {
                res = res + obj.name + ' ';
              }
              if (obj.defaultVariant) {
                res = res + '(' + productionVariantLabelDefault + ') ';
              }
              if (!obj.active) {
                res = res + '(' + productionVariantLabelInactive + ') ';
              }
              return res;
            } else {
              return '';
            }
          }
        });
 }
]);
'use strict';

angular.module('dodomaApp').directive('dodomaWorkType', 
    [ '$rootScope', '$translate', 'WorkType',  'directiveBuilder', 
      function($rootScope, $translate, WorkType, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.workType',
    loader : function(txt, callback) {
      WorkType.query({name : txt}, callback);
    }
  });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaWorkStep', 
    [ '$rootScope', '$translate', 'WorkStep',  'directiveBuilder', 
      function($rootScope, $translate, WorkStep, directiveBuilder) {
      
      var inactiveLabel = $translate.instant('dodomaApp.workStep.inactive');
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.workStep',
    loader : function(txt, callback) {
      WorkStep.queryAll({name : txt}, callback);
    },
    formatObject : function(obj) {
      if (obj && obj.name) {
        var res = obj.name;
        if (obj.externalName) {
          res = res + ' (' + obj.externalName + ')';
        }
        if (obj.description) {
          res = res + ' [' + obj.description + ']';
        }
        
        if (!obj.active) {
          res = res + ' [' + inactiveLabel + ']';
        }
        return res;
      } else {
        return '';
      }
    }

  });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaWorker', 
    [ '$rootScope', '$translate', 'Worker',  'directiveBuilder', 
      function($rootScope, $translate, Worker, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.worker',
    loader : function(txt, callback, attrs) {
      var criteria = {
        name : txt,
        module: null,
      };
      if (angular.isDefined(attrs.module)) {
        criteria.module = attrs.module;
      }
      Worker.query(criteria, callback);
    },
    formatObject : function(obj) {
      if (obj) {
        var res = '';
        if (obj.lastName) {
          res = res + obj.lastName + ' ';
        }
        if (obj.firstName) {
          res = res + obj.firstName;
        }
        if (obj.name) {
          res = res + obj.name;
        }
        return res;
      } else {
        return '';
      }
    }
  });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaUserField', 
    [ '$rootScope', '$translate', 'User',  'directiveBuilder', 
      function($rootScope, $translate, User, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.user',
    loader : function(txt, callback) {
      User.find({name : txt}, callback);
    }
  });
 } 
]);
'use strict';

angular
  .module('dodomaApp')
  .directive('dodomaMovementType', [ '$rootScope', '$translate', 'Movement',  'directiveBuilder', 
                                     function($rootScope, $translate, Movement, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
    placeholderKey : 'autocomplete.pick.movementType',
    objectList : Movement.types(),
    formatObject : function(name) {
      // it's a hack ..
      var v = this.$item || name;
      return $translate.instant('dodomaApp.movement.typeLabel.'+v); 
    }
  });
 } 
]);
'use strict';

angular.module('dodomaApp').directive('dodomaOrderPlan', [ '$rootScope', '$translate', 'OrderPlan',  'directiveBuilder', function($rootScope, $translate, OrderPlan, directiveBuilder) {
  return directiveBuilder($translate, $rootScope, {
      placeholderKey : 'autocomplete.pick.orderPlan',
      loader : function(txt, callback) {
        OrderPlan.query({name : txt}, callback);
      },
      formatObject : function(obj) {
          if (obj && obj.name) {
            var res = obj.name;
            if (obj.client) {
              res = res + ' (' + obj.client.name + ')';
            }
            return res;
          } else {
            return '';
          }
        }
    });
 }
]);
'use strict';

angular.module('dodomaApp')
  .directive('backButton', ['$state', '$window','historyRecords', function($state,$window,historyRecords) {
    return {
        restrict: 'E',
        scope: {
            page : '='
        },
        templateUrl: 'scripts/components/templates/backButton.html',
        controller: function ($scope) {
          $scope.goBack = function() {
            if (angular.isString($scope.page)) {
              $state.go($scope.page);
            } else {
              historyRecords.backStep();
            }
          }
        }        
    };
  }]
);

'use strict';

angular.module('dodomaApp')
  .directive('booleanIcon', function() {
    return {
        restrict: 'E',
        scope: {
        	value : '='
        },
        template : '<span ng-class=\'{"fas":true, "fa-check" : value, "fa-times": !value}\'></span>'
    };
  }
);

'use strict';

angular.module('dodomaApp')
  .directive('cellRender', ['$state', function($state) {
    return {
        restrict: 'E',
        scope: {
            cell : '='
        },
        templateUrl: 'scripts/components/templates/cell.html',
        link: function (scope, element, attrs) {
        }
    };
  }]
);

'use strict';

angular.module('dodomaApp')
  .directive('docLink', ['$state', function($state) {
    return {
        restrict: 'E',
        scope: {
            document : '=',
            recordId : '='
        },
        templateUrl: 'scripts/components/templates/docLink.html',
        controller: function ($scope) {
          $scope.getUrl = function (doc) {
            return '/api/workerRecords/'+$scope.recordId + '/documents/' + doc.id + '/' + doc.name;
          };
        }
    };
  }]
);

/* global $ */
(function () {
  'use strict';

  
  
  
  angular.module('dodomaApp')
    .directive('dodField', ['dodomaValidation', function(dodomaValidation) {
      return {
        restrict: 'E',
        // label : the label of the component
        // expr : if expr is specified, then that expression should evaluate to a variable name, for example : expr="'xxx_'+idx" will use workerRecord.params['xxx_'+idx], 
        //   otherwise the model is 'workerRecord.params.(name + suffix) 
        compile: function ($elem, $attr) {
          var label = $attr.label;
          var name = $attr.name;
          var type = $attr.type || 'text';
          var isDate = (type === 'datetime' || type === 'date' || type === 'datetime-local');
          var suffix = (isDate || type ==='number' || type==='checkbox') ? '_'+type.replace('-','_') : '';
          var ngModelDef = angular.isString($attr.expr) ? 'workerRecord.params[' + $attr.expr + ']' : 'workerRecord.params.'+name+suffix;
          var select = type === 'select' || type==='yesno';
          var divClass = angular.isString($attr.size) ? 'col-md-'+$attr.size : 'form-group';
          var hasRequired = angular.isString($attr.required);
          var required= hasRequired ? ' ng-required="'+$attr.required+'" ' : '';
          var html =  '<div class="'+divClass+'">';
          if (isDate) {
            html += '<i class="fa fa-calendar"></i>&nbsp;';
          }
          html += '<label for="cf_'+name+'">'+label+ /*(hasRequired ? '<span class="warning-required">*</span>' : '') +*/ '</label>';
          if (select) {
            var options;
            if (type ==='yesno') {
              options = '<option ng-disabled="readonly" value="yes">Igen</option><option ng-disabled="readonly" value="no">Nem</option>';
            } else {
              var optDoms = $elem.find('option');
              angular.forEach(optDoms, function (optDom) {
                angular.element(optDom).attr('ng-disabled','readonly');
              });
              options = $elem.html();
            }
            html += '<select class="form-control" name="cf_'+name+'" id="cf_'+name+'" ng-model="'+ngModelDef+'" ng-readonly="readonly"'+required+'>' + options + '</select>';
          } else {
            var extraAttributes = '';
            if (isDate) {
              type = 'text';
              extraAttributes = 'bs-datepicker';
            }
            html += '<input class="form-control" name="cf_'+name+'" id="cf_'+name+'" ng-model="'+ngModelDef+'" type="'+type+'" ng-readonly="readonly" '+required+extraAttributes+'>';
          }
          html += '</div>';
          if (select) {
            $elem.children().remove();
          }
          var htmlElement = angular.element(html);
          $elem.append(htmlElement);
          if (hasRequired) {
            var validationDiv = dodomaValidation.displayBlocks('editForm.cf_'+name, {required:true}, htmlElement);
            $elem.append(validationDiv);
          }
        }
      };
    }]);
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('dodCheckbox', function() {
      return {
        restrict: 'E',
        compile: function ($elem, $attr) {
          var label = $attr.label;
          var name = $attr.name;
          var value = $attr.value || 'true';
          var html = '<div class="col-md-6"><input class="xform-control xdodoma-inline-checkbox" type="checkbox" id="chk_'+name+'" ng-disabled="readonly" ng-model="workerRecord.params.'+ name+'" value="'+ value+ '"><label for="chk_'+name+'">' + label + '</label></div>';
          $elem.append(angular.element(html));
        }
      };
    });
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('dodDisplayValue', function() {
      return {
        restrict: 'E',
        compile: function ($elem, $attr) {
          var labelKey = $attr.label;
          var value = angular.isDefined($attr.value) ? '{{' + $attr.value + '}}' : angular.isDefined($attr.boolean) ? '<boolean-icon value="'+$attr.boolean+'"></boolean-icon>' : $attr.custom;
          var html = '<div class="col-sm-6"><label class="col-sm-4" translate="'+labelKey+'">'+labelKey+'</label><p class="col-sm-8 input-sm form-control-static">'+value+'</p>';
          $elem.append(angular.element(html));
        }
      };
    });
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('dodFieldScoring', function() {
      return {
        restrict: 'E',
        compile: function ($elem, $attr) {
          var label = $attr.label;
          var path = $attr.path;
          var labelId = $attr.id;
          var name = $attr.name;
          if (!angular.isString(path)) {
            path = 'workerRecord.params.' + name;
          }
          if (!angular.isString(labelId)) {
            labelId = 'cf_'+name;
          }
          var i=0;
          var html = '<div class="row"><div class="col-md-6"><label for="'+labelId+'">'+label+'</label></div><div class="col-md-6"><div class="btn-group">';
          for (i=1;i<=5;i++) {
            html  += ('<label class="btn btn-success" ng-model="'+path+ '" uib-btn-radio="\''+i+'\'" uncheckable>'+i+'</label>');
          }
          html +=  '</div></div></div>';
          $elem.append(angular.element(html));
        }
      };
    });
})();
/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('dodNewRecord', function() {
      return {
        restrict: 'E',
        templateUrl: 'scripts/components/templates/dodNewRecord.html',
        controller: function ($scope) {
          $scope.newRecord = function() {
            $scope.$emit('dodomaApp:markWritable');
          }
        }
      };
    });
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('dodTable', function($compile) {
      return {
        restrict: 'EA',
        link: function (scope, element, attrs, ctrl) {
          var counter = attrs.counter;
          if (!angular.isString(counter)) {
            throw new Error('counter not specified!');
          }
          if (!counter.endsWith('_number')) {
            counter = counter + '_number';
          }

          var tpl = '<div class="form-group"><div class="table-responsive"><table class="table table-striped"><thead><th></th>';
          angular.forEach(scope.headers, function(header) {
            tpl += '<th>' + header + '</th>';
          });
          tpl += '</thead><tbody><tr ng-repeat="idx in range(getVariable(\''+ counter+ '\',1))">';
          tpl += '<td><button ng-if="$last" type="button" ng-disabled="readonly" class="btn btn-danger" ng-click="incVariable(\''+ counter+'\', -1, 1)"><span class="fas fa-minus-octagon"></span></button></td>'

          angular.forEach(scope.content, function(cnt) {
            tpl += '<td>'+cnt.replace('$$PATH$$', 'workerRecord.params.'+attrs.name+'[idx]' )+'</td>';
          });

          tpl += '</tr><tr><td><button type="button" class="btn btn-default" ng-disabled="readonly" ng-click="incVariable(\''+ counter+'\', 1, 1)"><span class="fas fa-plus-octagon"></span> Új</button></td></tr>';

          tpl += '</tbody></table></div></div>';

          var linkingFn = $compile(tpl);
          var tableElement = linkingFn(scope);
          element.replaceWith(tableElement);

          /*transclude(function(clone, scope) {
            element.find('tbody').append(clone);
          })*/;
        },
        controller: function($scope) {
          $scope.content = [];
          $scope.headers = [];
          this.addContent = function(header,obj) {
            $scope.headers.push(header);
            $scope.content.push(obj);
          }

        }
      };
    });

  angular.module('dodomaApp').directive('dodTableTextField', function() {
    return {
      require: '^dodTable',
      link: function(scope, element, attrs, dodTable) {
        if (attrs.type === 'date') {
          // bs-datepicker type="text"
          dodTable.addContent(attrs.header, '<input bs-datepicker type="text" class="form-control" ng-disabled="readonly" ng-model="$$PATH$$.'+attrs.name+'">');
        } else if (attrs.type === 'area'){
          dodTable.addContent(attrs.header, '<textarea class="form-control" ng-disabled="readonly" msd-elastic="\\n" ng-model="$$PATH$$.'+attrs.name+'"></textarea>');
        } else { 
          dodTable.addContent(attrs.header, '<input type="'+attrs.type+'" class="form-control" ng-disabled="readonly" ng-model="$$PATH$$.'+attrs.name+'">');
        }
      }
    }
  });
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('dodTextarea', function() {
      return {
        restrict: 'E',
        compile: function ($elem, $attr) {
          var label = $attr.label;
          var name = $attr.name;
          var modelDef = angular.isString(name) ? 'workerRecord.params.' + name : 'workerRecord.params[' + $attr.expr + ']';
          var html = '<div class="form-group"><label for="cf_'+name+'">'+label+'</label><textarea class="form-control" name="cf_'+name+'" id="cf_'+name+'" ng-model="'+modelDef+'" ng-maxlength="4096" msd-elastic="\\n" ng-readonly="readonly"></textarea></div>';
          $elem.append(angular.element(html));
        }
      };
    });
})();

'use strict';

angular.module('dodomaApp')
  .directive('downloadButton', ['$window', function($window) {
    return {
        restrict: 'E',
        scope: {
            url : '&',
            size: '@',
            label: '@'
        },
        template : '<a class="btn btn-default {{size}}" ng-click="start()"><span class="fa fa-file-excel-o"></span> <span>{{ (label || "global.export") | translate }}</span></a>',
        controller : function($scope) {
          $scope.start = function() {
            var url = $scope.url();
            $window.open(url, '_blank');
          }
        }
    };
  }]
);

'use strict';

angular.module('dodomaApp')
  .directive('deliveryNoteLink', function() {
    return {
        restrict: 'E',
        scope: {
          deliverynote : '='
        },
        template : '<a class="deliveryNoteLink" ui-sref="deliveryNoteDetail({deliveryNoteId:deliverynote.id})">{{deliverynote.name}}</a>'
    };
  }
);

'use strict';

angular.module('dodomaApp')
  .directive('giveOutLink', function() {
    return {
        restrict: 'E',
        scope: {
          giveout : '='
        },
        template : '<a class="giveOutLink" ui-sref="giveOutDetail({id:giveout.id})">{{giveout.name}}</a>'
    };
  }
);

'use strict';

angular.module('dodomaApp')
  .directive('orderPlanLink', function() {
    return {
        restrict: 'E',
        scope: {
          plan : '='
        },
        template : '<a class="orderPlanLink" ui-sref="orderPlan.detail({orderId:plan.id})">{{plan.name}} ({{plan.client.name}})</a>'
    };
  }
);

'use strict';

angular.module('dodomaApp')
  .directive('partLink', [ "$translate", function($translate) {
    var productionVariantLabelDefault = $translate.instant('dodomaApp.productionVariant.default');
    var productionVariantLabelInactive = $translate.instant('dodomaApp.productionVariant.inactive');

    return {
        restrict: 'E',
        scope: {
                part : '=',
                variant : '='
        },
        template : '<a class="partLink" ui-sref="partDetail({partId:part.id})" href="">{{displayPart(part, variant) | characters:100}}&nbsp;<i ng-if="part.canBeBuilt" class="far fa-industry-alt"></i></a>',
        controller : function($scope) {
          $scope.displayPart = function(part, variant) {
            if (!part) {
              return '';
            }
            var res = part.name;
            if (part.serialNumber) {
              res = res + ' (' + part.serialNumber + ')';
            }
            if (part.description) {
              res = res + ' (' + part.description + ')';
            }
            if (variant) {
              if (variant.name && variant.name !== '') {
                res = res + ' (' + variant.name + ')';
              } else if (variant.defaultVariant) {
                res = res + ' (' + productionVariantLabelDefault + ')';
              }
              if (variant.active === false) {
                res = res + ' (' + productionVariantLabelInactive + ')';
              }
            }
            return res;
          }
        }
    };
  }]
);

'use strict';

angular.module('dodomaApp')
  .directive('partTypeLink', function() {
    return {
        restrict: 'E',
        scope: {
                partType : '='
        },
        template : '<a class="partTypeLink" ui-sref="partTypeDetail({id:partType.id})">{{partType.name}}</a>'
    };
  }
);

'use strict';

angular.module('dodomaApp')
  .directive('partnerLink', function() {
    return {
        restrict: 'E',
        scope: {
                partner : '='
        },
        template : '<a class="partnerLink" ui-sref="partnerDetail({partnerId:partner.id})">{{partner.name}}</a>'
    };
  }
);

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('psivTable', function() {
      return {
        restrict: 'E',
        scope: {
          productionSheetItem : '=',
          detailed : '='
        },
        templateUrl: 'scripts/components/templates/psivTable.html',
      };
    });
})();

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .directive('psivVerifyButton', function() {
      return {
        restrict: 'E',
        scope: {
          productionSheetItem : '='
        },
        templateUrl: 'scripts/components/templates/psivVerifyButton.html'
      };
    });
})();

'use strict';

angular.module('dodomaApp')
  .directive('stockLink', function() {
    return {
        restrict: 'E',
        scope: {
          stock : '='
        },
        template : '<a class="stockLink" ui-sref="stockDetail({id:stock.id})">{{stock.name}}</a>'
    };
  }
);

'use strict';
(function() { 
  angular.module('dodomaApp')
    .directive('mainLayout', function() {
      return {
        restrict: 'E',
        transclude: {
          filter: '?paneFilter',
          main: 'paneMain'
        },
        scope: {
          titleKey : '@',
          titleExpression : '=',
          noFilter: '@'
        },
        templateUrl: 'scripts/components/templates/mainLayout.html',
        controller: function ($scope) {
          $scope.getTitle = function() {
            if (angular.isString($scope.titleKey)) {
              return $scope.titleKey;
            }
            if (angular.isDefined($scope.titleExpression)) {
              return $scope.titleExpression;
            }
          };
        }
      };
    }
  );
})();
'use strict';

angular.module('dodomaApp')
  .directive('uploadList', ['Upload', 'Document', 'CollectionUtil', function(Upload, Document, CollectionUtil) {
    return {
        restrict: 'E',
        scope: {
            documents : '=',
            recordId : '=',
            enable : '='
        },
        templateUrl: 'scripts/components/templates/uploadList.html',
        controller: function ($scope) {
          $scope.message = undefined;
          $scope.progressStatus = undefined;
          $scope.uploadOk = function () {
            return angular.isNumber($scope.recordId);
          };
          $scope.deleteDoc = function(doc) {
            if ($scope.enable) {
              Document.removeDocument({recordId: $scope.recordId, documentId: doc.id}, function(result) {
                CollectionUtil.remove($scope.documents, doc);
                $scope.$emit('dodomaApp:documentListChanged');
              });
            }
          }
          function executeUpload(file) {
            if (!$scope.enable) {
              return;
            }
            if (!angular.isNumber($scope.recordId)) {
              console.log("Error, record not saved!");
              return;
            }
            Upload.upload({
                url: 'api/workerRecords/' + $scope.recordId + '/documents',
                file: file
            }).progress(function (progressEvent) {
              $scope.progressStatus = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            }).success(function(doc) {
              $scope.progressStatus = undefined;
              $scope.documents.push(doc);
              $scope.$emit('dodomaApp:documentListChanged');
            }).error(function(response) {
              $scope.progressStatus = response.statusText;
              $scope.message = 'upload.failed';
            });
          };

          $scope.upload = function(files) {
            if (files && files.length && files.length > 0) {
              executeUpload(files.pop());
            }
          };
          $scope.callSave = function($event) {
            $event.preventDefault();
            $scope.$emit('dodomaApp:workerRecordInlineSave');
          };
          /*$scope.demo = function($event) {
            $interval(function() {
              if (angular.isNumber($scope.progressStatus)) {
                $scope.progressStatus = $scope.progressStatus + 10;
              } else {
                $scope.progressStatus = 0;
              }
            }, 1000, 10);
            $event.preventDefault();
          };*/
        }
    };
  }]
);

'use strict';

angular.module('dodomaApp')
  .directive('workerLink', function() {
    return {
        restrict: 'E',
        scope: {
          worker : '='
        },
        template : '<a class="workerLink" ui-sref="worker.detail({workerId:worker.id})">{{worker.lastName}} {{worker.firstName}} {{worker.name}}</a>'
    };
  }
);

'use strict';
(function() {
  angular.module('dodomaApp')
    .directive('workerRecordDisplay', function() {
      return {
        restrict: 'E',
        scope: {
          type : '=',
          recordReadonly : '=',
          workerRecord : '=',
          editForm : '=' // just to forward the editForm into the scope - so validation works correctly 
        },
        templateUrl: 'scripts/components/templates/workerRecordDisplay.html',
        controller: function ($scope) {
          $scope.isReadonly = function() {
            return $scope.recordReadonly === true;
          };

          function setIncludePath(type) {
            if (angular.isString(type)) {
              $scope.includePath = 'scripts/app/entities/workerRecord/templates/'+ type.toLowerCase()+'.html';
            } else {
              $scope.includePath = '';
            }
          };

          $scope.getVariable = function(name, defValue) {
            var value = ($scope.workerRecord && $scope.workerRecord.params) ? $scope.workerRecord.params[name] : undefined;
            return angular.isDefined(value) ? value : defValue;
          };

          $scope.incVariable = function(name, modValue, defValue) {
            var value = $scope.workerRecord.params[name];
            if (angular.isNumber(value)) {
              value = value + modValue;
            } else {
              value = defValue + modValue;
            }
            $scope.workerRecord.params[name] = value;
          };


          $scope.range = function(maxParam) {
            var max = angular.isNumber(maxParam) ? maxParam : (angular.isString(maxParam) ? parseInt(maxParam, 10) : 0);
            var input = [];
            for (var i = 0; i < max; i += 1) {
              if (arguments.length > 1) {
                var arr = [];
                for (var j = 1;j<arguments.length;j+= 1) {
                  arr.push(arguments[j] + i);
                }
                input.push(arr);
              } else {
                input.push(i);
              }
            }
            return input;
          };
          
          // usable as ng-repeat="idx in createRangeByVariable('myCounter',3)"
          $scope.createRangeByVariable = function(name, defValue) {
            return $scope.range($scope.getVariable(name, defValue));
          };

          setIncludePath($scope.type);
          $scope.$watch('type', function() {
            setIncludePath($scope.type);
          });

        }
      };
    }
  );
})();
'use strict';

angular.module('dodomaApp')
  .directive('workTypeLink', function() {
    return {
        restrict: 'E',
        scope: {
                workType : '='
        },
        template : '<a class="workTypeLink" ui-sref="workTypeDetail({workTypeId:workType.id})">{{workType.name}}</a>'
    };
  }
);

(function () {
    'use strict';

  angular.module('dodomaApp')
    .constant('validationConstraints', {
      EmploymentUpdateDTO : {
        startDate: {
          date: true,
          required: true
        },
        endDate: {
          date: true
        },
        description: {
          maxLength : 255
        },
        employmentCode: {
          maxLength: 255
        },
        workingHours: {
          required:true,
          number: true,
          min:0,
          max:10
        }
      },
      WorkerRecordDTO : {
        status : {
          required : true
        },
        type : {
          required : true
        },
        recordDate : {
          required : true,
          date: true
        },
        validityDate : {
          date: true
        },
        minutes : {
          min : 0,
          number: true,
        },
        worker: {
          required:  true
        }
      },
      DeliveryNoteUpdateDTO: {
        deliveryNumber : {
          required: true,
          maxLength: 50,
          minLength: 1
        },
        type: {
          required: true
        },
        deliveryDate: {
          required: true,
          date:true
        },
        supplier: {
          required: true
        },
        orderPlan: {
          required:true
        },
        initialAmount: {
          min: 0,
          number: true
        },
        initialItemPrice: {
          min: 0,
          number: true
        }
      },
      DeliveryNoteItemUpdateDTO : {
        part: {
          required: true
        },
        sentAmount: {
          required: true,
          min: 0,
          number: true,
        },
        countedAmount: {
          required: true,
          min: 0,
          number: true,
        },
        brokenAmount: {
          required: true,
          min: 0,
          number: true,
        },
        addToStockAmount: {
          required: true,
          min: 0,
          number: true,
        },
        itemPrice: {
          number: true,
        },
        price: {
          number: true,
        }
      },
      GiveOutUpdateDTO : {
        giveOutNumber : {
          required: true,
          maxLength: 50
        },
        type : {
          required: true
        },
        comment: {
          maxLength : 512
        },
        initialAmount: {
          min : 0
        }
      },
      OrderLineUpdateDTO: {
          amount: {
              number: true,
              required: true,
              min: 0
          },
          part: {
              required: true
          }
      },
      PartUpdateDTO : {
        name : {
          required : true,
          maxLength : 50
        },
        serialNumber : {
          maxLength : 50
        },
        description: {
          maxLength : 200
        },
        measuringType: {
          required : true
        },
        initialAmount: {
          min: 0,
          number: true,
          required:true
        },
        initialPrice: {
          min: 0,
          number: true
        },
        initialTime: {
          datetime:true
        }
      },
      PartnerUpdateDTO: {
        name : {
          required: true,
          maxLength : 100
        },
        description: {
          maxLength : 1024
        },
        address: {
          maxLength : 100
        },
        phone: {
          maxLength: 20
        },
        email: {
          maxLength: 100
        },
        taxNumber: {
          maxLength: 100
        }
      },
      PriceCalculationUpdateDTO: {
        workNeed: {
          number: true,
          min: 0
        },
        workTime: {
          number: true,
          min: 0
        },
        machineCost: {
          number: true,
          min: 0
        },
        maintenanceFee: {
          number: true,
          min: 0
        },
        shippingFee: {
          number: true,
          min: 0
        },
        otherFee: {
          number: true,
          min: 0
        },
        comment: {
          maxLength : 500
        }
      },
      ProductionSheetItemDTO: {
        amount: {
          required: true,
          min: 0,
          number: true,
          max: '{{maxAmount}}'
        },
        finishedAmount: {
          number: true,
          max: '{{productionSheetItem.amount * 2}}',
          required: true,
          min: 0
        },
        standardTimeOverride: {
            number: true,
            required: true,
            min: 0
        },
        timeSpent: {
            number: true,
            min: 0,
            required: true
        }
      },
      ProductionSheetItemVerificationUpdateDTO: {
        checkedAmount: {
          number: true,
          min: 0,
          required: true
        },
        brokenAmount: {
          number: true,
          min: 0,
          required: true,
          max: "{{productionSheetItemVerification.checkedAmount}}"
        }
      },
      ProductionEvaluationUpdateDTO : {
        productName: {
          required: true,
          maxLength: 50
        },
        workflow: {
          maxLength: 500
        },
        testStart: {
          required: true,
          datetimelocal: true
        },
        testerName: {
          required: true,
          maxLength: 50
        },
        numberOfProducts: {
          required: true,
          min: 0,
          number: true
        },
        verificationTime: {
          required: true,
          min: 0,
          number: true
        },

        toolNeed: {
          maxLength: 500
        },
        storeNeed: {
          maxLength: 500
        },
        transferNeed: {
          maxLength: 500
        },
        storageNeed: {
          maxLength: 500
        },
        logisticNeed: {
          maxLength: 500
        },
        worker: {
          required: true
        }

      },
      PartTypeUpdateDTO: {
        name: {
          required: true,
          maxLength: 50
        },
        description: {
          maxLength: 200
        }
      },
      ProductionSheetUpdateDTO: {
        executionDate: {
          required: true,
          date:true
        }
      },
      ProductionVariantUpdateDTO: {
        name: {
          required: true,
          maxLength: 100
        },
        description: {
          maxLength: 500
        },
      },
      StockLocationUpdateDTO : {
        physicalAmount: {
          number: true,
          required:true,
          min: 0
        },
        price: {
          number: true,
          required:true,
          min: 0
        },
        availableAmount: {
          number: true,
          required:true,
          min: 0
        }
      },
      StockUpdateDTO: {
        name: {
          required: true,
          maxLength: 100,
          minLength: 1
        },
        description: {
          maxLength: 1024
        }
      },
      OrderPlanUpdateDTO: {
        name: {
          required: true,
          maxLength: 50
        },
        client: {
          required: true
        },
        deliveryDate: {
          date:true
        },
        invoiceNumber: {
          required: true,
          maxLength: 50
        },
        invoiceAmount: {
          number:true,
          required:true,
          min: 0
        },
        invoiceDate: {
          required:true,
          date:true
        }
      },
      UserManagementDTO : {
        login : {
          required: true,
          maxLength: 50,
          pattern: '^[a-z0-9]*$',
        },
        firstName : {
          maxLength:50
        },
        lastName : {
          maxLength:50
        },
        email : {
          maxLength:100,
          required:true,
          minLength:5
        },
        langKey : {
          maxLength:5,
          required:true
        },
        
      },
      WorkerUpdateDTO: {
        firstName: {
          required: true,
          maxLength: 50
        },
        lastName: {
          required: true,
          maxLength: 50
        },
        socialSecurityNumber: {
          maxLength: 50
        },
        birthDate: {
          date:true
        },
        workingHours: {
          min:0,
          max:24
        }
      },
      WorkPricingCategoryUpdateDTO: {
        name: {
          required:true,
          maxLength: 20
        },
        hourlyRate: {
          required:true,
          number:true,
          min:0
        }
      },
      WorklogUpdateDTO: {
        recordDate: {
          date:true,
          required:true
        },
        task: {
          required: true,
          maxLength: 255
        },
        minutes: {
          required: true,
          number:true,
          min:0
        },
        relatedOther: {
          maxLength: 255
        },
        summary: {
          maxLength: 4096
        },
        executorUser: {
          required:true
        }
      },
      WorkStepUpdateDTO: {
        name: {
          required: true,
          maxLength: 100
        },
        externalName: {
          maxLength: 100
        },
        workType: {
          required: true
        },
        standardTime: {
          number:true,
          required:true,
          min: 0
        },
        description: {
          maxLength: 500
        }
      }
    });

})();
/* global $ */
(function () {
  'use strict';

  var dodomaValidation = function () {

    return {
      displayBlocks : function(path, fieldConstr, inputElement) {
        function checkAttribute(key, value) {
          if (inputElement) {
            if (!angular.isDefined(inputElement.attr(key))) {
              inputElement.attr(key, value);
            }
          }
        }
        
        var html = '';
        if (fieldConstr.required) {
          html += '<p class="help-block" ng-show="'+path+'.$error.required" translate="entity.validation.required">This field is required.</p>';
          if (inputElement && !angular.isDefined(inputElement.attr('ng-required'))) {
            checkAttribute('required', '');
          }
        }
        if (fieldConstr.number) {
          html += '<p class="help-block" ng-show="'+path+'.$error.number" translate="entity.validation.number">This field should be a number.</p>';
        }
        if (angular.isDefined(fieldConstr.min)) {
          html += '<p class="help-block" ng-show="'+path+'.$error.min" translate="entity.validation.min" translate-value-min="'+fieldConstr.min+'">This field should be more than '+fieldConstr.min+'.</p>';
          checkAttribute('min', fieldConstr.min);
        }
        if (angular.isDefined(fieldConstr.max)) {
          html += '<p class="help-block" ng-show="'+path+'.$error.max" translate="entity.validation.max" translate-value-max="'+fieldConstr.max+'">This field should be less than '+fieldConstr.max+'.</p>';
          checkAttribute('max', fieldConstr.max);
        }
        if (angular.isNumber(fieldConstr.maxLength)) {
          html += '<p class="help-block" ng-show="'+path+'.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="'+fieldConstr.maxLength+'">This field cannot be longer than '+fieldConstr.maxLength+' characters.</p>';
          checkAttribute('ng-maxlength', fieldConstr.maxLength);
        }
        if (angular.isNumber(fieldConstr.minLength)) {
          html += '<p class="help-block" ng-show="'+path+'.$error.minlength" translate="entity.validation.minlength" translate-value-min="'+fieldConstr.minLength+'">This field is required to be at least '+fieldConstr.minLength+' characters.</p>';
          checkAttribute('ng-minlength', fieldConstr.minLength);
        }
        if (angular.isDefined(fieldConstr.pattern)) {
          var readablePattern = fieldConstr.readablePattern || fieldConstr.pattern;
          html += '<p class="help-block" ng-show="'+path+'.$error.pattern" translate="entity.validation.pattern" translate-value-pattern="'+readablePattern+'">This field should follow pattern "'+readablePattern+'".</p>';
        }
        if (fieldConstr.datetime) {
          html += '<p class="help-block" ng-show="'+path+'.$error.datetimelocal" translate="entity.validation.datetimelocal">This field should be a valid date-time.</p>';
        }
        if (fieldConstr.date) {
          html += '<p class="help-block" ng-show="'+path+'.$error.date" translate="entity.validation.date">This field should be a valid date.</p>';
        }
        if (html.length > 0) {
          //var validationDiv = angular.element('<div ng-show="'+path+'.$invalid && '+path+'.$touched">' + html + '</p>');
          return angular.element('<div ng-show="'+path+'.$invalid">' + html + '</p>');
        } else {
          return;
        }
        
      }
    };
  };

  angular
  .module('dodomaApp')
  .service('dodomaValidation', dodomaValidation);

  angular.module('dodomaApp')
    .directive('validationMessages', ['validationConstraints', 'dodomaValidation', function(validationConstraints, dodomaValidation) {
      return {
        restrict: 'A',
        require: ['form'],
        compile: function ($form, $attr) {
          var dtoName = $attr.validationMessages;
          var formName = $form.attr('name');
          var formElements = $form.find('input[ng-model],select[ng-model],textarea[ng-model],ui-select');
          var constr = validationConstraints[dtoName];
          if (!angular.isObject(constr)) {
            throw new Error('No constraint defined for '+dtoName);
          }
          angular.forEach(formElements, function (inputDom) {
            let fieldName = inputDom.attributes["name"];
            if (!fieldName) {
              return;
            }
            let fieldType = inputDom.attributes["type"];
            if (fieldType && fieldType.value === "hidden") {
              // console.log('Skipping hidden field '+fieldName.value);
              return;
            }
            let fieldConstr = constr[fieldName.value];
            if (!fieldConstr) {
              return;
            }
            let inputElement = angular.element(inputDom);

            if (angular.isDefined(fieldConstr)) {
              let validationDiv = dodomaValidation.displayBlocks(formName + '.' + fieldName.value, fieldConstr, inputElement);
              if (validationDiv) {
                validationDiv.insertAfter(inputDom);
              }
            }
          });

        }
      };
    }]);
})();

'use strict';

angular
  .module('dodomaApp')
  .filter('prefixTranslate', ['$translate', function($translate) {
    return function(input, prefix) {
      return $translate.instant(prefix + input);
    };
}]);

angular
.module('dodomaApp')
.filter('deliveryNoteStatus', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.deliveryNote.stateLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('deliveryNoteType', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.deliveryNote.typeLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('movementType', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.movement.typeLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('measuringType', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.measuringType.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('giveOutType', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.giveOut.typeLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('giveOutState', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.giveOut.stateLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('giveOutApproval', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.giveOut.approvalLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('orderPlanState', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.orderPlan.stateLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('productionSheetState', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.productionSheet.stateLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('workerRecordType', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.workerRecord.typeLabel.' + input);
  };
}]);

angular
.module('dodomaApp')
.filter('workerRecordStatus', ['$translate', function($translate) {
  return function(input) {
    return $translate.instant('dodomaApp.workerRecord.statusLabel.' + input);
  };
}]);

/* global $ */
(function () {
  'use strict';

  angular
    .module('dodomaApp')
    .filter('timeFormat', ['$translate', function($translate) {
      return function timeFormat(minutes) {
        if (angular.isNumber(minutes)) {
          var hours = Math.floor(minutes / 60);
          var just_minutes = Math.floor( (minutes % 60) * 100)/100;
          return (hours > 0 ? "" + hours.toString() + " óra " : "") + just_minutes.toString()  + " perc";
        }
        return minutes;
      }
    }]);
})();

/* global angular */
(function () {
  'use strict';

  angular
    .module('dodomaApp')
    .provider('stateUtil', function() {
        var stateUtil = {
            stateWithParent : function (stateDef, parent, url, data) {
                var stateDef = angular.copy(stateDef);
                stateDef.parent = parent;
                if (angular.isString(url)) {
                    stateDef.url = url;
                }
                if (angular.isDefined(data)) {
                    stateDef.data = angular.extend(stateDef.data, data);
                }
                return stateDef;
            },

            stateUrl : function (stateDef, url, data) {
                var stateDef = angular.copy(stateDef);
                if (angular.isString(url)) {
                    stateDef.url = url;
                }
                if (angular.isDefined(data)) {
                    stateDef.data = angular.extend(stateDef.data, data);
                }
                return stateDef;
            }
        };

      return {
          $get : function() {
              return stateUtil;
          }
      };
    });
})();

(function () {
    'use strict';
    angular
        .module('dodomaApp')
        .service('EnumLabel', function () {
            return {
                giveOut: function(obj) {
                    if (obj.state === 'INIT') {
                        return 'label label-success';
                    } else {
                        return 'label label-info';
                    }
                },
                orderPlan: function(obj) {
                    if (obj.state === 'OFFER' || obj.state === 'PLANNING' || obj.state === 'EXECUTING') {
                        return 'label label-success';
                    } else if (obj.state === 'CANCELLED') {
                        return 'label label-default';
                    } else {
                        return 'label label-info';
                    }
                },
                deliveryNote: function(obj) {
                    if (obj.state === 'NEW') {
                        return 'label label-success';
                    } else if (obj.state === 'ADDED') {
                        return 'label label-primary';
                    } else if (obj.state === 'REVERTED') {
                        return 'label label-default';
                    } else {
                        return 'label label-info';
                    }
                }
            }
        })
})();
'use strict';

angular.module('dodomaApp')
  .directive('measuringSelect', function() {
    return {
      restrict : 'AE', // Attribute or entity
      scope: {
        ngModel : '='
      },
      controller : function($scope) {
          $scope.measuringTypes = [];
          angular.forEach(['PIECE','KG', 'LITER', 'METER', 'METER2', 'SQUARE_METER', 'METER3'], function(key) {
            $scope.measuringTypes.push({key:key, translationKey:'dodomaApp.measuringType.'+key});
          });
      },
      template: function(element, attrs) {
        return '<select class="form-control" name="measuringType" ng-model="ngModel" '+
            (attrs.required != undefined ? 'required ' : '') +
            'ng-options="opt.key as opt.translationKey | translate for opt in measuringTypes"></select>';        
      }
    };
  }
).directive('ddMeasuring', ['$translate', function($translate) {
    return {
      restrict: 'AE',
      scope : {
        ddMeasuring : '='
      },
      template: "{{translatedValue}}",
      controller: function($scope) {
        $scope.translatedValue = null;
        $scope.setValue = function(value) {
          if (value != '') {
            $translate('dodomaApp.measuringType.' + value).then(function(translation) {
              $scope.translatedValue = translation;
            });
          } else {
            $scope.translatedValue = '';
          }
        };
        $scope.$watch('ddMeasuring', function(newValue, oldValue) {
          if (newValue != oldValue) {
            $scope.setValue(newValue);
          }
        });
        $scope.setValue($scope.ddMeasuring);
      }
    };
}]);

'use strict';

angular.module('dodomaApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('sessions', {
                parent: 'account',
                url: '/sessions',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.sessions'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/account/sessions/sessions.html',
                        controller: 'SessionsController'
                    }
                }
            });
    });

'use strict';

angular.module('dodomaApp')
    .controller('SessionsController', function ($scope, Sessions, Principal) {
        Principal.identity().then(function(account) {
            $scope.account = account;
        });

        $scope.success = null;
        $scope.error = null;
        $scope.sessions = Sessions.getAll();
        $scope.invalidate = function (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    $scope.error = null;
                    $scope.success = 'OK';
                    $scope.sessions = Sessions.getAll();
                },
                function () {
                    $scope.success = null;
                    $scope.error = 'ERROR';
                });
        };
    });

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();

      var partner = {
          parent: 'productionManagement',
          url: '/partners',
          data: {
              roles: ['ROLE_USER'],
              pageTitle: 'dodomaApp.partner.home.title'
          },
          views: {
              'content@': {
                  templateUrl: 'scripts/app/entities/partner/partners.html',
                  controller: 'PartnerController'
              }
          }
      };
      var partnerDetail = {
          parent: 'partner',
          url: '/{partnerId:int}',
          data: {
              roles: ['ROLE_USER'],
              pageTitle: 'dodomaApp.partner.detail.title'
          },
          views: {
              'content@': {
                  templateUrl: 'scripts/app/entities/partner/partner-detail.html',
                  controller: 'PartnerDetailController'
              }
          },
          resolve: {
                entity: ['$stateParams', 'Partner', 'ErrorHandler', function($stateParams, Partner, ErrorHandler) {
                  return Partner.get({id : $stateParams.partnerId}).$promise
                    .catch(ErrorHandler.rejectWith('dodomaApp.partner.notFound'));
                }]

            }
      };
      
      var partnerNew = {
          url: '/new',
          data: {
              roles: ['ROLE_USER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function($stateParams, $state, $uibModal, $rootScope) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/partner/partner-dialog.html',
              controller: 'PartnerDialogController',
              size: 'lg',
              resolve: {
                entity : function() {
                  return {name: null, description: null, address: null, phone: null, email: null, customStock: true, active: true, id: null};
                }
              }
            }).result.then(function(result) {
              if ($state.current.data.sendEvent) {
                $rootScope.$broadcast('dodomaApp:newPartnerCreated', result);
                $state.go('^');
              } else {
                $state.go('partnerDetail', {partnerId: result.id});
              }
            }, function() {
              $state.go('^');
            })
          }]
        };
      var partnerEdit = {
          url: '/edit',
          data: {
              roles: ['ROLE_USER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/partner/partner-dialog.html',
              controller: 'PartnerDialogController',
              size: 'lg',
              resolve: {
                entity : ['Partner', function(Partner) {
                  return Partner.get({id: $stateParams.partnerId});
                }]
              }
            }).result.then(function(result) {
              $state.go('partnerDetail', {partnerId: result.id});
            }, function() {
              $state.go('partnerDetail', {partnerId: $stateParams.id});
            })
          }]
        };
      
        $stateProvider
            .state('partner', partner)
            .state('partnerDetail', partnerDetail)
            .state('partner.new', stateUtil.stateUrl(partnerNew))
            .state('offer.new.newPartner', stateUtil.stateUrl(partnerNew, '/newPartner', { sendEvent : true } ) )
            .state('offer.detail.edit.newPartner', stateUtil.stateUrl(partnerNew, '/newPartner', { sendEvent : true } ) )
            .state('orderPlan.new.newPartner', stateUtil.stateUrl(partnerNew, '/newPartner', { sendEvent : true }) )
            .state('orderPlan.detail.edit.newPartner', stateUtil.stateUrl(partnerNew, '/newPartner', { sendEvent : true } ) )
            .state('partnerDetail.edit', partnerEdit);
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('PartnerController',
                ['$scope', 'Partner', 'StorageUtil',
                function ($scope, Partner, StorageUtil) {
        $scope.partners = [];
        $scope.page = 1;
        StorageUtil.setupFilters("partnerController", $scope);
        $scope.pageResult = {};
        $scope.lastFilter = {};

        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);

          Partner.query(q, function(result, headers) {
            $scope.partners = result.entities;
            $scope.pageResult = result;
          });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Partner.get({id: id}, function(result) {
                $scope.$emit('clearErrors');
                $scope.partner = result;
                $('#deletePartnerConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Partner.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deletePartnerConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.clear = function () {
            $scope.partner = {name: null, description: null, address: null, phone: null, email: null, customStock: true, active: true, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('PartnerDetailController',
                ['$scope', '$rootScope', 'Partner', 'entity', 'OrderPlan', 'WorkStep', 'ErrorHandler',
                function ($scope, $rootScope, Partner, entity, OrderPlan, WorkStep, ErrorHandler) {
        $scope.partner = entity;
        $scope.deliveryNoteCriteria = {supplierId: $scope.partner.id};
        $scope.giveOutCriteria = {supplierId: $scope.partner.id};
        $scope.partCriteria = {partnerId: $scope.partner.id};
        $scope.partTabState = {partsLoaded: false};

        $scope.load = function (id) {
            Partner.get({id: id}, function(result) {
              $scope.partner = result;
            }, ErrorHandler.rejectWith('dodomaApp.partner.notFound'));
        };

        $scope.$on('dodomaApp:partnerUpdate', function(event, result) {
          $scope.partner = result;
        });

        // order plans tab

        $scope.loadOrderPlans = function(pageNumber) {
          var q = {
              page : pageNumber,
              per_page : 20,
              clientId: $scope.partner.id
            };
          OrderPlan.query(q, function(result) {
            $scope.orderPlans = result.entities;
            $scope.orderPlansResult = result;
          });
        };

        $scope.switchToOrderPlans = function() {
          if (!angular.isDefined($scope.orderPlans)) {
            $scope.loadOrderPlans(0);
          }
        };

        $scope.switchToParts = function() {
          if ($scope.partTabState.partsLoaded === false) {
            $scope.$broadcast('dodomaApp:showParts', 0);
          }
        }

        // work steps tab

        $scope.switchToWorkSteps = function() {
          if (!angular.isDefined($scope.workSteps)) {
            $scope.loadWorkSteps(0);
          }
        };

        $scope.$on('dodomaApp:workStepUpdate', function(event, result) {
            $scope.loadWorkSteps(0);
        });

        $scope.loadWorkSteps = function(pageNumber) {
          var q = {
              page : pageNumber,
              per_page : 20,
              partnerId: $scope.partner.id
          };
          WorkStep.queryVirtualParts(q, function(result) {
            $scope.workSteps = result.entities;
            $scope.workStepsResult = result;
          });
        };

        $scope.switchToDeliveryNotes = function() {
            $rootScope.$broadcast('dodomaApp:showDeliveryNotes', 0);
        };


        $scope.switchToGiveOuts = function() {
            $rootScope.$broadcast('dodomaApp:showGiveOuts', 0);
        };

    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Partner', ['$resource', function ($resource) {

        var responseHelper = function (data) {
            if (!data || data.trim() === '') {
                return null;
            }
            return angular.fromJson(data);
        };

        return $resource('api/partners/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: responseHelper,
                params : {name : '@name', includeInactive:'@includeInactive', customStock: '@customStock'}
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('stock', {
                parent: 'stockManagement',
                url: '/stocks',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.stock.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/stock/stocks.html',
                        controller: 'StockController'
                    }
                }
            })
            .state('stockDetail', {
                parent: 'stock',
                url: '/{id:int}',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.stock.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/stock/stock-detail.html',
                        controller: 'StockDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Stock', 'ErrorHandler', function($stateParams, Stock, ErrorHandler) {
                        return Stock.get({id : $stateParams.id}).$promise
                            .catch(ErrorHandler.rejectWith('dodomaApp.stock.notFound'));
                    }]
                }
            })
            .state('stock.new', {
              url: '/new',
              data: {
                  roles: ['ROLE_STOREMANAGER', 'ROLE_STOREREVIEWER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/stock/stock-dialog.html',
                  controller: 'StockDialogController',
                  size: 'lg',
                  resolve: {
                      entity: {name: null, description: null, id: null}
                  }
                }).result.then(function(result) {
                  $state.go('stockDetail', {id: result.id});
                }, function() {
                  $state.go('^');
                })
              }]
            })
            .state('stockDetail.edit', {
              url: '/edit',
              data: {
                  roles: ['ROLE_STOREMANAGER', 'ROLE_STOREREVIEWER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/stock/stock-dialog.html',
                  controller: 'StockDialogController',
                  size: 'lg',
                  resolve: {
                      entity: ['Stock', function(Stock) {
                          return Stock.get({id : $stateParams.id}).$promise;
                      }]
                  }
                }).result.then(function(result) {
                  $state.go('stockDetail', {id: result.id});
                }, function() {
                  $state.go('stockDetail', {id: $stateParams.id});
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('StockController',
                ['$scope', 'Stock',
                function ($scope, Stock) {
        $scope.stocks = [];
        $scope.pageResult = {};
        $scope.page = 1;
        $scope.loadAll = function() {
            Stock.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.stocks = result.entities;
                $scope.pageResult = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Stock.get({id: id}, function(result) {
                $scope.stock = result;
                $('#deleteStockConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Stock.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteStockConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.clear = function () {
            $scope.stock = {name: null, description: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('StockDetailController',
                ['$scope', 'entity', 'Stock', 'Movement', 'ErrorHandler',
                function ($scope, entity, Stock, Movement, ErrorHandler) {
        $scope.stock = entity;
        $scope.filter = {page: 1, per_page: 20};
        $scope.movementFilter = {page : 1, per_page: 20};
        $scope.partFilter = {stockId: $scope.stock.id};
        $scope.partTabState = {partsLoaded: false};
        var movementLoading = false;

        $scope.load = function (id) {
          Stock.get({id: id}, function(result) {
            $scope.stock = result;
          }, ErrorHandler.rejectWith('dodomaApp.stock.notFound'));
        };

        $scope.$on('dodomaApp:stockUpdate', function(event, result) {
          $scope.stock = result;
        });

        $scope.loadMovements = function() {
          movementLoading = true;
          $scope.movementFilter.stockId = $scope.stock.id;
          Movement.query($scope.movementFilter, function(result) {
            $scope.movementPageResult = result;
          });
        };
        $scope.changeMovementPage = function(page) {
          $scope.movementFilter.page = page;
          $scope.loadMovements();
        };

        $scope.switchTab = function(tab) {
          if (tab === 1) {
            console.log("partsTabState: ", $scope.partTabState);
            if ($scope.partTabState.partsLoaded === false) {
              $scope.$broadcast('dodomaApp:showParts', 0);
            }
          }
          if (tab === 2) {
            if (movementLoading === false) {
              $scope.loadMovements();
            }
          }
        }

        $scope.partExportUrl = function() {
          return '/api/parts/export.xls?format=xls&stockId=' + $scope.stock.id;
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Stock', ['$resource', function ($resource) {

        var responseHelper = function (data) {
            if (!data || data.trim() === '') {
                return null;
            }
            return angular.fromJson(data);
        };

        return $resource('api/stocks/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: responseHelper
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('partType', {
                parent: 'stockManagement',
                url: '/partTypes',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.partType.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/partType/partTypes.html',
                        controller: 'PartTypeController'
                    }
                }
            })
            .state('partTypeDetail', {
                parent: 'partType',
                url: '/{id:int}',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.partType.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/partType/partType-detail.html',
                        controller: 'PartTypeDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'PartType', function($stateParams, PartType) {
                        return PartType.get({id : $stateParams.id});
                    }]
                }
            })
            .state('partType.new', {
              url: '/new',
              data: {
                  roles: ['ROLE_STOREMANAGER','ROLE_STOREREVIEWER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/partType/partType-dialog.html',
                  controller: 'PartTypeDialogController',
                  size: 'lg',
                  resolve: {
                      entity: {name: null, description: null, active: true, id: null}
                  }
                }).result.then(function(result) {
                  $state.go('partTypeDetail', {id: result.id});
                }, function() {
                  $state.go('^');
                })
              }]
            })
            .state('partTypeDetail.edit', {
              url: '/edit',
              data: {
                  roles: ['ROLE_STOREMANAGER', 'ROLE_STOREREVIEWER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/partType/partType-dialog.html',
                  controller: 'PartTypeDialogController',
                  size: 'lg',
                  resolve: {
                      entity: ['PartType', function(PartType) {
                          return PartType.get({id : $stateParams.id});
                      }]
                  }
                }).result.then(function(result) {
                  $state.transitionTo('partTypeDetail', {id: result.id});
                }, function() {
                  $state.transitionTo('partTypeDetail', {id: $stateParams.id});
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('PartTypeController',
                ['$scope', 'PartType',
                function ($scope, PartType) {
        $scope.partTypes = [];
        $scope.page = 1;
        $scope.loadAll = function() {
          var q = {includeInactive: true, page: $scope.page, per_page: 20};
          PartType.query(q, function(result, headers) {
            $scope.partTypes = result;
          });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            PartType.get({id: id}, function(result) {
                $scope.partType = result;
                $('#deletePartTypeConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            PartType.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deletePartTypeConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.clear = function () {
            $scope.partType = {};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('PartTypeDetailController',
                ['$scope', '$rootScope', '$stateParams', 'PartType',
                function ($scope, $rootScope, $stateParams, PartType) {
        $scope.partType = {};
        $scope.load = function (id) {
            PartType.get({id: id}, function(result) {
              $scope.partType = result;
            });
        };
        $rootScope.$on('dodomaApp:partTypeUpdate', function(event, result) {
          $scope.partType = result;
        });

        $scope.load($stateParams.id);
    }]);

'use strict';

angular.module('dodomaApp').controller('PartTypeDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'PartType',
        function($scope, $stateParams, $uibModalInstance, entity, PartType) {

      $scope.partType = entity;
      $scope.load = function(id) {
        PartType.get({id : id}, function(result) {
          $scope.partType = result;
        });
      };

      var onSaveFinished = function (result) {
        $scope.$emit('dodomaApp:partTypeUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.save = function () {
          if ($scope.partType.id != null) {
            PartType.update($scope.partType, onSaveFinished);
          } else {
            PartType.save($scope.partType, onSaveFinished);
          }
        };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .factory('PartType', ['$resource', function ($resource) {
        return $resource('api/partTypes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();

        $stateProvider
            .state('part', {
                parent: 'stockManagement',
                url: '/parts',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.part.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/part/parts.html',
                        controller: 'PartController'
                    }
                }
            })
            .state('partDetail', {
                parent: 'part',
                url: '/{partId:int}',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.part.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/part/part-detail.html',
                        controller: 'PartDetailController'
                    }
                },
                resolve: {
                    partId : ['$stateParams', function($stateParams) {
                      return $stateParams.partId;
                    }],
                    entity: ['$stateParams', '$q', 'Part', 'ErrorHandler', function($stateParams, $q, Part, ErrorHandler) {
                      return Part.get({id: $stateParams.partId}, function(result) {
                        return result;
                      }, ErrorHandler.rejectWith('dodomaApp.part.notFound'));
                    }]
                }
            });
        var partNewState = {
          url: '/new?{stockId:int}',
          data: {
              roles: ['ROLE_STOREMANAGER', 'ROLE_STOREREVIEWER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/part/part-dialog.html',
              controller: 'PartDialogController',
              size: 'lg',
              resolve: {
                entity: function() {
                  return {name: null, serialNumber: null, description: null, measuringType: 'PIECE', active: true, hasPrice: true, id: null,
                    stock: { id : $stateParams.stockId }};
                },
                stock: ['Stock' , function(Stock) {
                  return Stock.get({id: $stateParams.stockId}).$promise;
                }]
              }

            }).result.then(function(result) {
              $state.go('partDetail', {partId: result.id});
            }, function() {
              $state.go('^');
            })
          }]
        };
        $stateProvider
            .state('part.new', stateUtil.stateUrl(partNewState))
            .state('stockDetail.partNew', stateUtil.stateUrl(partNewState))
            .state('partDetail.edit', {
              url: '/edit',
              data: {
                  roles: ['ROLE_STOREREVIEWER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/part/part-dialog.html',
                  controller: 'PartDialogController',
                  size: 'lg',
                  resolve : {
                    entity: ['Part', function(Part) {
                      return Part.get({id : $stateParams.partId}).$promise;
                    }],
                    stock : function() {
                      return [];
                    }
                  }
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('PartController',
                ['$scope', 'Part', 'StorageUtil', 'RequestUtil',
                function ($scope, Part, StorageUtil, RequestUtil) {
        $scope.parts = [];
        $scope.page = 1;
        StorageUtil.setupFilters("partController", $scope);
        $scope.pageResult = {};
        $scope.lastFilter = {};

        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.customFilter.partner) {
            q.partnerId = $scope.customFilter.partner.id;
          }
          if ($scope.customFilter.stock) {
            q.stockId = $scope.customFilter.stock.id;
          }
          if ($scope.customFilter.partType) {
            q.partTypeId = $scope.customFilter.partType.id;
          }
          if (angular.equals($scope.lastFilter, q)) {
            return;
          }
          $scope.lastFilter = q;
          Part.query(q, function(result, headers) {
            $scope.parts = result.entities;
            $scope.pageResult = result;
          });
        };
        
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Part.get({id: id}, function(result) {
                $scope.$emit('clearErrors');
                $scope.part = result;
                $('#deletePartConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Part.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deletePartConfirmation').modal('hide');
                    $scope.part = {};
                });
        };

        $scope.partExportUrl = function() {
          return RequestUtil.createLink('/api/parts/export.xls?format=xls&', $scope.filter);
        };

        $scope.$watch('filter.includeInactive', $scope.loadAll);

    }]);

'use strict';

angular.module('dodomaApp')
    .controller('PartDetailController',
                ['$scope', '$rootScope', 'Part', 'StockLocation', 'Movement', 'WorkStep', 'entity', 'ErrorHandler',
                function ($scope, $rootScope, Part, StockLocation, Movement, WorkStep, entity, ErrorHandler) {
        $scope.movements = [];
        $scope.deliveryNoteCriteria = {};
        $scope.giveOutCriteria = {};
        $scope.orderPlansCriteria = {};
        $scope.currentTab = '';

        function setPart(result) {
          $scope.part = result;
          $scope.deliveryNoteCriteria.partId = result.id;
          $scope.giveOutCriteria.partId = result.id;
          $scope.orderPlansCriteria.partId = result.id;
          if (angular.isString(result.serialNumber)) {
              $scope.$emit('$titleChange', 'dodomaApp.part.detail.windowTitle', {name:result.name, serialNumber:result.serialNumber});
          } else {
              $scope.$emit('$titleChange', 'dodomaApp.part.detail.windowTitleShort', {name:result.name});
          }
        };

        entity.$promise.then(setPart);

        $scope.load = function (id) {
            Part.get({id: id}, function(result) {
                setPart(result);
            }, ErrorHandler.rejectWith('dodomaApp.part.notFound'));
        };

        function resetMovements() {
          $scope.movements = [];
          if ($scope.currentTab = 'movements') {
            $scope.loadMovementPage(0);
          }
        };

        $scope.$on('dodomaApp:partUpdate', function(event, result) {
          setPart(result);
          resetMovements();
        });

        $scope.deleteStockLocation = function(stockLocationId) {
          StockLocation.delete({id:stockLocationId, partId: $scope.part.id}, function(result) {
            $scope.load($scope.part.id);
          });
        };

        $scope.deleteWorkStep = function(variant, workStepId) {
          WorkStep.delete({partId: $scope.part.id, variantId:variant.id, id:workStepId}, function(result) {
            $scope.part = result;
          });
        };

        $scope.setWorkStepActive = function(variant, workStepId, flag) {
          WorkStep.setActive({partId: $scope.part.id, variantId:variant.id, id:workStepId, flag:flag},  function(result) {
            $scope.part = result;
          });
        };

        $scope.changeWorkStepPrio = function(variant, workStepId, prio) {
          WorkStep.changePriority({partId: $scope.part.id, variantId:variant.id, id:workStepId, prio:prio},  function(result) {
            $scope.part = result;
          });
        };

        $scope.showChangeStockPrice = function() {
          $scope.$emit('clearErrors');
          $scope.changePrice = {id: $scope.part.id, dateOfChange: new Date(), price: 0};
          if ($scope.part && Array.isArray($scope.part.partPrices) && $scope.part.partPrices[0]) {
            $scope.changePrice.price = $scope.part.partPrices[0].price;
          }
          $('#changeStockPrice').modal('show');
        };

        $scope.executeChangeStockPrice = function() {
          Part.updateStockPrice($scope.changePrice, function(result) {
            $scope.part = result;
            resetMovements();
            $('#changeStockPrice').modal('hide');
          });
        };

        $scope.switchToMovements = function() {
          $scope.currentTab = 'movements';
          if ($scope.movements.length === 0) {
            $scope.loadMovementPage(0);
          }
        };

        $scope.loadMovementPage = function(pageNumber) {
          var q = {
              page : pageNumber,
              per_page : 20,
              partId: $scope.part.id
            };
          Movement.query(q, function(result) {
            $scope.movements = result.entities;
            $scope.movementPageResult = result;
          });
        };
        $scope.switchToDeliveryNotes = function() {
            $scope.currentTab = 'DeliveryNotes';
            $rootScope.$broadcast('dodomaApp:showDeliveryNotes', 0);
        };
        $scope.switchToGiveOuts = function() {
            $scope.currentTab = 'GiveOuts';
            $rootScope.$broadcast('dodomaApp:showGiveOuts', 0);
        };
        $scope.switchToOrderPlans = function() {
          $scope.currentTab = 'OrderPlans';
          $rootScope.$broadcast('dodomaApp:showOrderPlans', 0);
        }
    }]);

'use strict';

angular.module('dodomaApp').controller('PartDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'Part', 'stock',
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, Part, stock) {

      $scope.part = entity;
      $scope.load = function(id) {
        Part.get({id : id}, function(result) {
          $scope.part = result;
        });
      };

      $scope.create = function() {
        Part.update($scope.part, function(result) {
          $rootScope.$broadcast('dodomaApp:partUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.hasStock = function() {
        return $scope.part.stock && angular.isNumber($scope.part.stock.id);
      };

      if ($stateParams.stockId) {
        stock.$promise.then(function(stock) {
          $scope.part.stock = stock;
        });
      }
}]);

'use strict';

angular.module('dodomaApp')
.directive('partTable', ['Part', function(Part) {
    return {
        templateUrl: 'scripts/app/entities/part/partTable.html',
        scope: {
            query : '=',
            entityList : '=',
            // put a flag 'partsLoaded' to indicate if the parts are already loaded, or not.
            state : '=',
            showNewButton : '@',
        },
        controller: function ($scope) {
            if (!$scope.query && !$scope.entityList) {
                throw "query or entityList needs to be defined on scope: " + $scope;
            }
            if ($scope.state) {
              $scope.state.partsLoaded = false;
            }
            $scope.loadEntities = function(pageNumber) {
              if ($scope.entityList) {
                  $scope.entities = $scope.entityList;
                  return;
              }
              var q = angular.extend($scope.query, { page : pageNumber, per_page : 20 });
              Part.query(q, function(result) {
                $scope.entities = result.entities;
                $scope.result = result;
                if ($scope.state) {
                  $scope.state.partsLoaded = true;
                }
              });
            };
            $scope.$on('dodomaApp:showParts', function(event, page) {
                $scope.loadEntities(page);
            });
            $scope.extended = ($scope.hideExtended !== 'true');

          }
    };
}]);


'use strict';

angular.module('dodomaApp')
    .factory('Part', ['$resource', function ($resource) {

        var responseHelper = function (data) {
          if (!data || data.trim() === '') {
            return null;
          }
          try {
            return angular.fromJson(data);
          } catch (e) {
            // If not JSON, return raw data
            return data;
          }
        };
        return $resource('api/parts/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'queryMinimal': { method: 'GET', isArray: false, url: 'api/parts/minimal'},
            'get': {
                method: 'GET',
                transformResponse: responseHelper
            },
            'updateStockPrice': {
              method: 'PUT',
              url: 'api/parts/:id/updateStockPrice',
              params: { id:'@id' },
              transformResponse: responseHelper
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('stockLocation', {
                parent: 'stockManagement',
                url: '/stockLocation',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'dodomaApp.stockLocation.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/stockLocation/stockLocations.html',
                        controller: 'StockLocationController'
                    }
                }
            })
            .state('stockLocationDetail', {
                parent: 'stockManagement',
                url: '/stockLocation/:id',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'dodomaApp.stockLocation.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/stockLocation/stockLocation-detail.html',
                        controller: 'StockLocationDetailController'
                    }
                }
            })
            .state('stockLocationNew', {
              parent: 'partDetail',
              url: '/new',
              data: {
                  roles: ['ROLE_STOREMANAGER', 'ROLE_STOREREVIEWER']
              },
              onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                entity.$promise.then(function(part) {
                  $uibModal.open({
                    templateUrl: 'scripts/app/entities/stockLocation/stockLocation-dialog.html',
                    controller: 'StockLocationDialogController',
                    size: 'lg',
                    resolve: {
                      part: function() { 
                        return part;
                      },
                      stockLocation: function() {
                        return {physicalAmount: 0, availableAmount: null, id: null, part:{id:$stateParams.partId}};
                      }
                    }
                  }).result.then(function(result) {
                    $state.go('^');
                  }, function() {
                    $state.go('^');
                  });
                });
              }]
            })
            .state('stockLocationEdit', {
              parent: 'partDetail',
              url: '/stockLocation/{stockLocationId:int}',
              data: {
                  roles: ['ROLE_STOREREVIEWER']
              },
              onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                entity.$promise.then(function(part) {
                  $uibModal.open({
                    templateUrl: 'scripts/app/entities/stockLocation/stockLocation-dialog.html',
                    controller: 'StockLocationDialogController',
                    size: 'lg',
                    resolve: {
                      part: function() { 
                        return part;
                      },
                      stockLocation: ['StockLocation', function(StockLocation) {
                        return StockLocation.get({stockLocationId : $stateParams.stockLocationId, partId: $stateParams.partId}).$promise;
                      }]
                    }
                  }).result.then(function(result) {
                    $state.go('^');
                  }, function() {
                    $state.go('^');
                  });
                });
              }]
            })
            .state('stockLocationRevise', {
              parent: 'partDetail',
              url: '/stockLocation/{stockLocationId:int}/revise',
              data: {
                  roles: ['ROLE_STOREREVIEWER'],
                  revise:true
              },
              onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                entity.$promise.then(function(part) {
                  $uibModal.open({
                    templateUrl: 'scripts/app/entities/stockLocation/stockLocation-dialog.html',
                    controller: 'StockLocationDialogController',
                    size: 'lg',
                    resolve: {
                      part: function() {
                        return part;
                      },
                      stockLocation: ['StockLocation', function(StockLocation) {
                        return StockLocation.get({stockLocationId : $stateParams.stockLocationId, partId: $stateParams.partId}).$promise;
                      }]
                      
                    }
                  }).result.then(function(result) {
                    $state.go('^');
                  }, function() {
                    $state.go('^');
                  });
                });
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('StockLocationController',
                ['$scope', 'StockLocation', 'ParseLinks',
                function ($scope, StockLocation, ParseLinks) {
        $scope.stockLocations = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            StockLocation.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.stockLocations = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            StockLocation.get({id: id}, function(result) {
                $scope.stockLocation = result;
                $('#deleteStockLocationConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            StockLocation.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteStockLocationConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.clear = function () {
            $scope.stockLocation = {physicalAmount: null, availableAmount: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('StockLocationDetailController',
                ['$scope', '$rootScope', '$stateParams', 'StockLocation',
                function ($scope, $rootScope, $stateParams, StockLocation) {
        $scope.stockLocation = {};
        $scope.load = function (id) {
            StockLocation.get({id: id}, function(result) {
              $scope.stockLocation = result;
            });
        };
        $rootScope.$on('dodomaApp:stockLocationUpdate', function(event, result) {
          $scope.stockLocation = result;
        });

        $scope.load($stateParams.id);
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('StockLocation', ['$resource', function ($resource) {
        return $resource('api/parts/:partId/stockLocations/:id', { partId : '@part.id'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
              method: 'GET',
              url: 'api/parts/:partId/stockLocations/:stockLocationId', 
              params: { partId: '@partId', stockLocationId: '@stockLocationId' },
              transformResponse: function (data) {
                  data = angular.fromJson(data);
                  return data;
              }
            },
            'revise': {
              method: 'POST',
              url: 'api/parts/:partId/stockLocations/:stockLocationId/revise', 
              params: { partId: '@partId', stockLocationId: '@stockLocationId' },
              transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
              }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp').controller('StockLocationDialogController',
    ['$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'StockLocation', 'part', 'stockLocation', 
        function($scope, $rootScope, $state, $stateParams, $uibModalInstance, StockLocation, part, stockLocation) {

      var revise = $state.current && $state.current.data && $state.current.data.revise;

      $scope.showInitialTime = revise;
      $scope.stockLocation = stockLocation;
      $scope.part = part;
      $scope.load = function(partId, stockLocationId) {
        var q = {stockLocationId : stockLocationId, partId: partId};
        StockLocation.get(q, function(result) {
          $scope.stockLocation = result;
          $scope.stockLocation.part = {id:partId};
        });
      };

      $scope.create = function() {
        var update = revise ? StockLocation.revise : StockLocation.update;
        var obj = angular.extend({stockLocationId : $stateParams.stockLocationId, partId: part.id}, $scope.stockLocation);
        update(obj, function(result) {
          $rootScope.$broadcast('dodomaApp:partUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

}]);

'use strict';

angular.module('dodomaApp').controller('StockDialogController',
    ['$scope', '$stateParams', '$rootScope', '$uibModalInstance', 'entity', 'Stock',
        function($scope, $stateParams, $rootScope, $uibModalInstance, entity, Stock) {

      $scope.stock = entity;
      $scope.load = function(id) {
        Stock.get({id : id}, function(result) {
          $scope.stock = result;
        });
      };

      var onSaveFinished = function (result) {
        $rootScope.$broadcast('dodomaApp:stockUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.save = function () {
        if ($scope.stock.id != null) {
          Stock.update($scope.stock, onSaveFinished);
        } else {
          Stock.save($scope.stock, onSaveFinished);
        }
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp').controller('PartnerDialogController',
    ['$scope', '$rootScope', '$uibModalInstance', 'Partner', 'entity',
        function($scope, $rootScope, $uibModalInstance, Partner, entity) {

      $scope.partner = entity;
      $scope.load = function(id) {
        Partner.get({id : id}, function(result) {
          $scope.partner = result;
        });
      };

      $scope.create = function() {
        Partner.update($scope.partner, function(result) {
          $rootScope.$broadcast('dodomaApp:partnerUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

}]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();
      
      var deliveryNote = {
          parent: 'stockManagement',
          url: '/deliveryNotes',
          data: {
              roles: ['ROLE_STORE_VIEWER'],
              pageTitle: 'dodomaApp.deliveryNote.home.title'
          },
          views: {
              'content@': {
                  templateUrl: 'scripts/app/entities/deliveryNote/deliveryNotes.html',
                  controller: 'DeliveryNoteController'
              }
          },
      };
      var deliveryNoteDetail = {
          parent: 'deliveryNote',
          url: '/{deliveryNoteId:int}',
          data: {
              roles: ['ROLE_STORE_VIEWER'],
              pageTitle: 'dodomaApp.deliveryNote.detail.title'
          },
          views: {
              'content@': {
                  templateUrl: 'scripts/app/entities/deliveryNote/deliveryNote-detail.html',
                  controller: 'DeliveryNoteDetailController'
              }
          },
          resolve: {
              entity: ['$stateParams', 'DeliveryNote', 'ErrorHandler', function($stateParams, DeliveryNote, ErrorHandler) {
                  return DeliveryNote.get({id : $stateParams.deliveryNoteId}).$promise
                      .catch(ErrorHandler.rejectWith('dodomaApp.deliveryNote.notFound'));
              }]
          }
      };
      
      var deliveryNoteNew = {
          url: '/new?partId',
          data: {
              roles: ['ROLE_STORE_IN_OUT'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', 'historyRecords', function($stateParams, $state, $uibModal, historyRecords) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/deliveryNote/deliveryNote-dialog.html',
              controller: 'DeliveryNoteDialogController',
              size: 'lg',
              resolve: {
                addPart : ['Part', function(Part) {
                  if ($stateParams.partId) {
                    return Part.get({id: $stateParams.partId});
                  } else {
                    return undefined;
                  }
                }],
                entity: function() {
                  return {deliveryNumber: null, deliveryDate: new Date(), state: null, id: null, type:'INTERNAL', supplier:null, orderPlan: null, initialAmount:1, initialPrice:1};
                }
              }
            }).result.then(function(result) {
              $state.go('deliveryNoteDetail', {deliveryNoteId: result.id});
            }, function() {
              $state.go('^');
            })
          }]
      };
      var deliveryNoteEdit = {
          url: '/edit',
          data: {
              roles: ['ROLE_STORE_IN_OUT'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/deliveryNote/deliveryNote-dialog.html',
              controller: 'DeliveryNoteDialogController',
              size: 'lg',
              resolve: {
                  entity: ['DeliveryNote', function(DeliveryNote) {
                      return DeliveryNote.get({id : $stateParams.deliveryNoteId});
                  }],
                  addPart: function() {
                    return undefined;
                  }
              }
            }).result.then(function(result) {
              $state.go('deliveryNoteDetail', {deliveryNoteId: result.id});
            }, function() {
              $state.go('deliveryNoteDetail', {deliveryNoteId: $stateParams.deliveryNoteId});
            })
          }]
      };
      
      $stateProvider
            .state('deliveryNote', deliveryNote)
            .state('deliveryNoteDetail', deliveryNoteDetail)
            .state('deliveryNote.new', stateUtil.stateUrl(deliveryNoteNew))
            .state('partDetail.deliveryNoteNew', stateUtil.stateUrl(deliveryNoteNew, '/newDeliveryNote?partId'))
            .state('deliveryNoteDetail.edit', deliveryNoteEdit);
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('DeliveryNoteController',
                ['$scope', 'DeliveryNote', 'EnumLabel', 'StorageUtil',
                function ($scope, DeliveryNote, EnumLabel, StorageUtil) {
        $scope.deliveryNotes = [];
        $scope.page = 1;

        StorageUtil.setupFilters("deliveryNoteContoller", $scope);

        $scope.pageResult = {};
        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.customFilter.partner) {
            q.supplierId = $scope.customFilter.partner.id;
          }
          if ($scope.customFilter.part) {
            q.partId = $scope.customFilter.part.id;
          }
          if ($scope.customFilter.orderPlan) {
            q.orderPlanId = $scope.customFilter.orderPlan.id;
          }
          DeliveryNote.query(q, function(result, headers) {
            $scope.deliveryNotes = result.entities;
            $scope.pageResult = result;
          });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            DeliveryNote.get({id: id}, function(result) {
                $scope.deliveryNote = result;
                $('#deleteDeliveryNoteConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            DeliveryNote.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteDeliveryNoteConfirmation').modal('hide');
                    $scope.deliveryNote = {};
                });
        };

        $scope.isModifiable = function(obj) {
          return obj && obj.state && (obj.state !== 'ADDED' && obj.state !== 'REVERTED');
        };

        $scope.stateLabel = EnumLabel.deliveryNote;

    }]);

'use strict';

angular.module('dodomaApp').controller('DeliveryNoteDialogController',
    ['$scope', '$uibModalInstance', '$rootScope', 'entity', 'DeliveryNote', 'addPart', 
        function($scope, $uibModalInstance, $rootScope, entity, DeliveryNote, addPart) {

      $scope.deliveryNote = entity;
      if (addPart) {
        $scope.deliveryNote.initialPart= addPart;
        addPart.$promise.then(function(loadedPart) {
          var price = loadedPart.partPrices && loadedPart.partPrices[0] ? loadedPart.partPrices[0].price : 1;
          $scope.deliveryNote.initialItemPrice = price;
        });
      }

      $scope.load = function(id) {
        DeliveryNote.get({id : id}, function(result) {
          $scope.deliveryNote = result;
        });
      };

      var onSaveFinished = function (result) {
        $rootScope.$broadcast('dodomaApp:deliveryNoteUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.save = function () {
        if ($scope.deliveryNote.id != null) {
          DeliveryNote.update($scope.deliveryNote, onSaveFinished);
        } else {
          DeliveryNote.save($scope.deliveryNote, onSaveFinished);
        }
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('DeliveryNoteDetailController',
                ['$scope', 'entity', 'DeliveryNote', 'DeliveryNoteItem', 'ErrorHandler',
                function ($scope, entity, DeliveryNote, DeliveryNoteItem, ErrorHandler) {
        $scope.deliveryNote = entity;

        function updateFlags() {
          $scope.everyCounter = $scope.deliveryNote.type === 'EXTERNAL_DELIVERY';
        };

        $scope.load = function (id) {
            DeliveryNote.get({id: id}, function(result) {
              $scope.deliveryNote = result;
              updateFlags();
            }, ErrorHandler.rejectWith('dodomaApp.deliveryNote.notFound'));
        };
        $scope.$on('dodomaApp:deliveryNoteUpdate', function(event, result) {
          $scope.deliveryNote = result;
          updateFlags();
        });
        
        $scope.deleteItem = function(id) {
          DeliveryNoteItem.delete({deliveryNoteId: $scope.deliveryNote.id, id:id}, function(result){ 
            $scope.deliveryNote = result;
            updateFlags();
          });
        };

        $scope.addToStock = function(id) {
          DeliveryNoteItem.addToStock({deliveryNoteId: $scope.deliveryNote.id, id:id}, function(result){ 
            $scope.deliveryNote = result;
            updateFlags();
          });
        };

        $scope.revert = function() {
          DeliveryNoteItem.revert({deliveryNoteId: $scope.deliveryNote.id}, function(result){ 
            $scope.deliveryNote = result;
            updateFlags();
          });
        };

        $scope.isModifiable = function(obj) {
          return obj && obj.state && (obj.state !== 'ADDED' && obj.state !== 'REVERTED');
        };

        $scope.addAll = function() {
          DeliveryNoteItem.addAllToStock({deliveryNoteId: $scope.deliveryNote.id}, function(result){ 
            $scope.deliveryNote = result;
            updateFlags();
          });
        };
    }]);

'use strict';

angular.module('dodomaApp')
.directive('deliveryNotesTable', ['DeliveryNote', function(DeliveryNote) {
    return {
        templateUrl: 'scripts/app/entities/deliveryNote/deliveryNoteTable.html',
        scope: {
            query : '=',
            panelClass : '@',
            entityList : '=',
            hideExtended : '@',
        },
        controller: function ($scope) {
            if (!$scope.query && !$scope.entityList) {
                throw "query or entityList needs to be defined on scope: " + $scope;
            }
            $scope.loadEntities = function(pageNumber) {
              if ($scope.entityList) {
                  $scope.entities = $scope.entityList;
                  return;
              }
              var q = angular.extend($scope.query, { page : pageNumber, per_page : 20 });
              DeliveryNote.query(q, function(result) {
                $scope.entities = result.entities;
                $scope.result = result;
              });
            };
            $scope.$on('dodomaApp:showDeliveryNotes', function(event, page) {
                $scope.loadEntities(page);
            });
            $scope.extended = ($scope.hideExtended !== 'true');

          }
    };
}]);


'use strict';

angular.module('dodomaApp')
    .factory('DeliveryNote', ['$resource', 'DateUtils', function ($resource, DateUtils) {

        var responseHelper = function (data) {
            if (!data || data.trim() === '') {
                return null;
            }
            try {
                data = angular.fromJson(data);
            } catch (e) {
                return data;
            }
            if (data) {
                data.deliveryDate = DateUtils.convertLocaleDateFromServer(data.deliveryDate);
            }
            return data;
        };

        return $resource('api/deliveryNotes/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: responseHelper
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.deliveryDate = DateUtils.convertLocaleDateToServer(data.deliveryDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.deliveryDate = DateUtils.convertLocaleDateToServer(data.deliveryDate);
                    return angular.toJson(data);
                }
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('dnNewItem', {
              parent: 'deliveryNoteDetail',
              url: '/newItem?type',
              data: {
                  roles: ['ROLE_STORE_IN_OUT'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/deliveryNoteItem/deliveryNoteItem-dialog.html',
                  controller: 'DeliveryNoteItemDialogController',
                  size: 'lg'
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            })
            .state('dnEditItem', {
              parent: 'deliveryNoteDetail',
              url: '/editItem/:itemId?type',
              data: {
                  roles: ['ROLE_STORE_IN_OUT'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/deliveryNoteItem/deliveryNoteItem-dialog.html',
                  controller: 'DeliveryNoteItemDialogController',
                  size: 'lg'
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp').controller('DeliveryNoteItemDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', '$rootScope', 'DeliveryNoteItem', 'Part', 
        function($scope, $stateParams, $uibModalInstance, $rootScope, DeliveryNoteItem, Part) {

      $scope.deliveryNoteItem = {};
      $scope.part = {};
      $scope.stocklocations = [];
      $scope.everyCounter = $stateParams.type === 'EXTERNAL_DELIVERY';
      $scope.load = function(itemId) {
        DeliveryNoteItem.get({deliveryNoteId: $stateParams.deliveryNoteId, id : itemId}, function(result) {
          $scope.deliveryNoteItem = result;
          $scope.deliveryNoteItem.deliveryNoteId = $stateParams.id;
          $scope.stocklocations = result.part.stocks;
          $scope.part = result.part;
        });
      };

      $scope.create = function() {
        $scope.deliveryNoteItem.deliveryNoteId = $stateParams.deliveryNoteId;
        DeliveryNoteItem.update($scope.deliveryNoteItem, function(result) {
          $rootScope.$broadcast('dodomaApp:deliveryNoteUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.updateCountedAmount = function() {
        $scope.deliveryNoteItem.countedAmount = $scope.deliveryNoteItem.sentAmount;
        $scope.calculate();
      };

      $scope.calculate = function() {
        $scope.deliveryNoteItem.addToStockAmount = $scope.deliveryNoteItem.countedAmount - $scope.deliveryNoteItem.brokenAmount;
        $scope.calculateTotalPrice();
      };

      $scope.calculateTotalPrice = function() {
        $scope.deliveryNoteItem.price = $scope.deliveryNoteItem.addToStockAmount * $scope.deliveryNoteItem.itemPrice;
      };

      $scope.calculateItemPrice = function() {
        $scope.deliveryNoteItem.itemPrice = $scope.deliveryNoteItem.price / $scope.deliveryNoteItem.addToStockAmount;
      };

      $scope.partSelected = function(item) {
        if (item && item.id) {
          Part.get({id:item.id}, function(result) {
            $scope.stocklocations = result.stocks;
            $scope.part = result;
          });
        } else {
          $scope.stocklocations = [];
        }
      };
      
      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      if (typeof ($stateParams.itemId) != 'undefined' && $stateParams.itemId != 'new') {
        $scope.load($stateParams.itemId);
      } else {
        $scope.deliveryNoteItem = {
            sentAmount: 0, countedAmount: null, brokenAmount: 0, addToStockAmount: 0, 
            itemPrice: null, price: null, id: null, deliveryNoteId: $stateParams.id};
        $scope.part = {};
        $scope.stocklocations = [];
      }
}]);

'use strict';

angular.module('dodomaApp')
    .factory('DeliveryNoteItem', ['$resource', function ($resource) {
        return $resource('api/deliveryNotes/:deliveryNoteId/items/:id', { deliveryNoteId: '@deliveryNoteId' }, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'addToStock' : {
              method:'POST',
              url:'api/deliveryNotes/:deliveryNoteId/items/:id/addToStock', 
              params: { deliveryNoteId: '@deliveryNoteId', id:'@id' }
            },
            'addAllToStock' : {
              method:'POST',
              url:'api/deliveryNotes/:deliveryNoteId/items/addAllToStock', 
              params: { deliveryNoteId: '@deliveryNoteId' }
            },
            'revert' : {
              method:'POST',
              url:'api/deliveryNotes/:deliveryNoteId/items/revert', 
              params: { deliveryNoteId: '@deliveryNoteId' }
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('movement', {
                parent: 'stockManagement',
                url: '/movements',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.movement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/movement/movements.html',
                        controller: 'MovementController'
                    }
                }
            })
            .state('movementDetail', {
                parent: 'movement',
                url: '/{id:int}',
                data: {
                    roles: ['ROLE_STORE_VIEWER'],
                    pageTitle: 'dodomaApp.movement.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/movement/movement-detail.html',
                        controller: 'MovementDetailController'
                    }
                }
            });
    }]);

'use strict';

angular.module('dodomaApp').controller(
    'MovementController',
    [
        '$scope',
        'Movement',
        'DateUtils',
        'StorageUtil',
        'RequestUtil',
        function($scope, Movement, DateUtils, StorageUtil, RequestUtil) {
          $scope.movements = [];
          $scope.page = 1;

          StorageUtil.setupFilters("movementController", $scope, {filter:{style:0}});

          $scope.grp = {};
          $scope.pageResult = {};
          $scope.aggregateReportResult = {};
          $scope.historic = [];
          $scope.disableDateSelection = false;

          $scope.oldFilters = [{},{},{}];

          function checkFilter(idx, filter) {
            if (angular.equals($scope.oldFilters[idx], filter)) {
              return true;
            }
            $scope.oldFilters[idx] = filter;
            return false;
          }

          function buildQueryObject(q) {
            if (angular.isDefined($scope.filter.part) && $scope.filter.part) {
              q.partId = $scope.filter.part.id;
            }
            if (angular.isDefined($scope.filter.partType) && $scope.filter.partType) {
              q.partTypeId = $scope.filter.partType.id;
            }
            if (angular.isDefined($scope.filter.stock) && $scope.filter.stock) {
              q.stockId = $scope.filter.stock.id;
            }
            if (angular.isDefined($scope.filter.partner) && $scope.filter.partner) {
              q.partnerId = $scope.filter.partner.id;
            }
            if (angular.isDefined($scope.filter.startDate)) {
              q.after = DateUtils.convertLocaleDateToServer($scope.filter.startDate);
            }
            if (angular.isDefined($scope.filter.endDate)) {
              q.before = DateUtils.convertLocaleDateToServer($scope.filter.endDate);
            }
            if (angular.isArray($scope.filter.movementTypes)
                && $scope.filter.movementTypes.length > 0) {
              q.movementTypes = $scope.filter.movementTypes;
            }
            if (angular.isDefined($scope.filter.user)) {
              q.userId = $scope.filter.user.id;
            }
            return q;
          }

          $scope.loadAll = function() {
            var q = buildQueryObject({page : $scope.page, per_page : 20});

            switch ($scope.filter.style) {
              case 0: {
                if (checkFilter(0, q)) {
                  return;
                }
                Movement.query(q, function(result) {
                  $scope.movements = result.entities;
                  $scope.pageResult = result;
                });
                break;
              }
              case 1: {
                var qq = angular.copy($scope.grp);
                qq.criteria = q;
                if (checkFilter(1, qq)) {
                  return;
                }
                Movement.report(qq, function(result) {
                  $scope.aggregateReportResult = result;
                });
                break;
              }
              case 2: {
                if (angular.isDefined($scope.filter.statusAt)) {
                  q.statusAt = DateUtils.convertLocaleDateToServer($scope.filter.statusAt);
                }
                if (checkFilter(2, q)) {
                  return;
                }
                Movement.historic(q, function(result) {
                  $scope.historic = result.entities;
                  $scope.historicPageResult = result;
                });
                break;
              }
              default: {

              }
            }
          };
          $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
          };
          $scope.switchTab = function(tab) {
            if ($scope.filter.style !== tab) {
              $scope.filter.style = tab;
              $scope.loadAll();
            }
            $scope.disableDateSelection = (tab === 2);
          };
          $scope.todayAsString = function() {
            return DateUtils.todayAsString();
          };

          $scope.historicExportUrl = function() {
            var q = buildQueryObject({});
            if (angular.isDefined($scope.filter.statusAt)) {
              q.statusAt = DateUtils.convertLocaleDateToServer($scope.filter.statusAt);
            }
            return RequestUtil.createLink('/api/movements/historic/export.xls?format=xls&', q);
          }

          $scope.movementExportUrl = function() {
            var q = buildQueryObject({});
            return RequestUtil.createLink('/api/movements/export.xls?format=xls&', q);
          }

          $scope.$watch('filter.stockId', $scope.loadAll);
          $scope.$watch('filter.partTypeId', $scope.loadAll);

          $scope.$watch('filter.aggregateReport', $scope.loadAll);
          $scope.$watch('grp.groupByPart', $scope.loadAll);
          $scope.$watch('grp.groupByPartType', $scope.loadAll);
          $scope.$watch('grp.groupByYear', $scope.loadAll);
          $scope.$watch('grp.groupByMonth', $scope.loadAll);
          $scope.$watch('grp.groupByMovementType', $scope.loadAll);
          $scope.$watch('grp.groupByPartner', $scope.loadAll);
          $scope.$watch('grp.groupByStock', $scope.loadAll);
          $scope.$watch('grp.groupByUser', $scope.loadAll);

          $scope.loadAll();

        } ]);

'use strict';

angular.module('dodomaApp')
    .controller('MovementDetailController',
                ['$scope', '$rootScope', '$stateParams', 'Movement',
                function ($scope, $rootScope, $stateParams, Movement) {
        $scope.movement = {};
        $scope.load = function (id) {
            Movement.get({id: id}, function(result) {
              $scope.movement = result;
            });
        };
        $rootScope.$on('dodomaApp:movementUpdate', function(event, result) {
          $scope.movement = result;
        });

        $scope.load($stateParams.id);
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Movement', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/movements/:id', {}, {
            'query': { method: 'GET', isArray: false,  params: { part: '@partId' },
              transformResponse: function (data) {
                data = angular.fromJson(data);
                if (data) {
                    angular.forEach(data.entities, function(item) {
                       item.createdDate = DateUtils.convertDateTimeFromServer(item.createdDate);
                    });
                }
                return data;
              }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'types': { method: 'GET', isArray: true,url : 'api/movements/types' },
            'report': {
              method: 'POST',
              isArray: false,
              url: 'api/movements/report',
            },
            'historic': {
              method: 'GET',
              isArray: false,
              url: 'api/movements/historic',
              transformResponse: function (data) {
                data = angular.fromJson(data);
                if (data) {
                    angular.forEach(data.entities, function(item) {
                        item.createdDate = DateUtils.convertDateTimeFromServer(item.createdDate);
                    });
                }
                return data;
              }
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('workStepPartNeed', {
                parent: 'productionManagement',
                url: '/workStepPartNeeds',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'dodomaApp.workStepPartNeed.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workStepPartNeed/workStepPartNeeds.html',
                        controller: 'WorkStepPartNeedController'
                    }
                }
            })
            .state('workStepPartNeedDetail', {
                parent: 'productionManagement',
                url: '/workStepPartNeed/:id',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'dodomaApp.workStepPartNeed.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workStepPartNeed/workStepPartNeed-detail.html',
                        controller: 'WorkStepPartNeedDetailController'
                    }
                }
            })
            .state('partNeedNew', {
              parent: 'workStepDetail',
              url: '/new',
              data: {
                  roles: ['ROLE_USER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/workStepPartNeed/workStepPartNeed-dialog.html',
                  controller: 'WorkStepPartNeedDialogController',
                  size: 'lg'
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            })
            .state('partNeedEdit', {
              parent: 'workStepDetail',
              url: '/edit/:partNeedId',
              data: {
                  roles: ['ROLE_USER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/workStepPartNeed/workStepPartNeed-dialog.html',
                  controller: 'WorkStepPartNeedDialogController',
                  size: 'lg'
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkStepPartNeedController',
                ['$scope', 'WorkStepPartNeed', 'ParseLinks',
                function ($scope, WorkStepPartNeed, ParseLinks) {
        $scope.workStepPartNeeds = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            WorkStepPartNeed.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.workStepPartNeeds = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            WorkStepPartNeed.get({id: id}, function(result) {
                $scope.$emit('clearErrors');
                $scope.workStepPartNeed = result;
                $('#deleteWorkStepPartNeedConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            WorkStepPartNeed.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteWorkStepPartNeedConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.clear = function () {
            $scope.workStepPartNeed = {amount: null, type: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkStepPartNeedDetailController',
                ['$scope', '$rootScope', '$stateParams', 'WorkStepPartNeed',
                function ($scope, $rootScope, $stateParams, WorkStepPartNeed) {
        $scope.workStepPartNeed = {};
        $scope.load = function (id) {
            WorkStepPartNeed.get({id: id}, function(result) {
              $scope.workStepPartNeed = result;
            });
        };
        $rootScope.$on('dodomaApp:workStepPartNeedUpdate', function(event, result) {
          $scope.workStepPartNeed = result;
        });

        $scope.load($stateParams.id);
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkStepPartNeed', ['$resource', function ($resource) {
        return $resource('api/workSteps/:workStepId/parts/:partNeedId', { workStepId: '@workStepId', partNeedId: '@partNeedId' }, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
  .directive('ddWorkStepPartNeedSelect', function() {
    return {
      restrict : 'AE', // Attribute or entity
      scope: {
        ngModel : '='
      },
      controller : function($scope) {
          $scope.workStepPartNeedTypes = [];
          angular.forEach(['TOOL','CONSUMABLE', 'BY_PRODUCT', 'FLEX_CONSUMABLE'], function(key) {
            $scope.workStepPartNeedTypes.push({key:key, translationKey:'dodomaApp.workStepPartNeed.typeLabel.'+key});
          });
      },
      template: function(element, attrs) {
        return '<select class="form-control" name="workStepPartNeedType" ng-model="ngModel" '+
            (attrs.required != undefined ? 'required ' : '') +
            'ng-options="opt.key as opt.translationKey | translate for opt in workStepPartNeedTypes"></select>';        
      }
    };
  }
).directive('ddWorkStepPartNeedLabel', ['$translate', function($translate) {
    return {
      restrict: 'AE',
      scope : {
          ddWorkStepPartNeedLabel : '='
      },
      template: "{{translatedValue}}",
      controller: function($scope) {
        $scope.translatedValue = null;
        $scope.setValue = function(value) {
          if (value != '') {
            $translate('dodomaApp.workStepPartNeed.typeLabel.' + value).then(function(translation) {
              $scope.translatedValue = translation;
            });
          } else {
            $scope.translatedValue = '';
          }
        };
        $scope.$watch('ddWorkStepPartNeedLabel', function(newValue, oldValue) {
          if (newValue != oldValue) {
            $scope.setValue(newValue);
          }
        });
        $scope.setValue($scope.ddWorkStepPartNeedLabel);
      }
    };
}]);

'use strict';

angular.module('dodomaApp').controller('WorkStepPartNeedDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'WorkStepPartNeed', 
        function($scope, $stateParams, $uibModalInstance, WorkStepPartNeed) {

      $scope.workStepPartNeed = {};
      $scope.load = function(workStepId, partNeedId) {
        WorkStepPartNeed.get({workStepId : workStepId, partNeedId: partNeedId}, function(result) {
          $scope.workStepPartNeed = result;
        });
      };

      $scope.create = function() {
        $scope.workStepPartNeed.workStepId = $stateParams.workStepId;
        WorkStepPartNeed.update($scope.workStepPartNeed, function(result) {
          $scope.$emit('dodomaApp:workStepUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      if (typeof ($stateParams.partNeedId) != 'undefined' && $stateParams.partNeedId != 'new') {
        $scope.load($stateParams.workStepId, $stateParams.partNeedId);
      } else {
        $scope.workStepPartNeed = {amount: null, type: null, id: null};
      }
}]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();
        $stateProvider
            .state('workStep', {
                parent: 'productionManagement',
                url: '/workSteps',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.workStep.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workStep/workSteps.html',
                        controller: 'WorkStepController'
                    }
                }
            })
            .state('workStepDetail', {
                parent: 'productionManagement',
                url: '/workStep/{workStepId:int}',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.workStep.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workStep/workStep-detail.html',
                        controller: 'WorkStepDetailController'
                    }
                }
            });

        var workStepNew = {
            url: '/newStep?name&externalName&variantId',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/workStep/workStep-dialog.html',
                controller: 'WorkStepDialogController',
                size: 'lg',
                resolve: {
                  entity : function() {
                    return {name: $stateParams.name, externalName: $stateParams.externalName, variantId: $stateParams.variantId, description: null, standardTime: null, id: null, requirements:[], partnerId: $stateParams.partnerId};
                  }
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
        };
        var workStepEdit = {
          url: '/variant/{variantId:int}/editStep/{workStepId:int}',
          data: {
            roles: ['ROLE_PRODUCTIONMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/workStep/workStep-dialog.html',
              controller: 'WorkStepDialogController',
              size: 'lg',
              resolve: {
                entity : ['WorkStep', function(WorkStep) {
                  if (angular.isNumber($stateParams.partnerId)) {
                    return WorkStep.getByPartner({partnerId: $stateParams.partnerId, id:$stateParams.workStepId});
                  } else {
                    return WorkStep.get({partId: $stateParams.partId, variantId: $stateParams.variantId, id:$stateParams.workStepId});
                  }
                }]
              }
            }).result.then(function(result) {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };

        $stateProvider
            .state('partDetail.workStepNew', stateUtil.stateUrl(workStepNew))
            .state('partnerDetail.workStepNew', stateUtil.stateUrl(workStepNew))
            .state('partDetail.workStepEdit', stateUtil.stateUrl(workStepEdit))
            .state('partnerDetail.workStepEdit', stateUtil.stateUrl(workStepEdit))
        ;

    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkStepController',
                ['$scope', 'WorkStep', 'ParseLinks',
                function ($scope, WorkStep, ParseLinks) {
        $scope.workSteps = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            WorkStep.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.workSteps = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            WorkStep.get({id: id}, function(result) {
                $scope.workStep = result;
                $('#deleteWorkStepConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            WorkStep.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteWorkStepConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.clear = function () {
            $scope.workStep = {name: null, externalName: null, description: null, amount: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkStepDialogController',
    ['$scope',  '$rootScope', '$stateParams', '$uibModalInstance', 'WorkStep', 'WorkPricingCategory', 'ProductionEvaluation', 'entity',
        function($scope, $rootScope, $stateParams, $uibModalInstance, WorkStep, WorkPricingCategory, ProductionEvaluation, entity) {

      $scope.workStep = entity;
      $scope.pricings = WorkPricingCategory.query();
      $scope.evaluations = ProductionEvaluation.query();
      $scope.possibleRatios = [10, 5, 4, 2, 1];
      $scope.formatRatio = function(ratio) {
        return "1/"+ratio + " rész";
      };
      $scope.load = function(partId,id) {
        WorkStep.get({partId: partId, id : id}, function(result) {
          $scope.workStep = result;
        });
      };

      var closeFunction = function(result) {
        $rootScope.$broadcast('dodomaApp:workStepUpdate', result);
        $rootScope.$broadcast('dodomaApp:partUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.create = function() {
        if (angular.isNumber($stateParams.partId)) {
          $scope.workStep.partId = $stateParams.partId;
        }
        if (angular.isNumber($stateParams.partnerId)) {
          $scope.workStep.partnerId = $stateParams.partnerId;
        }
        WorkStep.persist($scope.workStep, closeFunction);
      };


      $scope.addNewLine = function() {
        $scope.workStep.requirements.push({id:null, type:'CONSUMABLE', part: {id:null}, amount:1.0});
      };
      $scope.removeLine = function($index) {
        $scope.workStep.requirements.splice($index,1);
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

}]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkStepDetailController',
                ['$scope', '$rootScope', '$stateParams', 'WorkStep', 'WorkStepPartNeed',
                function ($scope, $rootScope, $stateParams, WorkStep, WorkStepPartNeed) {
        $scope.workStep = {};
        $scope.load = function (id) {
            WorkStep.get({id: id}, function(result) {
              $scope.workStep = result;
            });
        };
        $rootScope.$on('dodomaApp:workStepUpdate', function(event, result) {
          $scope.workStep = result;
        });
        
        $scope.deletePartNeed = function(partNeedId) {
          WorkStepPartNeed.delete({workStepId : $stateParams.workStepId, partNeedId: partNeedId}, function(result) {
            $scope.workStep = result;
          });
        };

        $scope.load($stateParams.workStepId);
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkStep', ['$resource', function ($resource) {
        return $resource('api/parts/:partId/variant/:variantId/workSteps/:id', { partId: '@partId', variantId: '@variantId' }, {
            'query': { method: 'GET', isArray: true},
            'queryVirtualParts' : { method:'GET', isArray:false, url: 'api/partners/:partnerId/workSteps', params:{partnerId: '@partnerId'}},
            'queryAll': { method: 'GET', isArray: false, url : 'api/workSteps'},
            'persist': { method: 'POST', url: 'api/workSteps'},
            'setActive': { 
                method: 'POST', 
                url: 'api/parts/:partId/variant/:variantId/workSteps/:id/active/:flag',
                params: { flag: '@flag', id: '@id', variantId: '@variantId'},
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'changePriority': { 
                method: 'POST', 
                url: 'api/parts/:partId/variant/:variantId/workSteps/:id/prio/:prio',
                params: { prio: '@prio', id: '@id', variantId: '@variantId'},
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByPartner': {
                method: 'GET',
                url: 'api/partners/:partnerId/workSteps/:id',
                params:{partnerId: '@partnerId'},
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider','stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();

      var giveOut = {
          parent: 'stockManagement',
          url: '/giveOuts',
          data: {
              roles: ['ROLE_STORE_VIEWER'],
              pageTitle: 'dodomaApp.giveOut.home.title'
          },
          views: {
              'content@': {
                  templateUrl: 'scripts/app/entities/giveOut/giveOuts.html',
                  controller: 'GiveOutController'
              }
          }
      };
      
      var giveOutDetail = {
          parent: 'giveOut',
          url: '/{id:int}',
          data: {
              roles: ['ROLE_STORE_VIEWER'],
              pageTitle: 'dodomaApp.giveOut.detail.title'
          },
          views: {
              'content@': {
                  templateUrl: 'scripts/app/entities/giveOut/giveOut-detail.html',
                  controller: 'GiveOutDetailController'
              }
          },
          resolve: {
              entity: ['$stateParams', 'GiveOut', 'ErrorHandler', function($stateParams, GiveOut, ErrorHandler) {
                  return GiveOut.get({id : $stateParams.id}).$promise
                      .catch(ErrorHandler.rejectWith('dodomaApp.giveOut.notFound'));
              }]
          }
      };
      
      var giveOutNew = {
          url: '/new?partId',
          data: {
              roles: ['ROLE_STORE_IN_OUT'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', 'historyRecords', function($stateParams, $state, $uibModal, historyRecords) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/giveOut/giveOut-dialog.html',
              controller: 'GiveOutDialogController',
              size: 'lg',
              resolve: {
                addPart : ['Part', function(Part) {
                  if ($stateParams.partId) {
                    return Part.get({id: $stateParams.partId});
                  } else {
                    return undefined;
                  }
                }],
                entity: function() {
                  return {giveOutNumber: null, type: 'INTERNAL', state: null, comment: null, creationDate: null, giveOutTime: null, id: null, initialPart: null, initialAmount: 1};
                }
              }
            }).result.then(function(result) {
              $state.go('giveOutDetail', {id: result.id});
            }, function() {
              $state.go('^');
            })
          }]
      };
      var giveOutEdit = {
          url: '/edit',
          data: {
              roles: ['ROLE_STORE_IN_OUT'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/giveOut/giveOut-dialog.html',
              controller: 'GiveOutDialogController',
              size: 'lg',
              resolve: {
                entity: ['GiveOut', function(GiveOut) {
                  return GiveOut.get({id : $stateParams.id});
                }],
                addPart: function() {
                  return undefined;
                }
              }
            }).result.then(function(result) {
              $state.go('giveOutDetail', {id: result.id});
            }, function() {
              $state.go('giveOutDetail', {id: $stateParams.id});
            })
          }]
      };
      
      $stateProvider
            .state('giveOut', giveOut)
            .state('giveOutDetail', giveOutDetail)
            .state('giveOut.new', stateUtil.stateUrl(giveOutNew))
            .state('partDetail.giveOutNew', stateUtil.stateUrl(giveOutNew, '/newGiveOut?partId'))
            .state('giveOutDetail.edit', giveOutEdit)
            ;
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('GiveOutController',
                ['$scope', 'GiveOut', 'EnumLabel', 'StorageUtil',
                function ($scope, GiveOut, EnumLabel, StorageUtil) {
        $scope.giveOuts = [];
        $scope.page = 1;

        StorageUtil.setupFilters("giveOutController", $scope);

        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.customFilter.partner) {
            q.supplierId = $scope.customFilter.partner.id;
          }
          if ($scope.customFilter.creator) {
            q.creatorUserId = $scope.customFilter.creator.id;
          }
          if ($scope.customFilter.giveOutUser) {
            q.giveOutUserId = $scope.customFilter.giveOutUser.id;
          }
          if ($scope.customFilter.giveOutWorker) {
            q.workerId = $scope.customFilter.giveOutWorker.id;
          }
          if ($scope.customFilter.approvalUser) {
            q.approvalUserId = $scope.customFilter.approvalUser.id;
          }
          if ($scope.customFilter.part) {
            q.partId = $scope.customFilter.part.id;
          }

          GiveOut.query(q, function(result, headers) {
            $scope.giveOuts = result.entities;
            $scope.pageResult = result;
          });
        };

        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            GiveOut.get({id: id}, function(result) {
                $scope.giveOut = result;
                $('#deleteGiveOutConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            GiveOut.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteGiveOutConfirmation').modal('hide');
                    $scope.giveOut = {};
                });
        };

        $scope.isModifiable = function(obj) {
          return obj && obj.state && obj.state !== 'DONE';
        };

        $scope.stateLabel = EnumLabel.giveOut;

    }]);

'use strict';

angular.module('dodomaApp').controller('GiveOutDialogController',
    ['$scope', '$rootScope', '$uibModalInstance', 'GiveOut', 'entity', 'addPart', 'User',
        function($scope, $rootScope, $uibModalInstance, GiveOut, entity, addPart, User) {

      $scope.giveOut = entity;
      $scope.giveOut.backdatedGiveout = false;
      if (addPart) {
        $scope.giveOut.initialPart= addPart;
      }
      $scope.users = User.find({role:'ROLE_STORE_RECEIVER'});

      if (angular.isDefined(entity.$promise)) {
        entity.$promise.then(function(g) {
          $scope.giveOut.backdatedGiveout = g.giveOutTime !== null;
        });
      }

      $scope.backdatedChanged = function() {
          if ($scope.giveOut.backdatedGiveout === false) {
              $scope.giveOut.giveOutTime = null;
          }
      }

      $scope.load = function(id) {
        GiveOut.get({id : id}, function(result) {
          $scope.giveOut = result;
        });
      };

      $scope.create = function() {
        GiveOut.update($scope.giveOut, function(result) {
          $rootScope.$broadcast('dodomaApp:giveOutUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.showApproval = function() {
        return ($scope.giveOut.type === 'FOR_WORK') || ($scope.giveOut.type === 'INTERNAL');
      }

}]);

'use strict';

angular.module('dodomaApp')
    .controller('GiveOutDetailController',
                ['$scope', 'GiveOut', 'Principal', 'GiveOutItem', 'entity', 'ErrorHandler',
                function ($scope, GiveOut, Principal, GiveOutItem, entity, ErrorHandler) {
        $scope.giveOut = entity;
        $scope.approvable = false;

        function updateApprovable(obj) {
          if (obj && obj.state && obj.state === 'DONE' && obj.approval === 'ASKED') {
            Principal.identity().then(function(identity) {
              $scope.approvable = (identity.id === obj.approvalUser.id);
            });
          } else {
            $scope.approvable = false;
          }
        };

        $scope.load = function (id) {
            GiveOut.get({id: id}, function(result) {
              $scope.giveOut = result;
              updateApprovable(result);
            }, ErrorHandler.rejectWith('dodomaApp.giveOut.notFound'));
        };
        $scope.$on('dodomaApp:giveOutUpdate', function(event, result) {
          $scope.giveOut = result;
          updateApprovable(result);
        });

        $scope.isModifiable = function(obj) {
          return obj && obj.state && obj.state !== 'DONE';
        };

        $scope.deliver = function() {
          GiveOut.deliver({id: $scope.giveOut.id}, function(result) {
            $scope.giveOut = result;
            updateApprovable(result);
          });
        };

        function receive(state) {
          GiveOut.receive({id: $scope.giveOut.id, state: state}, function(result) {
            $scope.giveOut = result;
            updateApprovable(result);
          });
        };

        $scope.deleteItem = function(id) {
          GiveOutItem.delete({giveOutId: $scope.giveOut.id, id:id}, function(result){ 
            $scope.giveOut = result;
            updateApprovable(result);
          });
        };

        $scope.verify = function() {
          receive('VERIFIED');
        };
        $scope.decline = function() {
          receive('DECLINED');
        };

        updateApprovable(entity);
    }]);

'use strict';

angular.module('dodomaApp')
.directive('giveOutTable', ['GiveOut', function(GiveOut) {
    return {
        templateUrl: 'scripts/app/entities/giveOut/giveOutTable.html',
        scope: {
            query : '=',
            entityList : '=',
            hideExtended : '@',
        },
        controller: function ($scope) {
            if (!$scope.query && !$scope.entityList) {
                throw "query or entityList needs to be defined on scope: " + $scope;
            }
            $scope.loadEntities = function(pageNumber) {
              if ($scope.entityList) {
                  $scope.entities = $scope.entityList;
                  return;
              }
              var q = angular.extend($scope.query, { page : pageNumber, per_page : 20 });
              GiveOut.query(q, function(result) {
                $scope.entities = result.entities;
                $scope.result = result;
              });
            };
            $scope.$on('dodomaApp:showGiveOuts', function(event, page) {
                $scope.loadEntities(page);
            });
            $scope.extended = ($scope.hideExtended !== 'true');

          }
    };
}]);


'use strict';

angular.module('dodomaApp')
    .factory('GiveOut', ['$resource', 'DateUtils', function ($resource, DateUtils) {

        var responseHelper = function (data) {
            if (!data || data.trim() === '') {
                return null;
            }
            try {
                data = angular.fromJson(data);
            } catch (e) {
                return data;
            }
            if (data) {
                data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                data.giveOutTime = DateUtils.convertDateTimeFromServer(data.giveOutTime);
                data.approvalDate = DateUtils.convertDateTimeFromServer(data.approvalDate);
            }
            return data;
        };

        return $resource('api/giveOuts/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: responseHelper
            },
            'update': { method:'PUT' },
            'deliver': { method:'POST', url: 'api/giveOuts/:id/deliver', params:{id:'@id'}},
            'receive': { method:'POST', url: 'api/giveOuts/:id/receive/:state', params:{id:'@id', state:'@state'}}
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('newGiveOutItem', {
              parent: 'giveOutDetail',
              url: '/newItem',
              data: {
                  roles: ['ROLE_STORE_IN_OUT'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/giveOutItem/giveOutItem-dialog.html',
                  controller: 'GiveOutItemDialogController',
                  size: 'lg'
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            })
            .state('editGiveOutItem', {
              parent: 'giveOutDetail',
              url: '/editItem/:itemId',
              data: {
                  roles: ['ROLE_STORE_IN_OUT'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/giveOutItem/giveOutItem-dialog.html',
                  controller: 'GiveOutItemDialogController',
                  size: 'lg'
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp').controller('GiveOutItemDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', '$rootScope', 'GiveOutItem', 'Part',
        function($scope, $stateParams, $uibModalInstance, $rootScope, GiveOutItem, Part) {

      $scope.giveOutItem = {};
      $scope.stocklocations = [];
      $scope.maxAmount = 0;
      $scope.load = function(itemId) {
        GiveOutItem.get({giveOutId: $stateParams.id, id : itemId}, function(result) {
          $scope.giveOutItem = result;
          $scope.giveOutItem.giveOutId = $stateParams.id;
          $scope.stocklocations = result.part.stocks;
          angular.forEach($scope.stocklocations,function(item) {
            if (item.id === $scope.giveOutItem.stockLocation.id) {
              $scope.giveOutItem.stockLocation = item;
            }
          });
        });
      };

      $scope.create = function() {
        GiveOutItem.update($scope.giveOutItem, function(result) {
          $rootScope.$broadcast('dodomaApp:giveOutUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.partSelected = function(item) {
        if (item && angular.isNumber(item.id)) {
          Part.get({id:item.id}, function(result) {
            $scope.stocklocations = result.stocks;
            $scope.maxAmount = 0;
          });
        } else {
            $scope.stockLocations = [];
            $scope.maxAmount = 0;
        }
      };
      
      $scope.$watch("giveOutItem.stockLocation", function(item) {
        if (item) {
          $scope.maxAmount = item.availableAmount;
        }
      });
      
      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      if (angular.isDefined($stateParams.itemId) && ($stateParams.itemId !== 'new')) {
        $scope.load($stateParams.itemId);
      } else {
        $scope.giveOutItem = {giveOutId: $stateParams.id,
            amount: null, priority: null, id: null};
      }
}]);

'use strict';

angular.module('dodomaApp')
    .factory('GiveOutItem', ['$resource', function ($resource) {
        return $resource('api/giveOuts/:giveOutId/items/:id', { giveOutId : '@giveOutId'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();

      var worker = {
        data : {
          roles : [ 'ROLE_PRODUCTIONMANAGER', 'ROLE_REHABMANAGER' ],
          pageTitle : 'dodomaApp.worker.home.title'
        },
        views : {
          'content@' : {
            templateUrl : 'scripts/app/entities/worker/workers.html',
            controller : 'WorkerController'
          }
        }
      };
      var workerPlanning = {
        parent : 'productionManagement',
        url : '/planning',
        data : {
          roles : [ 'ROLE_PRODUCTIONMANAGER' ],
          pageTitle : 'dodomaApp.worker.home.title'
        },
        views : {
          'content@' : {
            templateUrl : 'scripts/app/entities/worker/workerPlanning.html',
            controller : 'WorkerPlanningController'
          }
        }
      };
      var workerDetail = {
        url : '/{workerId:int}',
        data : {
          roles : [ 'ROLE_PRODUCTIONMANAGER', 'ROLE_REHABMANAGER' ],
          pageTitle : 'dodomaApp.worker.detail.title'
        },
        views : {
          'content@' : {
            templateUrl : 'scripts/app/entities/worker/worker-detail.html',
            controller : 'WorkerDetailController'
          }
        },
        resolve : {
          entity : [ '$stateParams', 'Worker', 'ErrorHandler', function($stateParams, Worker, ErrorHandler) {
            return Worker.get({
              id : $stateParams.workerId
            }).$promise
              .catch(ErrorHandler.rejectWith('dodomaApp.worker.notFound'));
          } ]
        }
      };
      var workerNew = {
        url : '/new',
        data : {
          roles : [ 'ROLE_PRODUCTIONMANAGER', 'ROLE_REHABMANAGER' ],
        },
        onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl : 'scripts/app/entities/worker/worker-dialog.html',
            controller : 'WorkerDialogController',
            size : 'lg',
            resolve : {
              entity : function() {
                return {
                  firstName : null,
                  lastName : null,
                  socialSecurityNumber : null,
                  birthDate : new Date("1950-01-01"),
                  employmentStart : new Date(),
                  employmentEnd : null,
                  id : null,
                  workingHours : 8
                };
              }
            }
          }).result.then(function(result) {
            $state.go('^.detail', {
              workerId : result.id
            });
          }, function() {
            $state.go('^');
          })
        } ]
      };
      var workerDetailEdit = {
        url : '/edit',
        data : {
          roles : [ 'ROLE_PRODUCTIONMANAGER', 'ROLE_REHABMANAGER' ],
        },
        onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl : 'scripts/app/entities/worker/worker-dialog.html',
            controller : 'WorkerDialogController',
            size : 'lg',
            resolve : {
              entity : [ 'Worker', function(Worker) {
                return Worker.get({
                  id : $stateParams.workerId
                });
              } ]
            }
          }).result.then(function(result) {
            $state.go('^', {
              workerId : result.id
            });
          }, function() {
            $state.go('^', {
              workerId : $stateParams.workerId
            });
          })
        } ]
      };


      $stateProvider
        .state('workerPlanning', workerPlanning)

        .state('worker', stateUtil.stateWithParent(worker, 'productionManagement', '/prod/worker?{workstepId:int}', { module : 'PRODUCTION'} ))
        .state('worker.detail', stateUtil.stateUrl(workerDetail))
        .state('worker.new', stateUtil.stateUrl(workerNew))
        .state('worker.detail.edit', stateUtil.stateUrl(workerDetailEdit))

        .state('rehabWorker', stateUtil.stateWithParent(worker, 'rehabManagement', '/rehab/worker?{workstepId:int}', { module : 'REHABILITATION'} ))
        .state('rehabWorker.detail', stateUtil.stateUrl(workerDetail))
        .state('rehabWorker.new', stateUtil.stateUrl(workerNew))
        .state('rehabWorker.detail.edit', stateUtil.stateUrl(workerDetailEdit))
        ;
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkerController',
                ['$scope', '$state', 'Worker', 'DateUtils', 'WorkStep', 'StorageUtil', 'RequestUtil',
                function ($scope, $state, Worker, DateUtils, WorkStep, StorageUtil, RequestUtil) {
        $scope.workers = [];
        $scope.page = 1;

        var stateData = $state.current.data;
        $scope.prodModule = stateData.module === 'PRODUCTION'; 

        StorageUtil.setupFilters("workerController", $scope, {customFilter:{}, filter: { employmentDate : new Date(), module : stateData.module }});
        $scope.filter.module = stateData.module;

        if (angular.isNumber($state.params.workstepId)) {
          WorkStep.queryAll({workstepId:$state.params.workstepId}, function(result) {
            $scope.customFilter.workStep = result.entities[0];
          });
        }
        $scope.lastFilter = {};

        $scope.changePage = function(newParams) {
          var q = angular.extend(angular.copy($state.params), newParams);
          $state.go( $state.current.name, q);
        };

        $scope.loadAll = function(force) {
          // $state.params.workstepId should override the filter values.
          if (angular.isNumber($state.params.workstepId)) {
            $scope.filter.workstepId = $state.params.workstepId;
          } else {
            delete $scope.filter.workstepId;
          }
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          q.employmentDate = DateUtils.convertLocaleDateToServer(q.employmentDate);
          if (!$scope.prodModule) {
              delete q.workstepId;
          }
          if (angular.equals($scope.lastFilter, q) && force !== true) {
            return;
          }
          $scope.lastFilter = q;
          Worker.query(q, function(result, headers) {
            $scope.pageResult = result;
            $scope.workers = result.entities;
          });
        };

        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Worker.get({id: id}, function(result) {
                $scope.worker = result;
                $('#deleteWorkerConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Worker.delete({id: id},
                function () {
                    $scope.loadAll(true);
                    $('#deleteWorkerConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.workerExportUrl = function() {
          return RequestUtil.createLink('/api/workers/export.xls?format=xls&', $scope.filter, function(key, value) {
            if (key === 'employmentDate') {
              return DateUtils.convertLocaleDateToServer(value);
            }
            return value;
          });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.worker = {firstName: null, lastName: null, socialSecurityNumber: null, birthDate: null, employmentStart: null, employmentEnd: null, workingHours: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkerPlanningController',
                ['$scope', 'DateUtils', 'Worker',
                function ($scope, DateUtils, Worker) {
        $scope.workers = [];
        $scope.page = 1;
        $scope.filter = { date : new Date()};
        $scope.executionDate = '';
        $scope.loadAll = function() {
          var date = $scope.filter.date;
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          q.date = DateUtils.convertLocaleDateToServer(q.date);
          Worker.planning(q, function(result, headers) {
            $scope.executionYear = date.getFullYear();
            $scope.executionMonth = date.getMonth()+1;
            $scope.executionDay = date.getDate();
            $scope.workers = result;
          });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

    }]);

'use strict';

angular.module('dodomaApp').controller('WorkerDialogController',
    ['$scope', '$rootScope', '$uibModalInstance', 'entity', 'Worker',
        function($scope, $rootScope, $uibModalInstance, entity, Worker) {

      $scope.worker = entity;
      $scope.load = function(id) {
        Worker.get({id : id}, function(result) {
          $scope.worker = result;
        });
      };

      var onSaveFinished = function (result) {
        $rootScope.$broadcast('dodomaApp:workerUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.save = function () {
        if ($scope.worker.id != null) {
          Worker.update($scope.worker, onSaveFinished);
        } else {
          Worker.save($scope.worker, onSaveFinished);
        }
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkerDetailController',
                ['$scope', 'entity', 'Worker', 'WorkerQualification', 'WorkshopAssignment',
                  'WorkerRecord', 'WorkLog', 'Employment', 'Document', 'recordConfig', 'CollectionUtil', '$uibModal', 'ErrorHandler',
                function ($scope, entity, Worker, WorkerQualification, WorkshopAssignment,
                    WorkerRecord, WorkLog, Employment, Document, recordConfig, CollectionUtil, $uibModal, ErrorHandler) {
        $scope.worker = entity;
        $scope.workerRecords = [];
        $scope.workerRecordsPage = -1;

        $scope.workLogs = [];
        $scope.workLogPage = -1;

        $scope.load = function (id) {
            Worker.get({id: id}, function(result) {
              $scope.worker = result;
            }, ErrorHandler.rejectWith('dodomaApp.worker.notFound'));
        };
        $scope.$on('dodomaApp:workerUpdate', function(event, result) {
          $scope.worker = result;
        });
        $scope.deleteItem = function(id) {
          WorkerQualification.delete({workerId: $scope.worker.id, qualificationId:id}, function(result){
            $scope.worker = result;
          });
        };

        $scope.deleteAssignment= function(id) {
          WorkshopAssignment.delete({workerId: $scope.worker.id, assignmentId:id}, function(result){
            $scope.worker = result;
          });
        };

        $scope.hasRecord = function (log) {
          return angular.isDefined(log) && angular.isObject(log.createdRecord);
        };

        $scope.loadAllWorkLogs = function() {
          WorkLog.query({page: $scope.workLogPage, per_page: 20, workerId: $scope.worker.id}, function(result, headers) {
            $scope.workLogPagesResult = result;
            $scope.workLogs = result.entities;
          });
        };
        $scope.loadWorkLogPage = function(page) {
          $scope.workLogPage = page;
          $scope.loadAllWorkLogs();
        };

        $scope.loadAllWorkerRecord = function() {
            WorkerRecord.query({page: $scope.workerRecordsPage, per_page: 20, workerId: $scope.worker.id}, function(result, headers) {
                $scope.workerRecordsPageResult = result;
                $scope.workerRecords = result.entities;
                Document.findByWorker({workerId: $scope.worker.id}, function(documents) {
                  angular.forEach(documents, function(document) {
                    var workRec = CollectionUtil.findByField(result.entities, 'id', document.recordId);
                    if (workRec) { 
                      // it is possible, that workRec is not yet visible
                      var wrDoc = workRec.documents || [];
                      wrDoc.push(document);
                      workRec.documents = wrDoc;
                    }
                  });
                });
            });
        };
        $scope.loadWorkerRecordPage = function(page) {
          $scope.workerRecordsPage = page;
          $scope.loadAllWorkerRecord();
        };

        $scope.$on('dodomaApp:workerRecordUpdate', function(event, record) {
          $scope.loadAllWorkerRecord();
          $scope.loadAllWorkLogs();
          if (record.type === 'REHAB_PROFILE') {
            loadRehabProfile();
          }
        });
        $scope.$on('dodomaApp:workLogUpdate', function(event, record) {
          $scope.loadAllWorkLogs();
        });

        $scope.switchToRecords = function() {
          if ($scope.workerRecordsPage === -1) {
            $scope.loadWorkerRecordPage(1);
          }
        };
        $scope.switchToLogs = function() {
          if ($scope.workLogPage === -1) {
            $scope.loadWorkLogPage(1);
          }
        };
        // delete records
        $scope.deleteWorkerRecord = function (record) {
          $scope.recordToDelete = record;
          $('#deleteWorkerRecordConfirmation').modal('show');
        };

        $scope.confirmWorkerRecordDelete = function (id) {
          WorkerRecord.delete({id: id},
              function () {
                  $scope.loadAllWorkerRecord();
                  $('#deleteWorkerRecordConfirmation').modal('hide');
              });
        };

        // rehab profile tab

        function loadRehabProfile() {
          WorkerRecord.getByType({workerId:$scope.worker.id, recordType: 'REHAB_PROFILE'}, function(result) {
            $scope.rehabProfile = result;
          });
        };

        $scope.switchToRehabProfile = function() {
          if (!angular.isDefined($scope.rehabProfile)) {
            loadRehabProfile();
          }
        };

        // employment list tab

        $scope.openEmployments = function() {
          $uibModal.open({
            templateUrl: 'scripts/app/entities/worker/employment-list.html',
            controller: 'WorkerEmploymentListController',
            size: 'lg',
            resolve: {
              employments : function() {
                return Employment.query({workerId:$scope.worker.id}).$promise;
              }
            }
          });
        };

        function loadEmployments() {
          Employment.query({workerId:$scope.worker.id}, function(result) {
            $scope.employments = result;
          });
        };

        $scope.switchToEmployments = function() {
          if (!angular.isArray($scope.employments)) {
            loadEmployments();
          }
        }
        $scope.$on('dodomaApp:employmentUpdate', function(record) {
          loadEmployments();
        });

        // pdf export
        $scope.isExportable = function (entity) {
          return recordConfig.isPrintable(entity.type);
        };

        $scope.recordExportUrl = function (entity) {
          return "/api/workerRecords/" + entity.id+ ".pdf";
        };

        $scope.recordAggregatedDocs = function (entity) {
          return "/api/workers/" + entity.id + "/aggregation/full.pdf";
        };

    }]);


'use strict';

angular.module('dodomaApp')
  .controller('WorkerEmploymentListController',
              ['$scope', '$stateParams', '$uibModalInstance', 'employments', 'Employment',

               function ($scope, $stateParams, $uibModalInstance, employments, Employment) {

        $scope.employments = employments;

        $scope.clear = function() {
          $uibModalInstance.dismiss('cancel');
        };

        function loadEmployments() {
          Employment.query({workerId:$stateParams.workerId}, function(result) {
            $scope.employments = result;
          });
        };
        $scope.$on('dodomaApp:employmentUpdate', function(record) {
          loadEmployments();
        });

}]);

'use strict';

angular.module('dodomaApp')
    .factory('Worker', ['$resource', 'DateUtils', function ($resource, DateUtils) {

        var responseHelper = function (data) {
            if (!data || data.trim() === '') {
                return null;
            }
            try {
                data = angular.fromJson(data);
            } catch (e) {
                return data;
            }
            if (data) {
                data.birthDate = DateUtils.convertLocaleDateFromServer(data.birthDate);
                data.employmentStart = DateUtils.convertLocaleDateFromServer(data.employmentStart);
                data.employmentEnd = DateUtils.convertLocaleDateFromServer(data.employmentEnd);
            }
            return data;
        };

        function recordToJson(data) {
          var dt = angular.copy(data);
          dt.birthDate = DateUtils.convertLocaleDateToServer(dt.birthDate);
          dt.employmentStart = DateUtils.convertLocaleDateToServer(dt.employmentStart);
          dt.employmentEnd = DateUtils.convertLocaleDateToServer(dt.employmentEnd);
          return angular.toJson(dt);
        }

        return $resource('api/workers/:id', {}, {
            'query': { method: 'GET', isArray: false, param : {workTypeId : '@workTypeId'}},
            'planning': { method: 'GET', isArray: true, param : {date : '@date'}, url:'api/planning'},
            'get': {
                method: 'GET',
                transformResponse: responseHelper
            },
            'update': {
                method: 'PUT',
                transformRequest: recordToJson
            },
            'save': {
                method: 'POST',
                transformRequest: recordToJson
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('workType', {
                parent: 'productionManagement',
                url: '/workTypes',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'dodomaApp.workType.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workType/workTypes.html',
                        controller: 'WorkTypeController'
                    }
                }
            })
            .state('workTypeDetail', {
                parent: 'workType',
                url: '/{workTypeId:int}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'dodomaApp.workType.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workType/workType-detail.html',
                        controller: 'WorkTypeDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'WorkType', function($stateParams, WorkType) {
                        return WorkType.get({id : $stateParams.workTypeId});
                    }]
                }
            })
            .state('workType.new', {
              url: '/new',
              data: {
                  roles: ['ROLE_USER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/workType/workType-dialog.html',
                  controller: 'WorkTypeDialogController',
                  size: 'lg',
                  resolve: {
                      entity: {name: null, description: null, id: null}
                  }
                }).result.then(function(result) {
                  $state.go('workTypeDetail', {workTypeId: result.id});
                }, function() {
                  $state.go('^');
                })
              }]
            })
            .state('workTypeDetail.edit', {
              url: '/edit',
              data: {
                  roles: ['ROLE_USER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/workType/workType-dialog.html',
                  controller: 'WorkTypeDialogController',
                  size: 'lg',
                  resolve: {
                      entity: ['WorkType', function(WorkType) {
                          return WorkType.get({id : $stateParams.workTypeId});
                      }]
                  }
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkTypeController',
                ['$scope', 'WorkType',
                function ($scope,  WorkType) {
        $scope.workTypes = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            WorkType.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.pageResult = result;
                $scope.workTypes = result.entities;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            WorkType.get({id: id}, function(result) {
                $scope.workType = result;
                $('#deleteWorkTypeConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            WorkType.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteWorkTypeConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.workType = {name: null, description: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkTypeDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'WorkType',
        function($scope, $stateParams, $uibModalInstance, entity, WorkType) {

      $scope.workType = entity;
      $scope.load = function(id) {
        WorkType.get({id : id}, function(result) {
          $scope.workType = result;
        });
      };

      var onSaveFinished = function (result) {
        $scope.$emit('dodomaApp:workTypeUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.save = function () {
        if ($scope.workType.id != null) {
          WorkType.update($scope.workType, onSaveFinished);
        } else {
          WorkType.save($scope.workType, onSaveFinished);
        }
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkTypeDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'WorkType', 'Worker',
                function ($scope, $rootScope, $stateParams, entity, WorkType, Worker) {
        $scope.workType = entity;

        Worker.query({workTypeId: $stateParams.workTypeId}, function(result) {
          $scope.workers = result.entities;
        });

        $scope.load = function (id) {
            WorkType.get({id: id}, function(result) {
              $scope.workType = result;
            });
        };
        $rootScope.$on('dodomaApp:workTypeUpdate', function(event, result) {
          $scope.workType = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkType', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/workTypes/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();

        var newItem = {
          url: '/new',
          data: {
              roles: ['ROLE_PRODUCTIONMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', 'orderPlanEntity', function($stateParams, $state, $uibModal, orderPlanEntity) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/orderLine/orderLine-dialog.html',
              controller: 'OrderLineDialogController',
              size: 'md',
              resolve: {
                  entity: function() {
                    return {amount: null, fulfilledAmount: null, priority: null, id: null, part:{}, orderId : $stateParams.id};
                  },
                  orderPlanEntity: function() {
                      return orderPlanEntity;
                  }
              }
            }).result.then(function() {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };
        var editItem =  {
          url: '/edit/{itemId:int}',
          data: {
              roles: ['ROLE_PRODUCTIONMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/orderLine/orderLine-dialog.html',
              controller: 'OrderLineDialogController',
              size: 'md',
              resolve: {
                  entity: ['OrderLine', function(OrderLine) {
                      return OrderLine.get({id: $stateParams.itemId, orderId: $stateParams.orderId}).$promise;
                  }]
              }
            }).result.then(function() {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };

        $stateProvider
        .state('orderPlan.detail.lineNewItem', stateUtil.stateUrl(newItem))
        .state('offer.detail.lineNewItem', stateUtil.stateUrl(newItem))
        .state('orderPlan.detail.lineEditItem', stateUtil.stateUrl(editItem))
        .state('offer.detail.lineEditItem', stateUtil.stateUrl(editItem))
        ;

    }]);

'use strict';

angular.module('dodomaApp').controller('OrderLineDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', '$translate', 'entity', 'OrderLine', 'ProductionVariant', 'orderPlanManager',
        function($scope, $rootScope, $stateParams, $uibModalInstance, $translate, entity, OrderLine, ProductionVariant, orderPlanManager) {

      $scope.orderLine = entity;
      $scope.orderPlanEntity = orderPlanManager.orderPlan;
      $scope.productionVariants = [];
      $scope.load = function(id) {
        OrderLine.get({id : id}, function(result) {
          $scope.orderLine = result;
          $scope.loadProductionVariants();
        });
      };
      $scope.partChanged = function() {
        // console.log('Part changed:', $scope.orderLine.part);
        var orderLine = $scope.orderLine;
        orderLine.variant = null; // Reset variant when part changes
        $scope.loadProductionVariants();
      };
      $scope.loadProductionVariants = function() {
        if ($scope.orderLine.part && $scope.orderLine.part.id && $scope.orderLine.part.canBeBuilt) {
          ProductionVariant.query({partId: $scope.orderLine.part.id}, function(result) {
            $scope.productionVariants = result.entities;
            for (var i = 0; i < result.entities.length; i++) {
              if (result.entities[i].defaultVariant) {
                var entry = result.entities[i];
                if (!$scope.orderLine.variant) {
                  $scope.orderLine.variant = entry;
                }
                entry.name = entry.name + ' (' + $translate.instant('dodomaApp.productionVariant.default') + ')';
              }
            }
          });
        }
      };

      $scope.loadProductionVariants();
      
      $scope.save = function () {
        $scope.orderLine.orderId = $stateParams.orderId;
        OrderLine.save($scope.orderLine, function (result) {
          $rootScope.$broadcast('dodomaApp:orderPlanUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .factory('OrderLine', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/orderPlans/:orderId/lines/:id', { orderId : '@orderId'}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();

        var orderPlan = {
            parent: 'productionManagement',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
                pageTitle: 'dodomaApp.orderPlan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/app/entities/orderPlan/orderPlans.html',
                    controller: 'OrderPlanController'
                }
            }
        };

        var orderPlanDetail = {
            url: '/{orderId:int}',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
                pageTitle: 'dodomaApp.orderPlan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'scripts/app/entities/orderPlan/orderPlan-detail.html',
                    controller: 'OrderPlanDetailController'
                }
            },
            resolve: {
                orderPlanEntity: ['$stateParams', 'OrderPlan', 'orderPlanManager', 'ErrorHandler', function($stateParams, OrderPlan, orderPlanManager, ErrorHandler) {
                    return OrderPlan.get({id: $stateParams.orderId}, orderPlanManager.setOrderPlan.bind(orderPlanManager), ErrorHandler.rejectWith('dodomaApp.orderPlan.notFound'));
                }]
            }
        };

        var orderPlanNew = {
            url: '/new?{partnerId:int}',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/orderPlan/orderPlan-dialog.html',
                controller: 'OrderPlanDialogController',
                size: 'lg',
                resolve: {
                  partnerEntity: ['Partner', function(Partner) {
                    if (angular.isNumber($stateParams.partnerId)) {
                      return Partner.get({id:$stateParams.partnerId}).$promise;
                    } else {
                      return {};
                    }
                  }],
                  orderPlanEntity: ['OrderPlan', function(OrderPlan) {
                    return OrderPlan.getNew().$promise;
                  }]
                }
              }).result.then(function(result) {
                $state.go('^.detail', {orderId: result.id});
              }, function() {
                $state.go('^');
              })
            }]
        };

        var orderPlanEdit = {
            url: '/edit',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/orderPlan/orderPlan-dialog.html',
                controller: 'OrderPlanDialogController',
                size: 'lg',
                resolve: {
                  orderPlanEntity: ['OrderPlan', function(OrderPlan) {
                      return OrderPlan.get({id : $stateParams.orderId}).$promise;
                  }],
                  partnerEntity: function() {
                    return {};
                  }
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
        };

        $stateProvider
            .state('orderPlan', stateUtil.stateWithParent(orderPlan, 'productionManagement', '/orderPlans', { offerMode : false,pageTitle: 'dodomaApp.orderPlan.home.title' }))
            .state('orderPlan.detail', stateUtil.stateUrl(orderPlanDetail, null, { offerMode : false}))
            .state('orderPlan.new', stateUtil.stateUrl(orderPlanNew))
            .state('orderPlan.detail.edit', stateUtil.stateUrl(orderPlanEdit));
        $stateProvider
            .state('offer', stateUtil.stateWithParent(orderPlan, 'productionManagement', '/offers', { offerMode : true, pageTitle: 'dodomaApp.offer.detail.title'}))
            .state('offer.detail', stateUtil.stateUrl(orderPlanDetail, null, { offerMode : true}))
            .state('offer.new', stateUtil.stateUrl(orderPlanNew))
            .state('offer.detail.edit', stateUtil.stateUrl(orderPlanEdit));

    }]);

(function () {
    'use strict';

    var orderPlanManager = ['$translate', '$timeout', 'CollectionUtil', 'ProductionSheet', 
        function ($translate, $timeout, CollectionUtil, ProductionSheet) {

      return {
            sumText: '',
            planText : '',
            startedText : '',
            finishedText : '',

            orderPlan: undefined,

            orderPlanId: undefined,

            requiredWorks: undefined,
            requiredParts: undefined,

            editedSheets : [],
            activeIdx: undefined,
            viewConfig: {},

            removeOrderPlan: function () {
                this.orderPlan = undefined;
                this.orderPlanId = undefined;
                this.requiredWorks = undefined;
                this.requiredParts = undefined;
                this.activeIdx = undefined;
            },

            isPlanning : function(orderPlan) {
              return orderPlan.state === 'OFFER' || orderPlan.state === 'PLANNING';
            },
            isInvoicing : function(orderPlan) {
                return orderPlan.state === 'FINISHED' || orderPlan.state == 'INVOICED';
            },
            isLiveMode: function(orderPlan) {
              return orderPlan.state !== 'CANCELLED' && orderPlan.state !== 'FINISHED' && orderPlan.state !== 'INVOICED'  && orderPlan.state !== 'PAYED';
            },
            isFinalCalculation: function(orderPlan) {
              return orderPlan.state === 'FINISHED' || orderPlan.state === 'PAYED' || orderPlan.state === 'INVOICED';
            },
            getStandardTime: function(productionSheetItem) {
                return productionSheetItem.standardTimeOverride || productionSheetItem.orderLineWork.standardTime;
            },
            formatWork: function(work, line) {
              var result = work.name + '(' + work.externalName + ')  [' + this.sumText+': ' + line.amount;
              var open = line.amount;
              if (work.plannedAmount !== 0) {
                result = result + ' ' + this.planText +': ' + work.plannedAmount;
                open -= work.plannedAmount;
              }
              if (work.startedAmount !== 0) {
                result = result + ' ' + this.startedText +': ' + work.startedAmount;
                open -= work.startedAmount;
              }
              if (work.fulfilledAmount !== 0) {
                result = result + ' ' + this.finishedText +': ' + work.fulfilledAmount;
                open -= work.fulfilledAmount;
              }
              if (open !== line.amount) {
                result = result +' ' + this.openText + ': ' + open;
              }
              return result +']';
            },

            setOrderPlan: function (orderPlan) {
              if (this.orderPlanId !== orderPlan.id) {
                this.editedSheets = [];
              }
              this.orderPlanId = orderPlan.id;
              this.orderPlan = orderPlan;

              var works = [];
              var parts = [];

              this.sumText = $translate.instant('dodomaApp.productionSheetItem.work.sum');
              this.planText = $translate.instant('dodomaApp.productionSheetItem.work.plan');
              this.startedText = $translate.instant('dodomaApp.productionSheetItem.work.started');
              this.finishedText = $translate.instant('dodomaApp.productionSheetItem.work.finished');
              this.openText = $translate.instant('dodomaApp.productionSheetItem.work.open');

              var that = this;
              angular.forEach(orderPlan.orderLines, function (line) {
                if (line.canBeBuilt) {
                    angular.forEach(line.works, function(work) {
                      var name = that.formatWork(work, line);
                      works.push({line:line, work:work, id:work.id, name:name });
                      if (angular.isArray(work.requirements)) {
                          Array.prototype.push.apply(parts, work.requirements);
                      }
                    });
                } else {
                    parts.push({part:line.part, amount:line.amount, startedAmount: line.startedAmount, fulfilledAmount: line.fulfilledAmount});
                }
              });
              this.requiredWorks = works;
              this.requiredParts = parts;
              this.viewConfig = this.viewConfig || {};
              this.viewConfig.offerMode = (orderPlan.state === 'OFFER' || orderPlan.state === 'CANCELLED');
              this.viewConfig.openOffer = orderPlan.state === 'OFFER';
              this.viewConfig.orderMode = !this.viewConfig.offerMode; 
              this.viewConfig.liveMode = orderPlan.state !== 'CANCELLED' && orderPlan.state !== 'FINISHED' && orderPlan.state !== 'INVOICED'  && orderPlan.state !== 'PAYED';
              this.viewConfig.finalCalculation = orderPlan.state === 'FINISHED' || orderPlan.state === 'PAYED' || orderPlan.state === 'INVOICED';
              this.viewConfig.deliveryNoteButton = orderPlan.state === 'FINISHED' || orderPlan.state === 'EXECUTING';
              this.viewConfig.showDeliveryNotes = orderPlan.deliveryNotes && orderPlan.deliveryNotes.length > 0;
              return this.viewConfig;
            },

            emitWindowTitleUpdate: function(scope) {
              scope.$emit('$titleChange', 'dodomaApp.offer.detail.windowTitle', {name:this.orderPlan.name});
            },

            getRequiredWorksById : function(id) {
              return CollectionUtil.findByField(this.requiredWorks, 'id', id);
            },

            getSheetById: function(id) {
              var sheetWrapper = CollectionUtil.findByField(this.editedSheets, 'id', id);
              return sheetWrapper ? sheetWrapper.obj : undefined;
            },

            updateSheet: function(sheetContent) {
              var sheetWrapper = CollectionUtil.findByField(this.editedSheets, 'id', sheetContent.id);
              if (sheetWrapper) {
                sheetWrapper.obj = sheetContent;
              }
            },

            addNewSheet: function(sheet, sheetContent) {
              this.editedSheets.push({id: sheet.id, executionDate:sheet.executionDate, active: true, obj : sheetContent});
            },

            removeSheetById : function(id) {
              var idx = CollectionUtil.findIndexByField(this.editedSheets, 'id', id);
              if (angular.isNumber(idx)) {
                this.editedSheets.splice(idx);
              }
            },

            openSheet: function(sheet) {
              var idx = CollectionUtil.findIndexByField(this.editedSheets, 'id', sheet.id);
              if (angular.isNumber(idx)) {
                  this.activeIdx = sheet.id; 
              } else {
                  var that = this;
                  ProductionSheet.get({id : sheet.id, orderPlanId: this.orderPlanId}, function(handleResult) {
                      that.addNewSheet(sheet, handleResult);
                      //that.activeIdx = TABS + that.editedSheets.length - 1;
                      $timeout(function() { 
                          that.activeIdx = sheet.id; 
                          // console.log('activeIdx ', that.activeIdx);
                      }, 200);
                      // console.log('x activeIdx ', that.activeIdx);
                  });
              }
            }

        };
    }];

    angular
        .module('dodomaApp')
        .service('orderPlanManager', orderPlanManager);
})();

'use strict';

angular.module('dodomaApp')
.directive('orderPlansTable', ['OrderPlan', function(OrderPlan) {
    return {
        templateUrl: 'scripts/app/entities/orderPlan/orderPlansTable.html',
        scope: {
            query : '=',
            panelClass : '@',
            entityList : '=',
            hideExtended : '@',
        },
        controller: function ($scope) {
            if (!$scope.query && !$scope.entityList) {
                throw "query or entityList needs to be defined on scope: " + $scope;
            }
            $scope.loadEntities = function(pageNumber) {
              if ($scope.entityList) {
                  $scope.entities = $scope.entityList;
                  return;
              }
              var q = angular.extend($scope.query, { page : pageNumber, per_page : 20 });
              OrderPlan.query(q, function(result) {
                $scope.entities = result.entities;
                $scope.result = result;
              });
            };
            $scope.$on('dodomaApp:showOrderPlans', function(event, page) {
                $scope.loadEntities(page);
            });
            $scope.extended = ($scope.hideExtended !== 'true');

          }
    };
}]);


'use strict';

angular.module('dodomaApp')
    .controller('OrderPlanController',
                ['$scope', '$state', 'OrderPlan', 'DodomaConfig', 'Principal', 'EnumLabel', 'StorageUtil',
                function ($scope, $state, OrderPlan, DodomaConfig, Principal, EnumLabel, StorageUtil) {
        $scope.separateOffers = DodomaConfig.separateOffers;
        $scope.orderPlans = [];
        $scope.stateData = $state.current.data;
        $scope.page = 1;
        StorageUtil.setupFilters("orderPlanController", $scope);
        $scope.pageResult = {};
        $scope.isAdmin = Principal.isInRole('ROLE_ADMIN');
        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.customFilter.client) {
            q.clientId = $scope.customFilter.client.id;
          }
          if ($scope.customFilter.creator) {
            q.creatorId = $scope.customFilter.creator.id;
          }
          if ($scope.customFilter.part) {
            q.partId = $scope.customFilter.part.id;
          }
          if ($scope.separateOffers) {
            if ($scope.stateData.offerMode === true) {
              q.onlyOffers = true;
            } else {
              q.onlyLivePlans = true;
            }
          }
          OrderPlan.query(q, function(result, headers) {
            $scope.orderPlans = result.entities;
            $scope.pageResult = result;
          });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            OrderPlan.get({id: id}, function(result) {
                $scope.$emit('clearErrors');
                $scope.orderPlan = result;
                $('#deleteOrderPlanConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            OrderPlan.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteOrderPlanConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.orderPlan = {name: null, state: null, deliveryDate: null, id: null};
        };

        $scope.stateLabel = EnumLabel.orderPlan;
        $scope.deliveryNoteStateLabel = EnumLabel.deliveryNote;

    }]);

'use strict';

angular.module('dodomaApp').controller('OrderPlanDialogController',
    ['$scope', '$rootScope', '$uibModalInstance', 'orderPlanEntity', 'OrderPlan', 'ProductionVariant', 'partnerEntity', 'orderPlanManager',
        function($scope, $rootScope, $uibModalInstance, orderPlanEntity, OrderPlan, ProductionVariant, partnerEntity, orderPlanManager) {

      $scope.orderPlan = orderPlanEntity;
      $scope.saving = false;

      if (angular.isDefined(partnerEntity) && angular.isDefined(partnerEntity.id)) {
        $scope.orderPlan.client = partnerEntity;
      }

      $scope.planning = orderPlanManager.isPlanning(orderPlanEntity);
      $scope.invoicing = orderPlanManager.isInvoicing(orderPlanEntity);

      $scope.load = function(id) {
        OrderPlan.get({id : id}, function(result) {
          $scope.orderPlan = result;
        });
      };

      $scope.save = function () {
        if ($scope.saving) {
          return;
        }
        $scope.saving = true;
        OrderPlan.save($scope.orderPlan, function (result) {
          $scope.saving = false;
          $rootScope.$broadcast('dodomaApp:orderPlanUpdate', result);
          $uibModalInstance.close(result);
        }, function (error) {
          $scope.saving = false;
        });
      };

      $scope.addNewLine = function() {
        $scope.orderPlan.orderLines.push({id:null, part: {id:null}, amount:1.0});
      };
      $scope.removeLine = function($index) {
        $scope.orderPlan.orderLines.splice($index,1);
      };
      $scope.partChanged = function(orderLine, $index) {
        //console.log('Part changed for line index:', $index, orderLine);
        if (orderLine && orderLine.part && orderLine.part.id && orderLine.part.canBeBuilt) {
          // Load variants for the selected part
          ProductionVariant.getDefault({partId: orderLine.part.id}, function(defVariant) {
            // console.log('Default variant for part:', defVariant);
            orderLine.variant = defVariant;
          });
        }
      };

      $scope.$on('dodomaApp:newPartnerCreated', function(event, partner) {
        $scope.orderPlan.client = partner;
      });
      
      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('OrderPlanDetailController',
                ['$scope', '$state', 'Upload', 'orderPlanEntity', 'OrderPlan', 'OrderLine', 'ProductionSheet', 'ProductionSheetItem', 'CollectionUtil', 'orderPlanManager', 'ErrorHandler', 'Principal',
                function ($scope, $state, Upload, orderPlanEntity, OrderPlan, OrderLine, ProductionSheet, ProductionSheetItem, CollectionUtil, orderPlanManager, ErrorHandler, Principal) {

        $scope.orderPlanManager = orderPlanManager;
        $scope.orderPlan = {};
        $scope.viewConfig = {};
        $scope.giveOutQuery = {};
        $scope.isAdmin = Principal.isInRole('ROLE_ADMIN');

        function displayPlan(result) {
          $scope.viewConfig = orderPlanManager.setOrderPlan(result);
          orderPlanManager.emitWindowTitleUpdate($scope);
          $scope.orderPlan = result;
          $scope.giveOutQuery.orderPlanId = result.id;
          $scope.loadProductionSheets();
        }

        $scope.load = function (id) {
            OrderPlan.get({id: id}, displayPlan, ErrorHandler.rejectWith('dodomaApp.orderPlan.notFound'));
        };

        $scope.$on('dodomaApp:orderPlanUpdate', function(event, result) {
          displayPlan(result);
          event.preventDefault();
        });

        $scope.deleteItem = function(id) {
          OrderLine.delete({orderId: $scope.orderPlanManager.orderPlanId, id:id}, displayPlan);
        };

        orderPlanEntity.$promise.then(displayPlan);

        $scope.acceptOffer = function() {
          OrderPlan.setState({id: $scope.orderPlan.id, state: 'PLANNING'}, function(result) {
            displayPlan(result);
            $state.go('orderPlan.detail', {orderId: result.id});
          });
        };
        $scope.cancelOffer = function() {
          $('#cancelOfferConfirmation').modal('show');
        };
        $scope.confirmCancelOffer = function() {
          OrderPlan.setState({id: $scope.orderPlan.id, state: 'CANCELLED'}, function(result) {
            $('#cancelOfferConfirmation').modal('hide');
            displayPlan(result);
          });
        };
        $scope.earlyFinish = function() {
          OrderPlan.setState({id: $scope.orderPlan.id, state: 'FINISHED'}, displayPlan);
        }

        $scope.delete = function () {
          $('#deleteOrderPlanConfirmation').modal('show');
        };

        $scope.confirmDelete = function () {
          OrderPlan.delete({id: $scope.orderPlan.id}, function () {
            $('#deleteOrderPlanConfirmation').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            $state.go('orderPlan');
          });
        };

        // GiveOuts handling

        $scope.switchToGiveOuts = function() {
            $scope.$broadcast('dodomaApp:showGiveOuts', 0);
        };

        // delivery note handling

        $scope.switchToDeliveryNotes = function() {
            $scope.$broadcast('dodomaApp:showDeliveryNotes', 0);
        };

        $scope.createDeliveryNote = function() {
          OrderPlan.createDeliverynote({id: $scope.orderPlan.id}, displayPlan);
        };

        // price calculation handling

        $scope.showPriceCalculation = function() {
          return angular.isDefined($scope.orderPlan.priceCalculation) && 
                angular.isNumber($scope.orderPlan.priceCalculation.totalFee) && 
                $scope.orderPlan.priceCalculation.totalFee > 0; 
        };
        $scope.showPostCalculation = function() {
          return angular.isDefined($scope.orderPlan.postCalculation) && 
               angular.isNumber($scope.orderPlan.postCalculation.totalFee) && 
               $scope.orderPlan.postCalculation.totalFee > 0; 
        };

        // excel upload

        // upload on file select or drop
        $scope.upload = function (file) {
            if (!file) {
                return;
            }
            Upload.upload({
                url: '/api/orderPlans/' + $scope.orderPlan.id +'/upload',
                data: {file: file, 'id': $scope.orderPlan.id}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                $scope.orderPlan = resp.data;
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = Math.round(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };

        // sheet handling
        $scope.productionSheets = [];
        $scope.productionSheetsPage = {};

        // 
        $scope.loadProductionSheets = function(page) {
          ProductionSheet.sheetsByOrderPlan({orderPlanId : orderPlanManager.orderPlanId, page: page}, function(result) {
            $scope.productionSheets = result.entities;
            $scope.productionSheetsPage = result;
          });
        };

        $scope.startSheet = function(id) {
          ProductionSheet.start({orderPlanId : orderPlanManager.orderPlanId, id: id}, function(result) {
            orderPlanManager.updateSheet(result);
            $scope.reload();
          });
        };
        $scope.revertStartSheet = function(id) {
          ProductionSheet.revertStart({orderPlanId : orderPlanManager.orderPlanId, id: id}, function(result) {
            orderPlanManager.updateSheet(result);
            $scope.reload();
          });
        };

        $scope.finishSheet = function(id) {
          ProductionSheet.finish({orderPlanId : orderPlanManager.orderPlanId, id: id}, function(result) {
            orderPlanManager.updateSheet(result);
            $scope.reload();
          });
        };

        $scope.autoFillSheet = function(id) {
          ProductionSheet.autoFill({orderPlanId : orderPlanManager.orderPlanId, id: id}, function(result) {
            orderPlanManager.updateSheet(result);
            $scope.reload();
          });
        };

        $scope.deleteSheet = function(id) {
          ProductionSheet.delete({orderPlanId: orderPlanManager.orderPlanId, id: id}, function(result) {
            $scope.reload();
            orderPlanManager.removeSheetById(id);
          });
        };

        $scope.productionSheetItemEditable = function(productionSheetItem) {
            if (productionSheetItem) {
                return !productionSheetItem.finishedAmount;
            } else {
                return false;
            }
        }
        $scope.deleteProductionSheetItem = function(sheetId, id) {
          ProductionSheetItem.delete({sheetId : sheetId, orderId: $scope.orderPlanManager.orderPlanId, id: id}, function(result) {
            orderPlanManager.updateSheet(result);
            $scope.reload();
          });
        };

        $scope.reload = function() {
          $scope.load($scope.orderPlan.id);
        };

        $scope.$on('dodomaApp:productionSheetUpdate', function(event, result) {
          orderPlanManager.updateSheet(result);
          CollectionUtil.updateOrInsertByField($scope.productionSheets, 'id', result.id, result);
          $scope.reload();
        });

        $scope.editSheet = function(sheet) {
          $scope.orderPlanManager.openSheet(sheet);
        }
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('OrderPlan', ['$resource', 'DateUtils', function ($resource, DateUtils) {

        var responseHelper = function (data) {
            if (!data || data.trim() === '') {
                return null;
            }
            try {
                data = angular.fromJson(data);
            } catch (e) {
                return data;
            }
            if (data) {
                data.deliveryDate = DateUtils.convertLocaleDateFromServer(data.deliveryDate);
                data.invoiceDate = DateUtils.convertLocaleDateFromServer(data.invoiceDate);
            }
            return data;
        };

    	return $resource('api/orderPlans/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: responseHelper,
            },
            'getNew': {
                method: 'GET',
                url: 'api/orderPlans/new',
                transformResponse: responseHelper,
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.deliveryDate = DateUtils.convertLocaleDateToServer(data.deliveryDate);
                    data.invoiceDate = DateUtils.convertLocaleDateToServer(data.invoiceDate);
                    return angular.toJson(data);
                },
                transformResponse: responseHelper
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.deliveryDate = DateUtils.convertLocaleDateToServer(data.deliveryDate);
                    data.invoiceDate = DateUtils.convertLocaleDateToServer(data.invoiceDate);
                    return angular.toJson(data);
                },
                transformResponse: responseHelper
            },
            'createDeliverynote': {
                url: 'api/orderPlans/:id/createDeliverynote',
                method : 'POST',
                params: { id:'@id' },
                transformResponse: responseHelper
            },
            'setState': {
              url: 'api/orderPlans/:id/state/:state',
              method : 'POST',
              params: { id:'@id', state: '@state'},
              transformResponse: responseHelper
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkerQualification', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/worker/:workerId/qualifications/:qualificationId', { workerId: '@workerId', qualificationId: '@qualificationId'}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();

      var qualificationNewItem = {
          url: '/new',
          data: {
              roles: ['ROLE_USER'],
          },
          onEnter: ['$state', '$uibModal', function($state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/workerQualification/workerQualification-dialog.html',
              controller: 'WorkerQualificationDialogController',
              size: 'lg',
              resolve: {
                  entity: function() {
                    return {level: null, creationDate: null, id: null};
                  }
              }
            }).result.then(function(result) {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };
      
        var qualificationEditItem = {
            url: '/edit/{qualificationId:int}',
            data: {
                roles: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/workerQualification/workerQualification-dialog.html',
                controller: 'WorkerQualificationDialogController',
                size: 'lg',
                resolve: {
                    entity: ['WorkerQualification', function(WorkerQualification) {
                        return WorkerQualification.get({workerId : $stateParams.workerId, qualificationId: $stateParams.qualificationId});
                    }]
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
          };
        $stateProvider
            .state('worker.detail.qualificationNewItem', stateUtil.stateUrl(qualificationNewItem))
            .state('worker.detail.qualificationEditItem', stateUtil.stateUrl(qualificationEditItem))
            .state('rehabWorker.detail.qualificationNewItem', stateUtil.stateUrl(qualificationNewItem))
            .state('rehabWorker.detail.qualificationEditItem', stateUtil.stateUrl(qualificationEditItem))
         ;
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkerQualificationDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'WorkerQualification',
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, WorkerQualification) {

      $scope.workerQualification = entity;
      $scope.load = function(id) {
        WorkerQualification.get({id : id}, function(result) {
          $scope.workerQualification = result;
        });
      };

      $scope.save = function () {
        $scope.workerQualification.workerId = $stateParams.workerId;
        WorkerQualification.save($scope.workerQualification, function (result) {
          $rootScope.$broadcast('dodomaApp:workerUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkshopAssignment', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/worker/:workerId/assignments/:assignmentId', { workerId: '@workerId', assignmentId: '@assignmentId'}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();

      var workshopAssignmentNewItem = {
          url: '/workshopAssignment/new',
          data: {
              roles: ['ROLE_USER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/workshopAssignment/workshopAssignment-dialog.html',
              controller: 'WorkshopAssignmentDialogController',
              size: 'lg',
              resolve: {
                  entity: function() {
                    return {level: null, creationDate: null, id: null};
                  }
              }
            }).result.then(function(result) {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };
      
        var workshopAssignmentEditItem = {
            url: '/workshopAssignment/{assignmentId:int}',
            data: {
                roles: ['ROLE_USER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/workshopAssignment/workshopAssignment-dialog.html',
                controller: 'WorkshopAssignmentDialogController',
                size: 'lg',
                resolve: {
                    entity: ['WorkshopAssignment', function(WorkshopAssignment) {
                        return WorkshopAssignment.get({workerId : $stateParams.workerId, assignmentId: $stateParams.assignmentId});
                    }]
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
          };
        $stateProvider
            .state('worker.detail.workshopAssignmentNewItem', stateUtil.stateUrl(workshopAssignmentNewItem))
            .state('worker.detail.workshopAssignmentEditItem', stateUtil.stateUrl(workshopAssignmentEditItem))
            .state('rehabWorker.detail.workshopAssignmentNewItem', stateUtil.stateUrl(workshopAssignmentNewItem))
            .state('rehabWorker.detail.workshopAssignmentEditItem', stateUtil.stateUrl(workshopAssignmentEditItem))
         ;
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkshopAssignmentDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'WorkshopAssignment',
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, WorkshopAssignment) {

      $scope.workshopAssignment = entity;
      $scope.load = function(id) {
        WorkshopAssignment.get({id : id}, function(result) {
          $scope.workshopAssignment = result;
        });
      };

      $scope.save = function () {
        $scope.workshopAssignment.workerId = $stateParams.workerId;
        WorkshopAssignment.save($scope.workshopAssignment, function (result) {
          $rootScope.$broadcast('dodomaApp:workerUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();

        var newItem = {
            url: '/newItem/{sheetId:int}',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
            },
            onEnter: ['$state', '$uibModal', function($state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/productionSheetItem/productionSheetItem-dialog.html',
                controller: 'ProductionSheetItemDialogController',
                size: 'lg',
                resolve: {
                    entity: function() {
                      return {amount: null, finishedAmount: null, id: null};
                    },
                    mode: function() {
                      return 'PLANNING';
                    }
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
        };
        var editItem = {
            url: '/editItem/{sheetId:int}/{itemId:int}',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/productionSheetItem/productionSheetItem-dialog.html',
                controller: 'ProductionSheetItemDialogController',
                size: 'lg',
                resolve: {
                    entity: ['ProductionSheetItem', function(ProductionSheetItem) {
                        return ProductionSheetItem.get({id : $stateParams.itemId, sheetId: $stateParams.sheetId, orderId: $stateParams.orderId});
                    }],
                    mode: function() {
                      return 'PLANNING';
                    }
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
          };
        var finishItem = {
            url: '/finishItem/{sheetId:int}/{itemId:int}',
            data: {
                roles: ['ROLE_PRODUCTIONMANAGER'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                templateUrl: 'scripts/app/entities/productionSheetItem/productionSheetItem-dialog.html',
                controller: 'ProductionSheetItemDialogController',
                size: 'lg',
                resolve: {
                    entity: ['ProductionSheetItem', function(ProductionSheetItem) {
                        return ProductionSheetItem.get({id : $stateParams.itemId, sheetId: $stateParams.sheetId, orderId: $stateParams.orderId});
                    }],
                    mode: function() {
                      return 'EXECUTING';
                    }
                }
              }).result.then(function(result) {
                $state.go('^');
              }, function() {
                $state.go('^');
              })
            }]
          };



        $stateProvider
            .state('productionSheetItem', {
                parent: 'productionManagement',
                url: '/workVerification?{workerId:int}&{workerName}&{y:int}&{m:int}&{d:int}',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER', 'ROLE_PROD_QA'],
                    pageTitle: 'dodomaApp.productionSheetItem.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/productionSheetItem/productionSheetItems.html',
                        controller: 'ProductionSheetItemController'
                    }
                }
            })
            .state('productionSheetItemDetail', {
                parent: 'productionManagement',
                url: '/productionSheetItem/{id:int}',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER', 'ROLE_PROD_QA'],
                    pageTitle: 'dodomaApp.productionSheetItem.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/productionSheetItem/productionSheetItem-detail.html',
                        controller: 'ProductionSheetItemDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ProductionSheetItem', function($stateParams, ProductionSheetItem) {
                        return ProductionSheetItem.get({id : $stateParams.id});
                    }]
                }
            })
            .state('orderPlan.detail.newProductionSheetItem', stateUtil.stateUrl(newItem))
            .state('orderPlan.detail.editProductionSheetItem', stateUtil.stateUrl(editItem))
            .state('orderPlan.detail.finishProductionSheetItem', stateUtil.stateUrl(finishItem))
            .state('offer.detail.newProductionSheetItem', stateUtil.stateUrl(newItem))
            .state('offer.detail.editProductionSheetItem', stateUtil.stateUrl(editItem))
            .state('offer.detail.finishProductionSheetItem', stateUtil.stateUrl(finishItem))
            ;
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('ProductionSheetItemController',
                ['$scope', '$stateParams', 'DateUtils', 'ProductionSheetItem', 
                function ($scope, $stateParams, DateUtils, ProductionSheetItem) {
        $scope.productionSheetItems = [];
        $scope.page = 1;
        $scope.filter = {};
        $scope.customFilter = {};
        
        if (angular.isNumber($stateParams.workerId)) {
          $scope.customFilter.worker = {id: $stateParams.workerId, name: $stateParams.workerName};
        }
        if (angular.isNumber($stateParams.y) && angular.isNumber($stateParams.m) && angular.isNumber($stateParams.d)) {
          $scope.filter.after = DateUtils.convertLocaleDateToServer(new Date($stateParams.y, $stateParams.m-1, $stateParams.d));
          $scope.filter.before = DateUtils.convertLocaleDateToServer(new Date($stateParams.y, $stateParams.m-1, $stateParams.d));
        }

        $scope.loadAll = function() {
          function copyParam(name) {
            if ($scope.customFilter[name]) {
              q[name+'Id'] = $scope.customFilter[name].id;
            }
          }
          
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          copyParam('client');
          copyParam('workType');
          copyParam('workStep');
          copyParam('worker');
          copyParam('orderPlan');
          
          ProductionSheetItem.query(q, function(result) {
            $scope.pageResult = result;
            $scope.productionSheetItems = result.entities;
          });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };


        $scope.$on('dodomaApp:productionSheetUpdate', function(item) {
          $scope.loadPage($scope.page);
        });

        $scope.refresh = function () {
            $scope.loadAll();
        };

        $scope.loadAll();
    }]);

'use strict';

angular.module('dodomaApp').controller('ProductionSheetItemDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'ProductionSheetItem', 'Worker', 'entity', 'mode', 'orderPlanManager', 'DodomaConfig',  
        function($scope, $rootScope, $stateParams, $uibModalInstance, ProductionSheetItem, Worker, entity, mode, orderPlanManager, DodomaConfig) {

      $scope.productionSheetItem = entity;
      $scope.workers = [];
      $scope.orderPlanManager = orderPlanManager;
      $scope.maxAmount = 0;
      $scope.mode = mode; 
      var workstepId = -1;
      var maximumMapping = {};

      $scope.load = function(id) {
        ProductionSheetItem.get({id : id}, function(result) {
          $scope.productionSheetItem = result;
        });
      };

      $scope.save = function () {
        $scope.productionSheetItem.orderId = $stateParams.orderId;
        $scope.productionSheetItem.sheetId = $stateParams.sheetId;
        var worker = $scope.productionSheetItem.worker;
        var item = {orderId : $stateParams.orderId, 
          sheetId : $stateParams.sheetId, 
          id : $scope.productionSheetItem.id,
          amount : $scope.productionSheetItem.amount,
          standardTimeOverride : $scope.productionSheetItem.standardTimeOverride,
          finishedAmount: $scope.productionSheetItem.finishedAmount,
          timeSpent : $scope.productionSheetItem.timeSpent,
          worker : worker,
          orderLineWork: {id: $scope.productionSheetItem.orderLineWork.id},
        };
        ProductionSheetItem.save(item, function (result) {
          $rootScope.$broadcast('dodomaApp:productionSheetUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      function updateMaximum(obj) {
        var currentAmount = angular.isNumber(maximumMapping[obj.id]) ? maximumMapping[obj.id] : 0; 
        $scope.maxAmount = obj.line.amount - obj.work.startedAmount - obj.work.fulfilledAmount + currentAmount;
      }

      $scope.workSelected = function(obj) {
        if (obj.work.workstepId !== workstepId) {
          workstepId = obj.work.workstepId;
          Worker.query({workstepId : workstepId, per_page: DodomaConfig.magicalPageSize}, function(result) {
            $scope.workers = result.entities;
            if ($scope.workers.length === 1) {
              $scope.productionSheetItem.worker = $scope.workers[0];
            } else {
              $scope.productionSheetItem.worker = null;
            }
         });
        }
        updateMaximum(obj);
      };
      if ($scope.productionSheetItem.$promise) {
        $scope.productionSheetItem.$promise.then(function(result) {
          result.timeSpent = result.timeSpent || (result.amount * result.orderLineWork.standardTime);
          var obj = orderPlanManager.getRequiredWorksById(result.orderLineWork.id);
          maximumMapping[obj.id] = result.amount;

          updateMaximum(obj);
          workstepId = obj.work.workstepId;
          Worker.query({workstepId : workstepId, per_page:DodomaConfig.magicalPageSize}, function(workerList) {
            $scope.workers = workerList.entities;
          });
        });
      }
}]);

'use strict';

angular.module('dodomaApp')
    .controller('ProductionSheetItemDetailController',
                ['$scope', '$rootScope', 'entity', 'ProductionSheetItem',
                function ($scope, $rootScope, entity, ProductionSheetItem) {
        $scope.productionSheetItem = entity;
        $scope.load = function (id) {
            ProductionSheetItem.get({id: id}, function(result) {
              $scope.productionSheetItem = result;
            });
        };
        $rootScope.$on('dodomaApp:productionSheetItemUpdate', function(event, result) {
          $scope.productionSheetItem = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('ProductionSheetItem', ['$resource', function ($resource) {
        return $resource('api/orderPlans/:orderId/productionSheets/:sheetId/items/:id', {orderId: '@orderId', sheetId: '@sheetId'}, {
            'query': { 
              method: 'GET', 
              isArray: false,
              url: 'api/productionSheetItems'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();

        var newSheet = {
          url: '/newProductionSheet',
          data: {
            roles: ['ROLE_PRODUCTIONMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/productionSheet/productionSheet-dialog.html',
              controller: 'ProductionSheetDialogController',
              size: 'lg',
              resolve: {
                entity: function () {
                  return {executionDate: new Date(), state: null, id: null};
                }
              }
            }).result.then(function(result) {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };
        var editSheet = {
          url: '/editProductionSheet/{sheetId:int}',
          data: {
            roles: ['ROLE_PRODUCTIONMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
              templateUrl: 'scripts/app/entities/productionSheet/productionSheet-dialog.html',
              controller: 'ProductionSheetDialogController',
              size: 'lg',
              resolve: {
                entity: ['ProductionSheet', function(ProductionSheet) {
                  return ProductionSheet.get({id : $stateParams.sheetId, orderPlanId: $stateParams.orderId});
                }]
              }
            }).result.then(function(result) {
              $state.go('^');
            }, function() {
              $state.go('^');
            })
          }]
        };

        $stateProvider
            .state('productionSheet', {
                parent: 'productionManagement',
                url: '/productionSheets',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.productionSheet.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/productionSheet/productionSheets.html',
                        controller: 'ProductionSheetController'
                    }
                },
            })
            .state('productionSheetDetail', {
                parent: 'productionManagement',
                url: '/productionSheet/{id:int}',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.productionSheet.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/productionSheet/productionSheet-detail.html',
                        controller: 'ProductionSheetDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ProductionSheet', function($stateParams, ProductionSheet) {
                        return ProductionSheet.get({id : $stateParams.id});
                    }]
                }
            })
            .state('orderPlan.detail.productionSheetNew', stateUtil.stateUrl(newSheet))
            .state('orderPlan.detail.productionSheetEdit', stateUtil.stateUrl(editSheet))
            .state('offer.detail.productionSheetNew', stateUtil.stateUrl(newSheet))
            .state('offer.detail.productionSheetEdit', stateUtil.stateUrl(editSheet))

            ;
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('ProductionSheetController',
                ['$scope', 'ProductionSheet', 'DateUtils', 'ParseLinks', 'StorageUtil', 'RequestUtil',
                function ($scope, ProductionSheet, DateUtils, ParseLinks, StorageUtil, RequestUtil) {
        $scope.productionSheets = [];
        $scope.page = 1;

        StorageUtil.setupFilters("productionSheetController", $scope);

        $scope.loadAll = function() {
            var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
            if ($scope.customFilter.client) {
                q.clientId = $scope.customFilter.client.id;
            }
            if ($scope.customFilter.orderPlan) {
                q.orderPlanId = $scope.customFilter.orderPlan.id;
            }
            q.after = DateUtils.convertLocaleDateToServer(q.after);
            q.before = DateUtils.convertLocaleDateToServer(q.before);

            ProductionSheet.query(q, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.pageResult = result;
                $scope.productionSheets = result.entities;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        /*
        $scope.delete = function (id) {
            ProductionSheet.get({id: id}, function(result) {
                $scope.productionSheet = result;
                $('#deleteProductionSheetConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            ProductionSheet.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteProductionSheetConfirmation').modal('hide');
                    $scope.clear();
                });
        };*/

        $scope.exportUrl = function() {
            var s = '/api/productionSheets/excel.xls?format=xls&';
            if ($scope.customFilter.client) {
              s += 'clientId=' + encodeURIComponent($scope.customFilter.client.id)+'&';
            }
            if ($scope.customFilter.orderPlan) {
              s += 'orderPlanId=' + encodeURIComponent($scope.customFilter.orderPlan.id)+'&';
            }
            return RequestUtil.createLink(s, $scope.filter, function(key, value) {
              if (value instanceof Date) {
                return DateUtils.convertLocaleDateToServer(value);
              }
              return value;
            });
          };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.productionSheet = {executionDate: null, state: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('ProductionSheetDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'ProductionSheet',
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, ProductionSheet) {

      $scope.productionSheet = entity;
      $scope.load = function(id) {
        ProductionSheet.get({id : id}, function(result) {
          $scope.productionSheet = result;
        });
      };

      $scope.save = function () {
        $scope.productionSheet.orderPlanId = $stateParams.orderId;
        ProductionSheet.save($scope.productionSheet, function (result) {
          $rootScope.$broadcast('dodomaApp:productionSheetUpdate', result);
          $uibModalInstance.close(result);
        });
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('ProductionSheetDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductionSheet',
                function ($scope, $rootScope, $stateParams, entity, ProductionSheet) {
        $scope.productionSheet = entity;
        $scope.load = function (id) {
            ProductionSheet.get({id: id}, function(result) {
              $scope.productionSheet = result;
            });
        };
        $scope.$on('dodomaApp:productionSheetUpdate', function(event, result) {
          $scope.productionSheet = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('ProductionSheet', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/orderPlans/:orderPlanId/productionSheets/:id', {orderPlanId: '@orderPlanId'}, {
            'sheetsByOrderPlan': { method: 'GET', isArray: false},
            'query': {
                method: 'GET',
                url: 'api/productionSheets',
                params: {
                    after : '@after', 
                    before : '@before', 
                    clientId : '@clientId', 
                    orderPlanId : '@orderPlanId', 
                    sheetId : '@sheetId', 
                    orderPlanStatus: '@orderPlanStatus',
                    productionSheetStatus : '@productionSheetStatus'
                }
            },
            'start' : { 
              method : 'POST', 
              url: 'api/orderPlans/:orderPlanId/productionSheets/:id/start',
              params: {id : '@id'}
            },
            'revertStart' : { 
              method : 'POST', 
              url: 'api/orderPlans/:orderPlanId/productionSheets/:id/revertStart',
              params: {id : '@id'}
            },
            'finish' : { 
              method : 'POST', 
              url: 'api/orderPlans/:orderPlanId/productionSheets/:id/finish',
              params: {id : '@id'}
            },
            'autoFill' : { 
              method : 'POST', 
              url: 'api/orderPlans/:orderPlanId/productionSheets/:id/autoFill',
              params: {id : '@id'}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.executionDate = DateUtils.convertLocaleDateFromServer(data.executionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.executionDate = DateUtils.convertLocaleDateToServer(data.executionDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.executionDate = DateUtils.convertLocaleDateToServer(data.executionDate);
                    return angular.toJson(data);
                }
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        $stateProvider
            .state('workerRecord', {
                parent: 'entity',
                url: '/workerRecords',
                data: {
                    roles: ['ROLE_REHABMANAGER', 'ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.workerRecord.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workerRecord/workerRecords.html',
                        controller: 'WorkerRecordController'
                    }
                }
            })
            .state('workerRecordDetail', {
                parent: 'workerRecord',
                url: '/{id:int}',
                data: {
                    roles: ['ROLE_REHABMANAGER', 'ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.workerRecord.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workerRecord/workerRecord-detail.html',
                        controller: 'WorkerRecordDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'WorkerRecord', function($stateParams, WorkerRecord) {
                        return WorkerRecord.get({id : $stateParams.id}).$promise;
                    }]
                }
            });
        var newWorkerRecord = {
              url: '/new/{type}',
              data: {
                  roles: ['ROLE_REHABMANAGER', 'ROLE_PRODUCTIONMANAGER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/workerRecord/workerRecord-dialog.html',
                  controller: 'WorkerRecordDialogController',
                  size: 'lg',
                  resolve: {
                      entity: function () {
                          return {status: 'DRAFT', type: $stateParams.type, recordDate: new Date(), minutes: null, id: null, params: {}};
                      }
                  }
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            };
        var editWorkerRecord = {
              url: '/edit',
              data: {
                  roles: ['ROLE_REHABMANAGER', 'ROLE_PRODUCTIONMANAGER'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                  templateUrl: 'scripts/app/entities/workerRecord/workerRecord-dialog.html',
                  controller: 'WorkerRecordDialogController',
                  size: 'lg',
                  resolve: {
                      entity: ['WorkerRecord', function(WorkerRecord) {
                        if (angular.isDefined($stateParams.recordType)) {
                          return WorkerRecord.getByType({workerId: $stateParams.workerId, recordType: $stateParams.recordType}).$promise;
                        } else {
                          return WorkerRecord.get({id : $stateParams.id}).$promise;
                        }
                      }]
                  }
                }).result.then(function(result) {
                  $state.go('^');
                }, function() {
                  $state.go('^');
                })
              }]
            };
        var stateUtil = stateUtilProvider.$get();
        $stateProvider.state('workerRecord.newRecord', stateUtil.stateUrl(newWorkerRecord));
        $stateProvider.state('workerRecordDetail.edit', stateUtil.stateUrl(editWorkerRecord));

        $stateProvider.state('worker.detail.newRecord', stateUtil.stateUrl(newWorkerRecord, null, { mode:'PROD'}));
        $stateProvider.state('worker.detail.editRecord', stateUtil.stateUrl(editWorkerRecord, '/editRecord/{id}' , { mode:'PROD'}));
        $stateProvider.state('worker.detail.editProfile', stateUtil.stateUrl(editWorkerRecord, '/profile/{recordType}', { mode:'PROD'}));

        $stateProvider.state('rehabWorker.detail.newRecord', stateUtil.stateUrl(newWorkerRecord, null, { mode:'REHAB'} ));
        $stateProvider.state('rehabWorker.detail.editRecord', stateUtil.stateUrl(editWorkerRecord, '/editRecord/{id}', { mode:'REHAB'}));
        $stateProvider.state('rehabWorker.detail.editProfile', stateUtil.stateUrl(editWorkerRecord, '/profile/{recordType}', { mode:'REHAB'}));

    }]);

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .service('recordConfig', ['DodomaConfig', function (DodomaConfig) {

      function getRecord(type) {
        return DodomaConfig.records[type.toUpperCase()];
      }

      this.hasValidityDate = function(type) {
        var r = getRecord(type);
        return r && r.validityDate !== false;
      };
      this.isPrintable = function(type) {
        var r = getRecord(type);
        return r && r.printable === true;
      };
      this.isSimple = function(type) {
        var r = getRecord(type);
        return r && r.simple === true;
      };
      this.isShowMinutes = function(type) {
        var r = getRecord(type);
        return r && (r.showMinutes === true);
      };
      
      this.getDeadlines = function(type) {
        var r = getRecord(type);
        return angular.isDefined(r) ? r.deadlines : [];
      };
      // false is the default
      this.hasMultipleWorker = function(type) {
        var r = getRecord(type);
        return r && r.multipleWorker === true;
      };
      // true is the default
      this.showDocuments = function(type) {
        var r = getRecord(type);
        return r && r.showDocuments !== false;
      };
    }]);
})();

'use strict';

angular.module('dodomaApp')
    .controller('WorkerRecordController',
                ['$scope', 'WorkerRecord', 'StorageUtil',
                function ($scope, WorkerRecord, StorageUtil) {
        $scope.workerRecords = [];
        $scope.page = 1;

        StorageUtil.setupFilters("workerRecordController", $scope, {customFilter:{}, filter: { status : 'DRAFT' }});

        $scope.pageResult = {};
        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.customFilter.creator) {
            q.creatorId = $scope.customFilter.creator.id;
          }
          if ($scope.customFilter.worker) {
            q.workerId = $scope.customFilter.worker.id;
          }

          WorkerRecord.query(q, function(result, headers) {
                $scope.pageResult = result;
                $scope.workerRecords = result.entities;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            WorkerRecord.get({id: id}, function(result) {
                $scope.workerRecord = result;
                $('#deleteWorkerRecordConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            WorkerRecord.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteWorkerRecordConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.workerRecord = {status: null, type: null, recordDate: null, minutes: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkerRecordDialogController',
    ['$scope', '$rootScope', '$stateParams', '$state', '$uibModalInstance', 'entity', 'WorkerRecord', 'Worker', 'Document', 'recordConfig',
        function($scope, $rootScope, $stateParams, $state, $uibModalInstance, entity, WorkerRecord, Worker, Document, recordConfig) {

      $scope.workerRecord = entity;
      $scope.alreadyPressed = false;
      $scope.stateData = $state.current.data;

      $scope.simple = recordConfig.isSimple(entity.type);
      $scope.hasValidityDate = recordConfig.hasValidityDate(entity.type);
      $scope.showMultipleWorkerSelector = recordConfig.hasMultipleWorker(entity.type);
      $scope.showMinutes = recordConfig.isShowMinutes(entity.type);
      $scope.showDocuments = recordConfig.showDocuments(entity.type);

      if ($scope.showMultipleWorkerSelector) {
        if (!angular.isArray($scope.workerRecord.workers) || $scope.workerRecord.workers.length === 0) {
          Worker.get({id : $stateParams.workerId}, function(wrk) {
            $scope.workerRecord.workers = [wrk];
          });
        }
      }

      function loadDocumentsIfPossible() {
        if (!$scope.documents) {
          if ($scope.showDocuments && $scope.workerRecord.id) {
            Document.findByRecords({recordId : $scope.workerRecord.id}, function(documents) {
              $scope.documents = documents;
            });
          }
        }
      }

      function updateRecordReadonly() {
        $scope.recordReadonly = $scope.workerRecord.status === 'FINAL';
      }

      $scope.workers = [];
      $scope.load = function(id) {
        WorkerRecord.get({id : id}, function(result) {
          $scope.workerRecord = result;
          updateRecordReadonly();
        });
      };

      var onSaveFinished = function (result) {
        $rootScope.$broadcast('dodomaApp:workerRecordUpdate', result);
        $uibModalInstance.close(result);
        $scope.alreadyPressed = false;
      };

      var onSaveUpdate = function(result) {
        $rootScope.$broadcast('dodomaApp:workerRecordUpdate', result);
        $scope.alreadyPressed = false;
        $scope.workerRecord = result;
        updateRecordReadonly();
        loadDocumentsIfPossible();
      };

      function saveWithCallback(callback) {
        $scope.alreadyPressed = true;
        var deadlines = recordConfig.getDeadlines($scope.workerRecord.type);
        $scope.workerRecord.deadlineKeys = deadlines;

        if (angular.isDefined($stateParams.workerId)) {
          if (!angular.isArray($scope.workerRecord.workers) || $scope.workerRecord.workers.length === 0) {
            $scope.workerRecord.workers = [{id:$stateParams.workerId}];
          }
        }
        if ($scope.simple) {
          WorkerRecord.saveByType($scope.workerRecord, callback);
        } else {
          if ($scope.workerRecord.id != null) {
            WorkerRecord.update($scope.workerRecord, callback);
          } else {
            WorkerRecord.save($scope.workerRecord, callback);
          }
        }
      };

      $scope.save = function() {
        saveWithCallback(onSaveFinished);
      };

      $scope.finalize = function() {
        $scope.workerRecord.status = 'FINAL';
        $scope.save();
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

      $scope.$on('dodomaApp:workerRecordInlineSave', function() {
        saveWithCallback(onSaveUpdate);
      });

      $scope.$on('dodomaApp:markWritable', function() {
        delete $scope.workerRecord.id;
        $scope.workerRecord.status = 'DRAFT';
        $scope.recordReadonly = false;
        delete $scope.workerRecord.minutes;
        $scope.workerRecord.recordDate = new Date();
        delete $scope.workerRecord.validityDate;
      });

      $scope.showWorkerSelector = function() {
        return !angular.isDefined($stateParams.workerId);
      };

      // pdf export
      $scope.isExportable = function (entity) {
        return angular.isNumber(entity.id) && recordConfig.isPrintable(entity.type);
      };

      $scope.recordExportUrl = function (entity) {
        return "/api/workerRecords/" + entity.id+ ".pdf";
      };

      updateRecordReadonly();
      loadDocumentsIfPossible();
      if ($scope.showWorkerSelector()) {
        $scope.workers = Worker.query();
      }

}]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkerRecordDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'WorkerRecord',
                function ($scope, $rootScope, $stateParams, entity, WorkerRecord) {
        $scope.workerRecord = entity;
        $scope.load = function (id) {
            WorkerRecord.get({id: id}, function(result) {
              $scope.workerRecord = result;
            });
        };
        $rootScope.$on('dodomaApp:workerRecordUpdate', function(event, result) {
          $scope.workerRecord = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkerRecord', ['$resource', 'DateUtils', function ($resource, DateUtils) {

      function convertDatas(root) {
        for (var key in root) {
          var value = root[key];
          if (root.hasOwnProperty(key)) {
            if (key.endsWith('_number')) {
              root[key] = parseInt(value, 10);
            } else if (key.endsWith('_datetime_local')) {
              root[key] = DateUtils.convertDateTimeFromServer(value);
            } else if (key.endsWith('_date')) {
              // we send full timestamps ...
              root[key] = DateUtils.convertDateTimeFromServer(value);
            } else if (key.endsWith('_checkbox')) {
              root[key] = ('true' === value);
            } else if (value === 'true') {
              root[key] = true;
            } else if (value === 'false') {
              root[key] = false;
            } else if (!angular.isString(value) && angular.isObject(value) && !angular.isFunction(value)) {
              convertDatas(value);
            }
          }
        }
      }

      function recordResponseTransform(data) {
        data = angular.fromJson(data);
        if (data) {
            data.recordDate = DateUtils.convertLocaleDateFromServer(data.recordDate);
            data.validityDate = DateUtils.convertLocaleDateFromServer(data.validityDate);

            convertDatas(data.params);
        }
        return data;
      };
      function recordToJson(data) {
        var dt = angular.copy(data);
        dt.recordDate = DateUtils.convertLocaleDateToServer(dt.recordDate);
        dt.validityDate = DateUtils.convertLocaleDateToServer(dt.validityDate);
        return angular.toJson(dt);
      }

      return $resource('api/workerRecords/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: recordResponseTransform
            },
            'getByType': {
              method: 'GET',
              url: 'api/workers/:workerId/recordByType/:recordType',
              params: { workerId:'@workerId', recordType: '@recordType'},
              transformResponse: recordResponseTransform
            },
            'update': {
              method: 'PUT',
              transformRequest: recordToJson,
              transformResponse: recordResponseTransform
            },
            'saveByType': {
              method: 'POST',
              url: 'api/workers/recordByType',
              transformRequest: recordToJson,
              transformResponse: recordResponseTransform
            },
            'save': {
                method: 'POST',
                transformRequest: recordToJson,
                transformResponse: recordResponseTransform
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();
      var newItem = {
        url: '/verification/{itemId:int}/new',
        data: {
            roles: ['ROLE_PRODUCTIONMANAGER', 'ROLE_PROD_QA'],
        },
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'scripts/app/entities/productionSheetItemVerification/productionSheetItemVerification-dialog.html',
            controller: 'ProductionSheetItemVerificationDialogController',
            //size: 'sm',
            resolve: {
                entity: function () {
                    return {checkedAmount: null, brokenAmount: null, id: null, itemId: $stateParams.itemId};
                }
            }
          }).result.then(function(result) {
            $state.go('^');
          }, function() {
            $state.go('^');
          })
        }]
      };
      var editItem = {
        url: '/verification/{itemId:int}/edit/{verificationId:int}',
        data: {
            roles: ['ROLE_PRODUCTIONMANAGER', 'ROLE_PROD_QA'],
        },
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
          $uibModal.open({
            templateUrl: 'scripts/app/entities/productionSheetItemVerification/productionSheetItemVerification-dialog.html',
            controller: 'ProductionSheetItemVerificationDialogController',
            //size: 'sm',
            resolve: {
                entity: ['ProductionSheetItemVerification', function(ProductionSheetItemVerification) {
                    return ProductionSheetItemVerification.get({id : $stateParams.verificationId, itemId: $stateParams.itemId});
                }]
            }
          }).result.then(function(result) {
            $state.go('^');
          }, function() {
            $state.go('^');
          })
        }]
      };
      
      $stateProvider
            .state('orderPlan.detail.productionSheetItemVerificationNew', stateUtil.stateUrl(newItem))
            .state('orderPlan.detail.productionSheetItemVerificationEdit', editItem)
            .state('productionSheetItem.productionSheetItemVerificationNew', stateUtil.stateUrl(newItem))
            ;
    }]);

'use strict';

angular.module('dodomaApp').controller('ProductionSheetItemVerificationDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'ProductionSheetItemVerification',
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, ProductionSheetItemVerification) {

      $scope.productionSheetItemVerification = entity;
      $scope.load = function(id) {
        ProductionSheetItemVerification.get({id : id}, function(result) {
          $scope.productionSheetItemVerification = result;
        });
      };

      var onSaveFinished = function (result) {
        $rootScope.$broadcast('dodomaApp:productionSheetUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.save = function () {
        $scope.productionSheetItemVerification.itemId = $stateParams.itemId;
        if ($scope.productionSheetItemVerification.id != null) {
          ProductionSheetItemVerification.update($scope.productionSheetItemVerification, onSaveFinished);
        } else {
          ProductionSheetItemVerification.save($scope.productionSheetItemVerification, onSaveFinished);
        }
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };
}]);

'use strict';

angular.module('dodomaApp')
    .factory('ProductionSheetItemVerification', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/prodSheetItem/:itemId/verification/:id', { itemId: '@itemId'}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
  .config(['$stateProvider', 'stateUtilProvider', function($stateProvider, stateUtilProvider) {
    var stateUtil = stateUtilProvider.$get();

    var productionVariantNew = {
      url: '/newProductionVariant',
      data: {
        roles: ['ROLE_USER'],
      },
      onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'scripts/app/entities/productionVariant/productionVariant-dialog.html',
          controller: 'ProductionVariantDialogController',
          size: 'lg',
          resolve: {
            entity: { name: null, description: null, active: true, id: null }
          }
        }).result.then(function() {
          $state.go('^');
        }, function() {
          $state.go('^');
        })
      }]
    };
    var productionVariantDuplicate = {
      url: '/duplicateProductionVariant/{variantId}',
      data: {
        roles: ['ROLE_USER'],
      },
      onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'scripts/app/entities/productionVariant/productionVariant-dialog.html',
          controller: 'ProductionVariantDialogController',
          size: 'lg',
          resolve: {
            entity: ['ProductionVariant', function(ProductionVariant) {
              return ProductionVariant.get({ id: $stateParams.variantId, partId: $stateParams.partId }).$promise.then(function(variant) {
                variant.copiedFromId = variant.id;
                variant.id = null; // Reset ID for duplication
                return variant;
              });
            }]
          }
        }).result.then(function() {
          $state.go('^');
        }, function() {
          $state.go('^');
        })
      }]
    };

    var productionVariantEdit = {
      url: '/productionVariant/{variantId}',
      data: {
        roles: ['ROLE_USER'],
      },
      onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
          templateUrl: 'scripts/app/entities/productionVariant/productionVariant-dialog.html',
          controller: 'ProductionVariantDialogController',
          size: 'lg',
          resolve: {
            entity: ['ProductionVariant', function(ProductionVariant) {
              return ProductionVariant.get({ id: $stateParams.variantId, partId: $stateParams.partId }).$promise;
            }]
          }
        }).result.then(function() {
          $state.go('^');
        }, function() {
          $state.go('^');
        })
      }]
    };
    $stateProvider
    .state('partDetail.productionVariantNew', stateUtil.stateUrl(productionVariantNew))
    .state('partDetail.productionVariantDuplicate', stateUtil.stateUrl(productionVariantDuplicate))
    .state('partDetail.productionVariantEdit', stateUtil.stateUrl(productionVariantEdit))
    ;
  }]);

'use strict';

angular.module('dodomaApp').controller('ProductionVariantDialogController',
    ['$scope',  '$rootScope', '$stateParams', '$uibModalInstance', 'ProductionVariant', 'entity',
        function($scope, $rootScope, $stateParams, $uibModalInstance, ProductionVariant, entity) {

      $scope.productionVariant = entity;
      $scope.load = function(partId,id) {
        ProductionVariant.get({partId: partId, id : id}, function(result) {
          $scope.productionVariant = result;
        });
      };

      var closeFunction = function(result) {
        $rootScope.$broadcast('dodomaApp:workStepUpdate', result);
        $rootScope.$broadcast('dodomaApp:partUpdate', result);
        $uibModalInstance.close(result);
      };

      $scope.create = function() {
        if (angular.isNumber($stateParams.partId)) {
          $scope.productionVariant.partId = $stateParams.partId;
        }
        ProductionVariant.persist($scope.productionVariant, closeFunction);
      };

      $scope.clear = function() {
        $uibModalInstance.dismiss('cancel');
      };

}]);

'use strict';

angular.module('dodomaApp')
    .factory('ProductionVariant', ['$resource', function ($resource) {
        return $resource('api/part/:partId/variants/:id', {partId: '@partId'}, {
            'query': { 
              method: 'GET', 
              isArray: false//,
              //url: 'api/part'
            },
            'getDefault': {
              method: 'GET',
              url: 'api/part/:partId/variants/default',
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'persist': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('workPricingCategory', {
                parent: 'entity',
                url: '/workPricingCategorys',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.workPricingCategory.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workPricingCategory/workPricingCategorys.html',
                        controller: 'WorkPricingCategoryController'
                    }
                }
            })
            .state('workPricingCategory.detail', {
                url: '/workPricingCategory/{id}',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.workPricingCategory.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workPricingCategory/workPricingCategory-detail.html',
                        controller: 'WorkPricingCategoryDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'WorkPricingCategory', function($stateParams, WorkPricingCategory) {
                        return WorkPricingCategory.get({id : $stateParams.id});
                    }]
                }
            })
            .state('workPricingCategory.new', {
                url: '/new',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/workPricingCategory/workPricingCategory-dialog.html',
                        controller: 'WorkPricingCategoryDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {name: null, hourlyRate: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('workPricingCategory', null, { reload: true });
                    }, function() {
                        $state.go('workPricingCategory');
                    })
                }]
            })
            .state('workPricingCategory.edit', {
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/workPricingCategory/workPricingCategory-dialog.html',
                        controller: 'WorkPricingCategoryDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['WorkPricingCategory', function(WorkPricingCategory) {
                                return WorkPricingCategory.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('workPricingCategory', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkPricingCategoryController',
                ['$scope', 'WorkPricingCategory',
                function ($scope, WorkPricingCategory) {
        $scope.workPricingCategorys = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            WorkPricingCategory.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.pageResult = result;
                $scope.workPricingCategorys = result.entities;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            WorkPricingCategory.get({id: id}, function(result) {
                $scope.$emit('clearErrors');
                $scope.workPricingCategory = result;
                $('#deleteWorkPricingCategoryConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            WorkPricingCategory.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteWorkPricingCategoryConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.workPricingCategory = {name: null, hourlyRate: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkPricingCategoryDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'WorkPricingCategory',
        function($scope, $stateParams, $uibModalInstance, entity, WorkPricingCategory) {

        $scope.workPricingCategory = entity;
        $scope.load = function(id) {
            WorkPricingCategory.get({id : id}, function(result) {
                $scope.workPricingCategory = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('dodomaApp:workPricingCategoryUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.workPricingCategory.id != null) {
                WorkPricingCategory.update($scope.workPricingCategory, onSaveFinished);
            } else {
                WorkPricingCategory.save($scope.workPricingCategory, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkPricingCategoryDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'WorkPricingCategory',
                function ($scope, $rootScope, $stateParams, entity, WorkPricingCategory) {
        $scope.workPricingCategory = entity;
        $scope.load = function (id) {
            WorkPricingCategory.get({id: id}, function(result) {
                $scope.workPricingCategory = result;
            });
        };
        $rootScope.$on('dodomaApp:workPricingCategoryUpdate', function(event, result) {
          $scope.workPricingCategory = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkPricingCategory', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/workPricingCategorys/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
      var stateUtil = stateUtilProvider.$get();

      var edit = {
          url: '/priceCalculation',
          data: {
              roles: ['ROLE_PRODUCTIONMANAGER'],
          },

          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'scripts/app/entities/priceCalculation/priceCalculation-dialog.html',
                  controller: 'PriceCalculationDialogController',
                  size: 'lg',
                  resolve: {
                    backendService : ['PriceCalculation', function(PriceCalculation) {
                      return PriceCalculation;
                    }],
                    entity: ['PriceCalculation', function(PriceCalculation) {
                      return PriceCalculation.get({id : $stateParams.orderId}).$promise;
                    }],
                    mode: function() {
                      return 'PRE';
                    }
                  }
              }).result.then(function(result) {
                  $state.go('^');
              }, function() {
                  $state.go('^');
              })
          }]
      };
      
      var postCalculation = {
          url: '/postCalculation',
          data: {
              roles: ['ROLE_PRODUCTIONMANAGER'],
          },

          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'scripts/app/entities/priceCalculation/priceCalculation-dialog.html',
                  controller: 'PriceCalculationDialogController',
                  size: 'lg',
                  resolve: {
                    backendService : ['PostCalculation', function(PostCalculation) {
                      return PostCalculation;
                    }],
                    entity: ['PostCalculation', function(PostCalculation) {
                      return PostCalculation.get({id : $stateParams.orderId}).$promise;
                    }],
                    mode: function() {
                      return 'POST';
                    }
                  }
              }).result.then(function(result) {
                  $state.go('^');
              }, function() {
                  $state.go('^');
              })
          }]
      };

      $stateProvider
        .state('offer.detail.priceCalculationEdit', stateUtil.stateUrl(edit))
        .state('orderPlan.detail.priceCalculationEdit', stateUtil.stateUrl(edit))
        .state('orderPlan.detail.postCalculationEdit', postCalculation)
      ;
    }]);

'use strict';

angular.module('dodomaApp').controller('PriceCalculationDialogController',
    ['$scope', '$rootScope', '$uibModalInstance', 'entity', 'backendService', 'mode', 
        function($scope, $rootScope, $uibModalInstance, entity, backendService, mode) {

        $scope.priceCalculation = entity;

        $scope.mode = mode;
        $scope.load = function(id) {
          backendService.get({id : id}, function(result) {
                $scope.priceCalculation = result;
            });
        };

        $scope.save = function () {
          backendService.save($scope.priceCalculation, function (result) {
            $rootScope.$broadcast('dodomaApp:orderPlanUpdate', result);
            $uibModalInstance.close(result);
          });
        };
        
        $scope.sumUp = function() {
          var p = $scope.priceCalculation;
          p.totalFee = 0 + p.workNeed + p.machineCost + 
            p.maintenanceFee + p.shippingFee + p.otherFee + p.accountingFee + p.storageFee; 
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        function init() {
          var p = $scope.priceCalculation;
          p.machineCost = p.machineCost || 0; 
          p.maintenanceFee = p.maintenanceFee || 0; 
          p.shippingFee = p.shippingFee || 0; 
          p.otherFee = p.otherFee || 0; 
          p.accountingFee = p.accountingFee || 0; 
          p.otherFee = p.otherFee || 0;
          p.storageFee = p.storageFee || 0;
          $scope.sumUp();
        }

        init();

    }]);

'use strict';

angular.module('dodomaApp')
.factory('PriceCalculation', ['$resource', 'DateUtils', function ($resource, DateUtils) {
    return $resource('api/priceCalculations/:id', {}, {
        'query': { method: 'GET', isArray: false},
        'get': {
            method: 'GET',
            transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        'update': { method:'PUT' }
    });
}]);

'use strict';

angular.module('dodomaApp')
  .directive('priceCalculationDisplay', function() {
    return {
        restrict: 'E',
        scope: {
          priceCalculation : '=',
          extended : '='
        },
        templateUrl : 'scripts/app/entities/priceCalculation/priceCalculation.display.html'
    };
  }
);

'use strict';

angular.module('dodomaApp')
.factory('PostCalculation', ['$resource', 'DateUtils', function ($resource, DateUtils) {
    return $resource('api/postCalculations/:id', {}, {
        'query': { method: 'GET', isArray: false},
        'get': {
            method: 'GET',
            transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        'update': { method:'PUT' }
    });
}]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('productionEvaluation', {
                parent: 'entity',
                url: '/productionEvaluations',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.productionEvaluation.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/productionEvaluation/productionEvaluations.html',
                        controller: 'ProductionEvaluationController'
                    }
                }
            })
            .state('productionEvaluation.detail', {
                url: '/productionEvaluation/{id}',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                    pageTitle: 'dodomaApp.productionEvaluation.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/productionEvaluation/productionEvaluation-detail.html',
                        controller: 'ProductionEvaluationDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ProductionEvaluation', function($stateParams, ProductionEvaluation) {
                        return ProductionEvaluation.get({id : $stateParams.id}).$promise;
                    }]
                }
            })
            .state('productionEvaluation.new', {
                url: '/new',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                },
                onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/productionEvaluation/productionEvaluation-dialog.html',
                        controller: 'ProductionEvaluationDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {productName: null, workflow: null, testStart: null, testerName: null, numberOfProducts: null, verificationTime: null, toolNeed: null, storeNeed: null, transferNeed: null, storageNeed: null, logisticNeed: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('productionEvaluation', null, { reload: true });
                    }, function() {
                        $state.go('productionEvaluation');
                    })
                }]
            })
            .state('productionEvaluation.edit', {
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_PRODUCTIONMANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/productionEvaluation/productionEvaluation-dialog.html',
                        controller: 'ProductionEvaluationDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['ProductionEvaluation', function(ProductionEvaluation) {
                                return ProductionEvaluation.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('productionEvaluation', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('ProductionEvaluationController',
                ['$scope', 'ProductionEvaluation',
                function ($scope, ProductionEvaluation) {
        $scope.productionEvaluations = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            ProductionEvaluation.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.pageResult = result;
                $scope.productionEvaluations = result.entities;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            ProductionEvaluation.get({id: id}, function(result) {
                $scope.productionEvaluation = result;
                $('#deleteProductionEvaluationConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            ProductionEvaluation.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteProductionEvaluationConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.productionEvaluation = {productName: null, workflow: null, testStart: null, testerName: null, numberOfProducts: null, verificationTime: null, toolNeed: null, storeNeed: null, transferNeed: null, storageNeed: null, logisticNeed: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('ProductionEvaluationDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductionEvaluation', 'Worker',
        function($scope, $stateParams, $uibModalInstance, entity, ProductionEvaluation, Worker) {

        $scope.productionEvaluation = entity;
        $scope.workers = Worker.query();
        $scope.load = function(id) {
            ProductionEvaluation.get({id : id}, function(result) {
                $scope.productionEvaluation = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('dodomaApp:productionEvaluationUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.productionEvaluation.id != null) {
                ProductionEvaluation.update($scope.productionEvaluation, onSaveFinished);
            } else {
                ProductionEvaluation.save($scope.productionEvaluation, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('ProductionEvaluationDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'ProductionEvaluation',
                function ($scope, $rootScope, $stateParams, entity, ProductionEvaluation) {
        $scope.productionEvaluation = entity;
        $scope.load = function (id) {
            ProductionEvaluation.get({id: id}, function(result) {
                $scope.productionEvaluation = result;
            });
        };
        $rootScope.$on('dodomaApp:productionEvaluationUpdate', function(event, result) {
          $scope.productionEvaluation = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('ProductionEvaluation', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/productionEvaluations/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.testStart = DateUtils.convertDateTimeFromServer(data.testStart);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', 'stateUtilProvider', function ($stateProvider, stateUtilProvider) {
        var stateUtil = stateUtilProvider.$get();
        $stateProvider
            .state('workLog', {
                parent: 'entity',
                url: '/workLogs',
                data: {
                    roles: ['ROLE_WORKLOG'],
                    pageTitle: 'dodomaApp.workLog.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workLog/workLogs.html',
                        controller: 'WorkLogController'
                    }
                }
            })
            .state('workLog.detail', {
                url: '/{workLogId:int}',
                data: {
                    roles: ['ROLE_WORKLOG'],
                    pageTitle: 'dodomaApp.workLog.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/workLog/workLog-detail.html',
                        controller: 'WorkLogDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'WorkLog', function($stateParams, WorkLog) {
                        return WorkLog.get({id : $stateParams.workLogId}).$promise;
                    }]
                }
            });
        
        var newWorkLogState =  {
                url: '/new',
                data: {
                    roles: ['ROLE_WORKLOG'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/workLog/workLog-dialog.html',
                        controller: 'WorkLogDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {recordDate: new Date(), task: null, minutes: null, relatedOther: null, summary: null, id: null, status : 'DRAFT', relatedWorkers : []};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('^');
                    }, function() {
                        $state.go('^');
                    })
                }]
            };
        var editWorkLogState =  {
              url: '/{workLogId:int}/edit',
              data: {
                  roles: ['ROLE_WORKLOG'],
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                  $uibModal.open({
                      templateUrl: 'scripts/app/entities/workLog/workLog-dialog.html',
                      controller: 'WorkLogDialogController',
                      size: 'lg',
                      resolve: {
                          entity: ['WorkLog', function(WorkLog) {
                              return WorkLog.get({id : $stateParams.workLogId}).$promise;
                          }]
                      }
                  }).result.then(function(result) {
                      $state.go('^');
                  }, function() {
                      $state.go('^');
                  })
              }]
        };
        $stateProvider
          .state('workLog.new', stateUtil.stateUrl(newWorkLogState))
          .state('workLog.edit', stateUtil.stateUrl(editWorkLogState))
          .state('workLog.detail.edit', stateUtil.stateUrl(editWorkLogState, '/edit'))
          .state('worker.detail.newWorkLog', stateUtil.stateUrl(newWorkLogState, '/newWorkLog'))
          .state('worker.detail.editWorkLog', stateUtil.stateUrl(editWorkLogState, '/{workLogId:int}/editWorkLog'))
          .state('rehabWorker.detail.newWorkLog', stateUtil.stateUrl(newWorkLogState, '/newWorkLog'))
          .state('rehabWorker.detail.editWorkLog', stateUtil.stateUrl(editWorkLogState, '/{workLogId:int}/editWorkLog'))
        ;
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkLogController',
                ['$scope', 'WorkLog', 'User', 'Principal', 'DateUtils', 'DodomaConfig', 'StorageUtil', 'RequestUtil',
                function ($scope, WorkLog, User, Principal, DateUtils, DodomaConfig, StorageUtil, RequestUtil) {
        $scope.workLogs = [];
        $scope.page = 1;

        $scope.users = [];
        var now = new Date();
        StorageUtil.setupFilters("workLogController", $scope, {customFilter:{}, filter: { year : now.getFullYear(), month:now.getMonth()+1 }});

        $scope.selfId = -1;
        $scope.monthList = [1,2,3,4,5,6,7,8,9,10,11,12];

        $scope.displayMonth = function(value) {
          return DateUtils.getMonthName(value);
        };
        $scope.getFirstWorker = function(workLog) {
          return workLog.relatedWorkerNames[0];
        };

        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.customFilter.worker) {
            q.workerId = $scope.customFilter.worker.id;
          }
          q.date = DateUtils.convertLocaleDateToServer($scope.filter.date);

          WorkLog.query(q, function(result, headers) {
            $scope.pageResult = result;
            $scope.workLogs = result.entities;
          });
        };
        $scope.changeFilter = function() {
            $scope.page = 1;
            $scope.loadAll();
        }
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };

        User.query({per_page:DodomaConfig.magicalPageSize}, function(result) {
          $scope.users = result;
          if (!Principal.isInRole('ROLE_WORKLOG_OVERVIEW')) { 
              Principal.identity().then(function(account){
                $scope.filter.userId = account.id;
                $scope.loadAll();
              });
          } else {
              $scope.loadAll();
          }
        });


        $scope.formatUser = function(user) {
          var r = '';
          if (angular.isString(user.lastName) && user.lastName.length > 0) {
            r += user.lastName;
          }
          if (angular.isString(user.firstName) && user.firstName.length > 0) {
            r += ' ' + user.firstName;
          }
          if (angular.isString(user.login) && user.login.length > 0) {
            r += ' ('+ user.login+')';
          }
          return r;
        }

        $scope.logExportUrl = function() {
          var basePath = '/api/workLogs/export.xls?format=xls&';
          if ($scope.customFilter.creator) {
            basePath += 'userId=' + encodeURIComponent($scope.customFilter.creator.id) + '&';
          }
          return RequestUtil.createLink(basePath, $scope.filter, function(key, value) {
            if ('date' === key) {
              return DateUtils.convertLocaleDateToServer(value);
            }
            return value;
          });
        };


        $scope.delete = function (id) {
            WorkLog.get({id: id}, function(result) {
                $scope.workLog = result;
                $('#deleteWorkLogConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            WorkLog.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteWorkLogConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.hasRecord = function (log) {
          return angular.isDefined(log) && angular.isObject(log.createdRecord);
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.workLog = {recordDate: null, task: null, minutes: null, relatedOther: null, summary: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('WorkLogDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'WorkLog', 'Principal',
                function ($scope, $rootScope, $stateParams, entity, WorkLog, Principal) {
        $scope.workLog = entity;
        $scope.selfId = -1;

        $scope.load = function (id) {
            WorkLog.get({id: id}, function(result) {
                $scope.workLog = result;
            });
        };
        Principal.identity().then(function(account){
          $scope.selfId = account.id;
        });

        $rootScope.$on('dodomaApp:workLogUpdate', function(event, result) {
          $scope.workLog = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('WorkLog', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        function recordToJson(data) {
          var dt = angular.copy(data);
          dt.recordDate = DateUtils.convertLocaleDateToServer(dt.recordDate);
          return angular.toJson(dt);
        }
        return $resource('api/workLogs/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.recordDateAsString = data.recordDate;
                        data.recordDate = DateUtils.convertLocaleDateFromServer(data.recordDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: recordToJson
            },
            'save': {
                method: 'POST',
                transformRequest: recordToJson
            }
        });
    }]);

'use strict';

angular.module('dodomaApp').controller('WorkLogDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'WorkLog', 'Worker', 
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, WorkLog, Worker) {

        $scope.workLog = entity;
        $scope.recordReadonly = entity.status == 'FINAL';
        $scope.workers = Worker.query();
        $scope.load = function(id) {
            WorkLog.get({id : id}, function(result) {
                $scope.workLog = result;
            });
        };
        if (angular.isNumber($stateParams.workerId)) {
          $scope.workLog.relatedWorker = { id: $stateParams.workerId} ;
        }

        var onSaveFinished = function (result) {
          $rootScope.$broadcast('dodomaApp:workLogUpdate', result);
          $uibModalInstance.close(result);
        };

        $scope.save = function () {
          if (angular.isNumber($scope.workLog.id)) {
            WorkLog.update($scope.workLog, onSaveFinished);
          } else {
            WorkLog.save($scope.workLog, onSaveFinished);
          }
        };

        $scope.finalize = function() {
          $scope.workLog.status = 'FINAL';
          $scope.save();
        };

        $scope.clear = function() {
          $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('deadline', {
                parent: 'entity',
                url: '/deadlines',
                data: {
                    roles: ['ROLE_REHABMANAGER'],
                    pageTitle: 'dodomaApp.deadline.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/deadline/deadlines.html',
                        controller: 'DeadlineController'
                    }
                }
            })
            .state('deadline.detail', {
                url: '/{id:int}',
                data: {
                    roles: ['ROLE_REHABMANAGER'],
                    pageTitle: 'dodomaApp.deadline.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/deadline/deadline-detail.html',
                        controller: 'DeadlineDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Deadline', function($stateParams, Deadline) {
                        return Deadline.get({id : $stateParams.id});
                    }]
                }
            })
            .state('deadline.new', {
                url: '/new',
                data: {
                    roles: ['ROLE_REHABMANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/deadline/deadline-dialog.html',
                        controller: 'DeadlineDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {deadlineDate: null, type: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('deadline', null, { reload: true });
                    }, function() {
                        $state.go('deadline');
                    })
                }]
            })
            .state('deadline.edit', {
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_REHABMANAGER'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'scripts/app/entities/deadline/deadline-dialog.html',
                        controller: 'DeadlineDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Deadline', function(Deadline) {
                                return Deadline.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('deadline', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('DeadlineController',
                ['$scope', 'Deadline', 'DateUtils', '$translate', 'StorageUtil',
                function ($scope, Deadline, DateUtils, $translate, StorageUtil) {
        $scope.deadlines = [];
        $scope.page = 1;

        StorageUtil.setupFilters("deadlineController", $scope, {customFilter:{}, filter: { startDate : new Date() }});

        $scope.loadAll = function() {
          var q = angular.extend({page: $scope.page, per_page: 20}, $scope.filter);
          if ($scope.filter.worker) {
              q.workerId = $scope.filter.worker.id;
          }
          q.startDate = DateUtils.convertLocaleDateToServer($scope.filter.startDate);
          q.endDate = DateUtils.convertLocaleDateToServer($scope.filter.endDate);

          Deadline.query(q, function(result, headers) {
            $scope.pageResult = result;
            $scope.deadlines = result.entities;
          });
        };
        $scope.loadPage = function(page) {
          $scope.page = page;
          $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Deadline.get({id: id}, function(result) {
                $scope.deadline = result;
                $('#deleteDeadlineConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Deadline.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteDeadlineConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.deadline = {deadlineDate: null, type: null, id: null};
        };
        
        $scope.describeDeadline = function(dl) {
          var type = dl.type;
          if (angular.isString(type)) {
            if (type.startsWith('validitydate.')) {
              var recType = type.substring('validitydate.'.length);
              return $translate.instant('dodomaApp.deadline.typeLabel.validityDate') + $translate.instant('dodomaApp.workerRecord.typeLabel.' + recType);
            }
            if (type.startsWith('record.')) {
              var recType = type.substring('record.'.length);
              return $translate.instant('dodomaApp.deadline.typeLabel.record.' + recType);
            }
            
          }
          return type;
        }
    }]);

'use strict';

angular.module('dodomaApp').controller('DeadlineDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Deadline', 'Worker', 'WorkerRecord',
        function($scope, $stateParams, $uibModalInstance, entity, Deadline, Worker, WorkerRecord) {

        $scope.deadline = entity;
        $scope.workers = Worker.query();
        $scope.workerrecords = WorkerRecord.query();
        $scope.load = function(id) {
            Deadline.get({id : id}, function(result) {
                $scope.deadline = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('dodomaApp:deadlineUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.deadline.id != null) {
                Deadline.update($scope.deadline, onSaveFinished);
            } else {
                Deadline.save($scope.deadline, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('DeadlineDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'Deadline',
                function ($scope, $rootScope, $stateParams, entity, Deadline) {
        $scope.deadline = entity;
        $scope.load = function (id) {
            Deadline.get({id: id}, function(result) {
                $scope.deadline = result;
            });
        };
        $rootScope.$on('dodomaApp:deadlineUpdate', function(event, result) {
          $scope.deadline = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Deadline', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/deadlines/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.deadlineDate = DateUtils.convertLocaleDateFromServer(data.deadlineDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.deadlineDate = DateUtils.convertLocaleDateToServer(data.deadlineDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.deadlineDate = DateUtils.convertLocaleDateToServer(data.deadlineDate);
                    return angular.toJson(data);
                }
            }
        });
    }]);

/* global $ */
(function () {
  'use strict';

  angular.module('dodomaApp')
    .service('QueryConfig', ['$q', 'Query', function ($q, Query) {
      var deferred = $q.defer();

      var qconfig = this;

      Query.getDefinition(function(result) {
        qconfig.rootEntities = [];
        angular.forEach(result.definitions, function(value, key) {
          //console.log('checking ' + key+' : ', value);
          if (value.root === true) {
            qconfig.rootEntities.push({name: key, translationKey : 'dodomaApp.query.config.'+key});
          }
          value.linksAsList = [];

          if (angular.isObject(value.links)) {
            angular.forEach(value.links, function(innerValue, innerKey) {
              if (angular.isObject(result.definitions[innerValue])) {
                //console.log(' ok :' + key + '.'+ innerKey +' -> '+innerValue);
              } else {
                throw new Error('Not found : '+key + '.'+ innerKey +' -> '+innerValue);
              }
              value.linksAsList.push({name: innerKey, translationKey: 'dodomaApp.query.config.'+innerKey});
            });
          }
          value.filtersAsList = [];

          if (angular.isObject(value.filters)) {
            angular.forEach(value.filters, function(filterValue, filterKey) {
              value.filtersAsList.push({name:filterKey, translationKey: 'dodomaApp.query.filter.'+filterKey});
            });
          }
        });
        qconfig.definitions = result.definitions;
        console.log('query config is ok.', qconfig.definitions);
        deferred.resolve(qconfig);
      });

      this.initialize = function() {
        return deferred.promise;
      };

      this.createServerQuery = function(name) {
        return { name: name, linkedEntities : [], filters: []};
      }

      this.createQueryFragmentDefinition = function(name, query) {
        var def = angular.copy(qconfig.definitions[name]);
        def.name = name;
        def.translationKey = 'dodomaApp.query.config.'+name;
        def.query = query;
        def.linkedEntities = [];
        def.displayedChildEntities = {};
        def.displayedFilters = {};
        return def;
      }

      
    }]);
})();

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('query', {
                parent: 'entity',
                url: '/query',
                data: {
                    roles: ['ROLE_SYSADMIN'],
                    pageTitle: 'dodomaApp.query.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/entities/query/query.html',
                        controller: 'QueryController'
                    }
                },
                resolve: {
                    queryConfig: ['QueryConfig', function(QueryConfig) { 
                      return QueryConfig.initialize();
                    }]
                }
            });
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('QueryController',
                ['$scope', 'Query', 'queryConfig', 'CollectionUtil',
                function ($scope, Query, queryConfig, CollectionUtil) {
        $scope.rows = [];
        $scope.page = 1;
        $scope.qc = queryConfig.rootEntities;
        $scope.formParams = { rootEntity : ''};
        $scope.entityList = [];
        $scope.query = queryConfig.createServerQuery(null);
        $scope.numberFilterModifiers = [];

        function initNumberFilterType() {
          angular.forEach(['EQUAL', 'NOT_EQUAL', 'GT', 'GTE', 'LT', 'LTE'], function(type) {
            $scope.numberFilterModifiers.push({type: type, translationKey : 'dodomaApp.query.config.numberFilter.'+type});
          });
        }

        initNumberFilterType();

        $scope.changeEntityModel = function(entity) {
          // console.log('changeEntityModel', entity);
          var reLoadNeeded = false;
          angular.forEach(entity.linkedEntities, function(name) {
            if (entity.displayedChildEntities[name] === undefined) {
              var q = queryConfig.createServerQuery(name);
              var newEntityDef = queryConfig.createQueryFragmentDefinition(entity.links[name], q);
              $scope.entityList.push(newEntityDef);
              entity.query.linkedEntities.push(q);
              entity.displayedChildEntities[name] = newEntityDef;
              reLoadNeeded = true;
            }
          });
          angular.forEach(entity.displayedChildEntities, function(value, key) {
            if (entity.linkedEntities.indexOf(key) < 0) {
              CollectionUtil.remove($scope.entityList, value);
              CollectionUtil.removeByField(entity.query.linkedEntities, 'name', key);
              delete entity.displayedChildEntities[key];
              reLoadNeeded = true;
              //entity.query.linkedEntities.
            }
          });
          if (reLoadNeeded) {
            $scope.loadAll();
          }
        };

        $scope.changeFilterModel = function(entity) {
          var reLoadNeeded = false;
          angular.forEach(entity.enabledFilters, function(filterName) {
            if (entity.displayedFilters[filterName] === undefined) {
              var filterType = entity.filters[filterName];
              entity.query.filters.push ({name : filterName, type : filterType.type, params: filterType.params, value: null});
              entity.displayedFilters[filterName] = filterType;
              reLoadNeeded = true;
            }
          });
          angular.forEach(entity.displayedFilters, function (value, key) {
            if (entity.enabledFilters.indexOf(key) < 0) {
              CollectionUtil.removeByField(entity.query.filters, 'name', key);
              delete entity.displayedFilters[key];
              reLoadNeeded = true;
            }
          });

          if (reLoadNeeded) {
            $scope.loadAll();
          }
        };

        $scope.changeRootEntity = function() {
          var rootEntityName = $scope.formParams.rootEntity;
          $scope.query = queryConfig.createServerQuery(rootEntityName);

          var def = queryConfig.createQueryFragmentDefinition(rootEntityName, $scope.query);
          $scope.entityList = [ def ];

          $scope.loadAll();
        };

        $scope.loadAll = function() {
          //var m= {name : 'part', linkedEntities: [ {name:'relatedPartner'}]};
          var m = $scope.query;

          if (angular.isString(m.name) && m.name.length > 0 ) {
            $scope.rows = [];
            $scope.pageResult = {};

            var q= angular.extend({page: $scope.page, per_page: 20}, m);
            Query.query(q, function(result, headers) {
              $scope.pageResult = result;
              $scope.rows = result.entities;
            });
          } else {
            $scope.pageResult = {};
            $scope.rows = [];
          }
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Query', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/query', {}, {
            'query': { 
              method: 'POST', 
              isArray: false,   
              params: { page:'@page', per_page: '@per_page'}
            },
            
            'getDefinition': {
              method: 'GET',
              isArray: false,
              url:'api/query/definition'
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .config(['$stateProvider', function ($stateProvider) {
      var employmentNew = {
          parent: 'workerDetail',
          url: '/employment/new',
          data: {
              roles: ['ROLE_REHABMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'scripts/app/entities/employment/employment-dialog.html',
                  controller: 'EmploymentDialogController',
                  size: 'lg',
                  resolve: {
                      entity: function () {
                          return {startDate: null, endDate: null, description: null, employmentCode: null, workingHours: null, id: null};
                      }
                  }
              }).result.then(function(result) {
                  $state.go('^');
              }, function() {
                  $state.go('^');
              })
          }]
      };
      
      var employmentEdit = {
          parent: 'workerDetail',
          url: '/employment/{employmentId:int}',
          data: {
              roles: ['ROLE_REHABMANAGER'],
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'scripts/app/entities/employment/employment-dialog.html',
                  controller: 'EmploymentDialogController',
                  size: 'lg',
                  resolve: {
                      entity: ['Employment', function(Employment) {
                          return Employment.get({id : $stateParams.employmentId, workerId: $stateParams.workerId}).$promise;
                      }]
                  }
              }).result.then(function(result) {
                  $state.go('^');
              }, function() {
                  $state.go('^');
              })
          }]
      };
      
      
        $stateProvider
            .state('employmentNew', employmentNew)
            .state('employmentEdit', employmentEdit)
            ;
    }]);

'use strict';

angular.module('dodomaApp')
    .controller('EmploymentController',
                ['$scope', 'Employment',
                function ($scope, Employment) {
        $scope.employments = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            Employment.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.pageResult = result;
                $scope.employments = result.entities;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Employment.get({id: id}, function(result) {
                $scope.employment = result;
                $('#deleteEmploymentConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Employment.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteEmploymentConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.employment = {startDate: null, endDate: null, description: null, employmentCode: null, workingHours: null, id: null};
        };
    }]);

'use strict';

angular.module('dodomaApp').controller('EmploymentDialogController',
    ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'Employment',
        function($scope, $rootScope, $stateParams, $uibModalInstance, entity, Employment) {

        $scope.employment = entity;
        $scope.whType = angular.isNumber(entity.workingHoursLimit) ? 'WEEKLY' : 'DAILY';
        $scope.load = function(id) {
            Employment.get({id : id, workerId: $stateParams.workerId}, function(result) {
                $scope.employment = result;
            });
        };

        $scope.changeWhType = function() {
          if ($scope.whType === 'DAILY') {
            $scope.employment.workingHours = 0;
            delete $scope.employment.workingHourLimit;
          }
          if ($scope.whType === 'WEEKLY') {
            $scope.employment.workingHourLimit = 0;
            delete $scope.employment.workingHours;
          }

        }

        var onSaveFinished = function (result) {
            $rootScope.$broadcast('dodomaApp:employmentUpdate', result);
            $uibModalInstance.close(result);
        };

        $scope.save = function () {
          $scope.employment.workerId = $stateParams.workerId;
          if ($scope.employment.id != null) {
              Employment.update($scope.employment, onSaveFinished);
          } else {
              Employment.save($scope.employment, onSaveFinished);
          }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('dodomaApp')
    .controller('EmploymentDetailController',
                ['$scope', '$rootScope', '$stateParams', 'entity', 'Employment',
                function ($scope, $rootScope, $stateParams, entity, Employment) {
        $scope.employment = entity;
        $scope.load = function (id) {
            Employment.get({id: id}, function(result) {
                $scope.employment = result;
            });
        };
        $rootScope.$on('dodomaApp:employmentUpdate', function(event, result) {
          $scope.employment = result;
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Employment', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/worker/:workerId/employments/:id', { workerId : '@workerId'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data) {
                        data.startDate = DateUtils.convertLocaleDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocaleDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocaleDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocaleDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocaleDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocaleDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            }
        });
    }]);

'use strict';

angular.module('dodomaApp')
    .factory('Document', ['$resource', 'DateUtils', function ($resource, DateUtils) {
        return $resource('api/documents/:id', {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'removeDocument' : {
                method: 'DELETE',
                url:'api/workerRecords/:recordId/documents/:documentId',
                params: { recordId: '@recordId', documentId: '@documentId'}
            },
            'findByWorker' : {
                method: 'GET',
                isArray: true,
                url:'api/workers/:workerId/documents',
                params: { workerId: '@workerId' }
            },
            'findByRecords' : {
                method: 'GET',
                isArray: true,
                url:'api/workerRecords/:recordId/documents',
                params: { recordId: '@recordId' }
            }
        });
    }]);
(function(){'use strict';angular.module('dodomaApp').run(['$templateCache', function($templateCache) {$templateCache.put('scripts/app/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.http.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('scripts/app/error/error.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('scripts/app/main/main.html','<div ng-cloak><div class="row"><div class="col-md-3"></div><div class="col-md-6"><h1 translate="main.title">Welcome to Dodoma App!</h1><div ng-if="isAuthenticated()"><div class="alert alert-success" translate="main.logged.message" translate-values="{username: \'{{account.login}}\'}">You are logged in as user "{{account.login}}".</div></div><div ng-if="!isAuthenticated()"><div class="alert alert-warning"><span translate="global.messages.info.auth.pre">pre</span> <a ui-sref="login" translate="global.messages.info.auth.link">authenticate here</a> <span translate="global.messages.info.auth.post">pre</span></div><div class="alert alert-warning" ng-if="sysConfig.userRegistration"><span translate="global.messages.info.reg.pre">You don\'t have an account yet?</span> <a ui-sref="register" translate="global.messages.info.reg.link">Register a new account</a></div></div><div ng-if="isAuthenticated()"><div ng-if="DodomaConfig.modules.stock"><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_STORE_VIEWER"><div class="col-sm-12 dodoma-big"><a ui-sref="stock"><i class="fas fa-cubes"></i></a></div><div class="col-sm-12"><a ui-sref="stock"><p class="dodoma-cell-label" translate="global.menu.main.stockManagement">Stocks</p></a></div></div></div><div ng-if="DodomaConfig.modules.prod"><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_PRODUCTIONMANAGER"><div class="col-sm-12 dodoma-big"><a ui-sref="orderPlan"><i class="fas fa-users"></i></a></div><div class="col-sm-12"><a ui-sref="orderPlan"><p class="dodoma-cell-label" translate="global.menu.main.productionManagement">orderPlan</p></a></div></div></div><div ng-if="DodomaConfig.modules.rehab"><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_REHABMANAGER"><div class="col-sm-12 dodoma-big"><a ui-sref="rehab"><i class="fas fa-user"></i></a></div><div class="col-sm-12"><a ui-sref="rehab"><p class="dodoma-cell-label" translate="global.menu.main.rehabManagement">rehabManagement</p></a></div></div></div></div></div><div class="col-md-3"></div></div></div>');
$templateCache.put('scripts/components/errorhandler/errorDisplay.html','<div class="errorDisplay" collapse="collapsed"><div uib-alert ng-repeat="alert in alerts" ng-class="\'alert-\' + (alert.type || \'warning\')" close="closeAlert($index)" class="fade-in"><strong ng-show="alert.important">{{alert.important}} </strong>{{alert.msg}}</div></div>');
$templateCache.put('scripts/components/errorhandler/notificationDisplay.html','<div class="notif-container navbar navbar-default navbar-fixed-bottom" ng-if="notifications.length > 0"><div class="row" ng-repeat="notif in notifications"><div uib-alert class="alert-danger col-centered" close="closeAlert($index)" ng-if="$index < 3"><a href class="alert-link" ng-click="openNotification(notif)"><strong translate="{{ \'notification.\' + notif.labelType}}" translate-values="notif.parameters">message</strong></a></div></div></div>');
$templateCache.put('scripts/components/form/navigation.directive.html','<span uib-pagination ng-if="pageInfo.totalPages>1" ng-model="pageInfo.currentPageNumber" total-items="pageInfo.totalElements" max-size="10" boundary-links="true" items-per-page="pageInfo.size" ng-change="onLoadPage()" first-text="&lt;&lt;" last-text="&gt;&gt;" previous-text="&lt;" next-text="&gt;"></span>');
$templateCache.put('scripts/components/form/pager.html','<nav><ul class="dodomaApp-pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav>');
$templateCache.put('scripts/components/form/pagination.html','<nav><ul class="dodomaApp-pagination"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a>&lt;</a></li><li ng-show="page > 2" ng-click="loadPage(page - 2)"><a>{{page - 2}}</a></li><li ng-show="page > 1" ng-click="loadPage(page - 1)"><a>{{page - 1}}</a></li><li class="active"><a>{{page}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 2}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav>');
$templateCache.put('scripts/components/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <img src="{{DodomaConfig.logo}}" alt="logo" class="dodoma-brand-logo"> <a class="navbar-brand" href="#/"><span translate="global.title">jhipster</span> <span class="navbar-version" bs-tooltip="sysConfig.version ? \'Version: \' + sysConfig.version + \', Build: \' + sysConfig.buildTime : \'\'" data-placement="bottom">v{{VERSION}}</span></a></div><div class="collapse navbar-collapse" id="navbar-collapse" ng-switch="isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="{{DodomaConfig.modules.homeScreen()}}"><i class="fas fa-home"></i> <span translate="global.menu.home">Home</span></a></li><li ng-if="DodomaConfig.modules.stock" ng-class="{active: $state.includes(\'stockManagement\')}" ng-switch-when="true" class="dropdown pointer" has-role="ROLE_STORE_VIEWER"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="fas fa-cubes"></span> <span class="hidden-tablet" translate="global.menu.main.stockManagement">Stock Management </span><b class="caret"></b></span></a><ul class="dropdown-menu"><li ui-sref-active="active"><a ui-sref="stock"><i class="fas fa-chess-rook"></i> &#xA0;<span translate="global.menu.entities.stock">stock</span></a></li><li ui-sref-active="active"><a ui-sref="part"><span class="fas fa-cubes"></span> &#xA0;<span translate="global.menu.entities.part">part</span></a></li><li ui-sref-active="active"><a ui-sref="deliveryNote"><span class="far fa-paper-plane"></span> &#xA0;<span translate="global.menu.entities.deliveryNote">deliveryNote</span></a></li><li ui-sref-active="active"><a ui-sref="movement"><i class="fas fa-retweet"></i> &#xA0;<span translate="global.menu.entities.movement">movement</span></a></li><li ui-sref-active="active"><a ui-sref="giveOut"><span class="fas fa-share"></span> &#xA0;<span translate="global.menu.entities.giveOut">giveOut</span></a></li><li ui-sref-active="active"><a ui-sref="partType"><i class="fas fa-asterisk"></i> &#xA0;<span translate="global.menu.entities.partType">partType</span></a></li><li ui-sref-active="active"><a ui-sref="partner"><span class="far fa-credit-card"></span> &#xA0;<span translate="global.menu.entities.partner">partner</span></a></li><li ui-sref-active="active" has-role="ROLE_SYSADMIN"><a ui-sref="query"><i class="fas fa-asterisk"></i> &#xA0;<span translate="global.menu.entities.query">query</span></a></li><!-- JHipster will add entities to the menu here --></ul></li><li ng-if="DodomaConfig.modules.prod" ng-class="{active: $state.includes(\'productionManagement\')}" ng-switch-when="true" class="dropdown pointer" has-any-role="ROLE_PRODUCTIONMANAGER,ROLE_PROD_QA"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="fas fa-users"></span> <span class="hidden-tablet" translate="global.menu.main.productionManagement">Production Management </span><b class="caret"></b></span></a><ul class="dropdown-menu"><li ng-if="DodomaConfig.separateOffers" ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="offer"><span class="fas fa-suitcase"></span> &#xA0;<span translate="global.menu.entities.offer">offer</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="orderPlan"><span class="fas fa-suitcase"></span> &#xA0;<span translate="global.menu.entities.orderPlan">orderPlan</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="partner"><span class="far fa-credit-card"></span> &#xA0;<span translate="global.menu.entities.partner">partner</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="productionSheet"><i class="fas fa-address-card"></i> &#xA0;<span translate="global.menu.entities.productionSheet">production sheets</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="worker"><span class="fas fa-male"></span> &#xA0;<span translate="global.menu.entities.worker">worker</span></a></li><li ui-sref-active="active" has-role="ROLE_PROD_QA"><a ui-sref="productionSheetItem"><i class="fas fa-asterisk"></i> &#xA0;<span translate="global.menu.entities.productionSheetItem">productionSheetItem</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="workerPlanning"><span class="fas fa-th-list"></span> &#xA0;<span translate="global.menu.entities.workerPlanning">workerPlanning</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="workType"><i class="fas fa-asterisk"></i> &#xA0;<span translate="global.menu.entities.workType">workType</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="workPricingCategory"><i class="fas fa-asterisk"></i> &#xA0;<span translate="global.menu.entities.workPricingCategory">workPricingCategory</span></a></li><li ui-sref-active="active" has-role="ROLE_PRODUCTIONMANAGER"><a ui-sref="productionEvaluation"><i class="fas fa-asterisk"></i> &#xA0;<span translate="global.menu.entities.productionEvaluation">productionEvaluation</span></a></li><li ui-sref-active="active" has-role="ROLE_WORKLOG"><a ui-sref="workLog"><span class="fas fa-tasks"></span> &#xA0;<span translate="global.menu.entities.workLog">workLog</span></a></li><!-- JHipster will add entities to the menu here --></ul></li><li ng-if="DodomaConfig.modules.rehab" ng-class="{active: $state.includes(\'rehabManagement\')}" ng-switch-when="true" class="dropdown pointer" has-role="ROLE_REHABMANAGER"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="fas fa-user"></span> <span class="hidden-tablet" translate="global.menu.main.rehabManagement">Rehabilitation Management </span><b class="caret"></b></span></a><ul class="dropdown-menu"><li ui-sref-active="active"><a ui-sref="rehabWorker"><span class="fas fa-male"></span> &#xA0;<span translate="global.menu.entities.worker">worker</span></a></li><li ui-sref-active="active" has-role="ROLE_WORKLOG"><a ui-sref="workLog"><span class="fas fa-tasks"></span> &#xA0;<span translate="global.menu.entities.workLog">workLog</span></a></li><li ui-sref-active="active"><a ui-sref="deadline"><span class="fas fa-calendar-alt"></span> &#xA0;<span translate="global.menu.entities.deadline">deadline</span></a></li><li ui-sref-active="active" has-role="ROLE_REHABMANAGER"><a ui-sref="workerRecord"><span class="fas fa-check-square"></span> &#xA0;<span translate="global.menu.entities.workerRecord">workerRecord</span></a></li><!-- JHipster will add entities to the menu here --></ul></li><li ng-class="{active: $state.includes(\'account\')}" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><i class="fas fa-user"></i> <span class="hidden-tablet" translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu"><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings"><i class="fas fa-wrench"></i> &#xA0;<span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password"><i class="far fa-key"></i> &#xA0;<span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions"><span class="glyphicon glyphicon-cloud"></span> &#xA0;<span translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="logout()"><span class="glyphicon glyphicon-log-out"></span> &#xA0;<span translate="global.menu.account.logout">Log out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="login"><span class="glyphicon glyphicon-log-in"></span> &#xA0;<span translate="global.menu.account.login">Authenticate</span></a></li><li ui-sref-active="active" ng-switch-when="false" ng-if="sysConfig.userRegistration"><a ui-sref="register"><i class="fas fa-plus-circle"></i> &#xA0;<span translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: $state.includes(\'admin\')}" ng-switch-when="true" ng-if="showAdminMenu()" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><i class="fas fa-chess-rook"></i> <span class="hidden-tablet" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu"><li ui-sref-active="active" has-role="ROLE_ADMIN"><a ui-sref="userManagement"><i class="fas fa-user"></i> &#xA0;<span translate="global.menu.admin.userManagement">userManagement</span></a></li></ul></li><li ng-class="{active: $state.includes(\'admin\')}" ng-switch-when="true" ng-if="sysAdminRole()" class="dropdown pointer"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><i class="fas fa-chess-rook"></i> <span class="hidden-tablet" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu"><li ui-sref-active="active" has-role="ROLE_SYSADMIN"><a ui-sref="userManagement"><i class="fas fa-user"></i> &#xA0;<span translate="global.menu.admin.userManagement">userManagement</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="metrics"><span class="glyphicon glyphicon-dashboard"></span> &#xA0;<span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="health"><span class="glyphicon glyphicon-heart"></span> &#xA0;<span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="configuration"><span class="glyphicon glyphicon-list-alt"></span> &#xA0;<span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits"><span class="glyphicon glyphicon-bell"></span> &#xA0;<span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs"><span class="glyphicon glyphicon-tasks"></span> &#xA0;<span translate="global.menu.admin.logs">Logs</span></a></li><li ui-sref-active="active"><a ui-sref="docs"><span class="glyphicon glyphicon-book"></span> &#xA0;<span translate="global.menu.admin.apidocs">API</span></a></li><li ng-show="{{ENV === \'dev\'}}"><a href="/console" target="_tab"><span class="glyphicon glyphicon-hdd"></span> &#xA0;<span translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" class="dropdown pointer" ng-controller="LanguageController"><a class="dropdown-toggle" data-toggle="dropdown" href=""><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-tablet" translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu"><li active-menu="{{language}}" ng-repeat="language in languages"><a href="" ng-click="changeLanguage(language)">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('scripts/components/templates/backButton.html','<button type="submit" ng-click="goBack()" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button>');
$templateCache.put('scripts/components/templates/cell.html','<span ng-switch="cell.type"><span ng-switch-when="part"><a ng-if="cell.value" ui-sref="partDetail({partId:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="partner"><a ng-if="cell.value" ui-sref="partnerDetail({partnerId:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="partType"><a ng-if="cell.value" ui-sref="partTypeDetail({id:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="stock"><a ng-if="cell.value" ui-sref="stockDetail({id:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="giveOut"><a ng-if="cell.value" ui-sref="giveOutDetail({id:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="deliveryNote"><a ng-if="cell.value" ui-sref="deliveryNoteDetail({deliveryNoteId:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="movement"><a ng-if="cell.value" ui-sref="movementDetail({id:cell.value})">{{cell.label}}</a> </span><span ng-switch-when="price" class="price">{{cell.label}} </span><span ng-switch-when="itemPrice" class="itemPrice">{{cell.label}} </span><span ng-switch-when="amount" class="amount">{{cell.label}} </span><span ng-switch-when="label" class="label label-default">{{cell.label}} </span><span ng-switch-when="user">{{cell.label}} </span><span ng-switch-default>{{cell.label}} - {{cell.type}}:{{cell.value}}</span></span>');
$templateCache.put('scripts/components/templates/docLink.html','<a href="{{getUrl(document)}}" target="_blank">{{document.name}}</a>');
$templateCache.put('scripts/components/templates/dodNewRecord.html','<button type="button" class="btn btn-default" ng-click="newRecord()" ng-disabled="!recordReadonly"><i class="far fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.workerRecord.addNewRecord">AddNewRecord</span></button>');
$templateCache.put('scripts/components/templates/mainLayout.html','<div class="row"><div class="col-md-2 col-md-push-10 well col-sm-4" ng-if="!noFilter"><div ng-transclude="filter"></div></div><div class="col-md-10 col-md-pull-2 col-sm-8"><h2>{{ getTitle() | translate }}</h2><div ng-transclude="main"></div></div></div>');
$templateCache.put('scripts/components/templates/psivTable.html','<span ng-if="detailed"><table ng-if="productionSheetItem.verifications.length > 0" class="table table-striped"><thead><th translate="dodomaApp.productionSheetItemVerification.checkedAmount"></th><th translate="dodomaApp.productionSheetItemVerification.brokenAmount"></th><th translate="dodomaApp.productionSheetItemVerification.verifier"></th></thead><tr ng-repeat="verif in productionSheetItem.verifications"><td>{{verif.checkedAmount}}</td><td>{{verif.brokenAmount}}</td><td>{{verif.verifier.name}}</td></tr></table></span><div ng-if="!detailed"><div ng-repeat="verif in productionSheetItem.verifications"><span translate="dodomaApp.productionSheetItemVerification.errorLabel" translate-values="verif">error</span></div></div>');
$templateCache.put('scripts/components/templates/psivVerifyButton.html','<button type="submit" ui-sref=".productionSheetItemVerificationNew({itemId:productionSheetItem.id})" class="btn btn-default btn-sm"><i class="far fa-check-square"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.verify">Verify</span></button>');
$templateCache.put('scripts/components/templates/uploadList.html','<div class="panel panel-default"><div class="panel-heading" translate="dodomaApp.workerRecord.documents"></div><div class="panel-body"><ul class="list-group"><li class="list-group-item" ng-repeat="doc in documents | orderBy:\'name\'"><doc-link record-id="recordId" document="doc"></doc-link><button ng-if="enable" type="button" class="btn btn-danger" ng-click="deleteDoc(doc)"><i class="fas fa-minus-octagon"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></li></ul><div ng-if="progressStatus" class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{progressStatus}}" aria-valuemin="0" aria-valuemax="100" style="min-width: 2em; width: {{progressStatus}}%;" translate="dodomaApp.workerRecord.uploadProgress" translate-values="{value:progressStatus}">progress</div></div><button ng-if="uploadOk() && enable" class="btn btn-primary" ngf-select ngf-multiple="true" ngf-change="upload($files)" translate="dodomaApp.workerRecord.uploadDocument">Upload Document</button><!-- button class="btn btn-warning" ng-click="demo($event)">Demo</button> --></div><div class="panel-footer" ng-if="!uploadOk()"><span translate="dodomaApp.workerRecord.notSavedRecord">Not saved!</span> <button class="btn btn-primary" ng-click="callSave($event)"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></div>');
$templateCache.put('scripts/components/templates/workerRecordDisplay.html','<span class="workerRecordDisplay"><ng-include src="includePath"></ng-include></span>');
$templateCache.put('scripts/app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="success" translate="activate.messages.success"><strong>Your user has been activated.</strong> Please authenticate.</div><div class="alert alert-danger" ng-show="error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('scripts/app/account/login/login.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="login.title">Authentication</h1><div class="alert alert-danger" ng-show="authenticationError" translate="login.messages.error.authentication"><strong>Authentication failed!</strong> Please check your credentials and try again.</div><form class="form" role="form" ng-submit="login($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label> <input type="text" class="form-control" autocomplete="username" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="username"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label> <input type="password" class="form-control" autocomplete="current-password" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="rememberMe" checked="checked"> <span translate="login.form.rememberme">Automatic Login</span></label></div><button type="submit" class="btn btn-primary" translate="login.form.button">Authenticate</button></form><p></p><div class="alert alert-warning"><a ui-sref="requestReset" translate="login.password.forgot">Did you forget your password?</a></div><div ng-if="sysConfig.userRegistration" class="alert alert-warning"><span translate="global.messages.info.reg.pre">You don\'t have an account yet?</span> <a ui-sref="register" translate="global.messages.info.reg.link">Register a new account</a></div></div></div></div>');
$templateCache.put('scripts/app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{account.login}}\'}">Password for [<b>{{account.login}}</b>]</h2><div class="alert alert-success" ng-show="success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="changePassword()" show-validation><div class="form-group"><label translate="global.form.newpassword">New password</label> <input type="password" class="form-control" autocomplete="new-password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="password" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="password"></password-strength-bar></div><div class="form-group"><label translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('scripts/app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="register.title">Registration</h1><div class="alert alert-success" ng-show="success" translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="error" translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="errorUserExists" translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="errorEmailExists" translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form ng-show="!success" name="form" role="form" novalidate ng-submit="register()" show-validation><div class="form-group"><label translate="global.form.username">Login</label> <input type="text" class="form-control" autocomplete="username" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[a-z0-9]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" translate="register.messages.validate.login.required">Your login is required.</p><p class="help-block" ng-show="form.login.$error.minlength" translate="register.messages.validate.login.minlength">Your login is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" translate="register.messages.validate.login.maxlength">Your login cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" translate="register.messages.validate.login.pattern">Your login can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label translate="global.form.email">E-mail</label> <input type="email" class="form-control" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label translate="global.form.newpassword">New password</label> <input type="password" class="form-control" name="password" autocomplete="new-password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="registerAccount.password" ng-minlength="6" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="registerAccount.password"></password-strength-bar></div><div class="form-group"><label translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="confirmPassword" ng-minlength="6" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning"><span translate="global.messages.info.auth.pre">pre</span> <a ui-sref="login" translate="global.messages.info.auth.link">authenticate here</a> <span translate="global.messages.info.auth.post">pre</span></div></div></div></div>');
$templateCache.put('scripts/app/account/sessions/sessions.html','<div><h2 translate="sessions.title" translate-values="{username: \'{{account.login}}\'}">Active sessions for [<b>{{account.login}}</b>]</h2><div class="alert alert-success" ng-show="success" translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="error" translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="sessions.table.ipaddress">IP Address</th><th translate="sessions.table.useragent">User agent</th><th translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type="submit" class="btn btn-primary" ng-click="invalidate(session.series)" translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('scripts/app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="settings.title" translate-values="{username: \'{{settingsAccount.login}}\'}">User settings for [<b>{{settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="success" translate="settings.messages.success"><strong>Settings saved!</strong></div><div class="alert alert-danger" ng-show="errorEmailExists" translate="settings.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="error" translate="settings.messages.error.fail"><strong>An error has occurred!</strong> Settings could not be saved.</div><form name="form" role="form" novalidate ng-submit="save()" show-validation><div class="form-group"><label translate="settings.form.firstname">First Name</label> <input type="text" class="form-control" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="settings.form.lastname">Last Name</label> <input type="text" class="form-control" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="global.form.email">E-mail</label> <input type="email" class="form-control" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label translate="settings.form.language">Language</label> <select name="langKey" class="form-control" ng-model="settingsAccount.langKey" ng-controller="LanguageController" ng-options="code as (code | findLanguageFromKey) for code in languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('scripts/app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="fromDate" ng-change="onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="toDate" ng-change="onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table></div>');
$templateCache.put('scripts/app/admin/configuration/configuration.html','<div><h2 translate="configuration.title">configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties">Properties</th></tr></thead><tr ng-repeat="entry in configuration | filter:filter | orderBy:predicate:reverse"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-6">{{key}}</div><div class="col-md-6"><span class="pull-right label label-info" style="white-space: normal;word-break:break-all">{{value}}</span></div></div></td></tr></table></div>');
$templateCache.put('scripts/app/admin/docs/docs.html','<iframe src="swagger-ui.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('scripts/app/admin/health/health.html','<div><h2 translate="health.title">Health Check</h2><div class="modal fade" id="showHealthModal" tabindex="-1" role="dialog" aria-labelledby="showHealthLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><form name="form" role="form" novalidate class="ng-scope ng-invalid ng-invalid-required ng-dirty ng-valid-minlength" ng-submit="create()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + baseName(currentHealth.name) | translate}} {{subSystemName(currentHealth.name)}}</h4></div><div class="modal-body"><div ng-show="currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{currentHealth.error}}</pre></div></div></form></div></div></div><p><button type="button" class="btn btn-primary" ng-click="refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th><th class="col-md-1 text-center"></th></tr></thead><tbody><tr ng-repeat="health in healthData"><td>{{\'health.indicator.\' + baseName(health.name) | translate}} {{subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td><td></td></tr></tbody></table></div>');
$templateCache.put('scripts/app/admin/logs/logs.html','<div><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ loggers.length }}\'}">There are {{ loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('scripts/app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button> <button type="button" class="btn btn-primary" ng-click="clearCaches()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;Clear cache</button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}" ng-style="{width: (metrics.gauges[\'jvm.memory.total.used\'].value * 100 / metrics.gauges[\'jvm.memory.total.max\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.memory.total.used\'].value * 100 / metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}" ng-style="{width: (metrics.gauges[\'jvm.memory.heap.usage\'].value * 100 | number:0) + \'%\'}">{{(metrics.gauges[\'jvm.memory.heap.usage\'].value * 100 | number:0)}}%</div></div><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}" ng-style="{width: (metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0) + \'%\'}">{{(metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0)}}%</div></div></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.runnable.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><div class="progress progress-striped"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><div class="progress progress-striped"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.waiting.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><div class="progress progress-striped"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.blocked.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" aria-valuemin="0" aria-valuemax="{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" ng-style="{width: ((metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count) | number:0) + \'%\'}">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</div></div></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><div class="progress progress-striped"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" aria-valuemin="0" aria-valuemax="{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" ng-style="{width: ((metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count) | number:0) + \'%\'}">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</div></div></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><div class="progress progress-striped"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" aria-valuemin="0" aria-valuemax="{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" ng-style="{width: ((metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count) | number:0) + \'%\'}">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</div></div></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}" ng-style="{width: (metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0) + \'%\'}">{{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</div></div></td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div><!-- Modal used to display the threads dump --><div id="threadDump" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" id="myModalLabel" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body well"><span class="label label-primary" ng-click="threadDumpFilter = {}"><span translate="metrics.jvm.threads.all">All</span>&nbsp;<span class="badge">{{threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}"><span translate="metrics.jvm.threads.runnable">Runnable</span>&nbsp;<span class="badge">{{threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}"><span translate="metrics.jvm.threads.waiting">Waiting</span>&nbsp;<span class="badge">{{threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}"><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span>&nbsp;<span class="badge">{{threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}"><span translate="metrics.jvm.threads.blocked">Blocked</span>&nbsp;<span class="badge">{{threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div><div class="row" ng-repeat="(k, v) in threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="getLabelClass(v.threadState)">&nbsp;</span>&nbsp;{{v.threadName}} (<span translate="metrics.jvm.threads.dump.id">Id</span> {{v.threadId}})</h5><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th><th translate="metrics.jvm.threads.dump.stacktrace">StackTrace</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td><td><a ng-click="show = !show" data-placement="left"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">show</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">hide</span></a><div class="popover left" ng-show="show"><div class="popover-title"><h4><span translate="metrics.jvm.threads.dump.stacktrace">Stacktrace</span><button type="button" class="close" ng-click="show = !show">&times;</button></h4></div><div class="popover-content"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div></div></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('scripts/app/admin/userManagement/userManagement-detail.html','<div><h2><span translate="userManagement.detail.title">User</span> {{user.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="userManagement.login">Login</span></td><td><input type="text" class="input-sm form-control" value="{{user.login}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.firstName">FirstName</span></td><td><input type="text" class="input-sm form-control" value="{{user.firstName}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.lastName">LastName</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastName}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.email">Email</span></td><td><input type="text" class="input-sm form-control" value="{{user.email}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.activated">Activated</span></td><td><input type="text" class="input-sm form-control" value="{{user.activated}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.langKey">LangKey</span></td><td><input type="text" class="input-sm form-control" value="{{user.langKey}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.createdBy">CreatedBy</span></td><td><input type="text" class="input-sm form-control" value="{{user.createdBy}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.createdDate">CreatedDate</span></td><td><input type="text" class="input-sm form-control" value="{{user.createdDate | date:\'yyyy-MM-dd HH:mm\' }}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.lastModifiedBy">LastModifiedBy</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastModifiedBy}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.lastModifiedDate">LastCreatedDate</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}" readonly="readonly"></td></tr><tr><td><span translate="userManagement.profiles">Profiles</span></td><td><ul class="list-unstyled"><li ng-repeat="auth in user.authorities"><span>{{auth.name}}</span></li></ul></td></tr></tbody></table></div><button type="submit" ui-sref="userManagement" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/admin/userManagement/usersManagement.html','<div><div class="row"><h2 class="col-sm-6" translate="userManagement.home.title">User</h2></div><button ng-if="sysConfig.userCreation" class="btn btn-primary" ng-click="showUpdate()"><i class="fas fa-bolt"></i> <span translate="userManagement.home.createLabel">Create a new User</span></button><div class="modal fade" id="saveUserModal" tabindex="-1" role="dialog" aria-labelledby="myUserLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="UserManagementDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="userManagement.login">Login</label> <input type="text" class="form-control" name="login" ng-model="user.login" pattern="^[a-z0-9]*$"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.pattern" translate="entity.validation.illegalCharacter">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.firstName">FirstName</label> <input type="text" class="form-control" name="firstName" ng-model="user.firstName" ng-maxlength="50"></div><div class="form-group"><label translate="userManagement.lastName">LastName</label> <input type="text" class="form-control" name="lastName" ng-model="user.lastName" ng-maxlength="50"></div><div class="form-group"><label translate="userManagement.password" for="password">Password</label> <input type="text" class="form-control" id="password" name="password" ng-model="user.password" ng-maxlength="50"></div><div class="form-group"><label translate="userManagement.confirmPassword" for="confirmPassword">Password</label> <input type="text" class="form-control" id="confirmPassword" name="confirmPassword" ng-model="user.confirmPassword" ng-maxlength="50"></div><div class="form-group"><label translate="userManagement.email">Email</label> <input type="text" class="form-control" name="email" ng-model="user.email" required ng-maxlength="100"></div><div class="form-group"><label for="activated"><input type="checkbox" id="activated" ng-model="user.activated"> <span translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label translate="userManagement.langKey">LangKey</label> <select class="form-control" name="langKey" ng-model="user.langKey" ng-options="lng as (lng | findLanguageFromKey) for lng in languages"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label><div class="row"><div class="col-xs-6" ng-repeat="authority in authorities"><input class="xform-control xdodoma-inline-checkbox" type="checkbox" value="authority.name" ng-checked="hasAuthority(authority.name)" ng-click="toggleAuthority(authority.name)" id="{{\'authority_\'+authority.name}}"> <label for="{{\'authority_\'+authority.name}}">{{authorityName(authority.name)}}</label></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div><div class="modal fade" id="deleteUserConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(user.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="userManagement.delete.question" translate-values="{id: \'{{user.id}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="userManagement.login">Login</th><th translate="userManagement.email">Email</th><th></th><th translate="userManagement.langKey">LangKey</th><th translate="userManagement.profiles">Profiles</th><th translate="userManagement.createdDate">CreatedDate</th><th translate="userManagement.lastModifiedBy">LastModifiedBy</th><th translate="userManagement.lastModifiedDate">LastModifiedDate</th><th></th></tr></thead><tbody><tr ng-repeat="user in users"><td><a href="" ng-click="showUpdate(user.id)">{{user.id}}</a></td><td><a href="" ng-click="showUpdate(user.id)">{{user.login}} ({{user.lastName}} {{user.firstName}})</a></td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer;">Desactivated</span> <span class="label label-success" ng-click="setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer;">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authorityName(authority.name) }}</span></div></td><td>{{user.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td class="text-right"><button type="submit" ui-sref="userManagementDetail({id:user.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i></button> <button type="submit" ng-click="showUpdate(user.id)" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></div>');
$templateCache.put('scripts/app/entities/deadline/deadline-detail.html','<div><h2><span translate="dodomaApp.deadline.detail.title">Deadline</span> {{deadline.id}}</h2><button type="submit" ui-sref="deadlineDetail.edit({id:deadline.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.deadline.deadlineDate">DeadlineDate</span></td><td><input type="text" class="input-sm form-control" value="{{deadline.deadlineDate}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.deadline.type">Type</span></td><td><input type="text" class="input-sm form-control" value="{{deadline.type}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.deadline.worker">worker</span></td><td><input type="text" class="input-sm form-control" value="{{deadline.worker.name}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.deadline.workerRecord">workerRecord</span></td><td><input type="text" class="input-sm form-control" value="{{deadline.workerRecord.id}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="deadline" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/deadline/deadline-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myDeadlineLabel" translate="dodomaApp.deadline.home.createOrEditLabel">Create or edit a Deadline</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label> <input type="text" class="form-control" name="id" ng-model="deadline.id" readonly="readonly"></div><div class="form-group"><label translate="dodomaApp.deadline.deadlineDate" for="field_deadlineDate">DeadlineDate</label> <input type="date" class="form-control" name="deadlineDate" id="field_deadlineDate" ng-model="deadline.deadlineDate" required><div ng-show="editForm.deadlineDate.$invalid"><p class="help-block" ng-show="editForm.deadlineDate.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="dodomaApp.deadline.type" for="field_type">Type</label> <input type="text" class="form-control" name="type" id="field_type" ng-model="deadline.type" required ng-maxlength="50"><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.type.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="dodomaApp.deadline.worker" for="field_worker">worker</label> <select class="form-control" id="field_worker" name="worker" ng-model="deadline.worker.id" ng-options="worker.id as worker.name for worker in workers"></select></div><div class="form-group"><label translate="dodomaApp.deadline.workerRecord" for="field_workerRecord">workerRecord</label> <select class="form-control" id="field_workerRecord" name="workerRecord" ng-model="deadline.workerRecord.id" ng-options="workerRecord.id as workerRecord.id for workerRecord in workerrecords"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/deadline/deadlines.html','<main-layout title-key="dodomaApp.deadline.home.title"><pane-filter><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="after" translate="dodomaApp.deadline.filter.after">StartDate</label> <input bs-datepicker type="text" class="form-control" name="after" id="after" ng-model="filter.startDate" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="before" translate="dodomaApp.deadline.filter.before">EndDate</label> <input bs-datepicker type="text" class="form-control" name="before" id="before" ng-model="filter.endDate" ng-change="loadAll()"></div><div class="form-group"><label translate="dodomaApp.deadline.worker" for="field_worker">worker</label><ui-select ng-model="filter.worker" dodoma-worker module="REHABILITATION" allow-clear name="worker" id="field_worker" on-select="loadAll()" on-clear="loadAll()"></ui-select></div></pane-filter><pane-main><error-display></error-display><!--    <button class="btn btn-primary" ui-sref="deadline.new">\n        <i class="fas fa-bolt"></i> <span translate="dodomaApp.deadline.home.createLabel">Create a new Deadline</span>\n    </button>\n \n    <div class="modal fade" id="deleteDeadlineConfirmation">\n        <div class="modal-dialog">\n            <div class="modal-content">\n                <form name="deleteForm" ng-submit="confirmDelete(deadline.id)">\n                    <div class="modal-header">\n                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                                ng-click="clear()">&times;</button>\n                        <h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4>\n                    </div>\n                    <div class="modal-body">\n                        <p translate="dodomaApp.deadline.delete.question" translate-values="deadline">Are you sure you want to delete Deadline?</p>\n                    </div>\n                    <div class="modal-footer">\n                        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">\n                            <i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span>\n                        </button>\n                        <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger">\n                            <i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span>\n                        </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n--><div class="table-responsive"><table class="table table-striped"><thead><tr><!-- <th translate="global.field.id">ID</th> --><th translate="dodomaApp.deadline.deadlineDate">DeadlineDate</th><th translate="dodomaApp.deadline.type">Type</th><th translate="dodomaApp.deadline.worker">worker</th><th></th></tr></thead><tbody><tr ng-repeat="deadline in deadlines"><!-- <td><a ui-sref="deadline.detail({id:deadline.id})">{{deadline.id}}</a></td> --><td>{{deadline.deadlineDate}}</td><td><a ui-sref="rehabWorker.detail.editRecord({id:deadline.workerRecord.id,workerId:deadline.worker.id})">{{describeDeadline(deadline)}}</a></td><td><worker-link worker="deadline.worker"></worker-link></td><!-- <td>\n                        <button type="submit"\n                                ui-sref="deadline.detail({id:deadline.id})"\n                                class="btn btn-info btn-sm">\n                            <i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span>\n                        </button>\n                        <button type="submit"\n                                ui-sref="deadline.edit({id:deadline.id})"\n                                class="btn btn-primary btn-sm">\n                            <i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span>\n                        </button>\n                        <button type="submit"\n                                ng-click="delete(deadline.id)"\n                                class="btn btn-danger btn-sm">\n                            <i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span>\n                        </button>\n                    </td> --></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/deliveryNote/deliveryNote-detail.html','<div><h2>{{deliveryNote.deliveryNumber}}</h2><div class="panel panel-info" ng-if="isModifiable(deliveryNote)" has-role="ROLE_STORE_IN_OUT"><div class="panel-body"><button class="btn btn-primary" ng-click="addAll()" ng-if="deliveryNote.items.length > 0"><span class="fas fa-sign-in-alt"></span>&nbsp;<span translate="dodomaApp.deliveryNoteItem.addAll">Add all</span></button> <button type="submit" ui-sref="deliveryNoteDetail.edit({id:deliveryNote.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></div></div><div class="panel panel-danger" ng-if="deliveryNote.state === \'ADDED\'" has-role="ROLE_STOREREVIEWER"><div class="panel-body"><button class="btn btn-danger" ng-click="revert()"><span class="fas fa-bolt"></span>&nbsp;<span translate="dodomaApp.deliveryNoteItem.revert">revert</span></button></div></div><error-display></error-display><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.deliveryNote.detail.title"></div><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.deliveryNote.deliveryNumber" value="deliveryNote.deliveryNumber"></dod-display-value><dod-display-value label="dodomaApp.deliveryNote.type" value="deliveryNote.type | deliveryNoteType"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.deliveryNote.creationDate" value="deliveryNote.creationDate | dodTime"></dod-display-value><dod-display-value label="dodomaApp.deliveryNote.deliveryDate" value="deliveryNote.deliveryDate | justIsoDate"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.deliveryNote.state" value="deliveryNote.state | deliveryNoteStatus"></dod-display-value><dod-display-value ng-if="deliveryNote.type == \'EXTERNAL_DELIVERY\'" label="dodomaApp.deliveryNote.supplier" custom="<partner-link partner=\'deliveryNote.supplier\'></partner-link>"></dod-display-value><dod-display-value ng-if="deliveryNote.type == \'FROM_PRODUCTION\'" label="dodomaApp.deliveryNote.orderPlan" custom="<order-plan-link plan=\'deliveryNote.orderPlan\'></order-plan-link>"></dod-display-value></div><div class="row"><dod-display-value label="global.field.creator" value="deliveryNote.creator.name"></dod-display-value><dod-display-value ng-if="deliveryNote.receivedFromUser" label="dodomaApp.deliveryNote.receivedFromUser" value="deliveryNote.receivedFromUser.name"></dod-display-value></div><table class="table"><thead><tr><th></th><th translate="dodomaApp.deliveryNoteItem.part">part</th><th ng-if="everyCounter" translate="dodomaApp.deliveryNoteItem.sentAmount">SentAmount</th><th ng-if="everyCounter" translate="dodomaApp.deliveryNoteItem.countedAmount">CountedAmount</th><th ng-if="everyCounter" translate="dodomaApp.deliveryNoteItem.brokenAmount">BrokenAmount</th><th translate="dodomaApp.deliveryNoteItem.addToStockAmount">AddToStockAmount</th><th has-role="ROLE_STORE_PRICES" translate="dodomaApp.deliveryNoteItem.itemPrice">ItemPrice</th><th has-role="ROLE_STORE_PRICES" translate="dodomaApp.deliveryNoteItem.price">Price</th><th translate="dodomaApp.deliveryNoteItem.location">location</th><th></th><th></th></tr></thead><tbody><tr ng-repeat="deliveryNoteItem in deliveryNote.items"><td><button ng-if="!deliveryNoteItem.added" type="submit" ng-click="deleteItem(deliveryNoteItem.id)" has-role="ROLE_STORE_IN_OUT" class="btn btn-danger"><i class="far fa-times-circle"></i></button></td><td><part-link part="deliveryNoteItem.part"></part-link></td><td ng-if="everyCounter">{{deliveryNoteItem.sentAmount}}</td><td ng-if="everyCounter">{{deliveryNoteItem.countedAmount}}</td><td ng-if="everyCounter">{{deliveryNoteItem.brokenAmount}}</td><td>{{deliveryNoteItem.addToStockAmount}}</td><td has-role="ROLE_STORE_PRICES">{{deliveryNoteItem.itemPrice}}</td><td has-role="ROLE_STORE_PRICES">{{deliveryNoteItem.price}}</td><td><stock-link stock="deliveryNoteItem.location.stock"></stock-link></td><td><button ng-if="!deliveryNoteItem.added" type="submit" has-role="ROLE_STORE_IN_OUT" ui-sref="dnEditItem({itemId:deliveryNoteItem.id, type:deliveryNote.type})" class="btn btn-default"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td><td><button ng-if="!deliveryNoteItem.added" type="submit" ng-click="addToStock(deliveryNoteItem.id)" has-role="ROLE_STORE_IN_OUT" class="btn btn-primary"><span class="fas fa-sign-in-alt"></span>&nbsp;<span translate="dodomaApp.deliveryNoteItem.addToStock"> AddToStock</span></button></td></tr><tr ng-if="isModifiable(deliveryNote)" has-role="ROLE_STORE_IN_OUT"><td colspan="10"><button class="btn btn-default" ui-sref="dnNewItem({type:deliveryNote.type})"><i class="fas fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.deliveryNoteItem.home.createLabel">Create a new item</span></button></td></tr></tbody></table><!-- panel body end --></div><!-- panel  end --></div><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/deliveryNote/deliveryNote-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="DeliveryNoteUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myDeliveryNoteLabel" translate="dodomaApp.deliveryNote.home.createOrEditLabel">Create or edit a DeliveryNote</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.deliveryNote.deliveryNumber" for="field_deliveryNumber">DeliveryNumber</label> <input type="text" class="form-control" name="deliveryNumber" id="field_deliveryNumber" ng-model="deliveryNote.deliveryNumber"></div><div class="form-group"><label translate="dodomaApp.deliveryNote.type" for="field_type">Type</label><div class="btn-group" id="field_type"><span class="btn btn-primary" ng-model="deliveryNote.type" uib-btn-radio="\'INTERNAL\'" translate="dodomaApp.deliveryNote.typeLabel.INTERNAL" required>internal</span> <span class="btn btn-primary" ng-model="deliveryNote.type" uib-btn-radio="\'EXTERNAL_DELIVERY\'" translate="dodomaApp.deliveryNote.typeLabel.EXTERNAL_DELIVERY" required>external</span> <span class="btn btn-primary" ng-model="deliveryNote.type" uib-btn-radio="\'FROM_PRODUCTION\'" translate="dodomaApp.deliveryNote.typeLabel.FROM_PRODUCTION" required>from production</span> <span class="btn btn-primary" ng-model="deliveryNote.type" uib-btn-radio="\'BACK_TO_STOCK\'" translate="dodomaApp.deliveryNote.typeLabel.BACK_TO_STOCK" required>BACK_TO_STOCK</span></div><!-- just for validation --> <input type="hidden" name="type" ng-model="deliveryNote.type"></div><div class="form-group" ng-if="deliveryNote.type == \'EXTERNAL_DELIVERY\' || deliveryNote.type == \'INTERNAL\'"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.deliveryNote.deliveryDate" for="field_deliveryDate">DeliveryDate</label> <input bs-datepicker type="text" class="form-control" name="deliveryDate" id="field_deliveryDate" ng-model="deliveryNote.deliveryDate" ng-required="deliveryNote.type == \'EXTERNAL_DELIVERY\'"></div><div class="form-group" ng-if="deliveryNote.type == \'EXTERNAL_DELIVERY\'"><label translate="dodomaApp.deliveryNote.supplier">supplier</label><ui-select ng-model="deliveryNote.supplier" dodoma-partner allow-clear name="supplier" ng-required="deliveryNote.type == \'EXTERNAL_DELIVERY\'"></ui-select><input type="hidden" name="supplier" ng-model="deliveryNote.supplier"></div><div class="form-group" ng-if="deliveryNote.type == \'FROM_PRODUCTION\'"><label translate="dodomaApp.deliveryNote.orderPlan">order plan</label><ui-select ng-model="deliveryNote.orderPlan" dodoma-order-plan allow-clear name="orderPlan" ng-required="deliveryNote.type == \'FROM_PRODUCTION\'"></ui-select><input type="hidden" name="orderPlan" ng-model="deliveryNote.orderPlan"></div><div class="form-group" ng-if="deliveryNote.type == \'BACK_TO_STOCK\'"><label translate="dodomaApp.deliveryNote.receivedFromUser">receivedFromUser</label><ui-select ng-model="deliveryNote.receivedFromUser" dodoma-user-field allow-clear name="receivedFromUser"></ui-select></div><div class="row" ng-if="deliveryNote.initialPart"><div class="col-md-4"><label translate="dodomaApp.deliveryNoteItem.part">Part</label><div class="form-control">{{deliveryNote.initialPart.name}}</div></div><div class="col-md-4"><label translate="dodomaApp.deliveryNoteItem.countedAmount">Amount</label> <input type="number" class="form-control" name="initialAmount" ng-model="deliveryNote.initialAmount" ng-required="deliveryNote.initialPart"></div><div class="col-md-4" ng-if="deliveryNote.initialPart.hasPrice"><label translate="dodomaApp.deliveryNoteItem.itemPrice">price</label> <input type="number" class="form-control" name="initialItemPrice" ng-model="deliveryNote.initialItemPrice" ng-required="deliveryNote.initialPart"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/deliveryNote/deliveryNoteTable.html','<div class="{{ panelClass }}"><table class="table"><thead><tr><th translate="dodomaApp.deliveryNote.deliveryNumber">DeliveryNumber</th><th translate="dodomaApp.deliveryNote.deliveryDate">DeliveryDate</th><th translate="dodomaApp.deliveryNote.state">State</th><th translate="dodomaApp.deliveryNote.type">Type</th><th ng-if="extended" translate="dodomaApp.deliveryNote.supplier">supplier</th><th ng-if="extended" translate="global.field.creator">Creator</th></tr></thead><tbody><tr ng-repeat="deliveryNote in entities"><td><a ui-sref="deliveryNoteDetail({deliveryNoteId:deliveryNote.id})">{{deliveryNote.name}}</a></td><td>{{deliveryNote.deliveryDate}}</td><td><span class="{{stateLabel(deliveryNote)}}">{{deliveryNote.state | deliveryNoteStatus}}</span></td><td><span class="label label-default">{{deliveryNote.type | deliveryNoteType}}</span></td><td ng-if="extended"><partner-link partner="deliveryNote.supplier"></partner-link></td><td ng-if="extended">{{deliveryNote.creator.name}}</td></tr></tbody></table><dodoma-navigation page-info="result" callback-fn="loadEntities(page)"></dodoma-navigation></div>');
$templateCache.put('scripts/app/entities/deliveryNote/deliveryNotes.html','<main-layout title-key="dodomaApp.deliveryNote.home.title"><pane-filter><div class="form-group"><label class="control-label" for="deliveryNumber" translate="dodomaApp.deliveryNote.filter.deliveryNumber">deliveryNumber</label> <input type="text" class="form-control" name="deliveryNumber" id="deliveryNumber" ng-model="filter.name" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="partner" translate="dodomaApp.deliveryNote.filter.partner">Partner</label><ui-select ng-model="customFilter.partner" dodoma-partner allow-clear name="partner" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="after" translate="dodomaApp.deliveryNote.filter.after">StartDate</label> <input bs-datepicker data-max-date="today" type="text" class="form-control" name="after" id="after" ng-model="filter.after" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="before" translate="dodomaApp.deliveryNote.filter.before">EndDate</label> <input bs-datepicker data-min-date="{{filter.after}}" data-max-date="today" type="text" class="form-control" name="before" id="before" ng-model="filter.before" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="status" translate="dodomaApp.deliveryNote.filter.status">Status</label> <select class="form-control" name="status" id="status" ng-model="filter.status" ng-change="loadAll()"><option value="" translate="dodomaApp.deliveryNote.stateLabel.ALL">All</option><option value="NEW" translate="dodomaApp.deliveryNote.stateLabel.NEW">NEW</option><option value="PARTLY_ADDED" translate="dodomaApp.deliveryNote.stateLabel.PARTLY_ADDED">PARTLY_ADDED</option><option value="ADDED" translate="dodomaApp.deliveryNote.stateLabel.ADDED">ADDED</option><option value="REVERTED" translate="dodomaApp.deliveryNote.stateLabel.REVERTED">REVERTED</option></select></div><div class="form-group"><label class="control-label" for="type" translate="dodomaApp.deliveryNote.filter.type">Status</label> <select class="form-control" name="type" id="type" ng-model="filter.type" ng-change="loadAll()"><option value="" translate="dodomaApp.deliveryNote.stateLabel.ALL">All</option><option value="INTERNAL" translate="dodomaApp.deliveryNote.typeLabel.INTERNAL">INTERNAL</option><option value="EXTERNAL_DELIVERY" translate="dodomaApp.deliveryNote.typeLabel.EXTERNAL_DELIVERY">EXTERNAL_DELIVERY</option><option value="FROM_PRODUCTION" translate="dodomaApp.deliveryNote.typeLabel.FROM_PRODUCTION">FROM_PRODUCTION</option></select></div><div class="form-group"><label class="control-label" for="part" translate="dodomaApp.deliveryNote.filter.part">Part</label><ui-select ng-model="customFilter.part" dodoma-part allow-clear name="part" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="orderPlan" translate="dodomaApp.deliveryNote.filter.orderPlan">orderPlan</label><ui-select ng-model="customFilter.orderPlan" dodoma-order-plan allow-clear name="orderPlan" on-select="loadAll()" on-clear="loadAll()"></ui-select></div></pane-filter><pane-main><button class="btn btn-default" ui-sref="stock" has-role="ROLE_STORE_VIEWER"><i class="fas fa-chess-rook"></i> <span translate="global.menu.entities.stock">Stocks</span></button> <button class="btn btn-default" ui-sref="giveOut" has-role="ROLE_STORE_VIEWER"><span class="fas fa-share"></span> <span translate="global.menu.entities.giveOut">GiveOuts</span></button> <button class="btn btn-default" ui-sref="movement" has-role="ROLE_STORE_VIEWER"><i class="fas fa-retweet"></i> <span translate="global.menu.entities.movement">Movements</span></button> <button class="btn btn-primary" has-role="ROLE_STORE_IN_OUT" ui-sref="deliveryNote.new"><span class="fas fa-sign-in-alt"></span> <span translate="dodomaApp.deliveryNote.home.createLabel">Create a new DeliveryNote</span></button><div class="modal fade" id="deleteDeliveryNoteConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(deliveryNote.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.deliveryNote.delete.question" translate-values="deliveryNote">Are you sure you want to delete DeliveryNote?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.deliveryNote.deliveryNumber">DeliveryNumber</th><th translate="dodomaApp.deliveryNote.deliveryDate">DeliveryDate</th><th translate="dodomaApp.deliveryNote.state">State</th><th translate="dodomaApp.deliveryNote.type">Type</th><th translate="dodomaApp.deliveryNote.supplier">supplier</th><th translate="global.field.creator">Creator</th><th></th></tr></thead><tbody><tr ng-repeat="deliveryNote in deliveryNotes"><td><a ui-sref="deliveryNoteDetail({deliveryNoteId:deliveryNote.id})">{{deliveryNote.name}}</a></td><td>{{deliveryNote.deliveryDate}}</td><td><span class="{{stateLabel(deliveryNote)}}">{{deliveryNote.state | deliveryNoteStatus}}</span></td><td><span class="label label-default">{{deliveryNote.type | deliveryNoteType}}</span></td><td><partner-link partner="deliveryNote.supplier"></partner-link></td><td>{{deliveryNote.creator.name}}</td><td><button type="submit" ui-sref="deliveryNoteDetail({deliveryNoteId:deliveryNote.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" has-role="ROLE_STORE_IN_OUT" ng-if="isModifiable(deliveryNote)" ui-sref="deliveryNoteDetail.edit({deliveryNoteId:deliveryNote.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-if="isModifiable(deliveryNote)" has-role="ROLE_STORE_IN_OUT" ng-click="delete(deliveryNote.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div><back-button></back-button></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/deliveryNoteItem/deliveryNoteItem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="DeliveryNoteItemUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myDeliveryNoteItemLabel" translate="dodomaApp.deliveryNoteItem.home.createOrEditLabel">Create or edit a DeliveryNoteItem</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.deliveryNoteItem.part">part</label><ui-select ng-model="deliveryNoteItem.part" dodoma-part allow-clear name="part" required on-select="partSelected($item)"></ui-select></div><div class="form-group"><label translate="dodomaApp.deliveryNoteItem.location">location</label> <select class="form-control" name="location" ng-model="deliveryNoteItem.location.id" ng-options="stockLocation.id as stockLocation.stock.name for stockLocation in stocklocations"></select></div><div class="form-group" ng-if="everyCounter"><label translate="dodomaApp.deliveryNoteItem.sentAmount">SentAmount</label> <input type="number" class="form-control" name="sentAmount" ng-model="deliveryNoteItem.sentAmount" required min="0" ng-change="updateCountedAmount()"></div><div class="form-group"><label translate="dodomaApp.deliveryNoteItem.countedAmount">CountedAmount</label> <input type="number" class="form-control" name="countedAmount" ng-model="deliveryNoteItem.countedAmount" required min="0" ng-change="calculate()"></div><div class="form-group" ng-if="everyCounter"><label translate="dodomaApp.deliveryNoteItem.brokenAmount">BrokenAmount</label> <input type="number" class="form-control" name="brokenAmount" ng-model="deliveryNoteItem.brokenAmount" required min="0" ng-change="calculate()"></div><div class="form-group" ng-if="everyCounter"><label translate="dodomaApp.deliveryNoteItem.addToStockAmount">AddToStockAmount</label> <input type="number" class="form-control" name="addToStockAmount" ng-model="deliveryNoteItem.addToStockAmount" required min="0" ng-change="calculateTotalPrice()"></div><div class="form-group" ng-if="part.hasPrice"><label translate="dodomaApp.deliveryNoteItem.itemPrice">ItemPrice</label> <input type="number" class="form-control" name="itemPrice" ng-model="deliveryNoteItem.itemPrice" required ng-change="calculateTotalPrice()"></div><div class="form-group" ng-if="part.hasPrice"><label translate="dodomaApp.deliveryNoteItem.price">Price</label> <input type="number" class="form-control" name="price" ng-model="deliveryNoteItem.price" required ng-change="calculateItemPrice()"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/employment/employment-detail.html','<div><h2><span translate="dodomaApp.employment.detail.title">Employment</span> {{employment.id}}</h2><button type="submit" ui-sref="employmentDetail.edit({id:employment.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.employment.startDate">StartDate</span></td><td><input type="text" class="input-sm form-control" value="{{employment.startDate}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.employment.endDate">EndDate</span></td><td><input type="text" class="input-sm form-control" value="{{employment.endDate}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.employment.description">Description</span></td><td><input type="text" class="input-sm form-control" value="{{employment.description}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.employment.employmentCode">EmploymentCode</span></td><td><input type="text" class="input-sm form-control" value="{{employment.employmentCode}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.employment.workingHours">WorkingHours</span></td><td><input type="text" class="input-sm form-control" value="{{employment.workingHours}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.employment.worker">worker</span></td><td><input type="text" class="input-sm form-control" value="{{employment.worker.id}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="employment" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/employment/employment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="EmploymentUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myEmploymentLabel" translate="dodomaApp.employment.home.createOrEditLabel">Create or edit a Employment</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.employment.type" for="type">Type</label> <select ng-model="employment.type" class="form-control" name="type" id="type"><option value="TEMP" translate="dodomaApp.employment.typeLabel.TEMP"></option><option value="PERM" translate="dodomaApp.employment.typeLabel.PERM"></option></select></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.employment.startDate" for="field_startDate">StartDate</label> <input bs-datepicker type="text" data-max-date="{{employment.endDate}}" class="form-control" name="startDate" id="field_startDate" ng-model="employment.startDate" required></div><div class="form-group"><label translate="dodomaApp.employment.endDate" for="field_endDate">EndDate</label> <input bs-datepicker type="text" data-min-date="employment.startDate" class="form-control" name="endDate" id="field_endDate" ng-model="employment.endDate"></div><div class="form-group"><label translate="dodomaApp.employment.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="employment.description" ng-maxlength="255"></div><div class="form-group"><label translate="dodomaApp.employment.employmentCode" for="field_employmentCode">EmploymentCode</label> <input type="text" class="form-control" name="employmentCode" id="field_employmentCode" ng-model="employment.employmentCode"></div><div class="form-group"><label translate="dodomaApp.employment.workHourType" for="workHourType">Type</label> <select ng-model="whType" class="form-control" name="workHourType" id="workHourType" ng-change="changeWhType()"><option value="DAILY" translate="dodomaApp.employment.workHourTypeLabel.DAILY"></option><option value="WEEKLY" translate="dodomaApp.employment.workHourTypeLabel.WEEKLY"></option></select></div><div class="form-group" ng-if="whType === \'DAILY\'"><label translate="dodomaApp.employment.workingHours" for="field_workingHours">WorkingHours</label> <input type="number" class="form-control" name="workingHours" id="field_workingHours" ng-model="employment.workingHours" min="0" max="10"></div><div class="form-group" ng-if="whType === \'WEEKLY\'"><label translate="dodomaApp.employment.workingHourLimit" for="field_workingHourLimit">WorkingHours</label> <input type="number" class="form-control" name="workingHourLimit" id="field_workingHourLimit" ng-model="employment.workingHourLimit" min="0" max="100"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/employment/employments.html','<div><h2 translate="dodomaApp.employment.home.title">Employments</h2><button class="btn btn-primary" ui-sref="employment.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.employment.home.createLabel">Create a new Employment</span></button><div class="modal fade" id="deleteEmploymentConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(employment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.employment.delete.question" translate-values="employment">Are you sure you want to delete Employment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="dodomaApp.employment.startDate">StartDate</th><th translate="dodomaApp.employment.endDate">EndDate</th><th translate="dodomaApp.employment.description">Description</th><th translate="dodomaApp.employment.employmentCode">EmploymentCode</th><th translate="dodomaApp.employment.workingHours">WorkingHours</th><th translate="dodomaApp.employment.worker">worker</th><th></th></tr></thead><tbody><tr ng-repeat="employment in employments"><td><a ui-sref="employment.detail({id:employment.id})">{{employment.id}}</a></td><td>{{employment.startDate}}</td><td>{{employment.endDate}}</td><td>{{employment.description}}</td><td>{{employment.employmentCode}}</td><td>{{employment.workingHours}}</td><td>{{employment.worker.id}}</td><td><button type="submit" ui-sref="employment.detail({id:employment.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="employment.edit({id:employment.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(employment.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodomaapp-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodomaapp-navigation></div></div>');
$templateCache.put('scripts/app/entities/giveOut/giveOut-detail.html','<div><h2>{{giveOut.giveOutNumber}} ({{giveOut.state | giveOutState}})</h2><error-display></error-display><div ng-if="isModifiable(giveOut)" has-role="ROLE_STORE_IN_OUT" class="panel panel-info"><div class="panel-heading">{{giveOut.state | giveOutState}}</div><div class="panel-body"><button class="btn btn-primary" type="submit" ng-click="deliver()"><span class="fas fa-share"></span>&nbsp;<span translate="dodomaApp.giveOut.deliver"> Deliver</span></button> <button class="btn btn-warning" type="submit" ui-sref="giveOutDetail.edit({id:giveOut.id})"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></div></div><div ng-if="giveOut.approval == \'ASKED\'" class="panel panel-warning"><div class="panel-heading" translate="dodomaApp.giveOut.waitingForApproval">waitingForApproval</div><div class="panel-body" ng-if="approvable"><button class="btn btn-primary" type="submit" ng-click="verify()"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.giveOut.verify"> Verify</span></button> <button class="btn btn-danger" type="submit" ng-click="decline()"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.giveOut.decline"> Decline</span></button></div><div class="panel-body" ng-if="!approvable"><span class="panel-body" translate="dodomaApp.giveOut.waitingForApprovalBy" translate-values="{user: giveOut.approvalUser}">approval by user</span></div></div><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.giveOut.detail.title">GiveOut</div><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.giveOut.giveOutNumber" value="giveOut.giveOutNumber"></dod-display-value><dod-display-value label="dodomaApp.giveOut.type" value="giveOut.type | giveOutType"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.giveOut.state" value="giveOut.state | giveOutState"></dod-display-value><dod-display-value label="dodomaApp.giveOut.comment" value="giveOut.comment"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.giveOut.creationDate" value="giveOut.creationDate | dodTime"></dod-display-value><dod-display-value label="dodomaApp.giveOut.giveOutTime" value="giveOut.giveOutTime | dodTime"></dod-display-value></div><div class="row"><dod-display-value ng-if="giveOut.sendbackPartner" label="dodomaApp.giveOut.sendbackPartner" custom="<partner-link class=\'input-sm\' partner=\'giveOut.sendbackPartner\'></partner-link>"></dod-display-value><dod-display-value ng-if="giveOut.orderPlan" label="dodomaApp.giveOut.orderPlan" custom="<order-plan-link class=\'input-sm\' plan=\'giveOut.orderPlan\'></order-plan-link>"></dod-display-value></div><div class="row"><dod-display-value ng-if="giveOut.giveOutUser" label="dodomaApp.giveOut.giveOutUser" value="giveOut.giveOutUser.name"></dod-display-value><dod-display-value ng-if="giveOut.giveOutWorker" label="dodomaApp.giveOut.worker" custom="<worker-link class=\'input-sm\' worker=\'giveOut.giveOutWorker\'></worker-link>"></dod-display-value></div><div ng-if="giveOut.approval" class="row"><dod-display-value label="dodomaApp.giveOut.approval" value="giveOut.approval | giveOutApproval"></dod-display-value><dod-display-value label="dodomaApp.giveOut.approvalUser" value="giveOut.approvalUser.name"></dod-display-value></div><div class="row"><dod-display-value ng-if="giveOut.approvalDate" label="dodomaApp.giveOut.approvalDate" value="giveOut.approvalDate | dodTime"></dod-display-value></div><table class="table"><thead><tr><th></th><th translate="dodomaApp.giveOutItem.part">part</th><th translate="dodomaApp.giveOutItem.stockLocation">location</th><th translate="dodomaApp.giveOutItem.amount">SentAmount</th><th has-role="ROLE_STORE_PRICES" translate="dodomaApp.giveOutItem.itemPrice">item price</th><th has-role="ROLE_STORE_PRICES" translate="dodomaApp.giveOutItem.linePrice">line price</th><th></th></tr></thead><tbody><tr ng-repeat="giveOutItem in giveOut.items"><td><button type="submit" ng-if="isModifiable(giveOut)" ng-click="deleteItem(giveOutItem.id)" has-role="ROLE_STORE_IN_OUT" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td><td><part-link part="giveOutItem.part"></part-link></td><td><stock-link stock="giveOutItem.stockLocation.stock"></stock-link></td><td>{{giveOutItem.amount}}</td><td has-role="ROLE_STORE_PRICES">{{giveOutItem.itemPrice}}</td><td has-role="ROLE_STORE_PRICES">{{giveOutItem.itemPrice * giveOutItem.amount}}</td><td><button type="submit" ng-if="isModifiable(giveOut)" ui-sref="editGiveOutItem({itemId:giveOutItem.id})" has-role="ROLE_STORE_IN_OUT" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td></tr><tr><td colspan="7"><button class="btn btn-default btn-sm" has-role="ROLE_STORE_IN_OUT" ui-sref="newGiveOutItem" ng-if="isModifiable(giveOut)"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.giveOutItem.home.createLabel">Create a new item</span></button></td></tr></tbody></table></div></div><div class="row"><div class="col-md-1"><back-button></back-button></div></div></div>');
$templateCache.put('scripts/app/entities/giveOut/giveOut-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="GiveOutUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myGiveOutLabel" translate="dodomaApp.giveOut.home.createOrEditLabel">Create or edit a GiveOut</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.giveOut.giveOutNumber" for="field_giveOutNumber">GiveOutNumber</label> <input type="text" class="form-control" name="giveOutNumber" id="field_giveOutNumber" ng-model="giveOut.giveOutNumber" required ng-maxlength="50"></div><div class="form-group"><label translate="dodomaApp.giveOut.type" for="field_type">Type</label><div class="btn-group" id="field_type"><span class="btn btn-primary" ng-model="giveOut.type" uib-btn-radio="\'INTERNAL\'" translate="dodomaApp.giveOut.typeLabel.INTERNAL" required>internal</span> <span class="btn btn-primary" ng-model="giveOut.type" uib-btn-radio="\'FOR_WORK\'" translate="dodomaApp.giveOut.typeLabel.FOR_WORK" required>for work</span> <span class="btn btn-primary" ng-model="giveOut.type" uib-btn-radio="\'SENDBACK\'" translate="dodomaApp.giveOut.typeLabel.SENDBACK" required>sendback</span> <span class="btn btn-primary" ng-model="giveOut.type" uib-btn-radio="\'DISCARD\'" translate="dodomaApp.giveOut.typeLabel.DISCARD" required>discard</span> <span class="btn btn-primary" ng-model="giveOut.type" uib-btn-radio="\'SELL\'" translate="dodomaApp.giveOut.typeLabel.SELL" required>sell</span></div><!-- just for validation --> <input type="hidden" name="type" ng-model="giveOut.type"></div><div class="form-group" ng-if="giveOut.type === \'SENDBACK\'"><label translate="dodomaApp.giveOut.sendbackPartner" for="field_sendbackPartner">sendbackPartner</label><ui-select ng-model="giveOut.sendbackPartner" dodoma-partner allow-clear name="sendbackPartner" id="field_sendbackPartner"></ui-select></div><div class="form-group" ng-if="giveOut.type === \'FOR_WORK\'"><label translate="dodomaApp.giveOut.orderPlan" for="field_orderPlan">orderPlan</label><ui-select ng-model="giveOut.orderPlan" dodoma-order-plan allow-clear name="orderPlan" id="field_orderPlan"></ui-select></div><div class="form-group" ng-if="showApproval()"><label translate="dodomaApp.giveOut.approvalUser" for="field_approvalUser">approvalUser</label> <select class="form-control" name="approvalUser" id="field_approvalUser" ng-model="giveOut.approvalUser" ng-options="user as user.name for user in users.entities track by user.id"><option value=""></option></select></div><div class="form-group" ng-if="showApproval()"><label translate="dodomaApp.giveOut.worker" for="field_worker">worker</label><ui-select ng-model="giveOut.giveOutWorker" dodoma-worker module="STOCK" allow-clear name="worker" id="field_worker"></ui-select></div><div class="form-group" ng-if="DodomaConfig.backdatedMovements"><label translate="dodomaApp.giveOut.backdatedGiveout">Type</label> <input type="checkbox" id="backdatedGiveout" ng-model="giveOut.backdatedGiveout" ng-change="backdatedChanged()"></div><div class="form-group" ng-if="giveOut.backdatedGiveout && DodomaConfig.backdatedMovements"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.giveOut.giveOutTime" for="field_giveOutTime">giveOutDate</label><div class="form-group"><input bs-datepicker type="text" data-max-date="today" name="giveOutTime" id="field_giveOutTime" ng-model="giveOut.giveOutTime"> <input bs-timepicker type="text" ng-model="giveOut.giveOutTime"></div></div><div class="form-group"><label translate="dodomaApp.giveOut.comment" for="field_comment">Comment</label> <textarea class="form-control" name="comment" id="field_comment" ng-model="giveOut.comment" ng-maxlength="512"></textarea></div><div class="row" ng-if="giveOut.initialPart"><div class="col-md-6"><label translate="dodomaApp.giveOutItem.part">Part</label><div class="form-control">{{giveOut.initialPart.name}} ({{giveOut.initialPart.description}})</div></div><div class="col-md-6"><label translate="dodomaApp.giveOutItem.amount">Amount</label> <input type="number" class="form-control" name="initialAmount" ng-model="giveOut.initialAmount" ng-required="giveOut.initialPart"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/giveOut/giveOutTable.html','<div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.giveOut.giveOutNumber">GiveOutNumber</th><th translate="dodomaApp.giveOut.type">Type</th><th translate="dodomaApp.giveOut.state">State</th><th translate="dodomaApp.giveOut.creationDate">CreationDate</th><th translate="dodomaApp.giveOut.giveOutTime">GiveOutTime</th><th translate="dodomaApp.giveOut.sendbackPartner">sendbackPartner</th><th translate="global.field.creator">creator</th><th translate="dodomaApp.giveOut.giveOutUser">giveOutUser</th><th translate="dodomaApp.giveOut.approvalUser">approvalUser</th><th translate="dodomaApp.giveOut.worker">Worker</th></tr></thead><tbody><tr ng-repeat="giveOut in entities"><td><a ui-sref="giveOutDetail({id:giveOut.id})">{{giveOut.giveOutNumber}}</a></td><td><a ui-sref="giveOutDetail({id:giveOut.id})"><span class="label label-default">{{giveOut.type | giveOutType}}</span></a></td><td><a ui-sref="giveOutDetail({id:giveOut.id})"><span class="{{stateLabel(giveOut)}}">{{giveOut.state | giveOutState}}</span></a></td><td>{{giveOut.creationDate | dodTime}}</td><td>{{giveOut.giveOutTime | dodTime}}</td><td><partner-link partner="giveOut.sendbackPartner"></partner-link></td><td>{{giveOut.creator.name}}</td><td>{{giveOut.giveOutUser.name}}</td><td>{{giveOut.approvalUser.name}}</td><td><worker-link worker="giveOut.giveOutWorker"></worker-link></td></tr></tbody></table><dodoma-navigation page-info="result" callback-fn="loadEntities(page)"></dodoma-navigation></div>');
$templateCache.put('scripts/app/entities/giveOut/giveOuts.html','<main-layout title-key="dodomaApp.giveOut.home.title"><pane-filter><div class="form-group"><label class="control-label" for="giveOutNumber" translate="dodomaApp.giveOut.filter.giveOutNumber">giveOutNumber</label> <input type="text" class="form-control" name="giveOutNumber" id="giveOutNumber" ng-model="filter.name" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="status" translate="dodomaApp.giveOut.filter.status">Status</label> <select class="form-control" name="status" id="status" ng-model="filter.status" ng-change="loadAll()"><option value="" translate="dodomaApp.giveOut.stateLabel.ALL">All</option><option value="INIT" translate="dodomaApp.giveOut.stateLabel.INIT">INIT</option><option value="DONE" translate="dodomaApp.giveOut.stateLabel.DONE">DONE</option></select></div><div class="form-group"><label class="control-label" for="partner" translate="dodomaApp.giveOut.filter.partner">Partner</label><ui-select ng-model="customFilter.partner" dodoma-partner allow-clear name="partner" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="creator" translate="dodomaApp.giveOut.filter.creator">creator</label><ui-select ng-model="customFilter.creator" dodoma-user-field allow-clear name="creator" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="giveOutUser" translate="dodomaApp.giveOut.filter.giveOutUser">giveOutUser</label><ui-select ng-model="customFilter.giveOutUser" dodoma-user-field allow-clear name="giveOutUser" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="giveOutWorker" translate="dodomaApp.giveOut.filter.giveOutWorker">giveOutWorker</label><ui-select ng-model="customFilter.giveOutWorker" dodoma-worker module="STOCK" allow-clear name="giveOutWorker" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="approvalUser" translate="dodomaApp.giveOut.filter.approvalUser">approvalUser</label><ui-select ng-model="customFilter.approvalUser" dodoma-user-field allow-clear name="approvalUser" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="after" translate="dodomaApp.giveOut.filter.after">StartDate</label> <input bs-datepicker data-max-date="today" type="text" class="form-control" name="after" id="after" ng-model="filter.after" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="before" translate="dodomaApp.giveOut.filter.before">EndDate</label> <input bs-datepicker data-max-date="today" type="text" data-min-date="{{filter.after}}" class="form-control" name="before" id="before" ng-model="filter.before" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="type" translate="dodomaApp.giveOut.filter.type">Type</label> <select class="form-control" name="type" id="type" ng-model="filter.type" ng-change="loadAll()"><option value="" translate="dodomaApp.giveOut.typeLabel.ALL">All</option><option value="INTERNAL" translate="dodomaApp.giveOut.typeLabel.INTERNAL">INTERNAL</option><option value="FOR_WORK" translate="dodomaApp.giveOut.typeLabel.FOR_WORK">FOR_WORK</option><option value="SENDBACK" translate="dodomaApp.giveOut.typeLabel.SENDBACK">SENDBACK</option><option value="DISCARD" translate="dodomaApp.giveOut.typeLabel.DISCARD">DISCARD</option><option value="SELL" translate="dodomaApp.giveOut.typeLabel.SELL">SELL</option></select></div><div class="form-group"><label class="control-label" for="approval" translate="dodomaApp.giveOut.filter.approval">Approval</label> <select class="form-control" name="approval" id="approval" ng-model="filter.approval" ng-change="loadAll()"><option value="" translate="dodomaApp.giveOut.typeLabel.ALL">All</option><option value="ASKED" translate="dodomaApp.giveOut.approvalLabel.ASKED">ASKED</option><option value="VERIFIED" translate="dodomaApp.giveOut.approvalLabel.VERIFIED">VERIFIED</option><option value="DECLINED" translate="dodomaApp.giveOut.approvalLabel.DECLINED">DECLINED</option></select></div><div class="form-group"><label class="control-label" for="approvalSelfSearch" translate="dodomaApp.giveOut.filter.approvalSelfSearch">approvalSelfSearch</label> <input type="checkbox" class="dodoma-checkbox form-control" name="approvalSelfSearch" id="approvalSelfSearch" ng-model="filter.approvalSelfSearch" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="part" translate="dodomaApp.giveOut.filter.part">Part</label><ui-select ng-model="customFilter.part" dodoma-part allow-clear name="part" on-select="loadAll()" on-clear="loadAll()"></ui-select></div></pane-filter><pane-main><button class="btn btn-default" ui-sref="stock" has-role="ROLE_STORE_VIEWER"><i class="fas fa-chess-rook"></i> <span translate="global.menu.entities.stock">Stocks</span></button> <button class="btn btn-default" ui-sref="deliveryNote" has-role="ROLE_STORE_VIEWER"><span class="fas fa-sign-in-alt"></span> <span translate="global.menu.entities.deliveryNote">DeliveryNotes</span></button> <button class="btn btn-default" ui-sref="movement" has-role="ROLE_STORE_VIEWER"><i class="fas fa-retweet"></i> <span translate="global.menu.entities.movement">Movements</span></button> <button class="btn btn-primary" has-role="ROLE_STORE_IN_OUT" ui-sref="giveOut.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.giveOut.home.createLabel">Create a new GiveOut</span></button><div class="modal fade" id="deleteGiveOutConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(giveOut.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.giveOut.delete.question" translate-values="giveOut">Are you sure you want to delete GiveOut?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.giveOut.giveOutNumber">GiveOutNumber</th><th translate="dodomaApp.giveOut.type">Type</th><th translate="dodomaApp.giveOut.state">State</th><th translate="dodomaApp.giveOut.creationDate">CreationDate</th><th translate="dodomaApp.giveOut.giveOutTime">GiveOutTime</th><th translate="dodomaApp.giveOut.sendbackPartner">sendbackPartner</th><th translate="global.field.creator">creator</th><th translate="dodomaApp.giveOut.giveOutUser">giveOutUser</th><th translate="dodomaApp.giveOut.approvalUser">approvalUser</th><th translate="dodomaApp.giveOut.worker">Worker</th><th></th></tr></thead><tbody><tr ng-repeat="giveOut in giveOuts"><td><a ui-sref="giveOutDetail({id:giveOut.id})">{{giveOut.giveOutNumber}}</a></td><td><a ui-sref="giveOutDetail({id:giveOut.id})"><span class="label label-default">{{giveOut.type | giveOutType}}</span></a></td><td><a ui-sref="giveOutDetail({id:giveOut.id})"><span class="{{stateLabel(giveOut)}}">{{giveOut.state | giveOutState}}</span></a></td><td>{{giveOut.creationDate | dodTime}}</td><td>{{giveOut.giveOutTime | dodTime}}</td><td><partner-link partner="giveOut.sendbackPartner"></partner-link></td><td>{{giveOut.creator.name}}</td><td>{{giveOut.giveOutUser.name}}</td><td>{{giveOut.approvalUser.name}}</td><td><worker-link worker="giveOut.giveOutWorker"></worker-link></td><td><button type="submit" ui-sref="giveOutDetail({id:giveOut.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ng-if="isModifiable(giveOut)" has-role="ROLE_STORE_IN_OUT" ui-sref="giveOutDetail.edit({id:giveOut.id})" class="btn btn-warning btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-if="isModifiable(giveOut)" ng-click="delete(giveOut.id)" has-role="ROLE_STORE_IN_OUT" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div><back-button></back-button></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/giveOutItem/giveOutItem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myGiveOutItemLabel" translate="dodomaApp.giveOutItem.home.createOrEditLabel">Create or edit a GiveOutItem</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.giveOutItem.part" for="field_part">part</label><ui-select ng-model="giveOutItem.part" id="field_part" dodoma-part allow-clear name="part" required on-select="partSelected($item)"></ui-select><div ng-show="editForm.part.$invalid"><p class="help-block" ng-show="editForm.part.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="dodomaApp.giveOutItem.stockLocation" for="field_stockLocation">stockLocation</label> <select class="form-control" id="field_stockLocation" name="stockLocation" ng-model="giveOutItem.stockLocation" ng-options="stockLocation as stockLocation.stock.name for stockLocation in stocklocations" required></select><div ng-show="editForm.stockLocation.$invalid"><p class="help-block" ng-show="editForm.stockLocation.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="dodomaApp.giveOutItem.amount" for="field_amount">Amount</label> <input type="number" class="form-control" name="amount" id="field_amount" ng-model="giveOutItem.amount" required min="0" max="{{maxAmount}}"><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.min" translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.amount.$error.number" translate="entity.validation.number">This field should be a number.</p><p class="help-block" ng-show="editForm.amount.$error.max" translate="entity.validation.max" translate-value-max="{{maxAmount}}">This field should be more than XXX.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/movement/movement-detail.html','<div><h2>{{movement.part.name}} ({{movement.type | movementType}})</h2><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.movement.detail.title">Movement</div><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.movement.type" value="movement.type | movementType"></dod-display-value><dod-display-value label="dodomaApp.movement.part" custom="<part-link part=\'movement.part\'></part-link>"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.movement.physicalAmountChange" value="movement.physicalAmountChange"></dod-display-value><dod-display-value label="dodomaApp.movement.physicalAmount" value="movement.physicalAmount"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.movement.availableAmountChange" value="movement.availableAmountChange"></dod-display-value><dod-display-value label="dodomaApp.movement.availableAmount" value="movement.availableAmount"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.movement.createdDate" value="movement.createdDate | dodTime"></dod-display-value><dod-display-value label="dodomaApp.movement.user" value="movement.user.name"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.movement.itemPrice" value="movement.itemPrice"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.movement.currentStockValue" value="movement.currentStockValue"></dod-display-value><dod-display-value label="dodomaApp.movement.currentOverallValue" value="movement.currentValue"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.movement.comment" value="movement.comment"></dod-display-value><dod-display-value ng-if="movement.stock" label="dodomaApp.movement.stock" custom="<stock-link stock=\'movement.stock\'></stock-link>"></dod-display-value></div><div class="row" ng-if="movement.deliveryNote"><dod-display-value label="dodomaApp.movement.deliveryNote" custom="<delivery-note-link deliverynote=\'movement.deliveryNote\'></delivery-note-link>"></dod-display-value><dod-display-value ng-if="movement.deliveryNoteItem" label="dodomaApp.movement.deliveryNoteItem" value="movement.deliveryNoteItem.id"></dod-display-value></div><div class="row" ng-if="movement.relatedPartner"><dod-display-value label="dodomaApp.movement.relatedPartner" custom="<partner-link partner=\'movement.relatedPartner\'></partner-link>"></dod-display-value></div><div class="row" ng-if="movement.giveOut"><dod-display-value label="dodomaApp.movement.giveOut" custom="<give-out-link giveout=\'movement.giveOut\'></give-out-link>"></dod-display-value><dod-display-value label="dodomaApp.movement.giveOutType" value="movement.giveOutType | giveOutType"></dod-display-value></div></div></div><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/movement/movements.html','<main-layout title-key="dodomaApp.movement.home.title"><pane-main><div class="table-responsive"><button class="btn btn-default" ui-sref="stock" has-role="ROLE_STORE_VIEWER"><i class="fas fa-chess-rook"></i> <span translate="global.menu.entities.stock">Stocks</span></button> <button class="btn btn-default" ui-sref="giveOut" has-role="ROLE_STORE_VIEWER"><span class="fas fa-share"></span> <span translate="global.menu.entities.giveOut">GiveOuts</span></button> <button class="btn btn-default" ui-sref="deliveryNote" has-role="ROLE_STORE_VIEWER"><span class="fas fa-sign-in-alt"></span> <span translate="global.menu.entities.deliveryNote">DeliveryNotes</span></button><uib-tabset justified="false" active="filter.style"><uib-tab index="0" heading="{{ \'dodomaApp.movement.tabs.movements\' | translate  }}" select="switchTab(0)"><div class="well"><download-button url="movementExportUrl()"></download-button></div><table class="table table-striped table-condensed"><thead><tr><th>ID</th><th translate="dodomaApp.movement.part">part</th><th translate="dodomaApp.movement.stock">stock</th><th translate="dodomaApp.movement.type">Type</th><th translate="dodomaApp.movement.physicalAmount">PhysicalAmount</th><th translate="dodomaApp.movement.value" has-role="ROLE_STORE_PRICES">Value</th><th ng-if="DodomaConfig.showPartReservation" translate="dodomaApp.movement.availableAmount">AvailableAmount</th><th></th><th translate="dodomaApp.movement.createdDate">CreatedDate</th><th translate="dodomaApp.movement.user">User</th><th></th></tr></thead><tbody><tr ng-repeat="movement in pageResult.entities"><td><a ui-sref="movementDetail({id:movement.id})">{{movement.id}}</a></td><td><part-link part="movement.part"></part-link></td><td>{{movement.stock.name}}</td><td><span class="label label-info">{{movement.type | movementType}}</span></td><td>{{movement.physicalAmount}} ({{movement.physicalAmountChange}})</td><td has-role="ROLE_STORE_PRICES">{{movement.physicalAmountChange * movement.itemPrice}} ({{movement.itemPrice}} Ft/db)</td><td ng-if="DodomaConfig.showPartReservation">{{movement.availableAmount}} ({{movement.availableAmountChange}})</td><td><span ng-if="movement.giveOut !== null"><give-out-link giveout="movement.giveOut"></give-out-link></span><span ng-if="movement.deliveryNote  !== null"><delivery-note-link deliverynote="movement.deliveryNote"></delivery-note-link></span></td><td>{{movement.createdDate | dodTime}}</td><td>{{movement.user.name}}</td><td><button type="submit" ui-sref="movementDetail({id:movement.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></uib-tab><uib-tab index="1" heading="{{ \'dodomaApp.movement.tabs.aggregations\' | translate  }}" select="switchTab(1)"><div class="well"><h3 translate="dodomaApp.movement.groupBy.title">Grouping</h3><div class="btn-group"><span class="btn btn-primary" ng-model="grp.groupByPart" uib-btn-checkbox translate="dodomaApp.movement.groupBy.part">Part</span> <span class="btn btn-primary" ng-model="grp.groupByPartType" uib-btn-checkbox translate="dodomaApp.movement.groupBy.partType">PartType</span> <span class="btn btn-primary" ng-model="grp.groupByYear" uib-btn-checkbox translate="dodomaApp.movement.groupBy.year">year</span> <span class="btn btn-primary" ng-model="grp.groupByMonth" uib-btn-checkbox translate="dodomaApp.movement.groupBy.month">month</span> <span class="btn btn-primary" ng-model="grp.groupByMovementType" uib-btn-checkbox translate="dodomaApp.movement.groupBy.movementType">MovementTYpe</span> <span class="btn btn-primary" ng-model="grp.groupByPartner" uib-btn-checkbox translate="dodomaApp.movement.groupBy.partner">Partner</span> <span class="btn btn-primary" ng-model="grp.groupByStock" uib-btn-checkbox translate="dodomaApp.movement.groupBy.stock">stock</span> <span class="btn btn-primary" ng-model="grp.groupByUser" uib-btn-checkbox translate="dodomaApp.movement.groupBy.user">user</span></div></div><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.movement.physicalAmountChange">PhysicalAmount</th><th translate="dodomaApp.movement.aggregate.count">Count</th><th has-role="ROLE_STORE_PRICES" translate="dodomaApp.movement.aggregate.value">Value</th><th ng-if="aggregateReportResult.visiblePart" translate="dodomaApp.movement.part">part</th><th ng-if="aggregateReportResult.visiblePartType" translate="dodomaApp.movement.groupBy.partType">PartType</th><th ng-if="aggregateReportResult.visibleMovementType" translate="dodomaApp.movement.type">Type</th><th ng-if="aggregateReportResult.visibleYear || aggregateReportResult.visibleMonth" translate="dodomaApp.movement.createdDate">Date</th><th ng-if="aggregateReportResult.visiblePartner" translate="dodomaApp.movement.groupBy.partner">partner</th><th ng-if="aggregateReportResult.visibleStock" translate="dodomaApp.movement.groupBy.stock">stock</th><th ng-if="aggregateReportResult.visibleUser" translate="dodomaApp.movement.groupBy.user">user</th></tr></thead><tbody><tr ng-repeat="movement in aggregateReportResult.lines"><td>{{movement.amount}} <span ng-if="aggregateReportResult.visiblePart" dd-measuring="movement.measuringType">XXX</span></td><td>{{movement.count}}</td><td has-role="ROLE_STORE_PRICES">{{movement.value}}</td><td ng-if="aggregateReportResult.visiblePart"><part-link part="movement.part"></part-link></td><td ng-if="aggregateReportResult.visiblePartType">{{movement.partType.name}}</td><td ng-if="aggregateReportResult.visibleMovementType">{{movement.movementType | movementType}}</td><td ng-if="aggregateReportResult.visibleYear || aggregateReportResult.visibleMonth">{{movement.year}} {{movement.month}}</td><td ng-if="aggregateReportResult.visiblePartner"><partner-link partner="movement.partner"></partner-link></td><td ng-if="aggregateReportResult.visibleStock"><stock-link stock="movement.stock"></stock-link></td><th ng-if="aggregateReportResult.visibleUser">{{movement.user.name}}</th></tr></tbody></table><dodoma-navigation page-info="aggregateReportResult" callback-fn="loadPage(page)"></dodoma-navigation></uib-tab><uib-tab index="2" heading="{{ \'dodomaApp.movement.tabs.historic\' | translate  }}" select="switchTab(2)"><div class="well"><div class="form-inline"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="statusAt" translate="dodomaApp.movement.filter.statusAt">Status At</label> <input bs-datepicker data-max-date="today" type="text" class="form-control" name="statusAt" id="statusAt" ng-model="filter.statusAt" ng-change="loadAll()"><download-button url="historicExportUrl()"></download-button></div></div><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.movement.part">part</th><th translate="dodomaApp.movement.stock">stock</th><th translate="dodomaApp.movement.physicalAmount">PhysicalAmount</th><th has-role="ROLE_STORE_PRICES" translate="dodomaApp.movement.currentValue">Value</th><th translate="dodomaApp.movement.lastChangeDate">CreatedDate</th></tr></thead><tbody><tr ng-repeat="historicLine in historic"><td><part-link part="::historicLine.part"></part-link></td><td>{{::historicLine.stock.name}}</td><td>{{::historicLine.amount}}</td><td has-role="ROLE_STORE_PRICES">{{::historicLine.value}}</td><td>{{::historicLine.createdDate | dodTime }}</td></tr></tbody></table><dodoma-navigation page-info="historicPageResult" callback-fn="loadPage(page)"></dodoma-navigation></uib-tab></uib-tabset><back-button></back-button></div></pane-main><pane-filter><div class="form-horizontal" name="filter"><div class="form-group"><label class="control-label" for="part" translate="dodomaApp.movement.filter.part">Part</label><ui-select ng-model="filter.part" dodoma-part allow-clear name="part" on-select="loadPage()"></ui-select></div><div class="form-group"><label class="control-label" for="partType" translate="dodomaApp.movement.filter.partType">Part type</label><ui-select ng-model="filter.partType" dodoma-part-type allow-clear name="partType" on-select="loadPage()"></ui-select></div><div class="form-group"><label class="control-label" for="stock" translate="dodomaApp.movement.filter.stock">Stock</label><ui-select ng-model="filter.stock" dodoma-stock allow-clear name="stock" on-select="loadPage()"></ui-select></div><div class="form-group"><label class="control-label" for="partner" translate="dodomaApp.movement.filter.partner">Partner</label><ui-select ng-model="filter.partner" dodoma-partner allow-clear name="partner" on-select="loadPage()"></ui-select></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="startDate" translate="dodomaApp.movement.filter.startDate">StartDate</label> <input bs-datepicker data-max-date="today" type="text" ng-disabled="disableDateSelection" class="form-control" name="startDate" id="startDate" ng-model="filter.startDate" ng-change="loadPage()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="endDate" translate="dodomaApp.movement.filter.endDate">EndDate</label> <input bs-datepicker data-min-date="{{filter.startDate}}" data-max-date="today" type="text" class="form-control" name="endDate" id="endDate" ng-disabled="disableDateSelection" ng-model="filter.endDate" ng-change="loadPage()"></div><div class="form-group"><label class="control-label" for="movementTypes" translate="dodomaApp.movement.filter.movementTypes">Movement types</label><ui-select ng-model="filter.movementTypes" dodoma-movement-type allow-clear name="movementType" on-select="loadPage()" on-remove="loadPage()" multiple="multiple"></ui-select></div><div class="form-group"><label class="control-label" for="user_selection" translate="dodomaApp.movement.filter.user">User</label><ui-select ng-model="filter.user" dodoma-user-field allow-clear name="user_selection" on-select="loadPage()" on-remove="loadPage()"></ui-select></div></div></pane-filter></main-layout>');
$templateCache.put('scripts/app/entities/orderLine/orderLine-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="OrderLineUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myOrderLineLabel" translate="dodomaApp.orderLine.home.createOrEditLabel">Create or edit a OrderLine</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.orderLine.part" for="field_part">part</label><ui-select ng-model="orderLine.part" dodoma-part include-virtual-partner-id="{{orderPlanEntity.client.id}}" on-select="partChanged()" allow-clear name="field_part" required></ui-select><input type="hidden" ng-model="orderLine.part.id" name="part"></div><div class="form-group" ng-if="orderLine.part && orderLine.part.canBeBuilt"><label translate="dodomaApp.orderLine.productionVariant" for="field_productionVariant">Variant</label> <select name="field_productionVariant" id="field_productionVariant" class="form-control" ng-model="orderLine.variant" ng-options="item as item.name for item in productionVariants track by item.id"></select></div><div class="form-group"><label translate="dodomaApp.orderLine.amount" for="field_amount">Amount</label> <input type="number" class="form-control" name="amount" id="field_amount" ng-model="orderLine.amount" required min="0"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/orderPlan/orderPlan-detail.html','<div><h2>{{orderPlan.name}} ({{orderPlan.state | orderPlanState}})</h2><h4 ng-if="viewConfig.orderMode" translate="dodomaApp.orderPlan.detail.title">OrderPlan</h4><h4 ng-if="viewConfig.offerMode" translate="dodomaApp.offer.detail.title">OrderPlan</h4><div class="panel panel-info" ng-if="orderPlan.state !== \'CANCELLED\'"><div class="panel-body"><button type="submit" ng-if="viewConfig.liveMode" ui-sref=".edit({id:orderPlan.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button class="btn btn-primary" ng-click="acceptOffer()" ng-if="viewConfig.openOffer"><i class="fas fa-check"></i>&nbsp;<span translate="dodomaApp.orderPlan.action.acceptOffer">acceptOffer</span></button> <button class="btn btn-danger" ng-click="cancelOffer()" ng-if="viewConfig.openOffer"><span class="fas fa-minus-octagon"></span>&nbsp;<span translate="dodomaApp.orderPlan.action.cancelOffer">cancelOffer</span></button> <button class="btn btn-default" ui-sref=".priceCalculationEdit" ng-if="viewConfig.openOffer"><i class="fas fa-check"></i>&nbsp;<span translate="dodomaApp.orderPlan.action.priceCalculation">price calculation</span></button> <button class="btn btn-default" ngf-select="upload($file)" ng-if="viewConfig.liveMode"><span class="far fa-file-excel"></span>&nbsp;<span translate="dodomaApp.orderPlan.action.upload">Upload Excel</span></button> <button type="submit" class="btn btn-default" ui-sref=".productionSheetNew" ng-if="viewConfig.liveMode && viewConfig.orderMode"><i class="fas fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.productionSheet.home.createLabel">New</span></button> <button class="btn btn-default" ng-click="createDeliveryNote()" ng-if="viewConfig.deliveryNoteButton && DodomaConfig.sendBackToStock"><span class="far fa-paper-plane"></span>&nbsp;<span translate="dodomaApp.orderPlan.action.deliveryNote">create delivery note</span></button> <button class="btn btn-default" has-role="ROLE_PROD_EARLY_FINISH" ng-click="earlyFinish()" ng-if="viewConfig.liveMode && viewConfig.orderMode"><i class="far fa-clipboard-list-check"></i>&nbsp;<span translate="dodomaApp.orderPlan.action.earlyFinish">Finish</span></button> <button type="submit" ng-if="viewConfig.finalCalculation" ui-sref=".edit({id:orderPlan.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="dodomaApp.orderPlan.action.invoicing"> Invoice</span></button> <button class="btn btn-default" ui-sref=".postCalculationEdit" ng-if="viewConfig.finalCalculation"><i class="fas fa-check"></i>&nbsp;<span translate="dodomaApp.orderPlan.action.postCalculation">post calculation</span></button> <button ng-if="orderPlan.deletable || isAdmin" type="submit" ng-click="delete()" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></div></div><div class="modal fade" id="deleteOrderPlanConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><error-display></error-display><p translate="dodomaApp.orderPlan.delete.question" translate-values="{name:orderPlan.name}">Are you sure you want to delete OrderPlan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="modal fade" id="cancelOfferConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="cancelOfferForm" ng-submit="confirmCancelOffer()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" translate="dodomaApp.orderPlan.action.cancelConfirmation">Confirm cancellation</h4></div><div class="modal-body"><p translate="dodomaApp.orderPlan.cancel.question" translate-values="{name:orderPlan.name}">Are you sure you want to cancel the Order?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="cancelOfferForm.$invalid" class="btn btn-danger"><span class="fas fa-minus-octagon"></span>&nbsp;<span translate="dodomaApp.orderPlan.action.cancelOffer">cancelOffer</span></button></div></form></div></div></div><error-display></error-display><uib-tabset justified="false" active="orderPlanManager.activeIdx"><uib-tab index="\'general\'"><uib-tab-heading><span class="fas fa-suitcase"></span>&nbsp;<span translate="dodomaApp.orderPlan.detail.general">General</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.orderPlan.name" value="orderPlan.name"></dod-display-value><dod-display-value label="dodomaApp.orderPlan.state" value="orderPlan.state | orderPlanState"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.orderPlan.deliveryDate" value="orderPlan.deliveryDate | justIsoDate"></dod-display-value><dod-display-value label="dodomaApp.orderPlan.client" custom="<partner-link partner=\'orderPlan.client\'></partner-link>"></dod-display-value></div><div class="row"><dod-display-value label="global.field.creator" value="orderPlan.creator.name"></dod-display-value><dod-display-value label="dodomaApp.orderPlan.creationDate" value="orderPlan.creationDate | justIsoDate"></dod-display-value></div><div class="row"><dod-display-value ng-if="orderPlan.timeSpent" label="dodomaApp.productionSheetItem.timeSpent" value="orderPlan.timeSpent | timeFormat"></dod-display-value><dod-display-value ng-if="orderPlan.invoiceNumber" label="dodomaApp.orderPlan.invoiceNumber" value="orderPlan.invoiceNumber"></dod-display-value></div><div class="row"><dod-display-value ng-if="orderPlan.invoiceAmount" label="dodomaApp.orderPlan.invoiceAmount" value="orderPlan.invoiceAmount"></dod-display-value><dod-display-value ng-if="orderPlan.invoiceDate" label="dodomaApp.orderPlan.invoiceDate" value="orderPlan.invoiceDate | justIsoDate"></dod-display-value></div></div></div><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.orderPlan.detail.lines">Lines</div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.orderLine.amount">Amount</th><th translate="dodomaApp.orderLine.startedAmount">StartedAmount</th><th translate="dodomaApp.orderLine.fulfilledAmount">FulfilledAmount</th><th ng-if="viewConfig.showDeliveryNotes" translate="dodomaApp.orderLine.backReportedAmount">To Stock</th><th translate="dodomaApp.orderLine.part">part</th><th></th></tr></thead><tbody><tr ng-repeat="orderLineItem in orderPlan.orderLines"><td><button type="submit" ng-click="deleteItem(orderLineItem.id)" ng-if="viewConfig.liveMode" class="btn btn-danger"><i class="far fa-times-circle"></i></button></td><td>{{orderLineItem.amount}}</td><td>{{orderLineItem.startedAmount}}</td><td>{{orderLineItem.fulfilledAmount}}</td><td ng-if="viewConfig.showDeliveryNotes">{{orderLineItem.backReportedAmount}}</td><td><span ng-if="!orderLineItem.virtualPart"><part-link part="orderLineItem.part" variant="orderLineItem.variant"></part-link></span><span ng-if="orderLineItem.virtualPart">{{orderLineItem.part.name}}</span><div ng-if="orderLineItem.partState !== \'OK\'" class="label label-danger"><strong translate="{{ \'dodomaApp.orderLine.status.\'+orderLineItem.partState }}"></strong></div></td><td><button type="submit" ui-sref=".lineEditItem({itemId:orderLineItem.id})" ng-if="viewConfig.liveMode" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td></tr><tr><td colspan="6"><button type="submit" class="btn btn-default" ui-sref=".lineNewItem" ng-if="viewConfig.liveMode"><i class="fas fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.orderLine.home.createLabel">Create a new orderLine</span></button></td></tr></tbody></table></div></div></uib-tab><uib-tab heading="{{ \'dodomaApp.orderPlan.detail.requiredWork\' | translate  }}" index="\'requiredWork\'"><div class="panel panel-info"><div class="panel-heading" translate="dodomaApp.orderPlan.detail.requiredWork">Required work</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.orderLine.amount">Amount</th><th translate="dodomaApp.orderLine.plannedAmount">PlannedAmount</th><th translate="dodomaApp.orderLine.startedAmount">StartedAmount</th><th translate="dodomaApp.orderLine.fulfilledAmount">FulfilledAmount</th><th translate="dodomaApp.workStep.name">WorkStepName</th><th translate="dodomaApp.workStep.price">Price</th><th translate="dodomaApp.orderPlan.allPrice">AllPrice</th><th translate="dodomaApp.workStep.standardTime">StandardTime</th><th translate="dodomaApp.orderPlan.allTime">AllTime</th></tr></thead><tbody><tr ng-repeat="item in orderPlanManager.requiredWorks"><td>{{item.line.amount}}</td><td>{{item.work.plannedAmount}}</td><td>{{item.work.startedAmount}}</td><td>{{item.work.fulfilledAmount}}</td><td><a ui-sref="worker({workstepId:item.work.workstepId})">{{item.work.name}} ({{item.work.externalName}})</a> (<work-type-link work-type="item.work.workType"></work-type-link>)</td><td>{{item.work.price}}</td><td>{{item.work.price * item.line.amount}}</td><td>{{item.work.standardTime | timeFormat}}</td><td>{{(item.work.standardTime * (item.line.amount - item.work.startedAmount - item.work.fulfilledAmount)) | timeFormat }}</td></tr></tbody></table></div></div></uib-tab><uib-tab heading="{{ \'dodomaApp.orderPlan.detail.partRequirement\' | translate  }}" index="\'partRequirement\'"><div class="panel panel-info"><div class="panel-heading" translate="dodomaApp.orderPlan.detail.partRequirement">partRequirement</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.orderLine.part">Part</th><th translate="dodomaApp.orderLine.amount">Amount</th><th translate="dodomaApp.orderLine.startedAmount">StartedAmount</th><th translate="dodomaApp.orderLine.fulfilledAmount">FulfilledAmount</th><th translate="dodomaApp.orderPlan.requiredAmount">Required Amount</th></tr></thead><tbody><tr ng-repeat="item in orderPlanManager.requiredParts"><td><part-link part="item.part"></part-link></td><td>{{item.amount}}</td><td>{{item.startedAmount}}</td><td>{{item.fulfilledAmount}}</td><td>{{item.amount - item.startedAmount - item.fulfilledAmount}}</td></tr></tbody></table></div></div></uib-tab><uib-tab heading="{{ \'dodomaApp.orderPlan.detail.priceCalculation\' | translate}}" ng-if="showPriceCalculation()" index="\'priceCalculation\'"><price-calculation-display price-calculation="orderPlan.priceCalculation" extended="false"></price-calculation-display></uib-tab><uib-tab heading="{{ \'dodomaApp.orderPlan.detail.postCalculation\' | translate}}" ng-if="showPostCalculation()" index="\'postCalculation\'"><price-calculation-display price-calculation="orderPlan.postCalculation" extended="true"></price-calculation-display></uib-tab><uib-tab ng-if="viewConfig.orderMode" index="\'productionSheets\'"><uib-tab-heading><i class="fas fa-address-card"></i>&nbsp;<span translate="dodomaApp.orderPlan.detail.productionSheets"></span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.orderPlan.detail.productionSheets">productionSheets</div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.productionSheet.executionDate">executionDate</th><th translate="dodomaApp.productionSheet.state">StartedAmount</th><th></th></tr></thead><tbody><tr ng-repeat="ps in productionSheets"><td><button type="submit" ng-if="ps.state == \'PLANNING\' && viewConfig.liveMode" ng-click="deleteSheet(ps.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.delete">Delete</span></button></td><td><a href="" ng-click="editSheet(ps)">{{ps.executionDate}}</a></td><td><a href="" ng-click="editSheet(ps)">{{ps.state | productionSheetState}}</a></td><td><button type="submit" ng-click="editSheet(ps)" class="btn btn-default"><span class="fas fa-tasks"></span>&nbsp;<span translate="dodomaApp.productionSheet.action.details"> Details</span></button> <button type="submit" ng-if="ps.state == \'PLANNING\' && viewConfig.liveMode" ui-sref=".productionSheetEdit({sheetId:ps.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.editDate"> Edit</span></button> <button type="submit" ng-if="ps.state == \'PLANNING\' && viewConfig.liveMode" ng-click="startSheet(ps.id)" class="btn btn-default"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.start"> Start</span></button> <button type="submit" ng-if="ps.state == \'EXECUTING\' && viewConfig.liveMode" ng-click="finishSheet(ps.id)" class="btn btn-default"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.finish"> Finish</span></button> <button type="submit" ng-if="ps.state == \'EXECUTING\' && viewConfig.liveMode" ng-click="revertStartSheet(ps.id)" class="btn btn-danger"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.revertStart"> revertStart</span></button></td></tr><tr><td colspan="4"><button type="submit" class="btn btn-default" ui-sref=".productionSheetNew" ng-if="viewConfig.liveMode"><i class="fas fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.productionSheet.home.createLabel">New</span></button><download-button url="\'/api/productionSheets/excel.xls?format=xls&orderPlanId=\'+orderPlan.id" label="dodomaApp.productionSheet.action.download"></download-button></td></tr></tbody></table><dodoma-navigation page-info="productionSheetsPage" callback-fn="loadProductionSheets(page)"></dodoma-navigation></div></div></uib-tab><uib-tab ng-repeat="tab in orderPlanManager.editedSheets" index="tab.id" ng-if="viewConfig.orderMode"><uib-tab-heading><i class="fas fa-address-card"></i>&nbsp;{{tab.executionDate}}</uib-tab-heading><div class="panel panel-info" ng-if="(tab.obj.state == \'PLANNING\' || tab.obj.state == \'EXECUTING\') && viewConfig.liveMode"><div class="panel-body"><button type="submit" ng-if="tab.obj.state == \'PLANNING\' && viewConfig.liveMode" ng-click="startSheet(tab.obj.id)" ng-disabled="tab.obj.items.length === 0" class="btn btn-default"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.start"> Start</span></button> <button type="submit" ng-if="tab.obj.state == \'PLANNING\' && viewConfig.liveMode" ng-click="autoFillSheet(tab.obj.id)" class="btn btn-default"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.autoFill">Autofill</span></button> <button type="submit" ng-if="tab.obj.state == \'EXECUTING\' && viewConfig.liveMode" ng-click="finishSheet(tab.obj.id)" class="btn btn-default"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.finish"> Finish</span></button> <button type="submit" ng-if="tab.obj.state == \'EXECUTING\' && viewConfig.liveMode" ng-click="revertStartSheet(tab.obj.id)" class="btn btn-danger"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.revertStart"> revertStart</span></button> <button type="submit" ng-if="tab.obj.state == \'PLANNING\'  && viewConfig.liveMode" ui-sref=".newProductionSheetItem({sheetId:tab.obj.id})" class="btn btn-default"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.productionSheetItem.home.createLabel">Create a new ProductionSheetItem</span></button></div></div><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.orderPlan.detail.editedSheet">editedSheet</div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.productionSheetItem.amount">Amount</th><th translate="dodomaApp.productionSheetItem.finishedAmount">FinishedAmount</th><th translate="dodomaApp.productionSheetItem.worker">worker</th><th translate="dodomaApp.productionSheetItem.orderLineWork">orderLineWork</th><th translate="dodomaApp.workStep.standardTime">StandardTime</th><th translate="dodomaApp.productionSheetItem.allTime">AllTime</th><th translate="dodomaApp.productionSheetItem.timeSpent">TimeSpent</th><th></th><th></th></tr></thead><tbody><tr ng-repeat="productionSheetItem in tab.obj.items"><td><button type="submit" ng-if="tab.obj.state == \'PLANNING\' && viewConfig.liveMode && productionSheetItemEditable(productionSheetItem)" ng-click="deleteProductionSheetItem(tab.obj.id, productionSheetItem.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td><td>{{productionSheetItem.amount}}</td><td>{{productionSheetItem.finishedAmount}}</td><td><worker-link worker="productionSheetItem.worker"></worker-link></td><td><a ui-sref="worker({workstepId:productionSheetItem.orderLineWork.workstepId})">{{productionSheetItem.orderLineWork.name}} ({{productionSheetItem.orderLineWork.externalName}})</a></td><td>{{orderPlanManager.getStandardTime(productionSheetItem) | timeFormat}}</td><td>{{(orderPlanManager.getStandardTime(productionSheetItem) * productionSheetItem.amount) | timeFormat}}</td><td>{{productionSheetItem.timeSpent | timeFormat}}</td><td><psiv-table production-sheet-item="productionSheetItem" detailed="true"></psiv-table></td><td><button type="submit" ng-if="tab.obj.state === \'PLANNING\' && viewConfig.liveMode  && productionSheetItemEditable(productionSheetItem)" ui-sref=".editProductionSheetItem({itemId:productionSheetItem.id, sheetId:tab.obj.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-if="tab.obj.state === \'EXECUTING\'" ui-sref=".finishProductionSheetItem({itemId:productionSheetItem.id, sheetId:tab.obj.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="dodomaApp.productionSheet.action.enterFinishAmount"> Finish</span></button><psiv-verify-button ng-if="tab.obj.state !== \'PLANNING\'" production-sheet-item="productionSheetItem"></psiv-verify-button></td></tr><tr ng-if="tab.obj.timeSpent"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{ tab.obj.timeSpent | timeFormat }}</td><td></td><td></td></tr><tr ng-if="tab.obj.state == \'PLANNING\'  && viewConfig.liveMode"><td colspan="8"><button class="btn btn-default" ui-sref=".newProductionSheetItem({sheetId:tab.obj.id})"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.productionSheetItem.home.createLabel">Create a new ProductionSheetItem</span></button></td></tr></tbody></table><download-button url="\'/api/productionSheets/excel.xls?format=xls&sheetId=\'+tab.obj.id" label="dodomaApp.productionSheet.action.download"></download-button></div></div></uib-tab><uib-tab index="\'giveOuts\'" select="switchToGiveOuts()"><uib-tab-heading><i class="fas fa-share"></i>&nbsp;<span translate="dodomaApp.orderPlan.detail.giveouts">GiveOuts</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.giveOut.multiple">GiveOuts</div><give-out-table query="giveOutQuery"></give-out-table><div class="panel-footer"></div></div></uib-tab><uib-tab index="\'deliveryNotes\'" select="switchToDeliveryNotes()"><uib-tab-heading><i class="far fa-paper-plane"></i>&nbsp;<span translate="dodomaApp.orderPlan.detail.deliveryNotes">DeliveryNotes</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.deliveryNote.multiple">Delivery Notes</div><delivery-notes-table panel-class="panel-body" hide-extended="true" entity-list="orderPlan.deliveryNotes"><div class="panel-footer"><button class="btn btn-default" ng-click="createDeliveryNote()" ng-if="viewConfig.deliveryNoteButton && DodomaConfig.sendBackToStock"><span class="far fa-paper-plane"></span>&nbsp;<span translate="dodomaApp.orderPlan.action.deliveryNote">create delivery note</span></button></div></delivery-notes-table></div></uib-tab></uib-tabset><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/orderPlan/orderPlan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="OrderPlanUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myOrderPlanLabel" translate="dodomaApp.orderPlan.home.createOrEditLabel">Create or edit a OrderPlan</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.orderPlan.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="orderPlan.name" required ng-maxlength="50"></div><div class="form-group" ng-if="planning"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.orderPlan.deliveryDate" for="field_deliveryDate">DeliveryDate</label> <input bs-datepicker type="text" class="form-control" name="deliveryDate" id="field_deliveryDate" ng-model="orderPlan.deliveryDate"></div><div class="form-group" ng-if="invoicing"><label translate="dodomaApp.orderPlan.invoiceNumber" for="field_invoiceNumber">invoiceNumber</label> <input type="text" class="form-control" name="invoiceNumber" id="field_invoiceNumber" ng-model="orderPlan.invoiceNumber"></div><div class="form-group" ng-if="invoicing"><label translate="dodomaApp.orderPlan.invoiceAmount" for="field_invoiceAmount">invoiceAmount</label> <input type="number" class="form-control" name="invoiceAmount" id="field_invoiceAmount" ng-model="orderPlan.invoiceAmount"></div><div class="form-group" ng-if="invoicing"><label translate="dodomaApp.orderPlan.invoiceDate" for="field_invoiceDate">invoiceDate</label> <input bs-datepicker type="text" class="form-control" name="invoiceDate" id="field_invoiceDate" ng-model="orderPlan.invoiceDate"></div><div class="form-group" ng-if="planning"><label translate="dodomaApp.orderPlan.client" for="field_client">client</label><ui-select ng-model="orderPlan.client" dodoma-partner allow-clear name="field_client" required></ui-select><input type="hidden" name="client" ng-model="orderPlan.client"> <button type="button" class="btn btn-info btn-sm" translate="dodomaApp.partner.action.createClient" ui-sref=".newPartner">New client</button></div><div class="form-group" ng-if="planning"><!--  table-responsive makes the autocomplete fields to collapse inside ... --><!--  div class="table-responsive"  --><table class="table table-striped"><thead><th></th><th translate="dodomaApp.orderLine.amount">amount</th><th translate="dodomaApp.orderLine.part">part</th><th translate="dodomaApp.orderLine.productionVariant">variant</th></thead><tbody><tr ng-repeat="orderLineItem in orderPlan.orderLines"><td><button type="button" class="btn btn-default btn-sm" ng-click="removeLine($index)"><i class="fas fa-minus-circle"></i></button></td><td><input type="number" name="orderLineItemAmount{{$index}}" ng-model="orderLineItem.amount" required min="0"></td><td><ui-select ng-model="orderLineItem.part" dodoma-part include-virtual-partner-id="{{orderPlan.client.id}}" on-select="partChanged(orderLineItem, $index)" name="part{{$index}}" required></ui-select><input type="hidden" name="hiddenPart{{$index}}" ng-model="orderLineItem.part.id" required></td><td><span ng-if="orderLineItem.part.canBeBuilt"><ui-select ng-model="orderLineItem.variant" dodoma-production-variant part-id="{{orderLineItem.part.id}}" name="variant{{$index}}" required></ui-select><input type="hidden" name="hiddenVariant{{$index}}" ng-model="orderLineItem.variant.id" required></span></td></tr><tr><td><button type="button" class="btn btn-default btn-sm far fa-plus-circle" ng-click="addNewLine()"></button></td><td></td><td></td><td></td></tr></tbody></table><!-- div --></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || saving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/orderPlan/orderPlans.html','<main-layout title-expression="separateOffers && stateData.offerMode ? \'dodomaApp.offer.home.title\' : \'dodomaApp.orderPlan.home.title\'"><pane-filter><div class="form-group"><label class="control-label" for="planName" translate="dodomaApp.orderPlan.name">plan name</label> <input type="text" class="form-control" name="planName" id="planName" ng-model="filter.name" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="client" translate="dodomaApp.orderPlan.client">Partner</label><ui-select ng-model="customFilter.client" dodoma-partner allow-clear name="client" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="after" translate="dodomaApp.orderPlan.filter.after">StartDate</label> <input bs-datepicker data-max-date="{{filter.before}}" type="text" class="form-control" name="after" id="after" ng-model="filter.after" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="before" translate="dodomaApp.orderPlan.filter.before">EndDate</label> <input bs-datepicker data-min-date="{{filter.after}}" type="text" class="form-control" name="before" id="before" ng-model="filter.before" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="creator" translate="dodomaApp.orderPlan.creator">Creator</label><ui-select ng-model="customFilter.creator" dodoma-user-field allow-clear name="creator" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="createdAfter" translate="dodomaApp.orderPlan.filter.createdAfter">created after</label> <input bs-datepicker data-max-date="{{filter.createdBefore}}" type="text" class="form-control" name="createdAfter" id="createdAfter" ng-model="filter.createdAfter" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="createdBefore" translate="dodomaApp.orderPlan.filter.createdBefore">createdBefore</label> <input bs-datepicker data-min-date="{{filter.createdAfter}}" type="text" class="form-control" name="createdBefore" id="createdBefore" ng-model="filter.createdBefore" ng-change="loadAll()"></div><div class="form-group" ng-if="stateData.offerMode"><label class="control-label" for="status" translate="dodomaApp.orderPlan.filter.status">Status</label> <select class="form-control" name="status" id="status" ng-model="filter.status" ng-change="loadAll()"><option value="" translate="dodomaApp.orderPlan.stateLabel.ALL">All</option><option value="OFFER" translate="dodomaApp.orderPlan.stateLabel.OFFER">OFFER</option><option value="CANCELLED" translate="dodomaApp.orderPlan.stateLabel.CANCELLED">CANCELLED</option></select></div><div class="form-group" ng-if="!stateData.offerMode"><label class="control-label" for="status" translate="dodomaApp.orderPlan.filter.status">Status</label> <select class="form-control" name="status" id="status" ng-model="filter.status" ng-change="loadAll()"><option value="" translate="dodomaApp.orderPlan.stateLabel.ALL">All</option><option ng-if="!separateOffers" value="OFFER" translate="dodomaApp.orderPlan.stateLabel.OFFER">OFFER</option><option ng-if="!separateOffers" value="CANCELLED" translate="dodomaApp.orderPlan.stateLabel.CANCELLED">CANCELLED</option><option value="PLANNING" translate="dodomaApp.orderPlan.stateLabel.PLANNING">PLANNING</option><option value="EXECUTING" translate="dodomaApp.orderPlan.stateLabel.EXECUTING">EXECUTING</option><option value="FINISHED" translate="dodomaApp.orderPlan.stateLabel.FINISHED">FINISHED</option><option value="INVOICED" translate="dodomaApp.orderPlan.stateLabel.INVOICED">INVOICED</option><option value="PAYED" translate="dodomaApp.orderPlan.stateLabel.PAYED">PAYED</option></select></div><div class="form-group"><label class="control-label" for="part" translate="dodomaApp.orderPlan.filter.part">Part</label><ui-select ng-model="customFilter.part" dodoma-part allow-clear name="part" on-select="loadAll()" on-clear="loadAll()"></ui-select></div></pane-filter><pane-main><button class="btn btn-primary" ng-if="separateOffers && !stateData.offerMode" ui-sref="offer"><i class="fas fa-chess-rook"></i> <span translate="global.menu.entities.offer">Offers</span></button> <button class="btn btn-primary" ng-if="separateOffers && stateData.offerMode" ui-sref="orderPlan"><i class="fas fa-chess-rook"></i> <span translate="global.menu.entities.orderPlan">Offers</span></button> <button class="btn btn-primary" ui-sref="worker"><span class="fas fa-male"></span> <span translate="global.menu.entities.worker">Worker</span></button> <button class="btn btn-primary" ng-if="stateData.offerMode && separateOffers" ui-sref="offer.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.offer.home.createLabel">Create a new OrderPlan</span></button> <button class="btn btn-primary" ng-if="!separateOffers" ui-sref=".new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.offer.home.createLabel">Create a new OrderPlan</span></button><div class="modal fade" id="deleteOrderPlanConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(orderPlan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><error-display></error-display><p translate="dodomaApp.orderPlan.delete.question" translate-values="{name:orderPlan.name}">Are you sure you want to delete OrderPlan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.orderPlan.name">Name</th><th translate="dodomaApp.orderPlan.state">State</th><th translate="dodomaApp.orderPlan.deliveryDate">DeliveryDate</th><th translate="dodomaApp.orderPlan.creationDate">creationDate</th><th translate="dodomaApp.orderPlan.client">client</th><th translate="global.field.creator">creator</th><th></th></tr></thead><tbody><tr ng-repeat="orderPlan in orderPlans"><td><a ui-sref=".detail({orderId:orderPlan.id})">{{orderPlan.name}}</a></td><td><span class="{{stateLabel(orderPlan)}}">{{orderPlan.state | orderPlanState}}</span></td><td><a ui-sref=".detail({orderId:orderPlan.id})">{{orderPlan.deliveryDate }}</a></td><td><a ui-sref=".detail({orderId:orderPlan.id})">{{orderPlan.creationDate | dodTime}}</a></td><td><partner-link partner="orderPlan.client"></partner-link></td><td>{{orderPlan.creator.name}}</td><td><button type="submit" ui-sref=".detail({orderId:orderPlan.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button ng-if="orderPlan.editable" type="submit" ui-sref=".detail.edit({orderId:orderPlan.id})" class="btn btn-warning btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button ng-if="orderPlan.deletable || isAdmin" type="submit" ng-click="delete(orderPlan.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/orderPlan/orderPlansTable.html','<div class="{{ panelClass }}"><table class="table"><thead><tr><th translate="dodomaApp.orderPlan.name">Name</th><th translate="dodomaApp.orderPlan.state">State</th><th translate="dodomaApp.orderPlan.deliveryDate">DeliveryDate</th><th translate="dodomaApp.orderPlan.creationDate">creationDate</th><th translate="dodomaApp.orderPlan.client">client</th><th translate="global.field.creator">creator</th><th></th></tr></thead><tbody><tr ng-repeat="orderPlan in entities"><td><a ui-sref="orderPlan.detail({orderId:orderPlan.id})">{{orderPlan.name}}</a></td><td><span class="{{stateLabel(orderPlan)}}">{{orderPlan.state | orderPlanState}}</span></td><td><a ui-sref="orderPlan.detail({orderId:orderPlan.id})">{{orderPlan.deliveryDate }}</a></td><td><a ui-sref="orderPlan.detail({orderId:orderPlan.id})">{{orderPlan.creationDate | dodTime}}</a></td><td><partner-link partner="orderPlan.client"></partner-link></td><td>{{orderPlan.creator.name}}</td><td><button type="submit" ui-sref="orderPlan.detail({orderId:orderPlan.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button ng-if="orderPlan.editable" type="submit" ui-sref="orderPlan.detail.edit({orderId:orderPlan.id})" class="btn btn-warning btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td></tr></tbody></table><dodoma-navigation page-info="result" callback-fn="loadEntities(page)"></dodoma-navigation></div>');
$templateCache.put('scripts/app/entities/part/part-detail.html','<div><h2>{{part.name}} <span ng-if="part.serialNumber">({{part.serialNumber}})</span></h2><div class="modal fade" id="changeStockPrice"><div class="modal-dialog"><div class="modal-content"><form name="changeStockPrice" ng-submit="executeChangeStockPrice()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="dodomaApp.part.changeStockPrice.title">Change Stock Price</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.part.changeStockPrice.price" for="field_price">Price</label> <input type="number" class="form-control" name="price" id="field_price" ng-model="changePrice.price" required min="0"></div><div class="form-group"><label translate="dodomaApp.part.changeStockPrice.comment" for="field_comment">Comment</label> <textarea class="form-control" name="comment" id="field_comment" ng-model="changePrice.comment" ng-maxlength="512"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="changeStockPrice.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="dodomaApp.part.changeStockPrice.change">Change</span></button></div></form></div></div></div><div class="panel panel-info"><div class="panel-body"><button class="btn btn-primary" has-role="ROLE_STORE_IN_OUT" ui-sref=".giveOutNew({partId:part.id})"><span class="fas fa-share"></span> <span translate="dodomaApp.giveOut.home.createLabel">Create a new GiveOut</span></button> <button class="btn btn-primary" has-role="ROLE_STORE_IN_OUT" ui-sref=".deliveryNoteNew({partId:part.id})"><span class="fas fa-sign-in-alt"></span> <span translate="dodomaApp.deliveryNote.home.createLabel">Create a new DeliveryNote</span></button> <button type="submit" has-role="ROLE_STOREREVIEWER" ui-sref="partDetail.edit({id:part.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" has-role="ROLE_STOREREVIEWER" ng-click="showChangeStockPrice()" class="btn btn-info"><i class="fas fa-piggy-bank"></i>&nbsp;<span translate="dodomaApp.part.changeStockPrice.start"> Edit</span></button></div></div><div uib-alert class="fade-in alert-danger" ng-if="part.status !== \'OK\'"><strong translate="{{ \'dodomaApp.part.status.\'+part.status }}"></strong></div><error-display></error-display><uib-tabset justified="false"><uib-tab><uib-tab-heading><span class="fas fa-cubes"></span>&nbsp;<span translate="dodomaApp.part.detail.general">General</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.part.name" value="part.name"></dod-display-value><dod-display-value label="dodomaApp.part.serialNumber" value="part.serialNumber"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.part.description" value="part.description"></dod-display-value><dod-display-value label="dodomaApp.part.measuringType" value="part.measuringType | measuringType"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.part.canBeBuilt" boolean="part.canBeBuilt"></dod-display-value><dod-display-value label="dodomaApp.part.hasPrice" boolean="part.hasPrice"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.part.active" boolean="part.active"></dod-display-value><dod-display-value label="dodomaApp.part.partType" custom="<part-type-link part-type=\'part.partType\'></part-type-link>"></dod-display-value></div><div class="row" ng-if="part.relatedPartner"><dod-display-value label="dodomaApp.part.relatedPartner" custom="<partner-link partner=\'part.relatedPartner\'></partner-link>"></dod-display-value></div></div></div></uib-tab><uib-tab><uib-tab-heading><i class="fas fa-chess-rook"></i>&nbsp;<span translate="dodomaApp.part.detail.stocks">Stocks</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.part.detail.stocks">Stocks</div><div class="panel-body"><table class="table"><thead><th></th><th translate="dodomaApp.stockLocation.physicalAmount">PhysicalAmount</th><th ng-if="DodomaConfig.showPartReservation" translate="dodomaApp.stockLocation.availableAmount">AvailableAmount</th><th translate="dodomaApp.stockLocation.stock">stock</th><th has-role="ROLE_STORE_PRICES" ng-if="part.hasPrice" translate="dodomaApp.part.values.allValue">all value</th><th></th></thead><tbody><tr ng-repeat="stockLocation in part.stocks"><td><button type="submit" has-role="ROLE_STOREREVIEWER" ng-click="deleteStockLocation(stockLocation.id)" class="btn btn-danger"><i class="far fa-times-circle"></i></button></td><td>{{stockLocation.physicalAmount}}</td><td ng-if="DodomaConfig.showPartReservation">{{stockLocation.availableAmount}}</td><td><stock-link stock="stockLocation.stock"></stock-link></td><td has-role="ROLE_STORE_PRICES" ng-if="part.hasPrice">{{stockLocation.currentValue}}</td><td><button type="submit" has-role="ROLE_STOREREVIEWER" ui-sref="stockLocationRevise({stockLocationId:stockLocation.id})" class="btn btn-danger"><i class="fas fa-bolt"></i> <span translate="dodomaApp.stockLocation.revise">Revise</span></button><!-- \n                            <button type="submit"\n                                    ui-sref="stockLocationEdit({stockLocationId:stockLocation.id})"\n                                    class="btn btn-primary">\n                                <i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span>\n                            </button> --></td></tr><tr has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER"><td colspan="5"><button class="btn btn-default" ui-sref="stockLocationNew"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.stockLocation.home.createLabel">Create a new stock</span></button></td></tr></tbody></table></div></div></uib-tab><uib-tab ng-if="part.canBeBuilt" has-role="ROLE_PRODUCTIONMANAGER"><uib-tab-heading><span class="fas fa-book"></span>&nbsp;<span translate="dodomaApp.part.detail.worksteps">worksteps</span></uib-tab-heading><div class="panel panel-primary" ng-repeat="variant in part.variants"><div class="panel-heading"><span translate="dodomaApp.part.detail.worksteps">WorkSteps</span>&nbsp;-&nbsp;{{variant.name}}<span ng-if="!variant.active">&nbsp;-&nbsp;<span translate="dodomaApp.productionVariant.inactive"></span></span></div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.workStep.name">Name</th><th translate="dodomaApp.workStep.workType">workType</th><th translate="dodomaApp.workStep.externalName">ExternalName</th><th translate="dodomaApp.workStep.standardTime">standardTime</th><th translate="dodomaApp.workStep.price">Price</th><th colspan="2" translate="dodomaApp.workStep.cmd.reordering">Reordering</th><th></th></tr></thead><tbody><tr ng-repeat="workstep in variant.steps" class="workstep-active-{{workstep.active && variant.active}}"><td><button type="submit" ng-if="variant.active" ng-click="deleteWorkStep(variant, workstep.id)" class="btn btn-danger"><i class="far fa-times-circle"></i></button></td><td class="inactive-label"><a ui-sref="worker({workstepId:workstep.id})">{{workstep.name}}</a></td><td><work-type-link work-type="workstep.workType"></work-type-link></td><td>{{workstep.externalName}}</td><td ng-if="workstep.fixStandardTime">{{workstep.standardTime | timeFormat }}</td><td ng-if="!workstep.fixStandardTime" translate="dodomaApp.workStep.noStandardTime">None</td><td>{{workstep.price}}</td><td><button ng-if="!$first && variant.active" type="submit" class="btn" ng-click="changeWorkStepPrio(variant, workstep.id, -1)"><i class="fas fa-arrow-alt-square-up"></i> <span translate="dodomaApp.workStep.cmd.before">Before</span></button></td><td><button ng-if="!$last && variant.active" type="submit" class="btn" ng-click="changeWorkStepPrio(variant, workstep.id, 1)"><i class="fas fa-arrow-alt-square-down"></i> <span translate="dodomaApp.workStep.cmd.after">After</span></button></td><td><button type="submit" ng-if="variant.active" ui-sref=".workStepEdit({variantId: variant.id, workStepId:workstep.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" class="btn btn-warning" ng-click="setWorkStepActive(variant, workstep.id, false)" ng-if="workstep.active && variant.active"><i class="fas fa-toggle-off"></i> <span translate="dodomaApp.workStep.cmd.deactivate">Deactivate</span></button> <button type="submit" class="btn btn-warning" ng-click="setWorkStepActive(variant, workstep.id, true)" ng-if="!workstep.active && variant.active"><i class="far fa-play-circle"></i> <span translate="dodomaApp.workStep.cmd.activate">Activate</span></button></td></tr><tr><td colspan="9"><button ng-if="variant.steps.length > 0 && variant.active" type="submit" class="btn btn-default" ui-sref=".workStepNew({variantId: variant.id})"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.workStep.home.createLabel">Create a new workstep</span></button> <button ng-if="variant.steps.length === 0 && variant.active" type="submit" class="btn btn-default" ui-sref=".workStepNew({name:part.name, externalName:part.serialNumber, variantId: variant.id})"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.workStep.home.createLabel">Create a new workstep</span></button> <button type="submit" class="btn btn-primary" ui-sref=".productionVariantEdit({variantId: variant.id, partId: part.id})"><i class="fas fa-pencil"></i> <span translate="dodomaApp.part.detail.variantEdit">Edit</span></button> <button type="submit" class="btn btn-warning" ui-sref=".productionVariantDuplicate({variantId: variant.id, partId: part.id})"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.productionVariant.home.duplicateLabel">Duplicate</span></button></td></tr></tbody></table></div></div><button type="submit" class="btn btn-default" ui-sref=".productionVariantNew"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.productionVariant.home.createLabel">Create a new variant</span></button></uib-tab><uib-tab ng-if="part.hasPrice" has-role="ROLE_STORE_PRICES"><uib-tab-heading><span class="fas fa-cubes"></span>&nbsp;<span translate="dodomaApp.part.detail.values">Prices</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><table class="table table-striped"><thead><tr><th translate="dodomaApp.part.values.amount">PhysicalAmount</th><th translate="dodomaApp.part.values.itemPrice">Item Price</th><th translate="dodomaApp.part.values.allValue">All value</th><th translate="dodomaApp.stockLocation.stock">stock</th></tr></thead><tbody><tr ng-repeat="partPrice in part.partPrices"><td>{{partPrice.amount}}</td><td>{{partPrice.price}}</td><td>{{partPrice.price * partPrice.amount}}</td><td><stock-link stock="partPrice.stock"></stock-link></td></tr></tbody></table></div></div></uib-tab><uib-tab select="switchToGiveOuts()"><uib-tab-heading><i class="fas fa-share"></i>&nbsp;<span translate="dodomaApp.giveOut.multiple">GiveOuts</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.giveOut.multiple">GiveOuts</div><give-out-table query="giveOutCriteria"></give-out-table><div class="panel-footer"></div></div></uib-tab><uib-tab select="switchToDeliveryNotes()"><uib-tab-heading><span class="far fa-paper-plane"></span>&nbsp;<span translate="dodomaApp.deliveryNote.multiple">Delivery Notes</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.deliveryNote.multiple">Delivery Notes</div><delivery-notes-table panel-class="panel-body" query="deliveryNoteCriteria"></delivery-notes-table><div class="panel-footer"></div></div></uib-tab><uib-tab select="switchToOrderPlans()"><uib-tab-heading><span class="fas fa-suitcase"></span>&nbsp;<span translate="dodomaApp.orderPlan.home.title">Order Plans</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.orderPlan.home.title">Order Plans</div><order-plans-table panel-class="panel-body" query="orderPlansCriteria"></order-plans-table><div class="panel-footer"></div></div></uib-tab><uib-tab select="switchToMovements()"><uib-tab-heading><i class="fas fa-retweet"></i>&nbsp;<span translate="dodomaApp.part.detail.movements">Movements</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.movement.stock">stock</th><th translate="dodomaApp.movement.type">Type</th><th translate="dodomaApp.movement.physicalAmount">PhysicalAmount</th><th ng-if="DodomaConfig.showPartReservation" translate="dodomaApp.movement.availableAmount">AvailableAmount</th><th ng-if="part.hasPrice" has-role="ROLE_STORE_PRICES" translate="dodomaApp.part.values.itemPrice">ItemPrice</th><th ng-if="part.hasPrice" has-role="ROLE_STORE_PRICES" translate="dodomaApp.part.values.allValue">allValue</th><th translate="dodomaApp.movement.createdDate">CreatedDate</th><th translate="dodomaApp.movement.user">User</th><th></th></tr></thead><tbody><tr ng-repeat="movement in movements"><td><stock-link stock="movement.stock"></stock-link></td><td><a ui-sref="movementDetail({id:movement.id})">{{movement.type | movementType}}</a></td><td><a ui-sref="movementDetail({id:movement.id})">{{movement.physicalAmount}} ({{movement.physicalAmountChange}})</a></td><td ng-if="DodomaConfig.showPartReservation">{{movement.availableAmount}} ({{movement.availableAmountChange}})</td><td ng-if="part.hasPrice" has-role="ROLE_STORE_PRICES">{{movement.itemPrice}}</td><td ng-if="part.hasPrice" has-role="ROLE_STORE_PRICES">{{movement.currentValue}}</td><td><a ui-sref="movementDetail({id:movement.id})">{{movement.createdDate | dodTime}}</a></td><td>{{movement.user.name}}</td><td><button type="submit" ui-sref="movementDetail({id:movement.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button></td></tr></tbody></table><dodoma-navigation page-info="movementPageResult" callback-fn="loadMovementPage(page)"></dodoma-navigation></div></div></uib-tab></uib-tabset><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/part/part-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="PartUpdateDTO"><div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myPartLabel" translate="dodomaApp.part.home.createOrEditLabel">Create or edit a Part</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.part.name" for="name">Name</label> <input type="text" class="form-control" name="name" id="name" ng-model="part.name" required ng-maxlength="50"></div><div class="form-group"><label translate="dodomaApp.part.serialNumber" for="serialNumber">SerialNumber</label> <input type="text" class="form-control" name="serialNumber" id="serialNumber" ng-model="part.serialNumber" ng-maxlength="50"></div><div class="form-group"><label translate="dodomaApp.part.description" for="description">Description</label> <textarea class="form-control" name="description" id="description" ng-model="part.description" ng-maxlength="200"></textarea></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.measuringType">MeasuringType</label><measuring-select ng-model="part.measuringType" required name="measuringType"></measuring-select></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.active" for="active">Active</label> <input type="checkbox" class="form-control" name="active" id="active" ng-model="part.active"></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.canBeBuilt" for="canBeBuilt">CanBeBuilt</label> <input type="checkbox" class="form-control" name="canBeBuilt" id="canBeBuilt" ng-model="part.canBeBuilt"></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.hasPrice" for="hasPrice">HasPrice</label> <input type="checkbox" class="form-control" name="hasPrice" id="hasPrice" ng-model="part.hasPrice"></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.relatedPartner">relatedPartner</label><ui-select ng-model="part.relatedPartner" dodoma-partner allow-clear name="relatedPartner"></ui-select></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.partType">partType</label><ui-select ng-model="part.partType" dodoma-part-type allow-clear name="partType"></ui-select></div></div><div class="row" ng-if="part.id === null"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.part.stock">stock</label><ui-select ng-model="part.stock" dodoma-stock allow-clear name="stock"></ui-select></div><div class="col-md-6 col-sm-12" ng-if="hasStock()"><label translate="dodomaApp.part.initialAmount">initialAmount</label> <input type="number" class="form-control" name="initialAmount" id="initialAmount" ng-model="part.initialAmount" min="0"></div></div><div class="row" ng-if="(part.id === null) && hasStock()"><div class="col-md-6 col-sm-12"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.part.initialTime">initialTime</label><div class="form-group"><input bs-datepicker type="text" data-max-date="today" name="initialTime" id="initialTime" ng-model="part.initialTime"> <input bs-timepicker type="text" ng-model="part.initialTime"></div></div><div class="col-md-6 col-sm-12" ng-show="part.hasPrice && hasStock()"><label translate="dodomaApp.part.initialPrice">initialPrice</label> <input type="number" class="form-control" name="initialPrice" id="initialPrice" ng-model="part.initialPrice" min="0"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/part/partTable.html','<div class="panel-body"><table class="table dodoma-table"><thead><tr><th translate="dodomaApp.part.name">Name</th><th translate="dodomaApp.stockLocation.physicalAmount">physicalAmount</th><th translate="dodomaApp.part.measuringType">MeasuringType</th><th translate="dodomaApp.part.stockLocationValue">Value</th><th translate="dodomaApp.part.active">Active</th><th translate="dodomaApp.part.relatedPartner">relatedPartner</th><th translate="dodomaApp.part.partType">partType</th></tr></thead><tbody><tr ng-repeat="part in entities"><td><part-link part="part"></part-link></td><td>{{part.physicalAmount}}</td><td dd-measuring="part.measuringType">XXX</td><td>{{part.value}}</td><td><boolean-icon value="part.active"></boolean-icon></td><td><partner-link partner="part.relatedPartner"></partner-link></td><td><part-type-link part-type="part.partType"></part-type-link></td></tr><tr ng-if="showNewButton"><td colspan="7"><button class="btn btn-default" has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER" ui-sref=".partNew({stockId:stock.id})"><i class="fas fa-bolt"></i> <span translate="dodomaApp.part.home.createLabel">Create a new Part</span></button></td></tr></tbody></table><dodoma-navigation page-info="result" callback-fn="loadEntities(page)"></dodoma-navigation></div>');
$templateCache.put('scripts/app/entities/part/parts.html','<main-layout title-key="dodomaApp.part.home.title"><pane-main><button class="btn btn-primary" has-role="ROLE_STOREMANAGER" ui-sref="part.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.part.home.createLabel">Create a new Part</span></button><download-button url="partExportUrl()" size="btn-lg"></download-button><div class="modal fade" id="deletePartConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(part.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><error-display></error-display><p translate="dodomaApp.part.delete.question" translate-values="{name : part.name, serialNumber: part.serialNumber}">Are you sure you want to delete Part?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed dodoma-table"><thead><tr><th translate="dodomaApp.part.name">Name</th><th translate="dodomaApp.part.serialNumber">SerialNumber</th><th class="desc-col" translate="dodomaApp.part.description">Description</th><th translate="dodomaApp.stockLocation.physicalAmount">physicalAmount</th><th translate="dodomaApp.part.measuringType">MeasuringType</th><th translate="dodomaApp.part.stockLocationValue">Value</th><th translate="dodomaApp.part.active">Active</th><th translate="dodomaApp.part.hasPrice">HasPrice</th><th translate="dodomaApp.part.relatedPartner">relatedPartner</th><th translate="dodomaApp.part.partType">partType</th><th></th></tr></thead><tbody><tr ng-repeat="part in parts"><td><a ui-sref="partDetail({partId:part.id})">{{part.name}}</a></td><td><a ui-sref="partDetail({partId:part.id})">{{part.serialNumber}}</a></td><td class="desc-col">{{part.description | words:20}}</td><td>{{part.physicalAmount}}</td><td dd-measuring="part.measuringType">XXX</td><td>{{part.value}}</td><td><boolean-icon value="part.active"></boolean-icon></td><td><boolean-icon value="part.hasPrice"></boolean-icon></td><td><partner-link partner="part.relatedPartner"></partner-link></td><td><part-type-link part-type="part.partType"></part-type-link></td><td><button type="submit" ui-sref="partDetail({partId:part.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" has-role="ROLE_STOREREVIEWER" ui-sref="partDetail.edit({partId:part.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" has-role="ROLE_STOREREVIEWER" ng-click="delete(part.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main><pane-filter><div class="form-horizontal"><div class="form-group"><label class="control-label" for="part" translate="dodomaApp.part.filter.name">Part</label> <input type="text" class="form-control" name="part" id="part" ng-model="filter.name" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="partType" translate="dodomaApp.part.filter.partType">Part type</label><ui-select ng-model="customFilter.partType" dodoma-part-type allow-clear name="partType" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="partner" translate="dodomaApp.part.filter.partner">Partner</label><ui-select ng-model="customFilter.partner" dodoma-partner allow-clear name="partner" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" translate="dodomaApp.part.filter.stock" for="stock">stock</label><ui-select ng-model="customFilter.stock" dodoma-stock allow-clear name="stock" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="includeInactive" translate="dodomaApp.part.filter.includeInactive">IncludeInactive</label> <input type="checkbox" id="includeInactive" value="true" name="includeInactive" ng-model="filter.includeInactive" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="showProductionProblems" translate="dodomaApp.part.filter.showProductionProblems">showProductionProblems</label> <input type="checkbox" id="includeInactive" value="true" name="showProductionProblems" ng-model="filter.showProductionProblems" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="isCanBeBuilt" translate="dodomaApp.part.filter.isCanBeBuilt">isCanBeBuilt</label> <input type="checkbox" id="isCanBeBuilt" value="true" name="isCanBeBuilt" ng-model="filter.isCanBeBuilt" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="hasPriceOn" translate="dodomaApp.part.filter.hasPriceOn">hasPriceOn</label> <input type="checkbox" id="hasPriceOn" value="true" name="hasPriceOn" ng-model="filter.hasPriceOn" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="isOnStock" translate="dodomaApp.part.filter.isOnStock">isOnStock</label> <input type="checkbox" id="isOnStock" value="true" name="isOnStock" ng-model="filter.isOnStock" ng-change="loadAll()"></div></div></pane-filter></main-layout>');
$templateCache.put('scripts/app/entities/partType/partType-detail.html','<div><h2>{{partType.name}}</h2><h4 translate="dodomaApp.partType.detail.title">PartType</h4><button type="submit" has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER" ui-sref="partTypeDetail.edit({id:partType.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.partType.name">Name</span></td><td><input type="text" class="input-sm form-control" value="{{partType.name}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.partType.description">Description</span></td><td><input type="text" class="input-sm form-control" value="{{partType.description}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.partType.active">Active</span></td><td><input type="text" class="input-sm form-control" value="{{partType.active}}" readonly="readonly"></td></tr></tbody></table></div><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/partType/partType-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="PartTypeUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myPartTypeLabel" translate="dodomaApp.partType.home.createOrEditLabel">Create or edit a PartType</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.partType.name">Name</label> <input type="text" class="form-control" name="name" ng-model="partType.name" required ng-maxlength="50"></div><div class="form-group"><label translate="dodomaApp.partType.description">Description</label> <textarea class="form-control" name="description" ng-model="partType.description" ng-maxlength="200">\n                    </textarea></div><div class="form-group"><label translate="dodomaApp.partType.active">Active</label> <input type="checkbox" class="form-control" name="active" ng-model="partType.active"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/partType/partTypes.html','<div><h2 translate="dodomaApp.partType.home.title">PartType</h2><button class="btn btn-primary" has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER" ui-sref="partType.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.partType.home.createLabel">Create a new PartType</span></button><div class="modal fade" id="deletePartTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(partType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.partType.delete.question" translate-values="partType">Are you sure you want to delete PartType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th>ID</th><th translate="dodomaApp.partType.name">Name</th><th translate="dodomaApp.partType.description">Description</th><th translate="dodomaApp.partType.active">Active</th><th></th></tr></thead><tbody><tr ng-repeat="partType in partTypes"><td><a ui-sref="partTypeDetail({id:partType.id})">{{partType.id}}</a></td><td>{{partType.name}}</td><td>{{partType.description}}</td><td><boolean-icon value="partType.active"></boolean-icon></td><td><button type="submit" ui-sref="partTypeDetail({id:partType.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER" ui-sref="partTypeDetail.edit({id:partType.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER" ng-click="delete(partType.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a>&lt;</a></li><li ng-show="page > 2" ng-click="loadPage(page - 2)"><a>{{page - 2}}</a></li><li ng-show="page > 1" ng-click="loadPage(page - 1)"><a>{{page - 1}}</a></li><li class="active"><a>{{page}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 2}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('scripts/app/entities/partner/partner-detail.html','<div><h2>{{partner.name}} ({{partner.description}})</h2><h4 translate="dodomaApp.partner.detail.title">Partner</h4><uib-tabset justified="false"><uib-tab><uib-tab-heading><span class="far fa-credit-card"></span>&nbsp;<span translate="dodomaApp.partner.detail.general">General</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.partner.name" value="partner.name"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.partner.address" value="partner.address"></dod-display-value><dod-display-value label="dodomaApp.partner.phone" value="partner.phone"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.partner.email" value="partner.email"></dod-display-value><dod-display-value label="dodomaApp.partner.taxNumber" value="partner.taxNumber"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.partner.customStock" boolean="partner.customStock"></dod-display-value><dod-display-value label="dodomaApp.partner.active" boolean="partner.active"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.partner.description" value="partner.description"></dod-display-value></div><div class="row"><div class="col-md-4"><button type="submit" ui-sref="partnerDetail.edit({id:partner.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></div></div></div></div></uib-tab><uib-tab select="switchToParts()"><uib-tab-heading><i class="fas fa-cubes"></i>&nbsp;<span translate="dodomaApp.part.detail.title">Parts</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.part.detail.title">Parts</div><part-table query="partCriteria" state="partTabState"></part-table><div class="panel-footer"></div></div></uib-tab><uib-tab select="switchToOrderPlans()"><uib-tab-heading><span class="fas fa-suitcase"></span>&nbsp;<span translate="dodomaApp.partner.detail.orders">Orders</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.partner.detail.orders">Orders</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.orderPlan.name">Name</th><th translate="dodomaApp.orderPlan.state">State</th><th translate="dodomaApp.orderPlan.deliveryDate">DeliveryDate</th><th translate="global.field.creator">creator</th><th></th></tr></thead><tbody><tr ng-repeat="orderPlan in orderPlans"><td><a ui-sref="orderPlan.detail({orderId:orderPlan.id})">{{orderPlan.name}}</a></td><td>{{orderPlan.state | orderPlanState}}</td><td><a ui-sref="orderPlan.detail({orderId:orderPlan.id})">{{orderPlan.deliveryDate}}</a></td><td>{{orderPlan.creator.name}}</td><td></td></tr><tr><td colspan="6"><button type="submit" class="btn btn-default" ui-sref="offer.new({partnerId:partner.id})"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.offer.home.createLabel">Create a new orderplan</span></button></td></tr></tbody></table><dodoma-navigation page-info="orderPlansResult" callback-fn="loadOrderPlans(page)"></dodoma-navigation></div></div></uib-tab><uib-tab select="switchToWorkSteps()"><uib-tab-heading><span translate="dodomaApp.partner.detail.workSteps">Worksteps</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.partner.detail.workSteps">WorkSteps</div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.workStep.name">Name</th><th translate="dodomaApp.workStep.workType">workType</th><th translate="dodomaApp.workStep.externalName">ExternalName</th><th translate="dodomaApp.workStep.standardTime">standardTime</th><th translate="dodomaApp.workStep.price">Price</th><th></th></tr></thead><tbody><tr ng-repeat="workstep in workSteps"><td></td><td>{{workstep.name}}</td><td><work-type-link work-type="workstep.workType"></work-type-link></td><td>{{workstep.externalName}}</td><td>{{workstep.standardTime | timeFormat }}</td><td>{{workstep.price}}</td><td><button type="submit" ui-sref=".workStepEdit({workStepId:workstep.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td></tr><tr><td colspan="7"><button type="submit" class="btn btn-default" ui-sref=".workStepNew"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.workStep.home.createLabel">Create a new workStep</span></button></td></tr></tbody></table><dodoma-navigation page-info="workStepsResult" callback-fn="loadWorkSteps(page)"></dodoma-navigation></div></div></uib-tab><uib-tab index="\'giveOuts\'" select="switchToGiveOuts()"><uib-tab-heading><i class="fas fa-share"></i>&nbsp;<span translate="dodomaApp.giveOut.multiple">GiveOuts</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.giveOut.multiple">GiveOuts</div><give-out-table query="giveOutCriteria"></give-out-table><div class="panel-footer"></div></div></uib-tab><uib-tab index="\'deliveryNotes\'" select="switchToDeliveryNotes()"><uib-tab-heading><span class="far fa-paper-plane"></span>&nbsp;<span translate="dodomaApp.deliveryNote.multiple">Delivery Notes</span></uib-tab-heading><div class="panel panel-info"><div class="panel-heading" translate="dodomaApp.deliveryNote.multiple">Delivery Notes</div><delivery-notes-table panel-class="panel-body" query="deliveryNoteCriteria"></delivery-notes-table><div class="panel-footer"></div></div></uib-tab></uib-tabset><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/partner/partner-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="PartnerUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myPartnerLabel" translate="dodomaApp.partner.home.createOrEditLabel">Create or edit a Partner</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.partner.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="partner.name"></div><div class="form-group"><label translate="dodomaApp.partner.description" for="field_description">Description</label> <textarea class="form-control" name="description" id="field_description" ng-model="partner.description"></textarea></div><div class="form-group"><label translate="dodomaApp.partner.address" for="field_address">Address</label> <input type="text" class="form-control" name="address" id="field_address" ng-model="partner.address"></div><div class="form-group"><label translate="dodomaApp.partner.phone" for="field_phone">Phone</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="partner.phone"></div><div class="form-group"><label translate="dodomaApp.partner.email" for="field_email">Email</label> <input type="text" class="form-control" name="email" id="field_email" ng-model="partner.email"></div><div class="form-group"><label translate="dodomaApp.partner.taxNumber" for="field_taxNumber">taxNumber</label> <input type="text" class="form-control" name="taxNumber" id="field_taxNumber" ng-model="partner.taxNumber"></div><div class="form-group"><label translate="dodomaApp.partner.customStock" for="field_customStock">CustomStock</label> <input type="checkbox" class="form-control" name="customStock" id="field_customStock" ng-model="partner.customStock"></div><div class="form-group"><label translate="dodomaApp.partner.active" for="field_active">Active</label> <input type="checkbox" class="form-control" name="active" id="field_active" ng-model="partner.active"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/partner/partners.html','<main-layout title-key="dodomaApp.partner.home.title"><pane-main><button class="btn btn-primary" ui-sref="partner.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.partner.home.createLabel">Create a new Partner</span></button><div class="modal fade" id="deletePartnerConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(partner.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><error-display></error-display><p translate="dodomaApp.partner.delete.question" translate-values="{name: partner.name, id:partner.id}">Are you sure you want to delete Partner {{partner.id}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.partner.name">Name</th><th translate="dodomaApp.partner.description">Description</th><th translate="dodomaApp.partner.address">Address</th><th translate="dodomaApp.partner.phone">Phone</th><th translate="dodomaApp.partner.email">Email</th><th translate="dodomaApp.partner.customStock">CustomStock</th><th translate="dodomaApp.partner.active">Active</th><th></th></tr></thead><tbody><tr ng-repeat="partner in partners"><td><partner-link partner="partner"></partner-link></td><td>{{partner.description}}</td><td>{{partner.address}}</td><td>{{partner.phone}}</td><td>{{partner.email}}</td><td><boolean-icon value="partner.customStock"></boolean-icon></td><td><boolean-icon value="partner.active"></boolean-icon></td><td><button type="submit" ui-sref="partnerDetail({partnerId:partner.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="partnerDetail.edit({partnerId:partner.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(partner.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main><pane-filter><div class="form-horizontal"><div class="form-group"><label class="control-label" for="partnerName" translate="dodomaApp.partner.name">Part</label> <input type="text" class="form-control" name="partnerName" id="partnerName" ng-model="filter.name" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="includeInactive" translate="dodomaApp.part.filter.includeInactive">IncludeInactive</label> <input type="checkbox" id="includeInactive" value="true" name="includeInactive" ng-model="filter.includeInactive" ng-change="loadAll()"></div></div></pane-filter></main-layout>');
$templateCache.put('scripts/app/entities/priceCalculation/priceCalculation-detail.html','<div><h2><span translate="dodomaApp.priceCalculation.detail.title">PriceCalculation</span> {{priceCalculation.id}}</h2><button type="submit" ui-sref="priceCalculationDetail.edit({id:priceCalculation.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.priceCalculation.workNeed">WorkNeed</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.workNeed}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.workTime">WorkTime</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.workTime}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.machineCost">MachineCost</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.machineCost}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.maintenanceFee">MaintenanceFee</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.maintenanceFee}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.shippingFee">ShippingFee</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.shippingFee}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.otherFee">OtherFee</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.otherFee}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.totalFee">TotalFee</span></td><td><input type="text" class="input-sm form-control" value="{{priceCalculation.totalFee}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.priceCalculation.comment">Comment</span></td><td><textarea class="input-sm form-control" value="{{priceCalculation.comment}}" readonly="readonly"></textarea></td></tr></tbody></table></div><button type="submit" ui-sref="priceCalculation" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/priceCalculation/priceCalculation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="PriceCalculationUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myPriceCalculationLabel" translate="dodomaApp.priceCalculation.home.createOrEditLabel">Create or edit a PriceCalculation</h4></div><div class="modal-body"><div class="form-group"><label translate="dodomaApp.priceCalculation.workTime" for="field_workTime">WorkTime</label> <input type="number" class="form-control" name="workTime" id="field_workTime" ng-model="priceCalculation.workTime" min="0" readonly="readonly"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.workNeed" for="field_workNeed">WorkNeed</label> <input type="number" class="form-control" name="workNeed" id="field_workNeed" ng-model="priceCalculation.workNeed" min="0" readonly="readonly"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.machineCost" for="field_machineCost">MachineCost</label> <input type="number" class="form-control" name="machineCost" id="field_machineCost" ng-model="priceCalculation.machineCost" min="0" ng-change="sumUp()"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.maintenanceFee" for="field_maintenanceFee">MaintenanceFee</label> <input type="number" class="form-control" name="maintenanceFee" id="field_maintenanceFee" ng-model="priceCalculation.maintenanceFee" min="0" ng-change="sumUp()"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.shippingFee" for="field_shippingFee">ShippingFee</label> <input type="number" class="form-control" name="shippingFee" id="field_shippingFee" ng-model="priceCalculation.shippingFee" min="0" ng-change="sumUp()"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.otherFee" for="field_otherFee">OtherFee</label> <input type="number" class="form-control" name="otherFee" id="field_otherFee" ng-model="priceCalculation.otherFee" min="0" ng-change="sumUp()"></div><div class="form-group" ng-if="mode === \'POST\'"><label translate="dodomaApp.priceCalculation.storageFee" for="field_storageFee">storageFee</label> <input type="number" class="form-control" name="storageFee" id="field_storageFee" ng-model="priceCalculation.storageFee" min="0" ng-change="sumUp()"></div><div class="form-group" ng-if="mode === \'POST\'"><label translate="dodomaApp.priceCalculation.accountingFee" for="field_accountingFee">accountingFee</label> <input type="number" class="form-control" name="accountingFee" id="field_accountingFee" ng-model="priceCalculation.accountingFee" min="0" ng-change="sumUp()"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.totalFee" for="field_totalFee">TotalFee</label> <input type="number" class="form-control" name="totalFee" id="field_totalFee" ng-model="priceCalculation.totalFee" min="0" readonly="readonly"></div><div class="form-group"><label translate="dodomaApp.priceCalculation.comment" for="field_comment">Comment</label> <textarea class="form-control" name="comment" id="field_comment" ng-model="priceCalculation.comment" ng-maxlength="500"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/priceCalculation/priceCalculation.display.html','<div class="panel panel-info"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.priceCalculation.workNeed" value="priceCalculation.workNeed"></dod-display-value><dod-display-value label="dodomaApp.priceCalculation.workTime" value="priceCalculation.workTime"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.priceCalculation.machineCost" value="priceCalculation.machineCost"></dod-display-value><dod-display-value label="dodomaApp.priceCalculation.maintenanceFee" value="priceCalculation.maintenanceFee"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.priceCalculation.shippingFee" value="priceCalculation.shippingFee"></dod-display-value><dod-display-value label="dodomaApp.priceCalculation.otherFee" value="priceCalculation.otherFee"></dod-display-value></div><div class="row" ng-if="extended"><dod-display-value label="dodomaApp.priceCalculation.storageFee" value="priceCalculation.storageFee"></dod-display-value><dod-display-value label="dodomaApp.priceCalculation.accountingFee" value="priceCalculation.accountingFee"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.priceCalculation.totalFee" value="priceCalculation.totalFee"></dod-display-value><dod-display-value label="dodomaApp.priceCalculation.comment" value="priceCalculation.comment"></dod-display-value></div></div></div>');
$templateCache.put('scripts/app/entities/productionEvaluation/productionEvaluation-detail.html','<div><h2>{{productionEvaluation.productName}}</h2><h4 translate="dodomaApp.productionEvaluation.detail.title">ProductionEvaluation</h4><button type="submit" ui-sref="productionEvaluationDetail.edit({id:productionEvaluation.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.productionEvaluation.productName">ProductName</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.productName}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.workflow">Workflow</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.workflow}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.testStart">TestStart</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.testStart}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.testerName">TesterName</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.testerName}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.numberOfProducts">NumberOfProducts</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.numberOfProducts}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.verificationTime">VerificationTime</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.verificationTime}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.toolNeed">ToolNeed</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.toolNeed}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.storeNeed">StoreNeed</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.storeNeed}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.transferNeed">TransferNeed</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.transferNeed}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.storageNeed">StorageNeed</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.storageNeed}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.logisticNeed">LogisticNeed</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.logisticNeed}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionEvaluation.worker">worker</span></td><td><input type="text" class="input-sm form-control" value="{{productionEvaluation.worker.name}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="productionEvaluation" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/productionEvaluation/productionEvaluation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="ProductionEvaluationUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myProductionEvaluationLabel" translate="dodomaApp.productionEvaluation.home.createOrEditLabel">Create or edit a ProductionEvaluation</h4></div><div class="modal-body"><div class="form-group"><label translate="dodomaApp.productionEvaluation.productName" for="field_productName">ProductName</label> <input type="text" class="form-control" name="productName" id="field_productName" ng-model="productionEvaluation.productName"></div><div class="form-group"><label translate="dodomaApp.productionEvaluation.workflow" for="field_workflow">Workflow</label> <textarea class="form-control" name="workflow" id="field_workflow" ng-model="productionEvaluation.workflow"></textarea></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.testStart" for="field_testStart">TestStart</label> <input bs-datepicker type="text" class="form-control" name="testStart" id="field_testStart" ng-model="productionEvaluation.testStart"> <input bs-timepicker type="text" class="form-control" name="testStart_time" id="field_testStart_time" ng-model="productionEvaluation.testStart"><div ng-show="editForm.testStart.$invalid"><p class="help-block" ng-show="editForm.testStart.$error.datetimelocal" translate="entity.validation.datetimelocal">This field should be a date and time.</p></div></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.testerName" for="field_testerName">TesterName</label> <input type="text" class="form-control" name="testerName" id="field_testerName" ng-model="productionEvaluation.testerName"></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.worker" for="field_worker">worker</label> <select class="form-control" id="field_worker" name="worker" ng-model="productionEvaluation.worker.id" ng-options="worker.id as (worker.lastName + \' \'+ worker.firstName) for worker in workers.entities"></select></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.numberOfProducts" for="field_numberOfProducts">NumberOfProducts</label> <input type="number" class="form-control" name="numberOfProducts" id="field_numberOfProducts" ng-model="productionEvaluation.numberOfProducts"></div></div><div class="form-group"><label translate="dodomaApp.productionEvaluation.verificationTime" for="field_verificationTime">VerificationTime</label> <input type="number" class="form-control" name="verificationTime" id="field_verificationTime" ng-model="productionEvaluation.verificationTime"></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.toolNeed" for="field_toolNeed">ToolNeed</label> <textarea class="form-control" name="toolNeed" id="field_toolNeed" ng-model="productionEvaluation.toolNeed"></textarea></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.storeNeed" for="field_storeNeed">StoreNeed</label> <textarea class="form-control" name="storeNeed" id="field_storeNeed" ng-model="productionEvaluation.storeNeed"></textarea></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.transferNeed" for="field_transferNeed">TransferNeed</label> <textarea class="form-control" name="transferNeed" id="field_transferNeed" ng-model="productionEvaluation.transferNeed"></textarea></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionEvaluation.storageNeed" for="field_storageNeed">StorageNeed</label> <textarea class="form-control" name="storageNeed" id="field_storageNeed" ng-model="productionEvaluation.storageNeed"></textarea></div></div><div class="form-group"><label translate="dodomaApp.productionEvaluation.logisticNeed" for="field_logisticNeed">LogisticNeed</label> <textarea class="form-control" name="logisticNeed" id="field_logisticNeed" ng-model="productionEvaluation.logisticNeed"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/productionEvaluation/productionEvaluations.html','<div><h2 translate="dodomaApp.productionEvaluation.home.title">ProductionEvaluations</h2><button class="btn btn-primary" ui-sref="productionEvaluation.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.productionEvaluation.home.createLabel">Create a new ProductionEvaluation</span></button><div class="modal fade" id="deleteProductionEvaluationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(productionEvaluation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.productionEvaluation.delete.question" translate-values="productionEvaluation">Are you sure you want to delete ProductionEvaluation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="dodomaApp.productionEvaluation.productName">ProductName</th><th translate="dodomaApp.productionEvaluation.workflow">Workflow</th><th translate="dodomaApp.productionEvaluation.testStart">TestStart</th><th translate="dodomaApp.productionEvaluation.testerName">TesterName</th><th translate="dodomaApp.productionEvaluation.numberOfProducts">NumberOfProducts</th><th translate="dodomaApp.productionEvaluation.verificationTime">VerificationTime</th><th translate="dodomaApp.productionEvaluation.toolNeed">ToolNeed</th><th translate="dodomaApp.productionEvaluation.storeNeed">StoreNeed</th><th translate="dodomaApp.productionEvaluation.transferNeed">TransferNeed</th><th translate="dodomaApp.productionEvaluation.storageNeed">StorageNeed</th><th translate="dodomaApp.productionEvaluation.logisticNeed">LogisticNeed</th><th translate="dodomaApp.productionEvaluation.worker">worker</th><th></th></tr></thead><tbody><tr ng-repeat="productionEvaluation in productionEvaluations"><td><a ui-sref="productionEvaluation.detail({id:productionEvaluation.id})">{{productionEvaluation.id}}</a></td><td>{{productionEvaluation.productName}}</td><td>{{productionEvaluation.workflow}}</td><td>{{productionEvaluation.testStart}}</td><td>{{productionEvaluation.testerName}}</td><td>{{productionEvaluation.numberOfProducts}}</td><td>{{productionEvaluation.verificationTime}}</td><td>{{productionEvaluation.toolNeed}}</td><td>{{productionEvaluation.storeNeed}}</td><td>{{productionEvaluation.transferNeed}}</td><td>{{productionEvaluation.storageNeed}}</td><td>{{productionEvaluation.logisticNeed}}</td><td>{{productionEvaluation.worker.name}}</td><td><button type="submit" ui-sref="productionEvaluation.detail({id:productionEvaluation.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="productionEvaluation.edit({id:productionEvaluation.id})" class="btn btn-warning btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(productionEvaluation.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodomaapp-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodomaapp-navigation></div></div>');
$templateCache.put('scripts/app/entities/productionSheet/productionSheet-detail.html','<div><h2><span translate="dodomaApp.productionSheet.detail.title">ProductionSheet</span> {{productionSheet.id}}</h2><button type="submit" ui-sref="productionSheetDetail.edit({id:productionSheet.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.productionSheet.executionDate">ExecutionDate</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheet.executionDate}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionSheet.state">State</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheet.state}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionSheet.orderPlan">orderPlan</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheet.orderPlan.name}}" readonly="readonly"></td></tr></tbody></table></div><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/productionSheet/productionSheet-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="ProductionSheetUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myProductionSheetLabel" translate="dodomaApp.productionSheet.home.createOrEditLabel">Create or edit a ProductionSheet</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.productionSheet.executionDate" for="field_executionDate">ExecutionDate</label> <input bs-datepicker type="text" class="form-control" name="executionDate" id="field_executionDate" ng-model="productionSheet.executionDate" required> <input type="hidden" name="executionDate"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/productionSheet/productionSheets.html','<main-layout title-key="dodomaApp.productionSheet.home.title"><pane-filter><div class="form-group"><label class="control-label" for="client" translate="dodomaApp.orderPlan.client">Partner</label><ui-select ng-model="customFilter.client" dodoma-partner allow-clear name="client" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="after" translate="dodomaApp.orderPlan.filter.after">StartDate</label> <input bs-datepicker data-max-date="{{filter.before}}" type="text" class="form-control" name="after" id="after" ng-model="filter.after" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="before" translate="dodomaApp.orderPlan.filter.before">EndDate</label> <input bs-datepicker data-min-date="{{filter.after}}" type="text" class="form-control" name="before" id="before" ng-model="filter.before" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="orderPlan" translate="dodomaApp.productionSheetItem.filter.orderPlan">orderPlan</label><ui-select ng-model="customFilter.orderPlan" dodoma-order-plan allow-clear name="orderPlan" on-select="loadAll()" on-clear="loadAll()"></ui-select></div></pane-filter><pane-main><div class="container"><div class="row"><div class="col-md-4"><download-button url="exportUrl()" size="btn-lg" label="dodomaApp.productionSheet.action.download"></download-button><!-- <button class="btn btn-primary" ui-sref="productionSheet.new">\n                      <i class="fas fa-bolt"></i> <span translate="dodomaApp.productionSheet.home.createLabel">Create a new ProductionSheet</span>\n                  </button> --></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.productionSheet.orderPlan">orderPlan</th><th translate="dodomaApp.orderPlan.client">orderPlan</th><th translate="dodomaApp.productionSheet.executionDate">ExecutionDate</th><th translate="dodomaApp.productionSheet.state">State</th><!-- <th></th> --></tr></thead><tbody><tr ng-repeat="productionSheet in productionSheets"><td><a ui-sref="orderPlan.detail({orderId:productionSheet.orderPlan.id})">{{productionSheet.orderPlan.name}}</a></td><td><a ui-sref="orderPlan.detail({orderId:productionSheet.orderPlan.id})">{{productionSheet.client.name}}</a></td><td><a ui-sref="orderPlan.detail({orderId:productionSheet.orderPlan.id})">{{productionSheet.executionDate}}</a></td><td>{{productionSheet.state | productionSheetState}}</td><!-- <td>\n                        <button type="submit"\n                                ui-sref="productionSheetDetail({id:productionSheet.id})"\n                                class="btn btn-info btn-sm">\n                            <i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span>\n                        </button>\n                    </td> --></tr></tbody></table><dodomaapp-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodomaapp-navigation></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/productionSheetItem/productionSheetItem-detail.html','<div><h2><span translate="dodomaApp.productionSheetItem.detail.title">ProductionSheetItem</span> {{productionSheetItem.id}}</h2><button type="submit" ui-sref="productionSheetItemDetail.edit({id:productionSheetItem.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.productionSheetItem.amount">Amount</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheetItem.amount}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionSheetItem.finishedAmount">FinishedAmount</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheetItem.finishedAmount}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionSheetItem.worker">worker</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheetItem.worker.id}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.productionSheetItem.orderLineWork">orderLineWork</span></td><td><input type="text" class="input-sm form-control" value="{{productionSheetItem.orderLineWork.id}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="productionSheetItem" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/productionSheetItem/productionSheetItem-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="ProductionSheetItemDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myProductionSheetItemLabel" translate="{{ \'dodomaApp.productionSheetItem.createOrEditLabel.\' + mode }}">Create or edit a ProductionSheetItem</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.productionSheetItem.orderLineWork" for="field_orderLineWork">orderLineWork</label> <select class="form-control" id="field_orderLineWork" name="orderLineWork" ng-model="productionSheetItem.orderLineWork" ng-options="orderLineWork as orderLineWork.name for orderLineWork in orderPlanManager.requiredWorks track by orderLineWork.id" ng-change="workSelected(productionSheetItem.orderLineWork)" ng-readonly="mode==\'EXECUTING\'"></select></div><div class="form-group"><label translate="dodomaApp.productionSheetItem.amount" for="field_amount">Amount</label> <input type="number" class="form-control" name="amount" id="field_amount" ng-model="productionSheetItem.amount" ng-readonly="mode==\'EXECUTING\'"></div><div class="form-group" ng-if="mode==\'PLANNING\' && productionSheetItem.orderLineWork && !productionSheetItem.orderLineWork.fixStandardTime"><label translate="dodomaApp.productionSheetItem.standardTimeOverride" for="field_standardTimeOverride">standardTimeOverride</label> <input type="number" class="form-control" name="standardTimeOverride" id="field_standardTimeOverride" ng-model="productionSheetItem.standardTimeOverride" ng-readonly="mode==\'EXECUTING\'"></div><div class="form-group" ng-if="mode==\'PLANNING\'"><label translate="dodomaApp.productionSheetItem.worker" for="field_worker">worker</label> <select class="form-control" id="field_worker" name="worker" ng-model="productionSheetItem.worker" ng-options="worker as (worker.lastName + \' \' + worker.firstName) for worker in workers track by worker.id"></select></div><div class="form-group" ng-if="mode==\'EXECUTING\'"><label translate="dodomaApp.productionSheetItem.worker" for="field_worker">worker</label> <input class="form-control" id="field_worker" name="worker" value="{{productionSheetItem.worker.lastName + \' \' + productionSheetItem.worker.firstName}}" readonly="readonly"></div><div class="form-group" ng-if="mode==\'EXECUTING\'"><label translate="dodomaApp.productionSheetItem.finishedAmount" for="field_finishedAmount">FinishedAmount</label> <input type="number" class="form-control" name="finishedAmount" id="field_finishedAmount" ng-model="productionSheetItem.finishedAmount"></div><div class="form-group" ng-if="mode==\'EXECUTING\'"><label translate="dodomaApp.productionSheetItem.timeSpent" for="field_timeSpent">timeSpent</label> <input type="number" class="form-control" name="timeSpent" id="field_timeSpent" ng-model="productionSheetItem.timeSpent"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/productionSheetItem/productionSheetItems.html','<main-layout title-key="dodomaApp.productionSheetItem.home.title"><pane-main><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="dodomaApp.productionSheet.executionDate">Amount</th><th translate="dodomaApp.productionSheetItem.amount">Amount</th><th translate="dodomaApp.productionSheetItem.finishedAmount">FinishedAmount</th><th translate="dodomaApp.productionSheetItem.worker">worker</th><th translate="dodomaApp.productionSheetItem.orderLineWork">orderLineWork</th><th translate="dodomaApp.productionSheetItem.workType">workType</th><th translate="dodomaApp.productionSheet.orderPlan">orderPlan</th><th></th></tr></thead><tbody><tr ng-repeat="productionSheetItem in productionSheetItems"><td>{{productionSheetItem.productionSheet.executionDate}}</td><td>{{productionSheetItem.amount}}</td><td>{{productionSheetItem.finishedAmount}}</td><td><worker-link worker="productionSheetItem.worker"></worker-link></td><td>{{productionSheetItem.orderLineWork.name}} ({{productionSheetItem.orderLineWork.externalName}})</td><td><work-type-link work-type="productionSheetItem.orderLineWork.workType"></work-type-link></td><td><order-plan-link plan="productionSheetItem.orderPlan"></order-plan-link></td><td><psiv-table production-sheet-item="productionSheetItem" detailed="false"></psiv-table><psiv-verify-button production-sheet-item="productionSheetItem"></psiv-verify-button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main><pane-filter><div class="form-group"><label class="control-label" for="client" translate="dodomaApp.productionSheetItem.filter.client">Client</label><ui-select ng-model="customFilter.client" dodoma-partner allow-clear name="client" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="workType" translate="dodomaApp.productionSheetItem.filter.workType">WorkType</label><ui-select ng-model="customFilter.workType" dodoma-work-type allow-clear name="workType" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="workStep" translate="dodomaApp.productionSheetItem.filter.workStep">WorkType</label><ui-select ng-model="customFilter.workStep" dodoma-work-step allow-clear name="workStep" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="worker" translate="dodomaApp.productionSheetItem.filter.worker">worker</label><ui-select ng-model="customFilter.worker" dodoma-worker module="PRODUCTION" allow-clear name="worker" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="orderPlan" translate="dodomaApp.productionSheetItem.filter.orderPlan">orderPlan</label><ui-select ng-model="customFilter.orderPlan" dodoma-order-plan allow-clear name="orderPlan" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="after" translate="dodomaApp.productionSheetItem.filter.after">StartDate</label> <input bs-datepicker data-max-date="{{filter.before}}" type="text" class="form-control" name="after" id="after" ng-model="filter.after" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="before" translate="dodomaApp.productionSheetItem.filter.before">EndDate</label> <input bs-datepicker data-min-date="{{filter.after}}" type="text" class="form-control" name="before" id="before" ng-model="filter.before" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="hideVerified" translate="dodomaApp.productionSheetItem.filter.hideVerified">hideVerified</label> <input type="checkbox" id="hideVerified" value="false" name="hideVerified" ng-model="filter.hideVerified" ng-change="loadAll()"></div></pane-filter></main-layout>');
$templateCache.put('scripts/app/entities/productionSheetItemVerification/productionSheetItemVerification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="ProductionSheetItemVerificationUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myProductionSheetItemVerificationLabel" translate="dodomaApp.productionSheetItemVerification.home.createOrEditLabel">Create or edit a ProductionSheetItemVerification</h4></div><div class="modal-body"><div class="form-group"><label translate="dodomaApp.productionSheetItemVerification.checkedAmount" for="field_checkedAmount">CheckedAmount</label> <input type="number" class="form-control" name="checkedAmount" id="field_checkedAmount" ng-model="productionSheetItemVerification.checkedAmount" required min="0"></div><div class="form-group"><label translate="dodomaApp.productionSheetItemVerification.brokenAmount" for="field_brokenAmount">BrokenAmount</label> <input type="number" class="form-control" name="brokenAmount" id="field_brokenAmount" ng-model="productionSheetItemVerification.brokenAmount" required min="0"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/productionVariant/productionVariant-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="ProductionVariantUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myLabel" translate="dodomaApp.productionVariant.home.createOrEditLabel">Create or edit a WorkStep</h4></div><div class="modal-body"><error-display></error-display><div class="row"><div class="col-md-12 col-sm-12"><label translate="dodomaApp.productionVariant.name">Name</label> <input type="text" class="form-control" name="name" ng-model="productionVariant.name"></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.productionVariant.active">Active</label> <input type="checkbox" class="form-control" name="active" ng-model="productionVariant.active"></div></div><div class="form-group"><label translate="dodomaApp.productionVariant.description">Description</label> <textarea class="form-control" name="description" ng-model="productionVariant.description"> </textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/query/query.html','<div><h2 translate="dodomaApp.query.home.title">Querys</h2><form><error-display></error-display><div class="form-group"><label translate="dodomaApp.query.base.text" for="field_query">Query</label> <button type="button" class="btn btn-default" ng-model="formParams.rootEntity" ng-change="changeRootEntity()" data-html="1" data-animation="am-flip-x" placeholder="{{\'dodomaApp.query.placeholder.root\' | translate }}" bs-select bs-options="entity.name as (entity.translationKey|translate) for entity in qc">Action <span class="caret"></span></button> <span ng-repeat="entity in entityList">{{entity.translationKey | translate }} <button ng-if="entity.linksAsList.length > 0" type="button" class="btn btn-default" ng-model="entity.linkedEntities" ng-change="changeEntityModel(entity)" data-html="1" data-multiple="1" data-animation="am-flip-x" placeholder="{{\'dodomaApp.query.placeholder.linkEntity\' | translate }}" bs-select bs-options="ce.name as (ce.translationKey|translate) for ce in entity.linksAsList">Action <span class="caret"></span></button> <button ng-if="entity.filtersAsList.length > 0" type="button" class="btn btn-default" ng-model="entity.enabledFilters" ng-change="changeFilterModel(entity)" data-html="1" data-multiple="1" data-animation="am-flip-x" placeholder="{{\'dodomaApp.query.placeholder.filters\' | translate }}" bs-select bs-options="ce.name as (ce.translationKey|translate) for ce in entity.filtersAsList"><span class="caret"></span></button> <span ng-repeat="filter in entity.query.filters"><span ng-switch="filter.type"><span ng-switch-when="string" class="form-group"><label translate="{{ \'dodomaApp.query.filter.\'+ filter.name }}">filterName</label> <input type="text" ng-model="filter.value" class="form-control" ng-change="loadAll()"> </span><span ng-switch-when="number" class="form-group"><label translate="{{ \'dodomaApp.query.filter.\'+ filter.name }}">filterName</label> <button type="button" class="btn btn-default" ng-model="filter.modifier" ng-change="loadAll()" data-html="1" data-multiple="false" data-animation="am-flip-x" required bs-select bs-options="ce.type as (ce.translationKey|translate) for ce in numberFilterModifiers"><span class="caret"></span></button> <input type="number" ng-model="filter.value" class="form-control" ng-change="loadAll()"> </span><span ng-switch-when="selection" class="form-group"><label translate="{{ \'dodomaApp.query.filter.\'+ filter.name }}">filterName</label> <button ng-if="filter.params.values.length > 0" type="button" class="btn btn-default" ng-model="filter.value" ng-change="loadAll()" data-html="1" data-multiple="1" data-animation="am-flip-x" bs-select bs-options="fv as ((filter.params.prefix + fv)|translate) for fv in filter.params.values"><span class="caret"></span></button> </span><span ng-switch-when="datetime" class="form-group"><label translate="{{ \'dodomaApp.query.filter.\'+ filter.name }}">filterName</label> <button type="button" class="btn btn-default" ng-model="filter.modifier" ng-change="loadAll()" data-html="1" data-multiple="false" data-animation="am-flip-x" required bs-select bs-options="ce.type as (ce.translationKey|translate) for ce in numberFilterModifiers"><span class="caret"></span></button> <input bs-datepicker type="text" ng-model="filter.value" class="form-control" ng-change="loadAll()"> </span><span ng-switch-when="date" class="form-group"><label translate="{{ \'dodomaApp.query.filter.\'+ filter.name }}">filterName</label> <button type="button" class="btn btn-default" ng-model="filter.modifier" ng-change="loadAll()" data-html="1" data-multiple="false" data-animation="am-flip-x" required bs-select bs-options="ce.type as (ce.translationKey|translate) for ce in numberFilterModifiers"><span class="caret"></span></button> <input bs-datepicker type="text" ng-model="filter.value" class="form-control" ng-change="loadAll()"></span></span></span></span></div><!--       <button class="btn btn-primary" ng-click="loadPage(0)">\n          <i class="fas fa-running"></i> Run\n      </button> --></form><!-- <pre>{{query | json}}</pre> --><div class="table-responsive"><table class="table table-striped"><thead><tr><th ng-repeat="header in pageResult.header">{{header.name}}</th></tr></thead><tbody><tr ng-repeat="row in rows"><td ng-repeat="cell in row"><cell-render cell="cell"></cell-render></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></div>');
$templateCache.put('scripts/app/entities/rehab/rehab.html','<div ng-cloak><div class="row"><div class="col-md-3"></div><div class="col-md-6"><div ng-if="isAuthenticated()"><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_PRODUCTIONMANAGER,ROLE_REHABMANAGER"><div class="col-sm-12 dodoma-big"><a ui-sref="rehabWorker"><span class="fas fa-male"></span></a></div><div class="col-sm-12"><a ui-sref="rehabWorker"><p class="dodoma-cell-label" translate="global.menu.entities.worker">Worker</p></a></div></div><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_WORKLOG"><div class="col-sm-12 dodoma-big"><a ui-sref="workLog"><span class="fas fa-tasks"></span></a></div><div class="col-sm-12"><a ui-sref="workLog"><p class="dodoma-cell-label" translate="global.menu.entities.workLog">workLog</p></a></div></div><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_REHABMANAGER"><div class="col-sm-12 dodoma-big"><a ui-sref="deadline"><i class="fas fa-calendar-alt"></i></a></div><div class="col-sm-12"><a ui-sref="deadline"><p class="dodoma-cell-label" translate="global.menu.entities.deadline">deadline</p></a></div></div><div class="col-sm-4 dodoma-cell btn btn-default" has-role="ROLE_REHABMANAGER"><div class="col-sm-12 dodoma-big"><a ui-sref="workerRecord"><i class="fas fa-check-square"></i></a></div><div class="col-sm-12"><a ui-sref="workerRecord"><p class="dodoma-cell-label" translate="global.menu.entities.workerRecord">workerRecord</p></a></div></div></div></div></div></div>');
$templateCache.put('scripts/app/entities/stock/stock-detail.html','<div><h2>{{stock.name}} <span ng-if="stock.relatedPartner.name">({{stock.relatedPartner.name}})</span></h2><h4 translate="dodomaApp.stock.detail.title">Stock</h4><div class="panel panel-info" has-role="ROLE_STOREREVIEWER"><div class="panel-body"><button type="submit" ui-sref="stockDetail.edit({id:stock.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><download-button url="partExportUrl()"></download-button></div></div><uib-tabset justified="false"><uib-tab heading="{{ \'dodomaApp.stock.detail.general\' | translate  }}" select="switchTab(0)"><div class="panel panel-primary"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.stock.name" value="stock.name"></dod-display-value><dod-display-value ng-if="stock.relatedPartner" label="dodomaApp.stock.relatedPartner" custom="<partner-link class=\'input-sm\' partner=\'stock.relatedPartner\'></partner-link>"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.stock.description" value="stock.description"></dod-display-value></div></div></div></uib-tab><uib-tab heading="{{ \'dodomaApp.stock.detail.parts\' | translate  }}" select="switchTab(1)"><div class="panel panel-primary"><part-table query="partFilter" state="partTabState" show-new-button="true"></part-table></div></uib-tab><uib-tab heading="{{ \'dodomaApp.stock.detail.movements\' | translate  }}" select="switchTab(2)"><div class="panel panel-primary"><div class="panel-body"><table class="table dodoma-table"><thead><tr><th>ID</th><th translate="dodomaApp.movement.part">part</th><th translate="dodomaApp.movement.type">Type</th><th translate="dodomaApp.stock.linkedObject">Linked Object</th><th translate="dodomaApp.movement.amount">PhysicalAmount</th><th translate="dodomaApp.movement.amountChange">physicalAmountChange</th><th ng-if="DodomaConfig.showPartReservation" translate="dodomaApp.movement.availableAmount">AvailableAmount</th><th translate="dodomaApp.movement.createdDate">CreatedDate</th><th translate="dodomaApp.movement.user">User</th><th></th></tr></thead><tbody><tr ng-repeat="movement in movementPageResult.entities"><td><a ui-sref="movementDetail({id:movement.id})">{{movement.id}}</a></td><td><part-link part="movement.part"></part-link></td><td>{{movement.type | movementType}}</td><td><span ng-if="movement.giveOut !== null"><give-out-link giveout="movement.giveOut"></give-out-link></span><span ng-if="movement.deliveryNote  !== null"><delivery-note-link deliverynote="movement.deliveryNote"></delivery-note-link></span></td><td>{{movement.physicalAmount}}</td><td>{{movement.physicalAmountChange}}</td><td ng-if="DodomaConfig.showPartReservation">{{movement.availableAmount}} ({{movement.availableAmountChange}})</td><td>{{movement.createdDate | dodTime}}</td><td>{{movement.user.name}}</td><td><button type="submit" ui-sref="movementDetail({id:movement.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button></td></tr></tbody></table><dodoma-navigation page-info="movementPageResult" callback-fn="changeMovementPage(page)"></dodoma-navigation></div></div></uib-tab></uib-tabset><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/stock/stock-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="StockUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myStockLabel" translate="dodomaApp.stock.home.createOrEditLabel">Create or edit a Stock</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.stock.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="stock.name" required ng-maxlength="100"></div><div class="form-group"><label translate="dodomaApp.stock.description" for="field_description">Description</label> <textarea class="form-control" name="description" id="field_description" rows="5" ng-model="stock.description" ng-maxlength="1024"></textarea></div><div class="form-group"><label translate="dodomaApp.stock.relatedPartner" for="field_relatedPartner">relatedPartner</label><ui-select ng-model="stock.relatedPartner" dodoma-partner allow-clear name="relatedPartner"></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/stock/stocks.html','<div><h2 translate="dodomaApp.stock.home.title">Stock</h2><button class="btn btn-default" ui-sref="giveOut" has-role="ROLE_STORE_VIEWER"><span class="fas fa-share"></span> <span translate="global.menu.entities.giveOut">GiveOuts</span></button> <button class="btn btn-default" ui-sref="deliveryNote" has-role="ROLE_STORE_VIEWER"><span class="fas fa-sign-in-alt"></span> <span translate="global.menu.entities.deliveryNote">DeliveryNotes</span></button> <button class="btn btn-default" ui-sref="movement" has-role="ROLE_STORE_VIEWER"><i class="fas fa-retweet"></i> <span translate="global.menu.entities.movement">Movements</span></button> <button class="btn btn-primary" ui-sref="stock.new" has-role="ROLE_STOREMANAGER,ROLE_STOREREVIEWER"><i class="fas fa-chess-rook"></i> <span translate="dodomaApp.stock.home.createLabel">Create a new Stock</span></button><div class="modal fade" id="deleteStockConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(stock.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.stock.delete.question" translate-values="{name : stock.name, id: stock.id}">Are you sure you want to delete Stock {{name}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th>ID</th><th translate="dodomaApp.stock.name">Name</th><th translate="dodomaApp.stock.description">Description</th><th translate="dodomaApp.stock.relatedPartner">relatedPartner</th><th></th></tr></thead><tbody><tr ng-repeat="stock in stocks"><td><a ui-sref="stockDetail({id:stock.id})">{{stock.id}}</a></td><td><a ui-sref="stockDetail({id:stock.id})">{{stock.name}}</a></td><td>{{stock.description | words:30 | characters: 200}}</td><td><partner-link partner="stock.relatedPartnerName"></partner-link></td><td><button type="submit" ui-sref="stockDetail({id:stock.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" has-role="ROLE_STOREREVIEWER" ui-sref="stockDetail.edit({id:stock.id})" class="btn btn-warning btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" has-role="ROLE_STOREREVIEWER" ng-click="delete(stock.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></div>');
$templateCache.put('scripts/app/entities/stockLocation/stockLocation-detail.html','<div><h2><span translate="dodomaApp.stockLocation.detail.title">StockLocation</span> {{stockLocation.id}}</h2><button type="submit" ui-sref="stockLocationDetail.edit({id:stockLocation.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.stockLocation.physicalAmount">PhysicalAmount</span></td><td><input type="text" class="input-sm form-control" value="{{stockLocation.physicalAmount}}" readonly="readonly"></td></tr><tr ng-if="DodomaConfig.showPartReservation"><td><span translate="dodomaApp.stockLocation.availableAmount">AvailableAmount</span></td><td><input type="text" class="input-sm form-control" value="{{stockLocation.availableAmount}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.stockLocation.stock">stock</span></td><td><input type="text" class="input-sm form-control" value="{{stockLocation.stock.name}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.stockLocation.Part">Part</span></td><td><input type="text" class="input-sm form-control" value="{{stockLocation.Part.name}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="stockLocation" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/stockLocation/stockLocation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="StockLocationUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myStockLocationLabel" translate="dodomaApp.stockLocation.home.createOrEditLabel">Create or edit a StockLocation</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.stockLocation.physicalAmount">PhysicalAmount</label> <input type="number" class="form-control" name="physicalAmount" ng-model="stockLocation.physicalAmount" required min="0"></div><div ng-if="part.hasPrice" class="form-group"><label translate="dodomaApp.stockLocation.price">Price</label> <input type="number" class="form-control" name="price" ng-model="stockLocation.price" required min="0"></div><div ng-if="DodomaConfig.showPartReservation" class="form-group"><label translate="dodomaApp.stockLocation.availableAmount">AvailableAmount</label> <input type="number" class="form-control" name="availableAmount" ng-model="stockLocation.availableAmount" required min="0"></div><div ng-if="showInitialTime" class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.part.initialTime">initialTime</label><div class="form-group"><input bs-datepicker type="text" data-max-date="today" name="initialTime" id="initialTime" ng-model="stockLocation.initialTime"> <input bs-timepicker type="text" ng-model="stockLocation.initialTime"></div></div><div class="form-group"><label translate="dodomaApp.stockLocation.stock">stock</label><ui-select ng-model="stockLocation.stock" dodoma-stock allow-clear name="stock"></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/stockLocation/stockLocations.html','<div><h2 translate="dodomaApp.stockLocation.home.title">StockLocation</h2><button class="btn btn-primary btn-lg" ui-sref="stockLocation.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.stockLocation.home.createLabel">Create a new StockLocation</span></button><div class="modal fade" id="deleteStockLocationConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(stockLocation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.stockLocation.delete.question" translate-values="stockLocation">Are you sure you want to delete StockLocation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>ID</th><th translate="dodomaApp.stockLocation.physicalAmount">PhysicalAmount</th><th translate="dodomaApp.stockLocation.availableAmount">AvailableAmount</th><th translate="dodomaApp.stockLocation.stock">stock</th><th translate="dodomaApp.stockLocation.Part">Part</th><th></th></tr></thead><tbody><tr ng-repeat="stockLocation in stockLocations"><td><a ui-sref="stockLocationDetail({id:stockLocation.id})">{{stockLocation.id}}</a></td><td>{{stockLocation.physicalAmount}}</td><td>{{stockLocation.availableAmount}}</td><td>{{stockLocation.stock.name}}</td><td>{{stockLocation.Part.name}}</td><td><button type="submit" ui-sref="stockLocationDetail({id:stockLocation.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="stockLocationDetail.edit({id:stockLocation.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(stockLocation.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('scripts/app/entities/workLog/workLog-detail.html','<div><h2><span translate="dodomaApp.workLog.detail.title">WorkLog</span> {{workLog.id}}</h2><button type="submit" ng-if="workLog.status == \'DRAFT\' && selfId==workLog.executor.id" ui-sref=".edit({workLogId:workLog.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.workLog.recordDate">RecordDate</span></td><td><input type="text" class="input-sm form-control" value="{{workLog.recordDateAsString}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workLog.task">Task</span></td><td><input type="text" class="input-sm form-control" value="{{workLog.task}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workLog.minutes">Minutes</span></td><td><input type="text" class="input-sm form-control" value="{{workLog.minutes}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workLog.relatedOther">RelatedOther</span></td><td><input type="text" class="input-sm form-control" value="{{workLog.relatedOther}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workLog.summary">Summary</span></td><td><textarea class="input-sm form-control" readonly="readonly">{{workLog.summary}}</textarea></td></tr><tr><td><span translate="dodomaApp.workLog.relatedWorker">relatedWorker</span></td><td><span ng-repeat="worker in workLog.relatedWorkers"><worker-link class="input-sm form-control" worker="worker"></worker-link></span></td></tr><tr><td><span translate="dodomaApp.workLog.executorUser">executorUser</span></td><td><input type="text" class="input-sm form-control" value="{{workLog.executor.name}}" readonly="readonly"></td></tr></tbody></table></div><back-button page="\'workLog\'"></back-button></div>');
$templateCache.put('scripts/app/entities/workLog/workLog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="WorklogUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkLogLabel" translate="dodomaApp.workLog.home.createOrEditLabel">Create or edit a WorkLog</h4></div><div class="modal-body"><error-display></error-display><div class="row"><div class="col-md-6 col-sm-12"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.workLog.recordDate" for="field_recordDate">RecordDate</label> <input bs-datepicker type="text" class="form-control" class="form-control" name="recordDate" id="field_recordDate" ng-readonly="recordReadonly" ng-model="workLog.recordDate"></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workLog.minutes" for="field_minutes">Minutes</label> <input type="number" class="form-control" name="minutes" id="field_minutes" ng-readonly="recordReadonly" ng-model="workLog.minutes"></div></div><div class="form-group"><label translate="dodomaApp.workLog.task" for="field_task">Task</label> <input type="text" class="form-control" name="task" id="field_task" ng-readonly="recordReadonly" ng-model="workLog.task"></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workLog.relatedWorker" for="field_relatedWorker">relatedWorker</label><ui-select class="form-control" ng-model="workLog.relatedWorkers" dodoma-worker multiple="multiple" allow-clear name="relatedWorker" id="field_relatedWorker" ng-readonly="recordReadonly"></ui-select></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workLog.relatedOther" for="field_relatedOther">RelatedOther</label> <input type="text" class="form-control" name="relatedOther" id="field_relatedOther" ng-readonly="recordReadonly" ng-model="workLog.relatedOther"></div></div><div class="form-group"><label translate="dodomaApp.workLog.summary" for="field_summary">Summary</label> <textarea class="form-control" name="summary" id="field_summary" rows="6" ng-readonly="recordReadonly" ng-model="workLog.summary"></textarea></div></div><div class="modal-footer" ng-if="!recordReadonly"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-disabled="editForm.$invalid" class="btn btn-primary" ng-click="finalize()"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.finalize">Finalize</span></button></div><div class="modal-footer" ng-if="recordReadonly"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="far fa-check-circle"></i>&nbsp;<span translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('scripts/app/entities/workLog/workLog-popover.html','<div class="popover"><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="yearPop" translate="dodomaApp.workLog.filter.year">year</label> <input type="number" name="yearPop" class="form-control" id="yearPop" ng-model="filter.year" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="monthPop" translate="dodomaApp.workLog.filter.month">year</label> <select name="monthPop" id="monthPop" class="form-control" ng-model="filter.month" ng-options="month as displayMonth(month) for month in monthList" ng-change="loadAll()"><option></option></select></div><div class="form-group"><download-button url="logExportUrl()"></download-button></div></div>');
$templateCache.put('scripts/app/entities/workLog/workLogs.html','<main-layout title-key="dodomaApp.workLog.home.title"><pane-filter><div class="form-group"><label class="control-label" for="task" translate="dodomaApp.workLog.filter.task">Task</label> <input ng-model="filter.task" class="form-control" name="task" ng-change="changeFilter()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="date" translate="dodomaApp.workLog.filter.date">date</label> <input bs-datepicker type="text" class="form-control" name="date" id="date" ng-model="filter.date" ng-change="changeFilter()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="year" translate="dodomaApp.workLog.filter.year">date</label> <input type="number" name="year" class="form-control" id="year" ng-model="filter.year" ng-change="changeFilter()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="month" translate="dodomaApp.workLog.filter.month">date</label> <select name="month" id="month" class="form-control dodoma-inline-form" ng-model="filter.month" ng-options="month as displayMonth(month) for month in monthList" ng-change="changeFilter()"><option></option></select></div><div class="form-group"><label class="control-label" for="worker" translate="dodomaApp.workLog.filter.worker">Worker</label><ui-select ng-model="customFilter.worker" dodoma-worker allow-clear name="worker" on-select="changeFilter()" on-clear="changeFilter()"></ui-select></div><div class="form-group"><label class="control-label" for="creator" translate="dodomaApp.workLog.filter.creator">Creator</label> <select class="form-control" name="creator" id="creator" ng-model="filter.userId" ng-options="user.id as formatUser(user) for user in users.entities" ng-change="changeFilter()"><option value=""></option></select></div></pane-filter><pane-main><button class="btn btn-primary" ui-sref="workLog.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.workLog.home.createLabel">Create a new WorkLog</span></button> <button type="button" class="btn btn-default" data-placement="right" data-template-url="scripts/app/entities/workLog/workLog-popover.html" data-animation="am-flip-x" bs-popover="popover"><span class="far fa-file-excel"></span> <span translate="global.export">Export</span></button><div class="modal fade" id="deleteWorkLogConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(workLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workLog.delete.question" translate-values="{task:workLog.task, recordDate: workLog.recordDateAsString}">Are you sure you want to delete WorkLog?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="dodomaApp.workLog.recordDate">RecordDate</th><th translate="dodomaApp.workLog.task">Task</th><th translate="dodomaApp.workLog.minutes">Minutes</th><th translate="dodomaApp.workLog.relatedOther">RelatedOther</th><th translate="dodomaApp.workLog.relatedWorker">relatedWorker</th><th></th></tr></thead><tbody><tr ng-repeat="workLog in workLogs"><td ng-if="!hasRecord(workLog)"><a ui-sref=".detail({workLogId:workLog.id})">{{workLog.recordDate}}</a></td><td ng-if="!hasRecord(workLog)"><a ui-sref=".detail({workLogId:workLog.id})">{{workLog.task}}</a></td><td ng-if="hasRecord(workLog)"><a ui-sref="rehabWorker.detail.editRecord({workerId:getFirstWorker(workLog).id, id:workLog.createdRecord.id})">{{workLog.recordDate}}</a></td><td ng-if="hasRecord(workLog)"><a ui-sref="rehabWorker.detail.editRecord({workerId:getFirstWorker(workLog).id, id:workLog.createdRecord.id})">{{workLog.createdRecord.type | workerRecordType }} - {{workLog.task}}</a></td><td>{{workLog.minutes | timeFormat}}</td><td>{{workLog.relatedOther}}</td><td><span ng-repeat="worker in workLog.relatedWorkerNames"><worker-link worker="worker"></worker-link></span></td><td ng-if="hasRecord(workLog)"></td><td ng-if="!hasRecord(workLog)"><button type="submit" ui-sref=".detail({workLogId:workLog.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ng-if="workLog.status == \'DRAFT\'  && selfId==workLog.executor.id" ui-sref=".edit({workLogId:workLog.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-if="workLog.status == \'DRAFT\' && selfId==workLog.executor.id" ng-click="delete(workLog.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/workPricingCategory/workPricingCategory-detail.html','<div><h2><span translate="dodomaApp.workPricingCategory.detail.title">WorkPricingCategory</span> {{workPricingCategory.id}}</h2><button type="submit" ui-sref="workPricingCategoryDetail.edit({id:workPricingCategory.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.workPricingCategory.name">Name</span></td><td><input type="text" class="input-sm form-control" value="{{workPricingCategory.name}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workPricingCategory.hourlyRate">HourlyRate</span></td><td><input type="text" class="input-sm form-control" value="{{workPricingCategory.hourlyRate}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="workPricingCategory" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/workPricingCategory/workPricingCategory-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="WorkPricingCategoryUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkPricingCategoryLabel" translate="dodomaApp.workPricingCategory.home.createOrEditLabel">Create or edit a WorkPricingCategory</h4></div><div class="modal-body"><div class="form-group"><label translate="dodomaApp.workPricingCategory.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="workPricingCategory.name" required ng-maxlength="20"></div><div class="form-group"><label translate="dodomaApp.workPricingCategory.hourlyRate" for="field_hourlyRate">HourlyRate</label> <input type="number" class="form-control" name="hourlyRate" id="field_hourlyRate" ng-model="workPricingCategory.hourlyRate" required min="0"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/workPricingCategory/workPricingCategorys.html','<div><h2 translate="dodomaApp.workPricingCategory.home.title">WorkPricingCategorys</h2><button class="btn btn-primary" ui-sref="workPricingCategory.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.workPricingCategory.home.createLabel">Create a new WorkPricingCategory</span></button><div class="modal fade" id="deleteWorkPricingCategoryConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(workPricingCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workPricingCategory.delete.question" translate-values="workPricingCategory">Are you sure you want to delete WorkPricingCategory?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="dodomaApp.workPricingCategory.name">Name</th><th translate="dodomaApp.workPricingCategory.hourlyRate">HourlyRate</th><th></th></tr></thead><tbody><tr ng-repeat="workPricingCategory in workPricingCategorys"><td><a ui-sref="workPricingCategory.detail({id:workPricingCategory.id})">{{workPricingCategory.name}}</a></td><td>{{workPricingCategory.hourlyRate}}</td><td><button type="submit" ui-sref="workPricingCategory.detail({id:workPricingCategory.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="workPricingCategory.edit({id:workPricingCategory.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(workPricingCategory.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodomaapp-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodomaapp-navigation></div></div>');
$templateCache.put('scripts/app/entities/workStep/workStep-detail.html','<div><h2><span translate="dodomaApp.workStep.detail.title">WorkStep</span> {{workStep.name}}</h2><uib-tabset justified="false"><uib-tab heading="{{ \'dodomaApp.workStep.detail.general\' | translate  }}"><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.workStep.name">Name</span></td><td><input type="text" class="input-sm form-control" value="{{workStep.name}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workStep.externalName">ExternalName</span></td><td><input type="text" class="input-sm form-control" value="{{workStep.externalName}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workStep.description">Description</span></td><td><input type="text" class="input-sm form-control" value="{{workStep.description}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workStep.standardTime">standardTime</span></td><td><input type="text" class="input-sm form-control" value="{{workStep.standardTime}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="workStepDetail.edit({id:workStep.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></uib-tab><uib-tab heading="{{ \'dodomaApp.workStep.detail.partsNeed\' | translate  }}"><div class="row"><div class="col-md-9"><div class="table-responsive"><table class="table table-striped"><thead><th translate="dodomaApp.workStepPartNeed.type">type</th><th translate="dodomaApp.workStepPartNeed.amount">AvailableAmount</th><th translate="dodomaApp.workStepPartNeed.part">stock</th><th></th></thead><tbody><tr ng-repeat="partNeed in workStep.requirements"><td>{{ \'dodomaApp.workStepPartNeed.typeLabel.\'+partNeed.type | translate }}</td><td>{{partNeed.amount}}</td><td><part-link part="partNeed.part"></part-link></td><td><button type="submit" ui-sref="partNeedEdit({partNeedId:partNeed.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="deletePartNeed(partNeed.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table></div></div><div class="col-md-2"><button class="btn btn-primary" ui-sref="partNeedNew"><i class="fas fa-bolt"></i> <span translate="dodomaApp.workStepPartNeed.home.createLabel">Create a new part need</span></button></div></div></uib-tab></uib-tabset><button type="submit" ui-sref="workStep" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/workStep/workStep-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation validation-messages="WorkStepUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkStepLabel" translate="dodomaApp.workStep.home.createOrEditLabel">Create or edit a WorkStep</h4></div><div class="modal-body"><error-display></error-display><div class="row"><div class="col-md-12 col-sm-12"><label translate="dodomaApp.workStep.name">Name</label> <input type="text" class="form-control" name="name" ng-model="workStep.name"></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.externalName">ExternalName</label> <input type="text" class="form-control" name="externalName" ng-model="workStep.externalName"></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.workType">workType</label><ui-select ng-model="workStep.workType" dodoma-work-type allow-clear required name="workType"></ui-select></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.fixStandardTime">fixStandardTime</label> <input type="checkbox" class="form-control" name="fixStandardTime" ng-model="workStep.fixStandardTime"></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.standardTime">standardTime</label> <input type="number" class="form-control" name="standardTime" ng-model="workStep.standardTime" ng-disabled="!workStep.fixStandardTime" ng-required="workStep.fixStandardTime"></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.pricing" for="field_pricing"></label> <select class="form-control" id="field_pricing" name="pricing" ng-model="workStep.pricing" ng-options="pricing as (pricing.name + \' (\'+ pricing.hourlyRate + \' Ft/\xF3ra)\') for pricing in pricings.entities track by pricing.id"><option value=""></option></select></div><div ng-if="DodomaConfig.showWorkStepMinimumRatio" class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.minimumRatio" for="field_minimumRatio"></label> <select class="form-control" id="field_minimumRatio" name="minimumRatio" ng-model="workStep.minimumRatio" ng-options="rationNumber as formatRatio(rationNumber) for rationNumber in possibleRatios"><option value="" translate="dodomaApp.workStep.minimumRatioNone"></option><option value="10">1/10</option><option value="5">1/5</option><option value="4">1/4</option><option value="2">1/2</option><option value="1">1</option></select></div></div><div class="row"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workStep.evaluation" for="field_evaluation"></label> <select class="form-control" id="field_evaluation" name="evaluation" ng-model="workStep.evaluation" ng-options="evaluation as evaluation.productName for evaluation in evaluations.entities track by evaluation.id"><option value=""></option></select></div></div><div class="form-group"><label translate="dodomaApp.workStep.description">Description</label> <textarea class="form-control" name="description" ng-model="workStep.description"> </textarea></div><div class="form-group"><div class="table-responsive"><table class="table table-striped"><thead><th></th><th translate="dodomaApp.workStepPartNeed.type">type</th><th translate="dodomaApp.workStepPartNeed.amount">AvailableAmount</th><th translate="dodomaApp.workStepPartNeed.part">stock</th></thead><tbody><tr ng-repeat="partNeed in workStep.requirements"><td><button type="button" class="btn btn-default btn-sm" ng-click="removeLine($index)"><i class="fas fa-minus-circle"></i></button></td><td><dd-work-step-part-need-select ng-model="partNeed.type" required name="partNeedType"></dd-work-step-part-need-select></td><td><input type="number" name="partNeedAmount" ng-model="partNeed.amount" required min="0"></td><td><ui-select ng-model="partNeed.part" dodoma-part name="part" required></ui-select></td></tr><tr><td><button type="button" class="btn btn-default btn-sm far fa-plus-circle" ng-click="addNewLine()"></button></td><td></td><td></td><td></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/workStep/workSteps.html','<div><h2 translate="dodomaApp.workStep.home.title">WorkStep</h2><button class="btn btn-primary btn-lg" ui-sref="workStep.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.workStep.home.createLabel">Create a new WorkStep</span></button><div class="modal fade" id="deleteWorkStepConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(workStep.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workStep.delete.question" translate-values="workStep">Are you sure you want to delete WorkStep?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>ID</th><th translate="dodomaApp.workStep.name">Name</th><th translate="dodomaApp.workStep.externalName">ExternalName</th><th translate="dodomaApp.workStep.description">Description</th><th translate="dodomaApp.workStep.standardTime">standardTime</th><th></th></tr></thead><tbody><tr ng-repeat="workStep in workSteps"><td><a ui-sref="workStepDetail({workStepId:workStep.id})">{{workStep.id}}</a></td><td>{{workStep.name}}</td><td>{{workStep.externalName}}</td><td>{{workStep.description}}</td><td>{{workStep.standardTime}}</td><td><button type="submit" ui-sref="workStepDetail({workStepId:workStep.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="workStepDetail.edit({workStepId:workStep.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(workStep.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pagination"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a>&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a>&lt;</a></li><li ng-show="page > 2" ng-click="loadPage(page - 2)"><a>{{page - 2}}</a></li><li ng-show="page > 1" ng-click="loadPage(page - 1)"><a>{{page - 1}}</a></li><li class="active"><a>{{page}}</a></li><li ng-show="page < links[\'last\']" ng-click="loadPage(page + 1)"><a>{{page + 1}}</a></li><li ng-show="page < links[\'last\'] - 1" ng-click="loadPage(page + 2)"><a>{{page + 2}}</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a>&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a>&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('scripts/app/entities/workStepPartNeed/workStepPartNeed-delete.html','<form name="deleteForm" ng-submit="confirmDelete(workStepPartNeed.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workStepPartNeed.delete.question" translate-values="workStepPartNeed">Are you sure you want to delete WorkStepPartNeed?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('scripts/app/entities/workStepPartNeed/workStepPartNeed-detail.html','<div><h2><span translate="dodomaApp.workStepPartNeed.detail.title">WorkStepPartNeed</span> {{workStepPartNeed.id}}</h2><button type="submit" ui-sref="workStepPartNeedDetail.edit({id:workStepPartNeed.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.workStepPartNeed.amount">Amount</span></td><td><input type="text" class="input-sm form-control" value="{{workStepPartNeed.amount}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workStepPartNeed.type">Type</span></td><td><input type="text" class="input-sm form-control" value="{{workStepPartNeed.type}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workStepPartNeed.part">part</span></td><td><input type="text" class="input-sm form-control" value="{{workStepPartNeed.part.name}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="workStepPartNeed" class="btn btn-info"><i class="fas fa-arrow-alt-square-left"></i>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('scripts/app/entities/workStepPartNeed/workStepPartNeed-dialog.html','<form name="editForm" role="form" novalidate ng-submit="create()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkStepPartNeedLabel" translate="dodomaApp.workStepPartNeed.home.createOrEditLabel">Create or edit a WorkStepPartNeed</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.workStepPartNeed.amount">Amount</label> <input type="number" class="form-control" name="amount" ng-model="workStepPartNeed.amount" required min="0"><div ng-show="editForm.amount.$invalid"><p class="help-block" ng-show="editForm.amount.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.amount.$error.min" translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.amount.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="dodomaApp.workStepPartNeed.type">Type</label><div class="input-group"><div class="btn-group"><label class="btn btn-primary" ng-model="workStepPartNeed.type" uib-btn-radio="\'TOOL\'" translate="dodomaApp.workStepPartNeed.typeLabel.TOOL" required>tool</label> <label class="btn btn-primary" ng-model="workStepPartNeed.type" uib-btn-radio="\'CONSUMABLE\'" translate="dodomaApp.workStepPartNeed.typeLabel.CONSUMABLE" required>tool</label></div></div><div ng-show="editForm.type.$invalid"><p class="help-block" ng-show="editForm.type.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.type.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label translate="dodomaApp.workStepPartNeed.part">part</label><ui-select ng-model="workStepPartNeed.part" name="part" dodoma-part allow-clear required></ui-select><div ng-show="editForm.part.$invalid"><p class="help-block" ng-show="editForm.part.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/workStepPartNeed/workStepPartNeeds.html','<div><h2 translate="dodomaApp.workStepPartNeed.home.title">WorkStepPartNeed</h2><button class="btn btn-primary btn-lg" ui-sref="workStepPartNeed.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.workStepPartNeed.home.createLabel">Create a new WorkStepPartNeed</span></button><div class="modal fade" id="deleteWorkStepPartNeedConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(workStepPartNeed.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><error-display></error-display><p translate="dodomaApp.workStepPartNeed.delete.question" translate-values="{amount:workStepPartNeed.amount, part:workStepPartNeed.part, id:workStepPartNeed.id}">Are you sure you want to delete WorkStepPartNeed?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th>ID</th><th translate="dodomaApp.workStepPartNeed.amount">Amount</th><th translate="dodomaApp.workStepPartNeed.type">Type</th><th translate="dodomaApp.workStepPartNeed.part">part</th><th></th></tr></thead><tbody><tr ng-repeat="workStepPartNeed in workStepPartNeeds"><td><a ui-sref="workStepPartNeedDetail({id:workStepPartNeed.id})">{{workStepPartNeed.id}}</a></td><td>{{workStepPartNeed.amount}}</td><td>{{workStepPartNeed.type}}</td><td>{{workStepPartNeed.part.name}}</td><td><button type="submit" ui-sref="workStepPartNeedDetail({id:workStepPartNeed.id})" class="btn btn-info"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="workStepPartNeedDetail.edit({id:workStepPartNeed.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(workStepPartNeed.id)" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('scripts/app/entities/workType/workType-detail.html','<div><h2>{{workType.name}}</h2><h4 translate="dodomaApp.workType.detail.title">WorkType</h4><error-display></error-display><uib-tabset justified="false"><uib-tab><uib-tab-heading><span class="fas fa-building"></span>&nbsp;<span translate="dodomaApp.workType.detail.general">General</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.workType.name" value="workType.name"></dod-display-value></div><div class="row"><dod-display-value label="dodomaApp.workType.description" value="workType.description"></dod-display-value></div><button type="submit" ui-sref="workTypeDetail.edit({id:workType.id})" class="btn btn-warning"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></div></div></uib-tab><uib-tab><uib-tab-heading><span class="fas fa-male"></span>&nbsp;<span translate="dodomaApp.workType.detail.workers">Workers</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.workType.detail.workers">Workers</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.workType.worker">Worker</th></tr></thead><tbody><tr ng-repeat="worker in workers"><td><worker-link worker="worker"></worker-link></td></tr></tbody></table></div></div></uib-tab></uib-tabset><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/workType/workType-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkTypeLabel" translate="dodomaApp.workType.home.createOrEditLabel">Create or edit a WorkType</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.workType.name" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="workType.name" required ng-maxlength="50"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="dodomaApp.workType.description" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="workType.description" ng-maxlength="500"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/workType/workTypes.html','<div><h2 translate="dodomaApp.workType.home.title">WorkTypes</h2><button class="btn btn-primary" ui-sref="workType.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.workType.home.createLabel">Create a new WorkType</span></button><div class="modal fade" id="deleteWorkTypeConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(workType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workType.delete.question" translate-values="workType">Are you sure you want to delete WorkType?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.workType.name">Name</th><th translate="dodomaApp.workType.description">Description</th><th></th></tr></thead><tbody><tr ng-repeat="workType in workTypes"><td><a ui-sref="workTypeDetail({workTypeId:workType.id})">{{workType.name}}</a></td><td>{{workType.description}}</td><td><button type="submit" ui-sref="workTypeDetail({workTypeId:workType.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="workTypeDetail.edit({workTypeId:workType.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(workType.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></div>');
$templateCache.put('scripts/app/entities/worker/employment-list.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkerLabel" translate="dodomaApp.worker.detail.employments">employments</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="dodomaApp.employment.startDate">StartDate</th><th translate="dodomaApp.employment.endDate">EndDate</th><th translate="dodomaApp.employment.description">Description</th><th translate="dodomaApp.employment.employmentCode">EmploymentCode</th><th translate="dodomaApp.employment.workingHours">WorkingHours</th></tr></thead><tbody><tr ng-repeat="employment in employments"><td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.startDate}}</a></td><td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.endDate}}</a></td><td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.description}}</a></td><td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.employmentCode}}</a></td><td>{{employment.workingHours}}</td></tr><tr><td colspan="5"><button type="submit" class="btn btn-default" ui-sref="employmentNew"><i class="fas fa-plus-circle"></i> <span translate="dodomaApp.employment.home.createLabel">Create a new Employment</span></button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="far fa-check-circle"></i>&nbsp;<span translate="entity.action.close">Close</span></button></div>');
$templateCache.put('scripts/app/entities/worker/worker-detail.html','<div><h2>{{worker.lastName}} {{worker.firstName}}</h2><h4 translate="dodomaApp.worker.detail.title">Worker</h4><div class="row"><div class="col-md-8"><div class="btn-group" uib-dropdown uib-keyboard-nav><button id="base-datas" type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle><span translate="dodomaApp.workerRecord.menu.datas">datas</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="add-new-button"><li has-any-role="ROLE_REHABMANAGER,ROLE_PRODUCTIONMANAGER"><a ui-sref=".edit({id:worker.id})" translate="dodomaApp.worker.detail.edit">Edit</a></li><li><a ui-sref=".editProfile({recordType:\'personal_profile\'})" translate="dodomaApp.workerRecord.menu.personalProfile">personalProfile</a></li><li><a ui-sref=".editProfile({recordType:\'employment\'})" translate="dodomaApp.workerRecord.menu.employmentProfile">employmentProfile</a></li><li has-role="ROLE_REHABMANAGER" ng-if="worker.visibleInRehab"><a ui-sref=".editProfile({recordType:\'rehab_profile\'})" translate="dodomaApp.workerRecord.menu.rehabProfile">rehabProfile</a></li><!-- <li>\n               <a ui-sref=".editProfile({recordType:\'employment_profile\'})" translate="dodomaApp.workerRecord.menu.rehabProfile">rehabProfile</a>\n             </li> --></ul></div><button type="submit" ui-sref=".editProfile({recordType:\'TESTWORK_EVALUATION\'})" class="btn btn-primary" has-role="ROLE_REHABMANAGER" ng-if="worker.visibleInRehab"><i class="fas fa-pencil"></i>&nbsp;<span translate="dodomaApp.workerRecord.menu.testWorkEvaluation"> Edit</span></button><div class="btn-group" has-role="ROLE_REHABMANAGER" ng-if="worker.visibleInRehab" uib-dropdown uib-keyboard-nav><button id="personal-rehab-plan" type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle><span translate="dodomaApp.workerRecord.menu.personalRehabPlan">datas</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="add-new-button"><li><a ui-sref=".editProfile({recordType:\'PERSONAL_REHAB_PLAN\'})" translate="dodomaApp.workerRecord.menu.personalRehabPlan">personalProfile</a></li><li class="divider"></li><li><a ui-sref=".editProfile({recordType:\'health_assessment\'})" translate="dodomaApp.workerRecord.create.HEALTH_ASSESSMENT">health_assessment</a></li><li><a ui-sref=".editProfile({recordType:\'social_assessment\'})" translate="dodomaApp.workerRecord.create.SOCIAL_ASSESSMENT">social_assessment</a></li><li><a ui-sref=".editProfile({recordType:\'rehab_carrier_plan\'})" translate="dodomaApp.workerRecord.create.REHAB_CARRIER_PLAN">rehab_carrier_plan</a></li><li><a ui-sref=".editProfile({recordType:\'aptitude_survey\'})" translate="dodomaApp.workerRecord.create.APTITUDE_SURVEY">aptitude_survey</a></li><li><a ui-sref=".editProfile({recordType:\'PROFESSIONAL_TEAM_OPINION\'})" translate="dodomaApp.workerRecord.create.PROFESSIONAL_TEAM_OPINION">PROFESSIONAL_TEAM_OPINION</a></li><li><a ui-sref=".editProfile({recordType:\'edu_work_exp_assessment\'})" translate="dodomaApp.workerRecord.create.EDU_WORK_EXP_ASSESSMENT">edu_work_exp_assessment</a></li><li class="divider"></li><li><a ui-sref=".editProfile({recordType:\'REHAB_PLAN_INV_REPORT\'})" translate="dodomaApp.workerRecord.create.REHAB_PLAN_INV_REPORT">REHAB_PLAN_INV_REPORT</a></li></ul></div><button has-role="ROLE_REHABMANAGER" ng-if="worker.visibleInRehab" type="submit" ui-sref=".editProfile({recordType:\'TESTWORK_SHEET\'})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="dodomaApp.workerRecord.menu.testWork"> Edit</span></button> <button type="submit" ui-sref=".newWorkLog" class="btn btn-primary" has-role="ROLE_WORKLOG" ng-if="worker.visibleInRehab"><i class="fas fa-pencil"></i>&nbsp;<span translate="dodomaApp.workLog.home.createLabel"> New</span></button><download-button has-role="ROLE_REHABMANAGER" ng-if="worker.visibleInRehab" url="recordAggregatedDocs(worker)" label="dodomaApp.workerRecord.aggregatedDocsDownload"></download-button></div><div class="col-md-4" has-role="ROLE_SYSADMIN"><div class="btn-group" uib-dropdown uib-keyboard-nav><button id="add-new-button" type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle><span translate="dodomaApp.workerRecord.createNew">Add new</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="add-new-button"><li ng-repeat="wr in DodomaConfig.workerRecords"><a ui-sref=".newRecord({type:wr})" translate="{{\'dodomaApp.workerRecord.create.\'+wr }}">Create a new WorkerRecord</a></li></ul></div></div></div><div class="modal fade" id="deleteWorkerRecordConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmWorkerRecordDelete(recordToDelete.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workerRecord.delete.question" translate-values="recordToDelete">Are you sure you want to delete WorkerRecord?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><uib-tabset justified="false"><uib-tab><uib-tab-heading><span class="fas fa-male"></span>&nbsp;<span translate="dodomaApp.worker.detail.general">General</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-body"><div class="row"><dod-display-value label="dodomaApp.worker.lastName" value="worker.lastName"></dod-display-value><dod-display-value label="dodomaApp.worker.firstName" value="worker.firstName"></dod-display-value></div></div></div></uib-tab><uib-tab has-role="ROLE_PRODUCTIONMANAGER" ng-if="worker.visibleInProd"><uib-tab-heading><span class="fas fa-building"></span>&nbsp;<span translate="dodomaApp.worker.detail.workshopAssignment">workshopAssignment</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.worker.detail.workshopAssignment">Orders</div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.workshopAssignment.level">Level</th><th translate="dodomaApp.workshopAssignment.workType">Work shop</th><th></th></tr></thead><tbody><tr ng-repeat="assignment in worker.assignments"><td><button type="submit" ng-click="deleteAssignment(assignment.id)" class="btn btn-danger"><i class="far fa-times-circle"></i></button></td><td>{{assignment.level}}</td><td><work-type-link work-type="assignment.workType"></work-type-link></td><td><button type="submit" ui-sref=".workshopAssignmentEditItem({assignmentId:assignment.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td></tr><tr><td colspan="4"><button type="submit" class="btn btn-default" ui-sref=".workshopAssignmentNewItem"><i class="fas fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.workshopAssignment.home.createLabel">Create a new workshop assignment</span></button></td></tr></tbody></table></div></div></uib-tab><uib-tab has-role="ROLE_PRODUCTIONMANAGER" ng-if="worker.visibleInProd"><uib-tab-heading><span class="fas fa-book"></span>&nbsp;<span translate="dodomaApp.worker.detail.qualifications">qualifications</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.worker.detail.qualifications">Qualifications</div><div class="panel-body"><table class="table"><thead><tr><th></th><th translate="dodomaApp.workerQualification.level">Level</th><th translate="dodomaApp.workerQualification.workstep">Work type</th><th></th></tr></thead><tbody><tr ng-repeat="qualification in worker.qualifications" class="workstep-active-{{qualification.workstep.active}}"><td><button type="submit" ng-click="deleteItem(qualification.id)" class="btn btn-danger"><i class="far fa-times-circle"></i></button></td><td>{{qualification.level}}</td><td>{{qualification.workstep.name}} ({{qualification.workstep.externalName}})</td><td><button type="submit" ui-sref=".qualificationEditItem({qualificationId:qualification.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button></td></tr><tr><td colspan="4"><button type="submit" class="btn btn-default" ui-sref=".qualificationNewItem"><i class="fas fa-plus-circle"></i>&nbsp;<span translate="dodomaApp.workerQualification.home.createLabel">Create a new worker qualification</span></button></td></tr></tbody></table></div></div></uib-tab><!-- <uib-tab heading="{{ \'dodomaApp.worker.detail.employments\' | translate }}" select="switchToEmployments()" has-role="ROLE_SYSADMIN"  ng-if="worker.visibleInProd">\n      <div class="table-responsive">\n        <table class="table table-striped">\n            <thead>\n                <tr>\n                    <th translate="dodomaApp.employment.startDate">StartDate</th>\n                    <th translate="dodomaApp.employment.endDate">EndDate</th>\n                    <th translate="dodomaApp.employment.description">Description</th>\n                    <th translate="dodomaApp.employment.employmentCode">EmploymentCode</th>\n                    <th translate="dodomaApp.employment.workingHours">WorkingHours</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="employment in employments">\n                    <td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.startDate}}</a></td>\n                    <td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.endDate}}</a></td>\n                    <td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.description}}</a></td>\n                    <td><a ui-sref="employmentEdit({employmentId:employment.id})">{{employment.employmentCode}}</a></td>\n                    <td>{{employment.workingHours}}</td>\n                </tr>\n                <tr>\n                    <td colspan="5">\n                      <button type="submit" class="btn btn-default" ui-sref="employmentNew">\n                        <i class="fas fa-plus-circle"></i> <span translate="dodomaApp.employment.home.createLabel">Create a new Employment</span>\n                      </button>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n      </div>\n    </uib-tab> --><uib-tab has-role="ROLE_REHABMANAGER" select="switchToRecords()" ng-if="worker.visibleInRehab"><uib-tab-heading><span class="fas fa-check-square"></span>&nbsp;<span translate="dodomaApp.worker.detail.rehab">documentation</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.worker.detail.rehab">documentation</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.workerRecord.status">Status</th><th translate="dodomaApp.workerRecord.type">Type</th><th translate="dodomaApp.workerRecord.recordDate">RecordDate</th><th translate="dodomaApp.workerRecord.validityDate">ValidityDate</th><th translate="dodomaApp.workerRecord.lastModifiedDate">lastModifiedDate</th><th translate="dodomaApp.workerRecord.minutes">Minutes</th><th translate="dodomaApp.workerRecord.documents">Documents</th><th translate="global.field.creator">creator</th><th></th></tr></thead><tbody><tr ng-repeat="workerRecord in workerRecords"><td><a ui-sref=".editRecord({id:workerRecord.id})">{{workerRecord.status | workerRecordStatus }}</a></td><td><a ui-sref=".editRecord({id:workerRecord.id})">{{workerRecord.type | workerRecordType }}</a></td><td>{{workerRecord.recordDate}}</td><td>{{workerRecord.validityDate}}</td><td>{{workerRecord.lastModifiedDate | dodTime}}</td><td>{{workerRecord.minutes}}</td><td><span ng-repeat="doc in workerRecord.documents"><doc-link record-id="workerRecord.id" document="doc"></doc-link></span></td><td>{{workerRecord.creator.name}}</td><td><button type="submit" ui-sref=".editRecord({id:workerRecord.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><download-button ng-if="isExportable(workerRecord)" url="recordExportUrl(workerRecord)"></download-button><button type="submit" ng-if="workerRecord.type !== \'LOG\'" has-role="ROLE_REHABMANAGER" ng-click="deleteWorkerRecord(workerRecord)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="workerRecordsPageResult" callback-fn="loadWorkerRecordPage(page)"></dodoma-navigation></div></div></uib-tab><uib-tab has-role="ROLE_REHABMANAGER" select="switchToRecords()" ng-if="worker.visibleInRehab"><uib-tab-heading><span class="fas fa-calendar-alt"></span>&nbsp;<span translate="dodomaApp.worker.detail.rehabLogs">rehab logs</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.worker.detail.rehabLogs">rehab logs</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.workerRecord.status">Status</th><th translate="dodomaApp.workerRecord.title">Title</th><th translate="dodomaApp.workerRecord.recordDate">RecordDate</th><th translate="dodomaApp.workerRecord.documents">Documents</th><th translate="global.field.creator">creator</th><th></th></tr></thead><tbody><tr ng-repeat="workerRecord in (workerRecords | filter:{type:\'LOG\'}) "><td><a ui-sref=".editRecord({id:workerRecord.id})">{{workerRecord.status | workerRecordStatus }}</a></td><td><a ui-sref=".editRecord({id:workerRecord.id})">{{workerRecord.title }}</a></td><td>{{workerRecord.recordDate}}</td><td><span ng-repeat="doc in workerRecord.documents"><doc-link record-id="workerRecord.id" document="doc"></doc-link></span></td><td>{{workerRecord.creator.name}}</td><td><button type="submit" ui-sref=".editRecord({id:workerRecord.id})" class="btn btn-primary btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><download-button ng-if="isExportable(workerRecord)" url="recordExportUrl(workerRecord)"></download-button><button type="submit" ng-if="workerRecord.type !== \'LOG\'" has-role="ROLE_REHABMANAGER" ng-click="deleteWorkerRecord(workerRecord)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><!-- TODO: this paging is not correct --><dodoma-navigation page-info="workerRecordsPageResult" callback-fn="loadWorkerRecordPage(page)"></dodoma-navigation><br><button type="submit" ui-sref=".newRecord({type:\'LOG\'})" class="btn btn-primary"><i class="fas fa-bolt"></i>&nbsp;<span translate="dodomaApp.workerRecord.create.LOG"> Edit</span></button></div></div></uib-tab><uib-tab has-role="ROLE_SYSADMIN" select="switchToLogs()" ng-if="worker.visibleInRehab"><uib-tab-heading><span class="fas fa-tasks"></span>&nbsp;<span translate="dodomaApp.worker.detail.worklog">rehab logs</span></uib-tab-heading><div class="panel panel-primary"><div class="panel-heading" translate="dodomaApp.worker.detail.worklog">rehab logs</div><div class="panel-body"><table class="table"><thead><tr><th translate="dodomaApp.workLog.recordDate">RecordDate</th><th translate="dodomaApp.workLog.task">Task</th><th translate="dodomaApp.workLog.minutes">Minutes</th><th translate="dodomaApp.workLog.executorUser">user</th><th translate="dodomaApp.workLog.relatedOther">RelatedOther</th></tr></thead><tbody><tr ng-repeat="workLog in workLogs"><td ng-if="!hasRecord(workLog)"><a ui-sref=".editWorkLog({workLogId:workLog.id})">{{workLog.recordDate}}</a></td><td ng-if="!hasRecord(workLog)"><a ui-sref=".editWorkLog({workLogId:workLog.id})">{{workLog.task}}</a></td><td ng-if="hasRecord(workLog)"><a ui-sref=".editRecord({id:workLog.createdRecord.id})">{{workLog.recordDate}}</a></td><td ng-if="hasRecord(workLog)"><a ui-sref=".editRecord({id:workLog.createdRecord.id})">{{workLog.createdRecord.type | workerRecordType }} - {{workLog.task}}</a></td><td>{{workLog.minutes | timeFormat}}</td><td>{{workLog.executor.name}}</td><td>{{workLog.relatedOther}}</td></tr></tbody></table><dodoma-navigation page-info="workLogPagesResult" callback-fn="loadWorkLogPage(page)"></dodoma-navigation></div></div></uib-tab></uib-tabset><div>&nbsp;</div><back-button page="\'worker\'"></back-button></div>');
$templateCache.put('scripts/app/entities/worker/worker-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="WorkerUpdateDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkerLabel" translate="dodomaApp.worker.home.createOrEditLabel">Create or edit a Worker</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.worker.lastName" for="field_lastName">LastName</label> <input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="worker.lastName" required ng-maxlength="50"></div><div class="form-group"><label translate="dodomaApp.worker.firstName" for="field_firstName">FirstName</label> <input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="worker.firstName"></div><div class="row"><div class="col-md-4"><label translate="dodomaApp.worker.visibleInStock" for="field_visibleInStock">visibleInStock</label> <input type="checkbox" class="form-control" name="visibleInStock" id="field_visibleInStock" ng-model="worker.visibleInStock"></div><div class="col-md-4"><label translate="dodomaApp.worker.visibleInProd" for="field_visibleInProd">visibleInProd</label> <input type="checkbox" class="form-control" name="visibleInProd" id="field_visibleInProd" ng-model="worker.visibleInProd"></div><div class="col-md-4"><label translate="dodomaApp.worker.visibleInRehab" for="field_visibleInRehab">visibleInRehab</label> <input type="checkbox" class="form-control" name="visibleInRehab" id="field_visibleInRehab" ng-model="worker.visibleInRehab"></div></div><div has-role="ROLE_SYSADMIN_HIDDEN"><div class="form-group"><label translate="dodomaApp.worker.socialSecurityNumber" for="field_socialSecurityNumber">SocialSecurityNumber</label> <input type="text" class="form-control" name="socialSecurityNumber" id="field_socialSecurityNumber" ng-model="worker.socialSecurityNumber"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.worker.birthDate" for="field_birthDate">BirthDate</label> <input bs-datepicker type="text" class="form-control" name="birthDate" id="field_birthDate" ng-model="worker.birthDate"></div><worker-record-display worker-record="worker.personalProfile" type="\'PERSONAL_PROFILE\'" record-readonly="false"></worker-record-display></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/worker/workerPlanning.html','<main-layout title-key="dodomaApp.worker.home.title"><pane-filter><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="date" translate="dodomaApp.worker.filter.date">Date</label> <input bs-datepicker type="text" class="form-control" name="date" id="date" ng-model="filter.date" ng-change="loadAll()"></div></pane-filter><pane-main><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.worker.firstName">FirstName</th><th translate="dodomaApp.worker.lastName">LastName</th><th translate="dodomaApp.worker.socialSecurityNumber">SocialSecurityNumber</th><th translate="dodomaApp.worker.employmentStart">EmploymentStart</th><th translate="dodomaApp.worker.employmentEnd">EmploymentEnd</th><th translate="dodomaApp.worker.workingHours">WorkingHours</th><th translate="dodomaApp.worker.plannedTime">PlannedTime</th><th translate="dodomaApp.worker.freeTime">freeTime</th><th></th></tr></thead><tbody><tr ng-repeat="worker in workers"><td><a ui-sref="worker.detail({workerId:worker.id})">{{worker.firstName}}</a></td><td><a ui-sref="worker.detail({workerId:worker.id})">{{worker.lastName}}</a></td><td>{{worker.socialSecurityNumber}}</td><td>{{worker.employmentStart}}</td><td>{{worker.employmentEnd}}</td><td>{{worker.workingHours}}</td><td><a ui-sref="productionSheetItem({workerId:worker.id, workerName: (worker.lastName + \' \' + worker.firstName), y:executionYear, m:executionMonth, d:executionDay})">{{worker.plannedTime}}</a></td><td>{{worker.freeTime}}</td><td><button type="submit" ui-sref="worker.detail({workerId:worker.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button></td></tr></tbody></table></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/worker/workers.html','<main-layout title-key="dodomaApp.worker.home.title"><pane-filter class="form-horizontal"><div class="form-group"><label class="control-label" for="worker" translate="dodomaApp.worker.filter.worker">Worker</label> <input type="text" class="form-control" name="worker" id="worker" ng-model="filter.name" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="employmentDate" translate="dodomaApp.worker.filter.date">employmentDate</label> <input bs-datepicker type="text" class="form-control" name="employmentDate" id="employmentDate" ng-model="filter.employmentDate" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="workHours" translate="dodomaApp.worker.filter.workHours">workHours</label> <input type="number" class="form-control" name="workHours" id="workHours" ng-model="filter.workHours" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="module" translate="dodomaApp.worker.filter.module">module</label> <select class="form-control" name="module" id="module" ng-model="filter.module" ng-change="loadAll()"><option value=""></option><option value="STOCK" translate="dodomaApp.worker.module.STOCK"></option><option value="PRODUCTION" translate="dodomaApp.worker.module.PRODUCTION"></option><option value="REHABILITATION" translate="dodomaApp.worker.module.REHABILITATION"></option></select></div><div class="form-group"><label class="control-label" for="recordType" translate="dodomaApp.worker.filter.workerRecordType">workerRecordType</label> <select class="form-control" name="recordType" id="recordType" ng-model="filter.recordType" ng-change="loadAll()" ng-options="(wr | workerRecordType) for wr in DodomaConfig.listedWorkerRecords"><option value=""></option></select></div><div class="form-group"><label class="control-label" for="recordText" translate="dodomaApp.worker.filter.recordText">recordText</label> <input type="text" class="form-control" name="recordText" id="recordText" ng-model="filter.recordText" ng-change="loadAll()"></div><div class="form-group" ng-if="prodModule"><label class="control-label" for="workStep" translate="dodomaApp.productionSheetItem.filter.workStep">WorkType</label><ui-select ng-model="customFilter.workStep" dodoma-work-step allow-clear name="workStep" on-select="changePage({workstepId: $item.id})" on-clear="changePage({workstepId:null})"></ui-select></div></pane-filter><pane-main><button class="btn btn-primary" ui-sref="worker.new"><i class="fas fa-bolt"></i> <span translate="dodomaApp.worker.home.createLabel">Create a new Worker</span></button><download-button url="workerExportUrl()"></download-button><div class="modal fade" id="deleteWorkerConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(worker.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.worker.delete.question" translate-values="{ id:worker.id, firstName: worker.firstName, lastName: worker.lastName}">Are you sure you want to delete Worker?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.worker.lastName">LastName</th><th translate="dodomaApp.worker.firstName">FirstName</th><th translate="dodomaApp.worker.employmentStart">EmploymentStart</th><th translate="dodomaApp.worker.employmentEnd">EmploymentEnd</th><th translate="dodomaApp.worker.workingHours">WorkingHours</th><th></th></tr></thead><tbody><tr ng-repeat="worker in workers"><td><a ui-sref=".detail({workerId:worker.id})">{{worker.lastName}}</a></td><td><a ui-sref=".detail({workerId:worker.id})">{{worker.firstName}}</a></td><td>{{worker.employmentStart}}</td><td>{{worker.employmentEnd}}</td><td>{{worker.workingHours}}</td><td><button type="submit" ui-sref=".detail({workerId:worker.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref=".detail.edit({workerId:worker.id})" class="btn btn-warning btn-sm"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(worker.id)" class="btn btn-danger btn-sm"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/workerQualification/workerQualification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkerQualificationLabel" translate="dodomaApp.workerQualification.home.createOrEditLabel">Create or edit a WorkerQualification</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.workerQualification.level" for="field_level">Level</label> <input type="number" class="form-control" name="level" id="field_level" ng-model="workerQualification.level" required min="0" max="10"><div ng-show="editForm.level.$invalid"><p class="help-block" ng-show="editForm.level.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.level.$error.min" translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.level.$error.max" translate="entity.validation.max" translate-value-max="10">This field cannot be more than 10.</p><p class="help-block" ng-show="editForm.level.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="dodomaApp.workerQualification.workstep" for="field_workstep">workstep</label><ui-select ng-model="workerQualification.workstep" dodoma-work-step allow-clear name="field_workstep" required></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/entities/workerRecord/workerRecord-detail.html','<div><h2><span translate="dodomaApp.workerRecord.detail.title">WorkerRecord</span> {{workerRecord.id}}</h2><button type="submit" ui-sref="workerRecordDetail.edit({id:workerRecord.id})" class="btn btn-primary"><i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span></button><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="dodomaApp.workerRecord.status">Status</span></td><td><input type="text" class="input-sm form-control" value="{{workerRecord.status}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workerRecord.type">Type</span></td><td><input type="text" class="input-sm form-control" value="{{workerRecord.type}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workerRecord.recordDate">RecordDate</span></td><td><input type="text" class="input-sm form-control" value="{{workerRecord.recordDate}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workerRecord.minutes">Minutes</span></td><td><input type="text" class="input-sm form-control" value="{{workerRecord.minutes}}" readonly="readonly"></td></tr><tr><td><span translate="dodomaApp.workerRecord.worker">worker</span></td><td><input type="text" class="input-sm form-control" value="{{workerRecord.worker.firstName}}" readonly="readonly"></td></tr></tbody></table></div><back-button></back-button></div>');
$templateCache.put('scripts/app/entities/workerRecord/workerRecord-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation validation-messages="WorkerRecordDTO"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkerRecordLabel" translate="{{\'dodomaApp.workerRecord.typeLabel.\' + workerRecord.type.toUpperCase()}}">Create or edit a WorkerRecord</h4></div><div class="modal-body"><error-display></error-display><div class="row" ng-if="!simple || showMinutes"><div class="col-md-6 col-sm-12"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.workerRecord.recordDate" for="field_recordDate">RecordDate</label> <input bs-datepicker type="text" class="form-control" name="recordDate" id="field_recordDate" ng-model="workerRecord.recordDate" ng-readonly="recordReadonly"></div><div class="col-md-6 col-sm-12" ng-if="stateData.mode === \'REHAB\'"><label translate="dodomaApp.workerRecord.minutes" for="field_minutes">Minutes</label> <input type="number" class="form-control" name="minutes" id="field_minutes" ng-model="workerRecord.minutes" ng-readonly="recordReadonly"></div></div><div class="row" ng-if="!simple"><div class="col-md-6 col-sm-12" ng-if="hasValidityDate"><i class="fas fa-calendar-alt"></i>&nbsp;<label translate="dodomaApp.workerRecord.validityDate" for="field_validityDate">validityDate</label> <input bs-datepicker type="text" class="form-control" name="validityDate" id="field_validityDate" ng-model="workerRecord.validityDate" ng-readonly="recordReadonly"></div><div class="col-md-6 col-sm-12" ng-if="showMultipleWorkerSelector"><label translate="dodomaApp.workerRecord.worker" for="field_workers">worker</label><ui-select class="form-control" ng-model="workerRecord.workers" dodoma-worker multiple="multiple" allow-clear name="relatedWorkers" id="field_workers" ng-readonly="recordReadonly"></ui-select></div><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workerRecord.status" for="field_status">Status</label> <input type="text" class="form-control" name="status" value="{{workerRecord.status | workerRecordStatus}}" readonly="readonly"></div></div><div class="row" ng-if="showWorkerSelector()"><div class="col-md-6 col-sm-12"><label translate="dodomaApp.workerRecord.worker" for="field_worker">worker</label> <select class="form-control" id="field_worker" name="worker" ng-readonly="recordReadonly" ng-model="workerRecord.workers[0].id" ng-options="worker.id as (worker.firstName + \' \'+worker.lastName) for worker in workers.entities"></select></div></div><worker-record-display worker-record="workerRecord" type="workerRecord.type" record-readonly="recordReadonly" edit-form="editForm"></worker-record-display><div class="row" ng-if="showDocuments"><div class="col-md-12"><upload-list documents="documents" record-id="workerRecord.id" enable="!recordReadonly"></upload-list></div></div><!--  has-role="ROLE_SYSADMIN">{{workerRecord.params | json }}</pre> --></div><div class="modal-footer" ng-if="!recordReadonly"><download-button ng-if="isExportable(workerRecord)" url="recordExportUrl(workerRecord)"></download-button><button type="button" class="btn btn-default" data-dismiss="modal" ng-disabled="alreadyPressed" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || alreadyPressed " class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button> <button type="button" ng-disabled="editForm.$invalid || alreadyPressed" class="btn btn-primary" ng-click="finalize()"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.finalize">Finalize</span></button></div><div class="modal-footer" ng-if="recordReadonly"><dod-new-record></dod-new-record><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="far fa-check-circle"></i>&nbsp;<span translate="entity.action.close">Close</span></button><download-button ng-if="isExportable(workerRecord)" url="recordExportUrl(workerRecord)"></download-button></div></form>');
$templateCache.put('scripts/app/entities/workerRecord/workerRecords.html','<main-layout title-key="global.menu.entities.workerRecord"><pane-filter><div class="form-group"><label class="control-label" for="recordType" translate="dodomaApp.worker.filter.workerRecordType">workerRecordType</label> <select class="form-control" name="recordType" id="recordType" ng-model="filter.recordType" ng-change="loadAll()" ng-options="(wr | workerRecordType) for wr in DodomaConfig.listedWorkerRecords"><option value=""></option></select></div><div class="form-group"><label class="control-label" for="status" translate="dodomaApp.workerRecord.status">Status</label> <select class="form-control" name="status" id="status" ng-model="filter.status" ng-change="loadAll()"><option value="" translate="dodomaApp.workerRecord.statusLabel.All">All</option><option value="DRAFT" translate="dodomaApp.workerRecord.statusLabel.DRAFT">DRAFT</option><option value="FINAL" translate="dodomaApp.workerRecord.statusLabel.FINAL">FINAL</option></select></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="after" translate="dodomaApp.workerRecord.filter.after">StartDate</label> <input bs-datepicker type="text" class="form-control" name="after" id="after" ng-model="filter.after" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="before" translate="dodomaApp.workerRecord.filter.before">EndDate</label> <input bs-datepicker type="text" class="form-control" name="before" id="before" ng-model="filter.before" ng-change="loadAll()"></div><div class="form-group"><label class="control-label" for="worker" translate="dodomaApp.workerRecord.filter.worker">Worker</label><ui-select ng-model="customFilter.worker" dodoma-worker module="REHABILITATION" allow-clear name="worker" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><label class="control-label" for="creator" translate="dodomaApp.workerRecord.filter.creator">Creator</label><ui-select ng-model="customFilter.creator" dodoma-user-field allow-clear name="creator" on-select="loadAll()" on-clear="loadAll()"></ui-select></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="validity_after" translate="dodomaApp.workerRecord.filter.validityAfter">validity_StartDate</label> <input bs-datepicker type="text" class="form-control" name="validity_after" id="validity_after" ng-model="filter.validityAfter" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="validity_before" translate="dodomaApp.workerRecord.filter.validityBefore">validity_EndDate</label> <input bs-datepicker type="text" class="form-control" name="validity_before" id="validity_before" ng-model="filter.validityBefore" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="modified_after" translate="dodomaApp.workerRecord.filter.modifiedAfter">StartDate</label> <input bs-datepicker type="text" class="form-control" name="modified_after" id="modified_after" ng-model="filter.modifiedAfter" ng-change="loadAll()"></div><div class="form-group"><i class="fas fa-calendar-alt"></i>&nbsp;<label class="control-label" for="modified_before" translate="dodomaApp.workerRecord.filter.modifiedBefore">EndDate</label> <input bs-datepicker type="text" class="form-control" name="modified_before" id="modified_before" ng-model="filter.modifiedBefore" ng-change="loadAll()"></div></pane-filter><pane-main><div class="row" ng-if="ROLE_SYSADMIN"><div class="col-md-4"><div class="btn-group" uib-dropdown uib-keyboard-nav><button id="add-new-button" type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle><span translate="dodomaApp.workerRecord.createNew">Add new</span> <span class="caret"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="add-new-button"><li ng-repeat="wr in DodomaConfig.workerRecords"><a ui-sref=".newRecord({type:wr})" translate="{{\'dodomaApp.workerRecord.create.\'+wr }}">Create a new WorkerRecord</a></li></ul></div></div></div><div class="modal fade" id="deleteWorkerRecordConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(workerRecord.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="dodomaApp.workerRecord.delete.question" translate-values="workerRecord">Are you sure you want to delete WorkerRecord?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th translate="dodomaApp.workerRecord.status">Status</th><th translate="dodomaApp.workerRecord.type">Type</th><th translate="dodomaApp.workerRecord.recordDate">RecordDate</th><th translate="dodomaApp.workerRecord.validityDate">ValidityDate</th><th translate="dodomaApp.workerRecord.lastModifiedDate">lastModifiedDate</th><th translate="dodomaApp.workerRecord.minutes">Minutes</th><th translate="dodomaApp.workerRecord.worker">worker</th><th translate="global.field.creator">worker</th><!-- <th></th> --></tr></thead><tbody><tr ng-repeat="workerRecord in workerRecords"><td><span class="label label-info">{{workerRecord.status | workerRecordStatus }}</span></td><td><a ui-sref="rehabWorker.detail.editRecord({id:workerRecord.id, workerId: workerRecord.workerNames[0].id})">{{workerRecord.type | workerRecordType}}</a></td><td>{{workerRecord.recordDate}}</td><td>{{workerRecord.validityDate}}</td><td>{{workerRecord.lastModifiedDate | dodTime}}</td><td>{{workerRecord.minutes}}</td><td><span ng-repeat="worker in workerRecord.workerNames"><a ui-sref="rehabWorker.detail.editRecord({id:workerRecord.id, workerId: worker.id})">{{worker.name}}</a></span></td><td>{{workerRecord.creator.name}}</td><!-- <td>\n                        <button type="submit"\n                                ui-sref="workerRecordDetail({id:workerRecord.id})"\n                                class="btn btn-info btn-sm">\n                            <i class="far fa-eye"></i>&nbsp;<span translate="entity.action.view"> View</span>\n                        </button>\n                        <button type="submit"\n                                ui-sref="workerRecordDetail.edit({id:workerRecord.id})"\n                                class="btn btn-primary btn-sm">\n                            <i class="fas fa-pencil"></i>&nbsp;<span translate="entity.action.edit"> Edit</span>\n                        </button>\n                        <button type="submit"\n                                ng-click="delete(workerRecord.id)"\n                                class="btn btn-danger btn-sm">\n                            <i class="far fa-times-circle"></i>&nbsp;<span translate="entity.action.delete"> Delete</span>\n                        </button>\n                    </td> --></tr></tbody></table><dodoma-navigation page-info="pageResult" callback-fn="loadPage(page)"></dodoma-navigation></div></pane-main></main-layout>');
$templateCache.put('scripts/app/entities/workshopAssignment/workshopAssignment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myWorkshopAssignmentLabel" translate="dodomaApp.workshopAssignment.home.createOrEditLabel">Create or edit a WorkshopAssignment</h4></div><div class="modal-body"><error-display></error-display><div class="form-group"><label translate="dodomaApp.workshopAssignment.level" for="field_level">Level</label> <input type="number" class="form-control" name="level" id="field_level" ng-model="workshopAssignment.level" required min="0" max="10"><div ng-show="editForm.level.$invalid"><p class="help-block" ng-show="editForm.level.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.level.$error.min" translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.level.$error.max" translate="entity.validation.max" translate-value-max="10">This field cannot be more than 10.</p><p class="help-block" ng-show="editForm.level.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label translate="dodomaApp.workshopAssignment.workType" for="field_workType">workType</label><ui-select ng-model="workshopAssignment.workType" dodoma-work-type allow-clear name="field_workType" required></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><i class="fas fa-ban"></i>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('scripts/app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="success || keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="success"><p translate="reset.finish.messages.success"><strong>Your password has been reset.</strong> Please <a href="#/login">authenticate</a>.</p></div><div class="alert alert-danger" ng-show="doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="keyMissing"><form ng-show="!success" name="form" role="form" novalidate ng-submit="finishReset()" show-validation><div class="form-group"><label translate="global.form.newpassword">New password</label> <input type="password" class="form-control" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="resetAccount.password" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="resetAccount.password"></password-strength-bar></div><div class="form-group"><label translate="global.form.confirmpassword">New password confirmation</label> <input type="password" class="form-control" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('scripts/app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!success" name="form" role="form" novalidate ng-submit="requestReset()" show-validation><div class="form-group"><label translate="global.form.email">E-mail</label> <input type="email" class="form-control" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Register</button></form></div></div></div>');
$templateCache.put('scripts/app/entities/workerRecord/templates/aptitude_survey.html','<uib-tabset><uib-tab heading="K\xE9pess\xE9gek"><div class="form-group"><label class="center">Kognit\xEDv teljes\xEDtm\xE9ny</label><dod-field-scoring name="field1" label="Figyelem, koncentr\xE1ci\xF3:"></dod-field-scoring><dod-field-scoring name="field2" label="Eml\xE9kez\u0151k\xE9pess\xE9g"></dod-field-scoring><dod-field-scoring name="field3" label="Tanul\xE9konys\xE1g"></dod-field-scoring><dod-field-scoring name="field4" label="Gondolkod\xE1si funkci\xF3"></dod-field-scoring><dod-field-scoring name="field5" label="Olvas\xE1s, \xE9rt\u0151 olvas\xE1s"></dod-field-scoring><dod-field-scoring name="field6" label="\xCDr\xE1s"></dod-field-scoring><dod-field-scoring name="field7" label="Sz\xE1mol\xE1s"></dod-field-scoring></div><div class="form-group"><label class="center">Motoros funkci\xF3k</label><dod-field-scoring name="field8" label="K\xE9z\xFCgyess\xE9g, finom motorika"></dod-field-scoring><dod-field-scoring name="field9" label="Szem-k\xE9zkoordin\xE1ci\xF3"></dod-field-scoring></div><div class="form-group"><label class="center">Szoci\xE1lis \xE9s t\xE1rsas funkci\xF3k</label><dod-field-scoring name="field10" label="Kommunik\xE1ci\xF3s k\xE9szs\xE9g"></dod-field-scoring><dod-field-scoring name="field11" label="Munkat\xE1rsakhoz val\xF3 viszony"></dod-field-scoring><dod-field-scoring name="field12" label="Egy\xFCttm\u0171k\xF6d\u0151 k\xE9szs\xE9g"></dod-field-scoring><dod-field-scoring name="field13" label="Kapcsolatteremt\u0151 k\xE9szs\xE9g"></dod-field-scoring><dod-field-scoring name="field14" label="Szab\xE1lytart\xE1s, \xF6nkontroll"></dod-field-scoring><dod-field-scoring name="field15" label="Konfliktuskezel\xE9s"></dod-field-scoring><dod-field-scoring name="field16" label="Stresszt\u0171r\u0151-k\xE9pess\xE9g"></dod-field-scoring><dod-field-scoring name="field17" label="Pontoss\xE1g, gondoss\xE1g"></dod-field-scoring></div></uib-tab><uib-tab heading="Munkamagatart\xE1s, viselked\xE9s \xE9rt\xE9kel\xE9se"><dod-field type="select" name="taskExecution" label="Feladat v\xE9grehajt\xE1s"><option value="0">nem hajtja v\xE9gre</option><option value="1">csak a neki tetsz\u0151 feladatokat oldja meg</option><option value="2">minden feladatot megold</option><option value="3">\xF6n\xE1ll\xF3 munkakezdem\xE9nyez\xE9s, munkav\xE9gz\xE9s</option></dod-field><dod-field type="select" name="taskConcussness" label="Feladattudat"><option value="0">kialakulatlan, nincs</option><option value="1">gyenge, fejlesztend\u0151</option><option value="2">megfelel\u0151</option></dod-field><dod-field type="select" name="taskUnderstanding" label="Feladat\xE9rt\xE9s"><option value="0">alacsony sz\xEDnvonal\xFA</option><option value="1">t\xF6bbsz\xF6r\xF6s magyar\xE1zat ut\xE1n meg\xE9rti</option><option value="2">megfelel\u0151</option></dod-field><dod-field type="select" name="workSpeed" label="Munkatemp\xF3"><option value="0">lass\xFA</option><option value="1">egyenetlen</option><option value="2">\xE1tlagos, megfelel\u0151</option></dod-field><dod-field type="select" name="workMotivation" label="Munkamotiv\xE1ci\xF3,teljes\xEDtm\xE9nymotiv\xE1ci\xF3"><option value="0">alacsony szint\u0171, teljes\xEDtm\xE9nye alatta marad k\xE9pess\xE9geinek</option><option value="1">v\xE1ltoz\xF3, egyenetlen teljes\xEDtm\xE9ny</option><option value="2">megfelel\u0151, k\xE9pess\xE9geinek megfelel\u0151 teljes\xEDtm\xE9nye</option></dod-field><dod-textarea name="otherRemarks" label="Egy\xE9b megjegyz\xE9s:"></dod-textarea></uib-tab></uib-tabset>');
$templateCache.put('scripts/app/entities/workerRecord/templates/edu_work_exp_assessment.html','<uib-tabset><uib-tab heading="K\xE9pzetts\xE9g"><dod-field type="text" name="highestSchool" label="Legmagasabb iskolai v\xE9gezetts\xE9ge:"></dod-field><dod-field type="text" name="profession" label="Szakk\xE9pzetts\xE9ge:"></dod-field><dod-textarea name="otherCertificates" label="Egy\xE9b Iskola/k\xE9pz\xE9si int\xE9zm\xE9ny/tanfolyam/jogos\xEDtv\xE1nyok:"></dod-textarea></uib-tab><uib-tab ng-repeat="idx in createRangeByVariable(\'jobCounter\', 3)" heading="{{\'Kor\xE1bbi munkak\u0151r (\'+(idx+1)+\')\'}}"><div class="well"><dod-textarea expr="\'prevWork_\'+idx" label="Kor\xE1bbi munkak\u0151r:"></dod-textarea><dod-textarea expr="\'jobDuties_\' + idx" label="Munkak\xF6ri feladatok:"></dod-textarea><dod-field expr="\'employer_\'+idx" label="Munk\xE1ltat\xF3 neve:"></dod-field><dod-field expr="\'employmentTime_\'+idx" label="Munkav\xE9gz\xE9s ideje:"></dod-field></div><button type="button" class="btn btn-default" ng-click="incVariable(\'jobCounter\', 3, 1)" ng-disabled="isReadonly()"><i class="far fa-plus-circle"></i>&nbsp;\xDAj munkak\u0151r</button></uib-tab></uib-tabset>');
$templateCache.put('scripts/app/entities/workerRecord/templates/employment.html','<dod-field type="date" name="employmentStart" label="Munkaviszony kezdete:"></dod-field><dod-field type="date" name="employmentEnd" label="Munkaviszony v\xE9ge:"></dod-field><dod-field type="select" name="workType" label="Munkaviszony t\xEDpusa:"><option value="term">hat\xE1rozott idej\u0171</option><option value="perm">hat\xE1rozatlan idej\u0171</option></dod-field><dod-field type="text" name="feorCode" label="FEOR k\xF3d:" required="workerRecord.worker.visibleInProd"></dod-field><dod-field type="date" name="feorValidity" label="FEOR \xE9rv\xE9nyess\xE9ge:" required="workerRecord.worker.visibleInProd"></dod-field><dod-field type="select" name="workHourType" label="Munkaid\u0151:" required="workerRecord.worker.visibleInProd"><option value="daily">napi munkaid\u0151</option><option value="weekly">munkaid\u0151 keret</option></dod-field><dod-field type="number" ng-if="workerRecord.params.workHourType === \'daily\'" name="workHours" label="Napi munkaid\u0151:" required="workerRecord.worker.visibleInProd"></dod-field><dod-field type="number" ng-if="workerRecord.params.workHourType === \'weekly\'" name="workHourLimit" label="Munkaid\u0151 keret:"></dod-field><dod-field type="text" name="workPlace" label="Munkav\xE9gz\xE9s helye:"></dod-field><dod-field type="date" name="healthCheck" label="Foglalkoz\xE1s-eg\xE9szs\xE9gy\xFCgyi vizsg\xE1lat kelte:" required="workerRecord.worker.visibleInProd"></dod-field><dod-field type="text" name="healthCheckResult" label="Eredm\xE9nye:" required="workerRecord.worker.visibleInProd"></dod-field><dod-field type="date" name="healthCheckValidity" label="\xC9rv\xE9nyess\xE9ge" required="workerRecord.worker.visibleInProd"></dod-field>');
$templateCache.put('scripts/app/entities/workerRecord/templates/health_assessment.html','<dod-textarea name="healtHistory" label="Betegs\xE9gt\xF6rt\xE9net, k\xF3rel\u0151zm\xE9nyek:"></dod-textarea><dod-textarea name="physicianOpinion" label="Foglalkoz\xE1s eg\xE9szs\xE9g\xFCgyi szakorvos v\xE9lem\xE9nye:"></dod-textarea><dod-field type="yesno" name="regularMedicine" label="Rendszeres gy\xF3gykezel\xE9s:"></dod-field><dod-field name="cureName" label="Gy\xF3gykezel\xE9s megnevez\xE9se:"></dod-field><dod-field name="medicineName" label="Gy\xF3gyszeres ter\xE1pia (megnevez\xE9s, adagol\xE1s):"></dod-field><dod-field type="yesno" name="publicHealthcare" label="K\xF6zgy\xF3gyell\xE1t\xE1sban r\xE9szes\xFCl:"></dod-field><dod-field type="yesno" name="useMedicalEquipments" label="Gy\xF3gy\xE1szati seg\xE9deszk\xF6z\xF6k haszn\xE1lata:"></dod-field><dod-field type="select" ng-if="workerRecord.params.useMedicalEquipments === \'yes\' " name="medicalEquipmentType" label="Gy\xF3gy\xE1szati seg\xE9deszk\xF6z t\xEDpusa:"><option value="rod">bot</option><option value="walker">j\xE1r\xF3keret</option><option value="crutches">mank\xF3</option><option value="wheelchair">tol\xF3sz\xE9k</option><option value="other">egy\xE9b</option></dod-field><dod-field name="medicalEquipmentOtherType" ng-if="workerRecord.params.medicalEquipmentType === \'other\' " label="Gy\xF3gy\xE1szati seg\xE9deszk\xF6z t\xEDpusa (egy\xE9b):"></dod-field><div class="well"><h4>Egy\xE9b fogyat\xE9koss\xE1g</h4><div class="row"><dod-field size="6" type="yesno" name="visuallyImpaired" label="L\xE1t\xE1ss\xE9r\xFClt:"></dod-field><dod-field size="6" type="yesno" name="hearingImpaired" label="Hall\xE1ss\xE9r\xFClt:"></dod-field></div><div class="row"><dod-field size="6" type="yesno" name="movmentsDisabled" label="Mozg\xE1skorl\xE1tozott:"></dod-field><dod-field size="6" type="yesno" name="mentallyDisabled" label="\xC9rtelmifogyat\xE9kos:"></dod-field></div></div><dod-field name="factorsLimitingWorkText" label="Munkav\xE9gz\xE9st korl\xE1toz\xF3 t\xE9nyez\u0151k:"></dod-field><dod-field type="select" name="factorsLimitingWork" label="\xC9letviteli jellemz\u0151k:"><option value="smoking">doh\xE1nyz\xE1s</option><option value="drugs">k\xE1b\xEDt\xF3szer</option><option value="alcohol">alkoholfogyaszt\xE1s</option><option value="gambling">j\xE1t\xE9kszenved\xE9ly</option><option value="other">egy\xE9b</option></dod-field><dod-field name="factorsLimitingWorkOther" label="Egy\xE9b t\xE9nyez\u0151:" ng-if="workerRecord.params.factorsLimitingWork === \'other\'"></dod-field><div class="well"><h4>Csal\xE1d eg\xE9szs\xE9g\xFCgyi helyzete</h4><div class="row"><dod-field size="6" type="yesno" name="familyLongTermIll" label="Van-e tart\xF3s beteg a csal\xE1dban?"></dod-field><dod-field size="6" type="yesno" name="familyLongTermCare" label="Van-e gondoz\xE1sra szorul\xF3 szem\xE9ly a csal\xE1dban?"></dod-field></div><div class="row"><dod-field size="6" name="longTermCareFamilyMember" ng-if="workerRecord.params.familyLongTermCare === \'yes\'" label="Szem\xE9ly megjel\xF6l\xE9se:"></dod-field><dod-field size="6" name="longTermCareIllnesssName" ng-if="workerRecord.params.familyLongTermCare === \'yes\'" label="Betegs\xE9g megjel\xF6l\xE9se:"></dod-field></div></div>');
$templateCache.put('scripts/app/entities/workerRecord/templates/log.html','<dod-textarea name="eventTopic" label="Esem\xE9ny t\xE9m\xE1ja:"></dod-textarea><dod-textarea name="performedActions" label="Megtett int\xE9zked\xE9s:"></dod-textarea><dod-textarea name="results" label="Eredm\xE9ny:"></dod-textarea>');
$templateCache.put('scripts/app/entities/workerRecord/templates/personal_data.html','<uib-tabset><uib-tab heading="Szem\xE9lyes adatok"><dod-field type="text" name="birthName" label="Sz\xFClet\xE9si neve:"></dod-field><dod-field type="text" name="permanentAddress" label="\xC1lland\xF3 lakc\xEDme:"></dod-field><dod-field type="text" name="phoneNumber" label="Telefonsz\xE1ma:"></dod-field><dod-field type="text" name="birthPlace" label="Sz\xFClet\xE9si helye, ideje:"></dod-field><div class="form-group"><label>Iskolai v\xE9gzetts\xE9ge:</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="less_than_8">8 \xE1ltal\xE1nos alatt</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="year_8">8 \xE1ltal\xE1nos</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="szakmunkas">szakmunk\xE1s</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="szakkozep">szakk\xF6z\xE9p</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="gimnazium">gimn\xE1zium</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="university">fels\u0151fok\xFA</label></div><dod-field type="text" name="proffession" label="Szakma:"></dod-field><dod-textarea name="otherEfficiencies" label="Egy\xE9b v\xE9gzetts\xE9g (jogos\xEDtv\xE1ny, sz\xE1m\xEDt\xF3g\xE9p ismeret, stb):"></dod-textarea><dod-field type="text" name="previousWorks" label="Kor\xE1bbi munkatapasztalatok:"></dod-field></uib-tab><uib-tab heading="Rehabilit\xE1ci\xF3"><div class="form-group"><label>Volt-e m\xE1r rehabilit\xE1lva?</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.previousRehab" value="true">igen</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.previousRehab" value="false">nem</label></div><div class="form-group"><label>Rehabilit\xE1ci\xF3s fel\xFClvizsg\xE1laton r\xE9szt vett?</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.rehabExamination" value="true">igen</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.rehabExamination" value="false">nem</label></div><dod-field type="date" name="officialExpertOpinion" label="Hat\xE1lyos szak\xE9rt\u0151i v\xE9lem\xE9ny kelte:"></dod-field><dod-field type="date" name="dateOfNextReview" label="K\xF6vetkez\u0151 fel\xFClvizsg\xE1lat d\xE1tuma:"></dod-field><div class="form-group"><label>Foglalkoztathat\xF3s\xE1g jellege:</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.employmentType" value="tranzit">tranzit</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.employmentType" value="tartos">tart\xF3s</label></div><div class="form-group"><label>Eredm\xE9nye:</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="B1">B1</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="C1">C1</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="B2">B2</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="C2">C2</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="E">E</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="D">D</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.result" value="other">egy\xE9b</label></div></uib-tab><uib-tab heading="Munkav\xE9gz\xE9s"><div class="form-group"><label>Regisztr\xE1lt \xE1ll\xE1skeres\u0151?</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.registeredAsWorkFinder" value="true">igen</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.registeredAsWorkFinder" value="false">nem</label></div><dod-field ng-if="workerRecord.params.registeredAsWorkFinder === \'true\'" type="date" name="registeredAsWorkFinderSince" label="Mikort\xF3l regisztr\xE1lt \xE1ll\xE1skeres\u0151?"></dod-field><div class="form-group"><label>Rehabilit\xE1ci\xF3s k\xE1rty\xE1val rendelkezik-e?</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.rehabCard" value="true">igen</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.rehabCard" value="false">nem</label></div><dod-field ng-if="workerRecord.params.rehabCard === \'true\'" type="date" name="rehabCardValidity" label="Rehabilit\xE1ci\xF3s k\xE1rtya \xE9rv\xE9nyess\xE9ge?"></dod-field><dod-field type="date" name="empHealthAssessment" label="Foglalkoz\xE1si eg\xE9szs\xE9g\xFCgyi vizsg\xE1lat kelte?"></dod-field><dod-field type="date" name="empHealthAssessValid" label="Foglalkoz\xE1si eg\xE9szs\xE9g\xFCgyi vizsg\xE1lat \xE9rv\xE9nyess\xE9ge?"></dod-field><dod-field type="number" name="numberOfChildren" label="16 \xE9v alatti saj\xE1t h\xE1ztart\xE1sban \xE9l\u0151 saj\xE1t gyermekek sz\xE1ma?"></dod-field><dod-field type="date" name="workStart" label="Mikor tudna munk\xE1ba \xE1llni?"></dod-field><div class="form-group"><label>Pr\xF3bamunk\xE1n r\xE9szt venne-e?</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.testWork" value="true">igen</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.testWork" value="false">nem</label></div></uib-tab></uib-tabset>');
$templateCache.put('scripts/app/entities/workerRecord/templates/personal_profile.html','<div class="row"><div class="col-sm-6"><dod-field type="date" name="birthDate" label="Sz\xFClet\xE9si id\u0151:"></dod-field></div><div class="col-sm-6"><dod-field type="text" name="birthPlace" label="Sz\xFClet\xE9si helye:"></dod-field></div></div><div class="row"><div class="col-sm-6"><dod-field type="text" name="birthName" label="Sz\xFClet\xE9si neve:"></dod-field></div><div class="col-sm-6"><dod-field type="text" name="permanentAddress" label="\xC1lland\xF3 lakc\xEDme:"></dod-field></div></div><div class="row"><div class="col-sm-6"><dod-field type="text" name="phoneNumber" label="Telefonsz\xE1ma:"></dod-field></div><div class="col-sm-6"><dod-field type="text" name="motherName" label="Anyja neve:"></dod-field></div></div><div class="row"><div class="col-sm-6"><dod-field type="text" name="taxNumber" label="Ad\xF3azonos\xEDt\xF3 jel:"></dod-field></div><div class="col-sm-6"><dod-field type="text" name="socialSecurityNumber" label="TAJ sz\xE1m:"></dod-field></div></div><div class="form-group"><label>Iskolai v\xE9gzetts\xE9ge:</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="less_than_8">8 \xE1ltal\xE1nos alatt</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="year_8">8 \xE1ltal\xE1nos</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="szakmunkas">szakmunk\xE1s</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="szakkozep">szakk\xF6z\xE9p</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="gimnazium">gimn\xE1zium</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.schoolLevel" value="university">fels\u0151fok\xFA</label></div><dod-field type="text" name="proffession" label="Szakk\xE9pzetts\xE9g:"></dod-field><dod-field type="number" name="numberOfChilds" label="16 \xE9ve alatti gyermek sz\xE1ma:"></dod-field><!--\n<dod-textarea name="otherEfficiencies" label="Egy\xE9b v\xE9gzetts\xE9g (jogos\xEDtv\xE1ny, sz\xE1m\xEDt\xF3g\xE9p ismeret, stb):"></dod-textarea>\n<dod-textarea name="previousWorks" label="Kor\xE1bbi munkatapasztalatok:"></dod-textarea>-->');
$templateCache.put('scripts/app/entities/workerRecord/templates/personal_rehab_plan.html','<uib-tabset><uib-tab heading="SWOT elemz\xE9s elk\xE9sz\xEDt\xE9se"><dod-textarea name="workerStrengths" label="A foglalkoztatott er\u0151ss\xE9gei:"></dod-textarea><dod-textarea name="workerWeakness" label="A foglalkoztatott gyenges\xE9gei:"></dod-textarea><dod-textarea name="workerOpportunities" label="Lehet\u0151s\xE9gek, amelyek seg\xEDtik a foglalkoztatottat a c\xE9ljai el\xE9r\xE9s\xE9hez:"></dod-textarea><dod-textarea name="workerThreats" label="Vesz\xE9lyek, mint a munkav\xE9gz\xE9st korl\xE1toz\xF3 t\xE9nyez\u0151k:"></dod-textarea><dod-textarea name="swotDescription" label="Sz\xF6veges \xE9rt\xE9kel\xE9s a SWOT elemz\xE9sr\u0151l:"></dod-textarea></uib-tab><uib-tab heading="Munkaer\u0151 piaci helyzet \xE9rt\xE9kel\xE9se"><dod-textarea name="workMarketPossibities" label="Mindenkori gazdas\xE1gi helyzet mellett adott szakma, k\xE9pes\xEDt\xE9s ir\xE1nti munkaer\u0151 kereslet felt\xE9rk\xE9pez\xE9se, figyelembe v\xE9ve a nemek szerinti lehet\u0151s\xE9geket is, munkahelyek felt\xE1r\xE1sa az adott r\xE9gi\xF3ban, esetleges alternat\xEDv/speci\xE1lis lehet\u0151s\xE9gek felt\xE1r\xE1sa:"></dod-textarea></uib-tab><uib-tab heading="Rehabilit\xE1ci\xF3s c\xE9lok meghat\xE1roz\xE1sa"><dod-textarea name="goals" label="C\xE9lok:"></dod-textarea></uib-tab><uib-tab heading="Ide\xE1lis foglalkoztat\xE1si forma kiv\xE1laszt\xE1sa"><dod-textarea name="jobPossibilities" label="Bet\xF6lthet\u0151 munkak\xF6r\xF6k (RRSZ \xE1ltal javasolt):"></dod-textarea><dod-textarea name="suggestedJobs" label="Javasolt munkak\xF6r\xF6k az \xE1llapotfelm\xE9r\xE9s alapj\xE1n:"></dod-textarea><div class="form-group"><label>Foglalkoztat\xE1si form\xE1k:</label><div class="row"><dod-checkbox name="employmentType_fullTime" label="teljes munkaid\u0151"></dod-checkbox><dod-checkbox name="employmentType_partTime" label="r\xE9szmunkaid\u0151s"></dod-checkbox></div><div class="row"><dod-checkbox name="employmentType_remote" label="t\xE1vmunka"></dod-checkbox><dod-checkbox name="employmentType_flexTime" label="rugalmas munkaid\u0151"></dod-checkbox></div><div class="row"><dod-checkbox name="employmentType_fromHome" label="otthon v\xE9gezhet\u0151"></dod-checkbox><dod-checkbox name="employmentType_outworker" label="bedolgoz\xF3i"></dod-checkbox></div><div class="row"><dod-checkbox name="employmentType_occasional" label="alkalmi"></dod-checkbox><dod-checkbox name="employmentType_entrepreneurial" label="v\xE1llalkoz\xF3i"></dod-checkbox></div><div class="row"><dod-checkbox name="employmentType_other" label="egy\xE9b"></dod-checkbox></div></div></uib-tab><uib-tab heading="Cselekv\xE9si \xFCtemterv"><dod-table counter="planStepCounter" name="planSteps"><dod-table-text-field header="R\xF6vid t\xE1v\xFA c\xE9lok" name="shortTermPlan" type="area"></dod-table-text-field><dod-table-text-field header="A c\xE9l el\xE9r\xE9s\xE9hez sz\xFCks\xE9ges l\xE9p\xE9sek" name="shortTermSteps" type="area"></dod-table-text-field><dod-table-text-field header="C\xE9l el\xE9r\xE9s\xE9nek ideje" name="reachGoal" type="text"></dod-table-text-field><dod-table-text-field header="Ig\xE9nybe vett seg\xEDt\u0151 szolg\xE1ltat\xE1s" name="service" type="area"></dod-table-text-field></dod-table><dod-table counter="longPlanStepCounter" name="longPlanSteps"><dod-table-text-field header="Hossz\xFA t\xE1v\xFA c\xE9lok" name="longTermPlan" type="area"></dod-table-text-field><dod-table-text-field header="A c\xE9l el\xE9r\xE9s\xE9hez sz\xFCks\xE9ges l\xE9p\xE9sek" name="shortTermSteps" type="area"></dod-table-text-field><dod-table-text-field header="C\xE9l el\xE9r\xE9s\xE9nek ideje" name="reachGoal" type="text"></dod-table-text-field><dod-table-text-field header="Ig\xE9nybe vett seg\xEDt\u0151 szolg\xE1ltat\xE1s" name="service" type="area"></dod-table-text-field></dod-table><div class="form-group"><label>A c\xE9l el\xE9r\xE9s\xE9hez ig\xE9nybe vett szolg\xE1ltat\xE1sok k\xF6re::</label><div class="row"><dod-checkbox name="servicesToReachTheGoal_tool01" label="bels\u0151 k\xE9pz\xE9s,fejleszt\xE9s"></dod-checkbox><dod-checkbox name="servicesToReachTheGoal_tool02" label="munkapr\xF3ba"></dod-checkbox></div><div class="row"><dod-checkbox name="servicesToReachTheGoal_tool03" label="\xE1t/tov\xE1bbk\xE9pz\xE9s"></dod-checkbox><dod-checkbox name="servicesToReachTheGoal_tool04" label="k\xE9szs\xE9gfejleszt\xE9s egy\xE9ni form\xE1ban"></dod-checkbox></div><div class="row"><dod-checkbox name="servicesToReachTheGoal_tool05" label="bels\u0151 tr\xE9ning"></dod-checkbox><dod-checkbox name="servicesToReachTheGoal_tool06" label="k\xE9szs\xE9gfejleszt\xE9s csoportos form\xE1ban"></dod-checkbox></div><div class="row"><dod-checkbox name="servicesToReachTheGoal_tool07" label="pszichol\xF3giai tan\xE1csad\xE1s"></dod-checkbox><dod-checkbox name="servicesToReachTheGoal_tool08" label="p\xE1lyatan\xE1csad\xE1s"></dod-checkbox></div><div class="row"><dod-checkbox name="servicesToReachTheGoal_tool09" label="\xE9letvezet\xE9si tan\xE1csad\xE1s"></dod-checkbox><dod-checkbox name="servicesToReachTheGoal_tool10" label="jogseg\xE9lyhaszn\xE1lat"></dod-checkbox></div><div class="row"><dod-checkbox name="servicesToReachTheGoal_tool11" label="csal\xE1dgondoz\xE1s"></dod-checkbox><dod-checkbox name="servicesToReachTheGoal_tool12" label="szoci\xE1lis \xFCgyint\xE9z\xE9s"></dod-checkbox></div></div>A Foglalkoz\xE1si rehabilit\xE1ci\xF3s terv megval\xF3s\xEDt\xE1s\xE1nak l\xE9p\xE9sei<dod-table counter="rehabPlanStepCounter" name="rehabPlanSteps"><dod-table-text-field header="Nyomon k\xF6vet\xE9s, egy\xFCttm\u0171k\xF6d\xE9s form\xE1ja" name="description" type="area"></dod-table-text-field><dod-table-text-field header="\xDCtemez\xE9s, gyakoris\xE1g" name="timing" type="area"></dod-table-text-field><dod-table-text-field header="\xC9rt\xE9kel\xE9s" name="evaluation" type="area"></dod-table-text-field></dod-table></uib-tab></uib-tabset>');
$templateCache.put('scripts/app/entities/workerRecord/templates/professional_team_opinion.html','<dod-field-scoring label="Figyelem:" name="attention"></dod-field-scoring><dod-field-scoring label="Feladat meg\xE9rt\xE9se = utas\xEDt\xE1sok pontos k\xF6vet\xE9se, megval\xF3s\xEDt\xE1sa:" name="instructionFollowing"></dod-field-scoring><dod-field-scoring label="Feladattudata=a r\xE1b\xEDzott feladatok elv\xE9gz\xE9se a feladat jelleg\xE9t\u0151l f\xFCggetlen\xFCl" name="jobConsciousness"></dod-field-scoring><dod-field-scoring label="Feladattart\xE1sa, kitart\xE1s" name="taskTracking"></dod-field-scoring><dod-field-scoring label="Feladat v\xE9grehajt\xE1sa (precizit\xE1s, pontoss\xE1g)" name="jobPrecision"></dod-field-scoring><dod-field-scoring label="Munkatemp\xF3" name="taskSpeed"></dod-field-scoring><dod-field-scoring label="\xD6n\xE1ll\xF3s\xE1g" name="selfDetermination"></dod-field-scoring><dod-field-scoring label="Csoportos munkav\xE9gz\xE9s" name="groupWork"></dod-field-scoring><dod-field-scoring label="K\xE9z\xFCgyess\xE9g (j\xF3, k\xF6zepes, fejletlen)" name="handSkills"></dod-field-scoring><dod-field-scoring label="Ig\xE9nyess\xE9g" name="demandiness"></dod-field-scoring><dod-field-scoring label="Szakmai ismeretek a munkak\xF6ri feladatok ell\xE1t\xE1s\xE1hoz" name="professionalKnowledge"></dod-field-scoring><dod-field-scoring label="Munkaeszk\xF6z\xF6k adekv\xE1t haszn\xE1lata" name="properToolUsage"></dod-field-scoring><dod-field-scoring label="Munkamenet betart\xE1sa, k\xF6vet\xE9se" name="workStepFollowing"></dod-field-scoring><dod-textarea name="otherRemarks" label="Egy\xE9b megjegyz\xE9s:"></dod-textarea>');
$templateCache.put('scripts/app/entities/workerRecord/templates/rehab_carrier_plan.html','<dod-textarea name="bestWork" label="Mi az, amit legjobban v\xE9gez, \xE9s mi az, amit a leggyeng\xE9bben?"></dod-textarea><dod-textarea name="likeWork" label="Mit szeret a legjobban csin\xE1lni, mit az, amit a legkev\xE9sb\xE9?"></dod-textarea><dod-textarea name="success" label="Mi volt eddigi legnagyobb sikeres a munk\xE1j\xE1ban, amikor \xFAgy \xE9rezte, hogy k\xFCl\xF6n\xF6sen produkt\xEDv volt, hogy k\xE9pess\xE9gei, k\xE9szs\xE9gei maximum\xE1t hasznos\xEDtotta?"></dod-textarea><dod-textarea name="possibleWork" label="Mit dolgozna, ha tehetn\xE9?"></dod-textarea><dod-textarea name="furtherAdvance" label="Szeretn\xE9-e tov\xE1bb k\xE9pezni mag\xE1t?"></dod-textarea><dod-textarea name="learnOtherProfession" label="Tanulna-e m\xE1s szakm\xE1t?"></dod-textarea><dod-textarea name="yearlyWorkPlan" label="Mik a tervei az elk\xF6vetkez\u0151 egy \xE9vre a munka ter\xE9n?"></dod-textarea><dod-textarea name="longTermPlans" label="Mik a hossz\xFA t\xE1v\xFA tervei a munk\xE1val kapcsolatban (3-5 \xE9ves t\xE1v)?"></dod-textarea>');
$templateCache.put('scripts/app/entities/workerRecord/templates/rehab_plan_inv_report.html','<div class="form-group"><label>Terv fel\xFClvizsg\xE1lat\xE1nak oka:</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.reviseCauseSelection" value="yearly">\xE9ves</label> <label class="radio-inline"><input type="radio" ng-model="workerRecord.params.reviseCauseSelection" value="other"> rendk\xEDv\xFCli</label></div><dod-textarea name="reviseCause" label="Rendk\xEDv\xFCli oka:" ng-show="workerRecord.params.reviseCauseSelection === \'other\'"></dod-textarea><dod-field type="date" name="reviseDate" label="Rehabilit\xE1ci\xF3s terv fel\xFClvizsg\xE1lat\xE1nak id\u0151pontja:"></dod-field><dod-table counter="numberOfGoals" name="steps"><dod-table-text-field header="C\xE9lok" name="goals" type="area"></dod-table-text-field><dod-table-text-field header="Eredm\xE9ny" name="results" type="area"></dod-table-text-field></dod-table><dod-textarea name="evaluation" label="Rehabilit\xE1ci\xF3s teammel val\xF3 egy\xFCttm\u0171k\xF6d\xE9s \xE9rt\xE9kel\xE9se:"></dod-textarea><dod-textarea name="work_efficiency" label="A munkav\xE1llal\xF3 munkahelyi r\xE9szv\xE9tele:"></dod-textarea><dod-textarea name="takingPartInPlanActions" label="A szem\xE9lyes tervben meghat\xE1rozottak szerinti tev\xE9kenys\xE9gekben val\xF3 r\xE9szv\xE9tel,pl. seg\xEDt\u0151 szolg\xE1ltat\xE1sok ig\xE9nybev\xE9tele:"></dod-textarea><dod-textarea name="medicalConditionChanges" label="A Rehabilit\xE1ci\xF3s terv felv\xE9tele \xF3ta eltelt id\u0151szakban t\xF6rt\xE9nt orvosszak\xE9rt\u0151i fel\xFClvizsg\xE1lat, komplex min\u0151s\xEDt\xE9s id\u0151pontja, eredm\xE9nye, eg\xE9szs\xE9g\xE1llapot v\xE1ltoz\xE1sok:"></dod-textarea><dod-textarea name="problemSolvingSteps" label="Az akad\xE1lyok elh\xE1r\xEDt\xE1sa \xE9rdek\xE9ben megtett int\xE9zked\xE9sek \xF6sszegz\xE9se:"></dod-textarea><div class="form-group"><label>Sz\xFCks\xE9ges \xFAj c\xE9lok megfogalmaz\xE1sa, \xFAj akad\xE1lyok felmer\xFCl\xE9se:</label><dod-table counter="planStepCounter" name="planSteps"><dod-table-text-field header="R\xF6vid t\xE1v\xFA c\xE9lok" name="shortTermPlan" type="area"></dod-table-text-field><dod-table-text-field header="A c\xE9l el\xE9r\xE9s\xE9hez sz\xFCks\xE9ges l\xE9p\xE9sek" name="shortTermSteps" type="area"></dod-table-text-field><dod-table-text-field header="C\xE9l el\xE9r\xE9s\xE9nek ideje" name="reachGoal" type="text"></dod-table-text-field><dod-table-text-field header="A c\xE9l el\xE9r\xE9s\xE9hez ig\xE9nybe vett seg\xEDt\u0151 szolg\xE1ltat\xE1s" name="service" type="area"></dod-table-text-field></dod-table><dod-table counter="longPlanStepCounter" name="longPlanSteps"><dod-table-text-field header="Hossz\xFA t\xE1v\xFA c\xE9lok" name="longTermPlan" type="area"></dod-table-text-field><dod-table-text-field header="A c\xE9l el\xE9r\xE9s\xE9hez sz\xFCks\xE9ges l\xE9p\xE9sek" name="shortTermSteps" type="area"></dod-table-text-field><dod-table-text-field header="C\xE9l el\xE9r\xE9s\xE9nek ideje" name="reachGoal" type="text"></dod-table-text-field><dod-table-text-field header="A c\xE9l el\xE9r\xE9s\xE9hez ig\xE9nybe vett seg\xEDt\u0151 szolg\xE1ltat\xE1s" name="service" type="area"></dod-table-text-field></dod-table></div><dod-textarea name="nextHelpingSteps" label="A tov\xE1bbi seg\xEDt\u0151 folyamat elemeinek meghat\xE1roz\xE1sa:"></dod-textarea>');
$templateCache.put('scripts/app/entities/workerRecord/templates/rehab_profile.html','<dod-field type="select" name="certType" label="Megv\xE1ltozott munkak\xE9pess\xE9gr\u0151l sz\xF3l\xF3 igazol\xE1s megnevez\xE9se"><option value="hatbiz">hat\xF3s\xE1gi bizony\xEDtv\xE1ny</option><option value="komplex">komplex min\u0151s\xEDt\xE9s</option><option value="other">egy\xE9b</option></dod-field><dod-field ng-if="workerRecord.params.certType === \'other\'" type="text" name="certTypeOther" label="Megnevez\xE9se"></dod-field><dod-field type="date" name="certDate" label="Megv\xE1ltozott munkak\xE9pess\xE9gr\u0151l  sz\xF3l\xF3 igazol\xE1s kelte:"></dod-field><dod-field type="date" name="certDateExpiry" label="Megv\xE1ltozott munkak\xE9pess\xE9gr\u0151l  sz\xF3l\xF3 igazol\xE1s lej\xE1rta:"></dod-field><dod-field type="text" name="healthState" label="Eg\xE9szs\xE9gi \xE1llapot m\xE9rt\xE9ke:"></dod-field><dod-field type="text" name="oek" label="\xD6EK:"></dod-field><dod-field type="select" name="classification" label="Min\u0151s\xEDt\xE9s"><option value="B1">B1</option><option value="C1">C1</option><option value="B2">B2</option><option value="C2">C2</option><option value="E">E</option><option value="D">D</option><option value="other">egy\xE9b</option></dod-field><dod-field type="select" name="employmentType" label="Foglalkoztathat\xF3s\xE1g jellege"><option value="tranzit">tranzit</option><option value="tartos">tart\xF3s</option></dod-field><dod-field type="text" name="paymentDescription" label="Megv\xE1ltozott munkak\xE9pess\xE9ghez kapcsol\xF3d\xF3 p\xE9nzbeli ell\xE1t\xE1s megnevez\xE9se"></dod-field><dod-field type="date" name="paymentEnd" label="Megv\xE1ltozott munkak\xE9pess\xE9ghez kapcsol\xF3d\xF3 p\xE9nzbeli ell\xE1t\xE1s foly\xF3s\xEDt\xE1s lej\xE1rt\xE1nak hat\xE1rideje:"></dod-field><dod-field type="yesno" name="rehabCard" label="Rehabilit\xE1ci\xF3s k\xE1rtya:"></dod-field><dod-field type="text" name="otherDeficiencyDesc" label="Egy\xE9b fogyat\xE9koss\xE1gr\xF3l sz\xF3l\xF3 igazol\xE1s megnevez\xE9se"></dod-field><dod-field type="date" name="otherDefExpiry" label="\xC9rv\xE9nyess\xE9ge:"></dod-field>');
$templateCache.put('scripts/app/entities/workerRecord/templates/social_assessment.html','<uib-tabset><uib-tab heading="J\xF6vedelmi helyzet"><dod-field type="select" name="maritalStatus" label="Csal\xE1di \xE1llapot"><option value="single">n\u0151tlen/hajadon</option><option value="married">h\xE1zas</option><option value="domesticPartner">\xE9lett\xE1rsi kapcsolatban \xE9l</option><option value="separated">elv\xE1lt</option><option value="widow">\xF6zvegy</option></dod-field><dod-field type="number" name="inHouseHold" label="Egy h\xE1ztart\xE1sban \xE9l\u0151k sz\xE1ma:"></dod-field><dod-field type="number" name="incomePerCapita" label="Egy f\u0151re jut\xF3 j\xF6vedelem (Ft):"></dod-field><h4>Egy\xE9b juttat\xE1s/j\xE1rad\xE9k:</h4><div class="row"><dod-checkbox name="widowPension_checkbox" label="\xF6zvegyi nyugd\xEDj"></dod-checkbox><dod-checkbox name="careAllowance_checkbox" label="\xE1pol\xE1si d\xEDj"></dod-checkbox></div><div class="row"><dod-checkbox name="familyAllowance_checkbox" label="csal\xE1di p\xF3tl\xE9k, tart\xE1sd\xEDj"></dod-checkbox><dod-checkbox name="childCare_checkbox" label="gyermekgondoz\xE1si seg\xE9ly, d\xEDj (GYES, GYED)"></dod-checkbox></div><div class="row"><dod-checkbox name="rehabAllowance_checkbox" label="rehabilit\xE1ci\xF3s j\xE1rad\xE9k"></dod-checkbox><dod-checkbox name="disabilityAllowance_checkbox" label="rokkants\xE1gi nyugd\xEDj"></dod-checkbox></div><div class="row"><dod-checkbox name="socialCare_checkbox" label="szoci\xE1lis t\xE1mogat\xE1s (pl. \xF6nkorm\xE1nyzati)"></dod-checkbox></div><dod-field type="actualAllowance" label="Aktu\xE1lis ell\xE1t\xE1s t\xEDpusa"></dod-field><dod-field type="number" name="avarageTotalIncome" label="\xC1tlagos havi bev\xE9tel (j\xF6vedelem+ juttat\xE1sok, j\xE1rad\xE9kok):"></dod-field><dod-field type="number" name="avarageTotalExpenses" label="\xC1tlagos havi k\xF6lts\xE9gek \xF6sszesen gy\xF3gyszerre, kezel\xE9sekre, gy\xF3gy\xE1szati seg\xE9deszk\xF6z\xF6kre:"></dod-field><dod-field type="yesno" name="financialDifficulties" label="Anyagi neh\xE9zs\xE9gek:"></dod-field><dod-field type="yesno" name="extraExpenses" label="Meg\xE9lhet\xE9st nehez\xEDt\u0151, korl\xE1toz\xF3 kiad\xE1sok:"></dod-field><dod-textarea name="extraExpensDescription" label="E kiad\xE1sok t\xEDpusai, \xF6sszege:"></dod-textarea></uib-tab><uib-tab heading="Munk\xE1ba j\xE1r\xE1s"><h4>Munk\xE1ba j\xE1r\xE1s m\xF3dja:</h4><div class="row"><dod-checkbox name="commute_rail_checkbox" label="vas\xFAti k\xF6zleked\xE9s"></dod-checkbox><dod-checkbox name="commute_car_checkbox" label="szem\xE9lyaut\xF3"></dod-checkbox></div><div class="row"><dod-checkbox name="commute_bus_checkbox" label="aut\xF3buszj\xE1rat"></dod-checkbox><dod-checkbox name="commute_bike_checkbox" label="ker\xE9kp\xE1r"></dod-checkbox></div><div class="row"><dod-checkbox name="commute_by_foot_checkbox" label="gyalog"></dod-checkbox></div><dod-field type="yesno" name="problemTravelToWork" label="Neh\xE9zs\xE9get jelent-e a munkahely megk\xF6zel\xEDthet\u0151s\xE9ge?"></dod-field><dod-field type="yesno" name="needHelpToTravel" label="Sz\xFCks\xE9ge lenne-e seg\xEDts\xE9gre a munk\xE1ba j\xE1r\xE1shoz?"></dod-field><dod-field name="helpNeeded" label="Milyen seg\xEDts\xE9get ig\xE9nyelne?"></dod-field></uib-tab><uib-tab heading="Lak\xE1sk\xF6r\xFClm\xE9nyek"><dod-field type="select" name="homeType" label="Lak\xF3\xE9p\xFClet jellege:"><option value="house">csal\xE1di h\xE1z</option><option value="condominium">t\xE1rsash\xE1z</option><option value="flat">lak\xF3telepi lak\xE1s</option><option value="weekendHouse">h\xE9tv\xE9gi h\xE1z</option><option value="other">egy\xE9b</option></dod-field><dod-field type="select" name="homeOwnership" label="Lak\xE1s tulajdonform\xE1ja:"><option value="own">saj\xE1t tulajdon</option><option value="localCouncil">\xF6nkorm\xE1nyzati</option><option value="otherOwn">m\xE1s tulajdona</option><option value="rent">alb\xE9rlet</option><option value="serviceFlat">k\xF6z\xFCleti/szolg\xE1lati</option></dod-field><dod-field type="text" name="homeSize" label="Lak\xE1s nagys\xE1ga:"></dod-field><dod-field type="number" name="roomCount" label="Szob\xE1k sz\xE1ma:"></dod-field><dod-field type="number" name="areaSize" label="Alapter\xFClet:"></dod-field><dod-field type="text" name="comfortLevel" label="Lak\xE1s komfortfokozata (V\xEDz, szennyv\xEDz, villanyf\u0171t\xE9si t\xEDpus stb.):"></dod-field></uib-tab><uib-tab heading="T\xE1rsas kapcsolatok"><dod-field type="number" name="childCount" label="Gyermekek sz\xE1ma:"></dod-field><dod-field type="text" name="otherCloseRelatives" label="Egy\xE9b k\xF6zeli hozz\xE1tartoz\xF3k:"></dod-field><dod-field type="yesno" name="goingToCommunity" label="Rehabilit\xE1ci\xF3s foglalkoztat\xE1son k\xEDv\xFCl j\xE1r-e k\xF6z\xF6ss\xE9gbe:"></dod-field><dod-field type="text" name="communityName" label="K\xF6z\xF6ss\xE9g megnevez\xE9se, l\xE1togat\xE1s gyakoris\xE1ga:"></dod-field><dod-field type="yesno" name="needHomeAssistance" label="Otthoni k\xF6r\xFClm\xE9nyek k\xF6z\xF6tt ig\xE9nyel-e szem\xE9lyi t\xE1mogat\xE1st?"></dod-field><h4>Kihez fordulhat? - Probl\xE9ma eset\xE9n seg\xEDts\xE9get ny\xFAjt\xF3 egy\xE9nek megjel\xF6l\xE9se:</h4><div class="row"><dod-checkbox name="assistanceType_family_checkbox" label="csal\xE1dtag"></dod-checkbox><dod-checkbox name="assistanceType_neighbour_checkbox" label="szomsz\xE9d"></dod-checkbox></div><div class="row"><dod-checkbox name="assistanceType_otherPrivate_checkbox" label="egy\xE9b mag\xE1nszem\xE9ly"></dod-checkbox><dod-checkbox name="assistanceType_familyCare_checkbox" label="csal\xE1dgondoz\xF3"></dod-checkbox></div><div class="row"><dod-checkbox name="assistanceType_localCouncil_checkbox" label="\xF6nkorm\xE1nyzat"></dod-checkbox><dod-checkbox name="assistanceType_ngo_checkbox" label="civil szervezetek"></dod-checkbox></div><dod-field type="yesno" name="hasFriends" label="Bar\xE1ti kapcsolatok megl\xE9te:"></dod-field><dod-field type="text" name="hobby" label="Szabadid\u0151 elt\xF6lt\xE9se, hobby:"></dod-field><dod-field type="text" name="placeWhereMostTimeAt" label="Hol t\xF6lti a legt\xF6bb idej\xE9t?"></dod-field><dod-field type="text" name="mostTimeOnActivities" label="Milyen tev\xE9kenys\xE9gekkel t\xF6lti a legt\xF6bb idej\xE9t?"></dod-field><dod-field type="text" name="mostTimeTogether" label="Kivel t\xF6lti a legt\xF6bb idej\xE9t?"></dod-field></uib-tab></uib-tabset>');
$templateCache.put('scripts/app/entities/workerRecord/templates/testwork_evaluation.html','<dod-field type="date" name="testWorkEnd" label="Pr\xF3baid\u0151 lej\xE1rta:"></dod-field><dod-textarea name="rehabTeamOpinion" label="Rehabilit\xE1ci\xF3s team \xF6sszefoglal\xF3 v\xE9lem\xE9nye:"></dod-textarea><dod-field type="yesno" name="rehabFurtherEmployment" label="Javaslata a tov\xE1bb foglalkoztat\xE1sra:"></dod-field><dod-textarea name="prodTeamOpinion" label="Termel\xE9si team \xF6sszefoglal\xF3 v\xE9lem\xE9nye:"></dod-textarea><dod-field type="yesno" name="prodFurtherEmployment" label="Javaslata a tov\xE1bb foglalkoztat\xE1sra:"></dod-field>');
$templateCache.put('scripts/app/entities/workerRecord/templates/testwork_evaluation2.html','Munkaad\xF3 tapasztalata a foglalkoztatottr\xF3l:<dod-textarea name="inWorkFilling" label="A munkak\xF6rben mennyire tal\xE1lta meg a hely\xE9t, hogy \xE9rezte mag\xE1t (szem\xE9lyes attit\u0171d, k\xE9pzetts\xE9g figyelembev\xE9tele mellett)?"></dod-textarea><dod-textarea name="newKnowledge" label="Esetleges \xFAj ismeretek okoztak e probl\xE9m\xE1t?"></dod-textarea><dod-textarea name="requirements" label="Elv\xE9gzett munka- mennyis\xE9gi/min\u0151s\xE9gi k\xF6vetelm\xE9nyei, hogy viszonyult a hasonl\xF3 munkak\xF6rben dolgoz\xF3 eg\xE9szs\xE9ges/nem megv\xE1ltozott munkak\xE9pess\xE9g\u0171 munkav\xE1llal\xF3k teljes\xEDt\xE9s\xE9hez?"></dod-textarea><dod-textarea name="otherWorkers" label="Milyen volt az alkalmazkod\xE1sai, viszonyul\xE1si k\xE9szs\xE9ge a t\xF6bbi munkav\xE1llal\xF3val, vezet\u0151vel szemben?"></dod-textarea><div class="form-group"><label for="cf_field5">\xD6sszbenyom\xE1s alapj\xE1n foglalkoztatn\xE1-e hossz\xFAt\xE1von, ny\xEDlt piaci k\xF6r\xFClm\xE9nyek k\xF6z\xF6tt?</label><div class="btn-group"><label class="btn btn-success" ng-model="workerRecord.params.employerDecision" uib-btn-radio="\'TRUE\'" uncheckable>Igen</label> <label class="btn btn-success" ng-model="workerRecord.params.employerDecision" uib-btn-radio="\'FALSE\'" uncheckable>Nem</label></div></div><dod-textarea name="mentorExperience" label="Rehabilit\xE1ci\xF3s mentor tapasztalata a foglalkoztatottr\xF3l?"></dod-textarea><div class="form-group"><label for="cf_field5">\xD6sszbenyom\xE1s alapj\xE1n foglalkoztatn\xE1-e hossz\xFAt\xE1von, ny\xEDlt piaci k\xF6r\xFClm\xE9nyek k\xF6z\xF6tt?</label><div class="btn-group"><label class="btn btn-success" ng-model="workerRecord.params.mentorDecision" uib-btn-radio="\'TRUE\'" uncheckable>Igen</label> <label class="btn btn-success" ng-model="workerRecord.params.mentorDecision" uib-btn-radio="\'FALSE\'" uncheckable>Nem</label></div></div>');
$templateCache.put('scripts/app/entities/workerRecord/templates/testwork_sheet.html','<dod-field type="date" name="contractCreationDate" label="Munkapr\xF3ba szerz\u0151d\xE9s kelte"></dod-field><dod-field type="date" name="startDate" label="Munkapr\xF3ba kezdete"></dod-field><dod-field type="date" name="endDate" label="Munkapr\xF3ba v\xE9ge"></dod-field><dod-field type="text" name="employerName" label="Befogad\xF3 munk\xE1ltat\xF3 megnevez\xE9se"></dod-field><dod-textarea name="workResult" label="Munkapr\xF3ba eredm\xE9nye:"></dod-textarea>');
$templateCache.put('scripts/app/entities/workerRecord/templates/testwork_sheet2.html','<dod-field type="text" name="workType" label="Munka jellege:"></dod-field><dod-field type="datetime-local" name="startTime" label="Pr\xF3bamunka kezd\xE9si id\u0151pontja:"></dod-field><dod-field type="datetime-local" name="endTime" label="Pr\xF3bamunka z\xE1r\xE1si id\u0151pontja:"></dod-field><dod-field type="number" name="plannedAmount" label="Elv\xE9gzend\u0151 mennyis\xE9g:"></dod-field><dod-field type="number" name="finishedAmount" label="Elv\xE9gzett mennyis\xE9g:"></dod-field><dod-field type="number" name="numberOfErrors" label="V\xE9tett mennyis\xE9gi hib\xE1k sz\xE1ma:"></dod-field><dod-textarea name="workerOpinion" label="Rehabilit\xE1land\xF3 tapasztalta a munk\xE1r\xF3l (tetszett e neki):"></dod-textarea><dod-textarea name="helperOpinion" label="Seg\xEDt\u0151 szem\xE9ly tapasztalata a rehabilit\xE1land\xF3 szem\xE9lyr\u0151l:"></dod-textarea>');}]);})();